{
    "variables": [
        {
            "vgroup": "record",
            "qtitle": "Record number",
            "colTitle": null,
            "title": "Record number",
            "rowTitle": null,
            "label": "record",
            "row": null,
            "type": "text",
            "col": null,
            "qlabel": null
        },
        {
            "vgroup": "uuid",
            "qtitle": "Participant identifier",
            "colTitle": null,
            "title": "Participant identifier",
            "rowTitle": null,
            "label": "uuid",
            "row": null,
            "type": "text",
            "col": null,
            "qlabel": null
        },
        {
            "vgroup": "date",
            "qtitle": "Completion time and date",
            "colTitle": null,
            "title": "Completion time and date",
            "rowTitle": null,
            "label": "date",
            "row": null,
            "type": "text",
            "col": null,
            "qlabel": null
        },
        {
            "vgroup": "markers",
            "qtitle": "Acquired markers",
            "colTitle": null,
            "title": "Acquired markers",
            "rowTitle": null,
            "label": "markers",
            "row": null,
            "type": "text",
            "col": null,
            "qlabel": null
        },
        {
            "vgroup": "status",
            "qtitle": "Participant status",
            "colTitle": null,
            "title": "Participant status",
            "rowTitle": null,
            "label": "status",
            "values": [
                {
                    "label": "terminated",
                    "value": 1,
                    "title": "Terminated"
                },
                {
                    "label": "overquota",
                    "value": 2,
                    "title": "Overquota"
                },
                {
                    "label": "qualified",
                    "value": 3,
                    "title": "Qualified"
                },
                {
                    "label": "partial",
                    "value": 4,
                    "title": "Partial"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "status"
        },
        {
            "vgroup": "ExitStatus",
            "qtitle": "Exit Status",
            "colTitle": null,
            "title": "Exit Status",
            "rowTitle": null,
            "label": "ExitStatus",
            "row": null,
            "type": "text",
            "col": null,
            "qlabel": "ExitStatus"
        },
        {
            "vgroup": "VendorState",
            "qtitle": "Vendor State",
            "colTitle": null,
            "title": "Vendor State",
            "rowTitle": null,
            "label": "VendorState",
            "row": null,
            "type": "text",
            "col": null,
            "qlabel": "VendorState"
        },
        {
            "vgroup": "QCRemovalReason",
            "qtitle": "QC Removal Reason",
            "colTitle": null,
            "title": "QC Removal Reason",
            "rowTitle": null,
            "label": "QCRemovalReason",
            "row": null,
            "type": "text",
            "col": null,
            "qlabel": "QCRemovalReason"
        },
        {
            "vgroup": "dvflag",
            "qtitle": "Data Validation Flags",
            "colTitle": null,
            "title": "Q8 Straightline - Data Validation Flags",
            "rowTitle": "Q8 Straightline",
            "label": "dvflagr1",
            "value": 1,
            "row": "r1",
            "type": "multiple",
            "col": null,
            "qlabel": "dvflag"
        },
        {
            "vgroup": "dvflag",
            "qtitle": "Data Validation Flags",
            "colTitle": null,
            "title": "Q9 Straightline - Data Validation Flags",
            "rowTitle": "Q9 Straightline",
            "label": "dvflagr2",
            "value": 1,
            "row": "r2",
            "type": "multiple",
            "col": null,
            "qlabel": "dvflag"
        },
        {
            "vgroup": "dvflag",
            "qtitle": "Data Validation Flags",
            "colTitle": null,
            "title": "Q15 Straightline - Data Validation Flags",
            "rowTitle": "Q15 Straightline",
            "label": "dvflagr3",
            "value": 1,
            "row": "r3",
            "type": "multiple",
            "col": null,
            "qlabel": "dvflag"
        },
        {
            "vgroup": "dvflag",
            "qtitle": "Data Validation Flags",
            "colTitle": null,
            "title": "RIDResult High - Data Validation Flags",
            "rowTitle": "RIDResult High",
            "label": "dvflagr96",
            "value": 1,
            "row": "r96",
            "type": "multiple",
            "col": null,
            "qlabel": "dvflag"
        },
        {
            "vgroup": "dvflag",
            "qtitle": "Data Validation Flags",
            "colTitle": null,
            "title": "SURVEY TESTING PORTAL - Data Validation Flags",
            "rowTitle": "SURVEY TESTING PORTAL",
            "label": "dvflagr97",
            "value": 1,
            "row": "r97",
            "type": "multiple",
            "col": null,
            "qlabel": "dvflag"
        },
        {
            "vgroup": "dvflag",
            "qtitle": "Data Validation Flags",
            "colTitle": null,
            "title": "Speeder - Data Validation Flags",
            "rowTitle": "Speeder",
            "label": "dvflagr98",
            "value": 1,
            "row": "r98",
            "type": "multiple",
            "col": null,
            "qlabel": "dvflag"
        },
        {
            "vgroup": "dvflag",
            "qtitle": "Data Validation Flags",
            "colTitle": null,
            "title": "Manual QC Removal - Data Validation Flags",
            "rowTitle": "Manual QC Removal",
            "label": "dvflagr99",
            "value": 1,
            "row": "r99",
            "type": "multiple",
            "col": null,
            "qlabel": "dvflag"
        },
        {
            "vgroup": "dvscore",
            "qtitle": "HOLDS FINAL DVSCORE",
            "colTitle": null,
            "title": "HOLDS FINAL DVSCORE",
            "rowTitle": null,
            "label": "dvscore",
            "row": null,
            "type": "number",
            "col": null,
            "qlabel": "dvscore"
        },
        {
            "vgroup": "sectionLOI",
            "qtitle": "Holds LOI&nbsp;of sections",
            "colTitle": null,
            "title": "Total - Holds LOI&nbsp;of sections",
            "rowTitle": "Total",
            "label": "sectionLOIr1",
            "row": "r1",
            "type": "text",
            "col": null,
            "qlabel": "sectionLOI"
        },
        {
            "vgroup": "sectionLOI",
            "qtitle": "Holds LOI&nbsp;of sections",
            "colTitle": null,
            "title": "Screener - Holds LOI&nbsp;of sections",
            "rowTitle": "Screener",
            "label": "sectionLOIr2",
            "row": "r2",
            "type": "text",
            "col": null,
            "qlabel": "sectionLOI"
        },
        {
            "vgroup": "sectionLOI",
            "qtitle": "Holds LOI&nbsp;of sections",
            "colTitle": null,
            "title": "Main - Holds LOI&nbsp;of sections",
            "rowTitle": "Main",
            "label": "sectionLOIr3",
            "row": "r3",
            "type": "text",
            "col": null,
            "qlabel": "sectionLOI"
        },
        {
            "vgroup": "sectionLOI",
            "qtitle": "Holds LOI&nbsp;of sections",
            "colTitle": null,
            "title": "Demographics - Holds LOI&nbsp;of sections",
            "rowTitle": "Demographics",
            "label": "sectionLOIr4",
            "row": "r4",
            "type": "text",
            "col": null,
            "qlabel": "sectionLOI"
        },
        {
            "vgroup": "DevType",
            "qtitle": "Device Type",
            "colTitle": null,
            "title": "Device Type",
            "rowTitle": null,
            "label": "DevType",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Laptop"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Mobile"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "DevType"
        },
        {
            "vgroup": "SampSource",
            "qtitle": "SAMPLE SOURCE",
            "colTitle": null,
            "title": "SAMPLE SOURCE",
            "rowTitle": null,
            "label": "SampSource",
            "row": null,
            "type": "number",
            "col": null,
            "qlabel": "SampSource"
        },
        {
            "vgroup": "GeoIP_Details",
            "qtitle": "Hidden: location details",
            "colTitle": null,
            "title": "country_code - Hidden: location details",
            "rowTitle": "country_code",
            "label": "GeoIP_Detailsr1",
            "row": "r1",
            "type": "text",
            "col": null,
            "qlabel": "GeoIP_Details"
        },
        {
            "vgroup": "GeoIP_Details",
            "qtitle": "Hidden: location details",
            "colTitle": null,
            "title": "country_name - Hidden: location details",
            "rowTitle": "country_name",
            "label": "GeoIP_Detailsr2",
            "row": "r2",
            "type": "text",
            "col": null,
            "qlabel": "GeoIP_Details"
        },
        {
            "vgroup": "GeoIP_Details",
            "qtitle": "Hidden: location details",
            "colTitle": null,
            "title": "dma_code - Hidden: location details",
            "rowTitle": "dma_code",
            "label": "GeoIP_Detailsr3",
            "row": "r3",
            "type": "text",
            "col": null,
            "qlabel": "GeoIP_Details"
        },
        {
            "vgroup": "GeoIP_Details",
            "qtitle": "Hidden: location details",
            "colTitle": null,
            "title": "region - Hidden: location details",
            "rowTitle": "region",
            "label": "GeoIP_Detailsr4",
            "row": "r4",
            "type": "text",
            "col": null,
            "qlabel": "GeoIP_Details"
        },
        {
            "vgroup": "GeoIP_Details",
            "qtitle": "Hidden: location details",
            "colTitle": null,
            "title": "region_name - Hidden: location details",
            "rowTitle": "region_name",
            "label": "GeoIP_Detailsr5",
            "row": "r5",
            "type": "text",
            "col": null,
            "qlabel": "GeoIP_Details"
        },
        {
            "vgroup": "RotateSelect",
            "qtitle": "HIDDEN: HOLDS Rotate Selection ORDER",
            "colTitle": null,
            "title": "HIDDEN: HOLDS Rotate Selection ORDER",
            "rowTitle": null,
            "label": "RotateSelect",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Top to bottom"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Bottom to top"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "RotateSelect"
        },
        {
            "vgroup": "Q1",
            "qtitle": "In what year were you born?",
            "colTitle": null,
            "title": "In what year were you born?",
            "rowTitle": null,
            "label": "Q1",
            "row": null,
            "type": "number",
            "col": null,
            "qlabel": "Q1"
        },
        {
            "vgroup": "HIDAge",
            "qtitle": "HIDDEN: Age recode 1",
            "colTitle": null,
            "title": "HIDDEN: Age recode 1",
            "rowTitle": null,
            "label": "HIDAge",
            "row": null,
            "type": "number",
            "col": null,
            "qlabel": "HIDAge"
        },
        {
            "vgroup": "HIDAge2",
            "qtitle": "HIDDEN: Age recode",
            "colTitle": null,
            "title": "HIDDEN: Age recode",
            "rowTitle": null,
            "label": "HIDAge2",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "18-24"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "25-34"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "35-44"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "45-54"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "55-64"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "65 plus"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "HIDAge2"
        },
        {
            "vgroup": "Q2",
            "qtitle": "What is your gender?",
            "colTitle": null,
            "title": "What is your gender?",
            "rowTitle": null,
            "label": "Q2",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Male"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Female"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Non-binary"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Prefer to self-describe"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q2"
        },
        {
            "vgroup": "Q3",
            "qtitle": "In what state do you reside?",
            "colTitle": null,
            "title": "In what state do you reside?",
            "rowTitle": null,
            "label": "Q3",
            "values": [
                {
                    "label": "AL",
                    "value": 1,
                    "title": "Alabama"
                },
                {
                    "label": "AK",
                    "value": 2,
                    "title": "Alaska"
                },
                {
                    "label": "AZ",
                    "value": 3,
                    "title": "Arizona"
                },
                {
                    "label": "AR",
                    "value": 4,
                    "title": "Arkansas"
                },
                {
                    "label": "CA",
                    "value": 5,
                    "title": "California"
                },
                {
                    "label": "CO",
                    "value": 6,
                    "title": "Colorado"
                },
                {
                    "label": "CT",
                    "value": 7,
                    "title": "Connecticut"
                },
                {
                    "label": "DE",
                    "value": 8,
                    "title": "Delaware"
                },
                {
                    "label": "DC",
                    "value": 9,
                    "title": "District of Columbia (DC)"
                },
                {
                    "label": "FL",
                    "value": 10,
                    "title": "Florida"
                },
                {
                    "label": "GA",
                    "value": 11,
                    "title": "Georgia"
                },
                {
                    "label": "HI",
                    "value": 12,
                    "title": "Hawaii"
                },
                {
                    "label": "ID",
                    "value": 13,
                    "title": "Idaho"
                },
                {
                    "label": "IL",
                    "value": 14,
                    "title": "Illinois"
                },
                {
                    "label": "IN",
                    "value": 15,
                    "title": "Indiana"
                },
                {
                    "label": "IA",
                    "value": 16,
                    "title": "Iowa"
                },
                {
                    "label": "KS",
                    "value": 17,
                    "title": "Kansas"
                },
                {
                    "label": "KY",
                    "value": 18,
                    "title": "Kentucky"
                },
                {
                    "label": "LA",
                    "value": 19,
                    "title": "Louisiana"
                },
                {
                    "label": "ME",
                    "value": 20,
                    "title": "Maine"
                },
                {
                    "label": "MD",
                    "value": 21,
                    "title": "Maryland"
                },
                {
                    "label": "MA",
                    "value": 22,
                    "title": "Massachusetts"
                },
                {
                    "label": "MI",
                    "value": 23,
                    "title": "Michigan"
                },
                {
                    "label": "MN",
                    "value": 24,
                    "title": "Minnesota"
                },
                {
                    "label": "MS",
                    "value": 25,
                    "title": "Mississippi"
                },
                {
                    "label": "MO",
                    "value": 26,
                    "title": "Missouri"
                },
                {
                    "label": "MT",
                    "value": 27,
                    "title": "Montana"
                },
                {
                    "label": "NE",
                    "value": 28,
                    "title": "Nebraska"
                },
                {
                    "label": "NV",
                    "value": 29,
                    "title": "Nevada"
                },
                {
                    "label": "NH",
                    "value": 30,
                    "title": "New Hampshire"
                },
                {
                    "label": "NJ",
                    "value": 31,
                    "title": "New Jersey"
                },
                {
                    "label": "NM",
                    "value": 32,
                    "title": "New Mexico"
                },
                {
                    "label": "NY",
                    "value": 33,
                    "title": "New York"
                },
                {
                    "label": "NC",
                    "value": 34,
                    "title": "North Carolina"
                },
                {
                    "label": "ND",
                    "value": 35,
                    "title": "North Dakota"
                },
                {
                    "label": "OH",
                    "value": 36,
                    "title": "Ohio"
                },
                {
                    "label": "OK",
                    "value": 37,
                    "title": "Oklahoma"
                },
                {
                    "label": "OR",
                    "value": 38,
                    "title": "Oregon"
                },
                {
                    "label": "PA",
                    "value": 39,
                    "title": "Pennsylvania"
                },
                {
                    "label": "RI",
                    "value": 40,
                    "title": "Rhode Island"
                },
                {
                    "label": "SC",
                    "value": 41,
                    "title": "South Carolina"
                },
                {
                    "label": "SD",
                    "value": 42,
                    "title": "South Dakota"
                },
                {
                    "label": "TN",
                    "value": 43,
                    "title": "Tennessee"
                },
                {
                    "label": "TX",
                    "value": 44,
                    "title": "Texas"
                },
                {
                    "label": "UT",
                    "value": 45,
                    "title": "Utah"
                },
                {
                    "label": "VT",
                    "value": 46,
                    "title": "Vermont"
                },
                {
                    "label": "VA",
                    "value": 47,
                    "title": "Virginia"
                },
                {
                    "label": "WA",
                    "value": 48,
                    "title": "Washington"
                },
                {
                    "label": "WV",
                    "value": 49,
                    "title": "West Virginia"
                },
                {
                    "label": "WI",
                    "value": 50,
                    "title": "Wisconsin"
                },
                {
                    "label": "WY",
                    "value": 51,
                    "title": "Wyoming"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q3"
        },
        {
            "vgroup": "DIVISION",
            "qtitle": "DIVISION",
            "colTitle": null,
            "title": "DIVISION",
            "rowTitle": null,
            "label": "DIVISION",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "New England"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Mid-Atlantic"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "East North Central"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "West North Central"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "South Atlantic"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "East South Central"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "West South Central"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "Mountain"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Pacific"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "DIVISION"
        },
        {
            "vgroup": "HQREGION",
            "qtitle": "REGION",
            "colTitle": null,
            "title": "REGION",
            "rowTitle": null,
            "label": "HQREGION",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Northeast"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Midwest"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "South"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "West"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "NONE OF THESE"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "HQREGION"
        },
        {
            "vgroup": "Q4",
            "qtitle": "Which of the following best describes your racial and ethnic heritage?",
            "colTitle": null,
            "title": "Which of the following best describes your racial and ethnic heritage?",
            "rowTitle": null,
            "label": "Q4",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "American Indian or Alaskan Native"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Asian"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Black or African American"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Hispanic or Latino"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "Middle Eastern or North African"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Native Hawaiian or Pacific Islander"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "White"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "Some other race"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q4"
        },
        {
            "vgroup": "Q5",
            "qtitle": "What is the highest level of education you have completed?",
            "colTitle": null,
            "title": "What is the highest level of education you have completed?",
            "rowTitle": null,
            "label": "Q5",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Did not graduate from high school"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "High school diploma or GED equivalent"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Some college or a two-year associates degree"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Four-year college degree"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "Two-year master's degree"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Doctoral degree"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q5"
        },
        {
            "vgroup": "Q6",
            "qtitle": "Which of the following ranges includes your household's TOTAL annual income?",
            "colTitle": null,
            "title": "Which of the following ranges includes your household's TOTAL annual income?",
            "rowTitle": null,
            "label": "Q6",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Less than $25,000"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "$25,000 - $49,999"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "$50,000 - $74,999"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "$75,000 - $99,999"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "$100,000 - $149,999"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "$150,000 - $199,999"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "$200,000 - $299,999"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "$300,000 - $399,999"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "$400,000 or more"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q6"
        },
        {
            "vgroup": "Q7",
            "qtitle": "Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
            "colTitle": null,
            "title": "The economy and job creation - Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
            "rowTitle": "The economy and job creation",
            "label": "Q7r1",
            "value": 1,
            "row": "r1",
            "type": "multiple",
            "col": null,
            "qlabel": "Q7"
        },
        {
            "vgroup": "Q7",
            "qtitle": "Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
            "colTitle": null,
            "title": "National defense and security - Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
            "rowTitle": "National defense and security",
            "label": "Q7r2",
            "value": 1,
            "row": "r2",
            "type": "multiple",
            "col": null,
            "qlabel": "Q7"
        },
        {
            "vgroup": "Q7",
            "qtitle": "Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
            "colTitle": null,
            "title": "Energy availability and reliability - Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
            "rowTitle": "Energy availability and reliability",
            "label": "Q7r3",
            "value": 1,
            "row": "r3",
            "type": "multiple",
            "col": null,
            "qlabel": "Q7"
        },
        {
            "vgroup": "Q7",
            "qtitle": "Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
            "colTitle": null,
            "title": "Increase use of clean energy - Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
            "rowTitle": "Increase use of clean energy",
            "label": "Q7r4",
            "value": 1,
            "row": "r4",
            "type": "multiple",
            "col": null,
            "qlabel": "Q7"
        },
        {
            "vgroup": "Q7",
            "qtitle": "Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
            "colTitle": null,
            "title": "Education and workforce development - Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
            "rowTitle": "Education and workforce development",
            "label": "Q7r5",
            "value": 1,
            "row": "r5",
            "type": "multiple",
            "col": null,
            "qlabel": "Q7"
        },
        {
            "vgroup": "Q7",
            "qtitle": "Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
            "colTitle": null,
            "title": "Cost of living / inflation - Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
            "rowTitle": "Cost of living / inflation",
            "label": "Q7r6",
            "value": 1,
            "row": "r6",
            "type": "multiple",
            "col": null,
            "qlabel": "Q7"
        },
        {
            "vgroup": "Q7",
            "qtitle": "Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
            "colTitle": null,
            "title": "Technological leadership and competitiveness - Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
            "rowTitle": "Technological leadership and competitiveness",
            "label": "Q7r7",
            "value": 1,
            "row": "r7",
            "type": "multiple",
            "col": null,
            "qlabel": "Q7"
        },
        {
            "vgroup": "Q7",
            "qtitle": "Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
            "colTitle": null,
            "title": "Infrastructure - Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
            "rowTitle": "Infrastructure",
            "label": "Q7r8",
            "value": 1,
            "row": "r8",
            "type": "multiple",
            "col": null,
            "qlabel": "Q7"
        },
        {
            "vgroup": "Q8",
            "qtitle": "Thinking about the past year, how has what you pay for each of the following changed, if at all?",
            "colTitle": null,
            "title": "Electricity bills - Thinking about the past year, how has what you pay for each of the following changed, if at all?",
            "rowTitle": "Electricity bills",
            "label": "Q8r1",
            "values": [
                {
                    "label": "c1",
                    "value": 1,
                    "title": "Increased a lot"
                },
                {
                    "label": "c2",
                    "value": 2,
                    "title": "Increased somewhat"
                },
                {
                    "label": "c3",
                    "value": 3,
                    "title": "Stayed about the same"
                },
                {
                    "label": "c4",
                    "value": 4,
                    "title": "Decreased somewhat"
                },
                {
                    "label": "c5",
                    "value": 5,
                    "title": "Decreased a lot"
                },
                {
                    "label": "c6",
                    "value": 6,
                    "title": "Not sure"
                }
            ],
            "row": "r1",
            "type": "single",
            "col": null,
            "qlabel": "Q8"
        },
        {
            "vgroup": "Q8",
            "qtitle": "Thinking about the past year, how has what you pay for each of the following changed, if at all?",
            "colTitle": null,
            "title": "Gas prices at the pump - Thinking about the past year, how has what you pay for each of the following changed, if at all?",
            "rowTitle": "Gas prices at the pump",
            "label": "Q8r2",
            "values": [
                {
                    "label": "c1",
                    "value": 1,
                    "title": "Increased a lot"
                },
                {
                    "label": "c2",
                    "value": 2,
                    "title": "Increased somewhat"
                },
                {
                    "label": "c3",
                    "value": 3,
                    "title": "Stayed about the same"
                },
                {
                    "label": "c4",
                    "value": 4,
                    "title": "Decreased somewhat"
                },
                {
                    "label": "c5",
                    "value": 5,
                    "title": "Decreased a lot"
                },
                {
                    "label": "c6",
                    "value": 6,
                    "title": "Not sure"
                }
            ],
            "row": "r2",
            "type": "single",
            "col": null,
            "qlabel": "Q8"
        },
        {
            "vgroup": "Q8",
            "qtitle": "Thinking about the past year, how has what you pay for each of the following changed, if at all?",
            "colTitle": null,
            "title": "Groceries - Thinking about the past year, how has what you pay for each of the following changed, if at all?",
            "rowTitle": "Groceries",
            "label": "Q8r3",
            "values": [
                {
                    "label": "c1",
                    "value": 1,
                    "title": "Increased a lot"
                },
                {
                    "label": "c2",
                    "value": 2,
                    "title": "Increased somewhat"
                },
                {
                    "label": "c3",
                    "value": 3,
                    "title": "Stayed about the same"
                },
                {
                    "label": "c4",
                    "value": 4,
                    "title": "Decreased somewhat"
                },
                {
                    "label": "c5",
                    "value": 5,
                    "title": "Decreased a lot"
                },
                {
                    "label": "c6",
                    "value": 6,
                    "title": "Not sure"
                }
            ],
            "row": "r3",
            "type": "single",
            "col": null,
            "qlabel": "Q8"
        },
        {
            "vgroup": "Q8",
            "qtitle": "Thinking about the past year, how has what you pay for each of the following changed, if at all?",
            "colTitle": null,
            "title": "Rent or mortgage - Thinking about the past year, how has what you pay for each of the following changed, if at all?",
            "rowTitle": "Rent or mortgage",
            "label": "Q8r4",
            "values": [
                {
                    "label": "c1",
                    "value": 1,
                    "title": "Increased a lot"
                },
                {
                    "label": "c2",
                    "value": 2,
                    "title": "Increased somewhat"
                },
                {
                    "label": "c3",
                    "value": 3,
                    "title": "Stayed about the same"
                },
                {
                    "label": "c4",
                    "value": 4,
                    "title": "Decreased somewhat"
                },
                {
                    "label": "c5",
                    "value": 5,
                    "title": "Decreased a lot"
                },
                {
                    "label": "c6",
                    "value": 6,
                    "title": "Not sure"
                }
            ],
            "row": "r4",
            "type": "single",
            "col": null,
            "qlabel": "Q8"
        },
        {
            "vgroup": "Q8",
            "qtitle": "Thinking about the past year, how has what you pay for each of the following changed, if at all?",
            "colTitle": null,
            "title": "Prescription drugs - Thinking about the past year, how has what you pay for each of the following changed, if at all?",
            "rowTitle": "Prescription drugs",
            "label": "Q8r5",
            "values": [
                {
                    "label": "c1",
                    "value": 1,
                    "title": "Increased a lot"
                },
                {
                    "label": "c2",
                    "value": 2,
                    "title": "Increased somewhat"
                },
                {
                    "label": "c3",
                    "value": 3,
                    "title": "Stayed about the same"
                },
                {
                    "label": "c4",
                    "value": 4,
                    "title": "Decreased somewhat"
                },
                {
                    "label": "c5",
                    "value": 5,
                    "title": "Decreased a lot"
                },
                {
                    "label": "c6",
                    "value": 6,
                    "title": "Not sure"
                }
            ],
            "row": "r5",
            "type": "single",
            "col": null,
            "qlabel": "Q8"
        },
        {
            "vgroup": "Q8",
            "qtitle": "Thinking about the past year, how has what you pay for each of the following changed, if at all?",
            "colTitle": null,
            "title": "Internet and phone bills - Thinking about the past year, how has what you pay for each of the following changed, if at all?",
            "rowTitle": "Internet and phone bills",
            "label": "Q8r6",
            "values": [
                {
                    "label": "c1",
                    "value": 1,
                    "title": "Increased a lot"
                },
                {
                    "label": "c2",
                    "value": 2,
                    "title": "Increased somewhat"
                },
                {
                    "label": "c3",
                    "value": 3,
                    "title": "Stayed about the same"
                },
                {
                    "label": "c4",
                    "value": 4,
                    "title": "Decreased somewhat"
                },
                {
                    "label": "c5",
                    "value": 5,
                    "title": "Decreased a lot"
                },
                {
                    "label": "c6",
                    "value": 6,
                    "title": "Not sure"
                }
            ],
            "row": "r6",
            "type": "single",
            "col": null,
            "qlabel": "Q8"
        },
        {
            "vgroup": "Q9",
            "qtitle": "When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
            "colTitle": null,
            "title": "Rising fuel costs for oil and gas - When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
            "rowTitle": "Rising fuel costs for oil and gas",
            "label": "Q9r1",
            "values": [
                {
                    "label": "c1",
                    "value": 1,
                    "title": "A great deal"
                },
                {
                    "label": "c2",
                    "value": 2,
                    "title": "Quite a bit"
                },
                {
                    "label": "c3",
                    "value": 3,
                    "title": "Some"
                },
                {
                    "label": "c4",
                    "value": 4,
                    "title": "Very little"
                },
                {
                    "label": "c5",
                    "value": 5,
                    "title": "Not at all"
                }
            ],
            "row": "r1",
            "type": "single",
            "col": null,
            "qlabel": "Q9"
        },
        {
            "vgroup": "Q9",
            "qtitle": "When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
            "colTitle": null,
            "title": "The cost of building new renewable energy projects - When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
            "rowTitle": "The cost of building new renewable energy projects",
            "label": "Q9r2",
            "values": [
                {
                    "label": "c1",
                    "value": 1,
                    "title": "A great deal"
                },
                {
                    "label": "c2",
                    "value": 2,
                    "title": "Quite a bit"
                },
                {
                    "label": "c3",
                    "value": 3,
                    "title": "Some"
                },
                {
                    "label": "c4",
                    "value": 4,
                    "title": "Very little"
                },
                {
                    "label": "c5",
                    "value": 5,
                    "title": "Not at all"
                }
            ],
            "row": "r2",
            "type": "single",
            "col": null,
            "qlabel": "Q9"
        },
        {
            "vgroup": "Q9",
            "qtitle": "When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
            "colTitle": null,
            "title": "Upgrades to the electric grid and transmission lines - When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
            "rowTitle": "Upgrades to the electric grid and transmission lines",
            "label": "Q9r3",
            "values": [
                {
                    "label": "c1",
                    "value": 1,
                    "title": "A great deal"
                },
                {
                    "label": "c2",
                    "value": 2,
                    "title": "Quite a bit"
                },
                {
                    "label": "c3",
                    "value": 3,
                    "title": "Some"
                },
                {
                    "label": "c4",
                    "value": 4,
                    "title": "Very little"
                },
                {
                    "label": "c5",
                    "value": 5,
                    "title": "Not at all"
                }
            ],
            "row": "r3",
            "type": "single",
            "col": null,
            "qlabel": "Q9"
        },
        {
            "vgroup": "Q9",
            "qtitle": "When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
            "colTitle": null,
            "title": "Government regulations - When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
            "rowTitle": "Government regulations",
            "label": "Q9r4",
            "values": [
                {
                    "label": "c1",
                    "value": 1,
                    "title": "A great deal"
                },
                {
                    "label": "c2",
                    "value": 2,
                    "title": "Quite a bit"
                },
                {
                    "label": "c3",
                    "value": 3,
                    "title": "Some"
                },
                {
                    "label": "c4",
                    "value": 4,
                    "title": "Very little"
                },
                {
                    "label": "c5",
                    "value": 5,
                    "title": "Not at all"
                }
            ],
            "row": "r4",
            "type": "single",
            "col": null,
            "qlabel": "Q9"
        },
        {
            "vgroup": "Q9",
            "qtitle": "When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
            "colTitle": null,
            "title": "Utility company profits - When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
            "rowTitle": "Utility company profits",
            "label": "Q9r5",
            "values": [
                {
                    "label": "c1",
                    "value": 1,
                    "title": "A great deal"
                },
                {
                    "label": "c2",
                    "value": 2,
                    "title": "Quite a bit"
                },
                {
                    "label": "c3",
                    "value": 3,
                    "title": "Some"
                },
                {
                    "label": "c4",
                    "value": 4,
                    "title": "Very little"
                },
                {
                    "label": "c5",
                    "value": 5,
                    "title": "Not at all"
                }
            ],
            "row": "r5",
            "type": "single",
            "col": null,
            "qlabel": "Q9"
        },
        {
            "vgroup": "Q9",
            "qtitle": "When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
            "colTitle": null,
            "title": "Increased electricity demand from data centers - When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
            "rowTitle": "Increased electricity demand from data centers",
            "label": "Q9r6",
            "values": [
                {
                    "label": "c1",
                    "value": 1,
                    "title": "A great deal"
                },
                {
                    "label": "c2",
                    "value": 2,
                    "title": "Quite a bit"
                },
                {
                    "label": "c3",
                    "value": 3,
                    "title": "Some"
                },
                {
                    "label": "c4",
                    "value": 4,
                    "title": "Very little"
                },
                {
                    "label": "c5",
                    "value": 5,
                    "title": "Not at all"
                }
            ],
            "row": "r6",
            "type": "single",
            "col": null,
            "qlabel": "Q9"
        },
        {
            "vgroup": "Q10",
            "qtitle": "Which do you prioritize more when thinking about America's energy future?",
            "colTitle": null,
            "title": "Which do you prioritize more when thinking about America's energy future?",
            "rowTitle": null,
            "label": "Q10",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Economic growth"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Energy security"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Environmental protection"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Energy affordability"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "All equally"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q10"
        },
        {
            "vgroup": "Q11",
            "qtitle": "Which statement comes closest to your view of the U.S. renewable energy industry?",
            "colTitle": null,
            "title": "Which statement comes closest to your view of the U.S. renewable energy industry?",
            "rowTitle": null,
            "label": "Q11",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "It's an innovative industry that delivers affordable, reliable energy."
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "It's a promising industry but often over-promises and under-delivers."
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "It's an industry that depends too much on government subsidies."
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "It mostly benefits big companies more than consumers or communities."
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q11"
        },
        {
            "vgroup": "Q12",
            "qtitle": "Do you think a focus on growing renewable energy helps or hurts America's ability to compete globally?",
            "colTitle": null,
            "title": "Do you think a focus on growing renewable energy helps or hurts America's ability to compete globally?",
            "rowTitle": null,
            "label": "Q12",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Helps a lot"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Helps somewhat"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Hurts somewhat"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Hurts a lot"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q12"
        },
        {
            "vgroup": "Q13",
            "qtitle": "Thinking about the future of electricity demand in the U.S., which of the following do you think is most likely in the next 10 years?",
            "colTitle": null,
            "title": "Thinking about the future of electricity demand in the U.S., which of the following do you think is most likely in the next 10 years?",
            "rowTitle": null,
            "label": "Q13",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Electricity demand will be much higher than today"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Electricity demand will be somewhat higher than today"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Electricity demand will stay about the same as today"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Electricity demand will be somewhat lower than today"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "Electricity demand will be much lower than today"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Not sure"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q13"
        },
        {
            "vgroup": "Q14",
            "qtitle": "Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
            "colTitle": null,
            "title": "Solar - Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
            "rowTitle": "Solar",
            "label": "Q14r1",
            "row": "r1",
            "type": "number",
            "col": null,
            "qlabel": "Q14"
        },
        {
            "vgroup": "Q14",
            "qtitle": "Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
            "colTitle": null,
            "title": "Wind - Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
            "rowTitle": "Wind",
            "label": "Q14r2",
            "row": "r2",
            "type": "number",
            "col": null,
            "qlabel": "Q14"
        },
        {
            "vgroup": "Q14",
            "qtitle": "Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
            "colTitle": null,
            "title": "Natural gas - Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
            "rowTitle": "Natural gas",
            "label": "Q14r3",
            "row": "r3",
            "type": "number",
            "col": null,
            "qlabel": "Q14"
        },
        {
            "vgroup": "Q14",
            "qtitle": "Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
            "colTitle": null,
            "title": "Hydropower - Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
            "rowTitle": "Hydropower",
            "label": "Q14r4",
            "row": "r4",
            "type": "number",
            "col": null,
            "qlabel": "Q14"
        },
        {
            "vgroup": "Q14",
            "qtitle": "Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
            "colTitle": null,
            "title": "Nuclear - Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
            "rowTitle": "Nuclear",
            "label": "Q14r5",
            "row": "r5",
            "type": "number",
            "col": null,
            "qlabel": "Q14"
        },
        {
            "vgroup": "Q14",
            "qtitle": "Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
            "colTitle": null,
            "title": "Coal - Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
            "rowTitle": "Coal",
            "label": "Q14r6",
            "row": "r6",
            "type": "number",
            "col": null,
            "qlabel": "Q14"
        },
        {
            "vgroup": "Q14",
            "qtitle": "Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
            "colTitle": null,
            "title": "Biomass - Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
            "rowTitle": "Biomass",
            "label": "Q14r7",
            "row": "r7",
            "type": "number",
            "col": null,
            "qlabel": "Q14"
        },
        {
            "vgroup": "Q14",
            "qtitle": "Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
            "colTitle": null,
            "title": "Geothermal - Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
            "rowTitle": "Geothermal",
            "label": "Q14r8",
            "row": "r8",
            "type": "number",
            "col": null,
            "qlabel": "Q14"
        },
        {
            "vgroup": "Q14",
            "qtitle": "Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
            "colTitle": null,
            "title": "Petroleum - Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
            "rowTitle": "Petroleum",
            "label": "Q14r9",
            "row": "r9",
            "type": "number",
            "col": null,
            "qlabel": "Q14"
        },
        {
            "vgroup": "Q14",
            "qtitle": "Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
            "colTitle": null,
            "title": "Other - Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
            "rowTitle": "Other",
            "label": "Q14r10",
            "row": "r10",
            "type": "number",
            "col": null,
            "qlabel": "Q14"
        },
        {
            "vgroup": "Q15",
            "qtitle": "Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
            "colTitle": null,
            "title": "Clean energy - Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
            "rowTitle": "Clean energy",
            "label": "Q15r1",
            "values": [
                {
                    "label": "c1",
                    "value": 0,
                    "title": "0 - Extremely negative"
                },
                {
                    "label": "c2",
                    "value": 1,
                    "title": "1"
                },
                {
                    "label": "c3",
                    "value": 2,
                    "title": "2"
                },
                {
                    "label": "c4",
                    "value": 3,
                    "title": "3"
                },
                {
                    "label": "c5",
                    "value": 4,
                    "title": "4"
                },
                {
                    "label": "c6",
                    "value": 5,
                    "title": "5 - Neutral"
                },
                {
                    "label": "c7",
                    "value": 6,
                    "title": "6"
                },
                {
                    "label": "c8",
                    "value": 7,
                    "title": "7"
                },
                {
                    "label": "c9",
                    "value": 8,
                    "title": "8"
                },
                {
                    "label": "c10",
                    "value": 9,
                    "title": "9"
                },
                {
                    "label": "c11",
                    "value": 10,
                    "title": "10 - Extremely positive"
                }
            ],
            "row": "r1",
            "type": "single",
            "col": null,
            "qlabel": "Q15"
        },
        {
            "vgroup": "Q15",
            "qtitle": "Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
            "colTitle": null,
            "title": "Renewable energy - Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
            "rowTitle": "Renewable energy",
            "label": "Q15r2",
            "values": [
                {
                    "label": "c1",
                    "value": 0,
                    "title": "0 - Extremely negative"
                },
                {
                    "label": "c2",
                    "value": 1,
                    "title": "1"
                },
                {
                    "label": "c3",
                    "value": 2,
                    "title": "2"
                },
                {
                    "label": "c4",
                    "value": 3,
                    "title": "3"
                },
                {
                    "label": "c5",
                    "value": 4,
                    "title": "4"
                },
                {
                    "label": "c6",
                    "value": 5,
                    "title": "5 - Neutral"
                },
                {
                    "label": "c7",
                    "value": 6,
                    "title": "6"
                },
                {
                    "label": "c8",
                    "value": 7,
                    "title": "7"
                },
                {
                    "label": "c9",
                    "value": 8,
                    "title": "8"
                },
                {
                    "label": "c10",
                    "value": 9,
                    "title": "9"
                },
                {
                    "label": "c11",
                    "value": 10,
                    "title": "10 - Extremely positive"
                }
            ],
            "row": "r2",
            "type": "single",
            "col": null,
            "qlabel": "Q15"
        },
        {
            "vgroup": "Q15",
            "qtitle": "Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
            "colTitle": null,
            "title": "Sustainable energy - Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
            "rowTitle": "Sustainable energy",
            "label": "Q15r3",
            "values": [
                {
                    "label": "c1",
                    "value": 0,
                    "title": "0 - Extremely negative"
                },
                {
                    "label": "c2",
                    "value": 1,
                    "title": "1"
                },
                {
                    "label": "c3",
                    "value": 2,
                    "title": "2"
                },
                {
                    "label": "c4",
                    "value": 3,
                    "title": "3"
                },
                {
                    "label": "c5",
                    "value": 4,
                    "title": "4"
                },
                {
                    "label": "c6",
                    "value": 5,
                    "title": "5 - Neutral"
                },
                {
                    "label": "c7",
                    "value": 6,
                    "title": "6"
                },
                {
                    "label": "c8",
                    "value": 7,
                    "title": "7"
                },
                {
                    "label": "c9",
                    "value": 8,
                    "title": "8"
                },
                {
                    "label": "c10",
                    "value": 9,
                    "title": "9"
                },
                {
                    "label": "c11",
                    "value": 10,
                    "title": "10 - Extremely positive"
                }
            ],
            "row": "r3",
            "type": "single",
            "col": null,
            "qlabel": "Q15"
        },
        {
            "vgroup": "Q15",
            "qtitle": "Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
            "colTitle": null,
            "title": "21st Century energy - Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
            "rowTitle": "21st Century energy",
            "label": "Q15r4",
            "values": [
                {
                    "label": "c1",
                    "value": 0,
                    "title": "0 - Extremely negative"
                },
                {
                    "label": "c2",
                    "value": 1,
                    "title": "1"
                },
                {
                    "label": "c3",
                    "value": 2,
                    "title": "2"
                },
                {
                    "label": "c4",
                    "value": 3,
                    "title": "3"
                },
                {
                    "label": "c5",
                    "value": 4,
                    "title": "4"
                },
                {
                    "label": "c6",
                    "value": 5,
                    "title": "5 - Neutral"
                },
                {
                    "label": "c7",
                    "value": 6,
                    "title": "6"
                },
                {
                    "label": "c8",
                    "value": 7,
                    "title": "7"
                },
                {
                    "label": "c9",
                    "value": 8,
                    "title": "8"
                },
                {
                    "label": "c10",
                    "value": 9,
                    "title": "9"
                },
                {
                    "label": "c11",
                    "value": 10,
                    "title": "10 - Extremely positive"
                }
            ],
            "row": "r4",
            "type": "single",
            "col": null,
            "qlabel": "Q15"
        },
        {
            "vgroup": "Q15",
            "qtitle": "Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
            "colTitle": null,
            "title": "Next Generation energy - Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
            "rowTitle": "Next Generation energy",
            "label": "Q15r5",
            "values": [
                {
                    "label": "c1",
                    "value": 0,
                    "title": "0 - Extremely negative"
                },
                {
                    "label": "c2",
                    "value": 1,
                    "title": "1"
                },
                {
                    "label": "c3",
                    "value": 2,
                    "title": "2"
                },
                {
                    "label": "c4",
                    "value": 3,
                    "title": "3"
                },
                {
                    "label": "c5",
                    "value": 4,
                    "title": "4"
                },
                {
                    "label": "c6",
                    "value": 5,
                    "title": "5 - Neutral"
                },
                {
                    "label": "c7",
                    "value": 6,
                    "title": "6"
                },
                {
                    "label": "c8",
                    "value": 7,
                    "title": "7"
                },
                {
                    "label": "c9",
                    "value": 8,
                    "title": "8"
                },
                {
                    "label": "c10",
                    "value": 9,
                    "title": "9"
                },
                {
                    "label": "c11",
                    "value": 10,
                    "title": "10 - Extremely positive"
                }
            ],
            "row": "r5",
            "type": "single",
            "col": null,
            "qlabel": "Q15"
        },
        {
            "vgroup": "Q15",
            "qtitle": "Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
            "colTitle": null,
            "title": "Green energy - Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
            "rowTitle": "Green energy",
            "label": "Q15r6",
            "values": [
                {
                    "label": "c1",
                    "value": 0,
                    "title": "0 - Extremely negative"
                },
                {
                    "label": "c2",
                    "value": 1,
                    "title": "1"
                },
                {
                    "label": "c3",
                    "value": 2,
                    "title": "2"
                },
                {
                    "label": "c4",
                    "value": 3,
                    "title": "3"
                },
                {
                    "label": "c5",
                    "value": 4,
                    "title": "4"
                },
                {
                    "label": "c6",
                    "value": 5,
                    "title": "5 - Neutral"
                },
                {
                    "label": "c7",
                    "value": 6,
                    "title": "6"
                },
                {
                    "label": "c8",
                    "value": 7,
                    "title": "7"
                },
                {
                    "label": "c9",
                    "value": 8,
                    "title": "8"
                },
                {
                    "label": "c10",
                    "value": 9,
                    "title": "9"
                },
                {
                    "label": "c11",
                    "value": 10,
                    "title": "10 - Extremely positive"
                }
            ],
            "row": "r6",
            "type": "single",
            "col": null,
            "qlabel": "Q15"
        },
        {
            "vgroup": "Q15",
            "qtitle": "Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
            "colTitle": null,
            "title": "Alternative energy - Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
            "rowTitle": "Alternative energy",
            "label": "Q15r7",
            "values": [
                {
                    "label": "c1",
                    "value": 0,
                    "title": "0 - Extremely negative"
                },
                {
                    "label": "c2",
                    "value": 1,
                    "title": "1"
                },
                {
                    "label": "c3",
                    "value": 2,
                    "title": "2"
                },
                {
                    "label": "c4",
                    "value": 3,
                    "title": "3"
                },
                {
                    "label": "c5",
                    "value": 4,
                    "title": "4"
                },
                {
                    "label": "c6",
                    "value": 5,
                    "title": "5 - Neutral"
                },
                {
                    "label": "c7",
                    "value": 6,
                    "title": "6"
                },
                {
                    "label": "c8",
                    "value": 7,
                    "title": "7"
                },
                {
                    "label": "c9",
                    "value": 8,
                    "title": "8"
                },
                {
                    "label": "c10",
                    "value": 9,
                    "title": "9"
                },
                {
                    "label": "c11",
                    "value": 10,
                    "title": "10 - Extremely positive"
                }
            ],
            "row": "r7",
            "type": "single",
            "col": null,
            "qlabel": "Q15"
        },
        {
            "vgroup": "Q15",
            "qtitle": "Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
            "colTitle": null,
            "title": "Advanced energy - Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
            "rowTitle": "Advanced energy",
            "label": "Q15r8",
            "values": [
                {
                    "label": "c1",
                    "value": 0,
                    "title": "0 - Extremely negative"
                },
                {
                    "label": "c2",
                    "value": 1,
                    "title": "1"
                },
                {
                    "label": "c3",
                    "value": 2,
                    "title": "2"
                },
                {
                    "label": "c4",
                    "value": 3,
                    "title": "3"
                },
                {
                    "label": "c5",
                    "value": 4,
                    "title": "4"
                },
                {
                    "label": "c6",
                    "value": 5,
                    "title": "5 - Neutral"
                },
                {
                    "label": "c7",
                    "value": 6,
                    "title": "6"
                },
                {
                    "label": "c8",
                    "value": 7,
                    "title": "7"
                },
                {
                    "label": "c9",
                    "value": 8,
                    "title": "8"
                },
                {
                    "label": "c10",
                    "value": 9,
                    "title": "9"
                },
                {
                    "label": "c11",
                    "value": 10,
                    "title": "10 - Extremely positive"
                }
            ],
            "row": "r8",
            "type": "single",
            "col": null,
            "qlabel": "Q15"
        },
        {
            "vgroup": "Q15",
            "qtitle": "Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
            "colTitle": null,
            "title": "Future energy - Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
            "rowTitle": "Future energy",
            "label": "Q15r9",
            "values": [
                {
                    "label": "c1",
                    "value": 0,
                    "title": "0 - Extremely negative"
                },
                {
                    "label": "c2",
                    "value": 1,
                    "title": "1"
                },
                {
                    "label": "c3",
                    "value": 2,
                    "title": "2"
                },
                {
                    "label": "c4",
                    "value": 3,
                    "title": "3"
                },
                {
                    "label": "c5",
                    "value": 4,
                    "title": "4"
                },
                {
                    "label": "c6",
                    "value": 5,
                    "title": "5 - Neutral"
                },
                {
                    "label": "c7",
                    "value": 6,
                    "title": "6"
                },
                {
                    "label": "c8",
                    "value": 7,
                    "title": "7"
                },
                {
                    "label": "c9",
                    "value": 8,
                    "title": "8"
                },
                {
                    "label": "c10",
                    "value": 9,
                    "title": "9"
                },
                {
                    "label": "c11",
                    "value": 10,
                    "title": "10 - Extremely positive"
                }
            ],
            "row": "r9",
            "type": "single",
            "col": null,
            "qlabel": "Q15"
        },
        {
            "vgroup": "Q16",
            "qtitle": "Please read the below statements and select the one that comes the closest to your own opinion.",
            "colTitle": null,
            "title": "Please read the below statements and select the one that comes the closest to your own opinion.",
            "rowTitle": null,
            "label": "Q16",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "I believe fossil fuels should play the largest role in America's energy mix. Oil, natural gas, and coal remain the most proven sources of energy, and moving away from them would be a mistake."
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "I believe the U.S. is too reliant on fossil fuels. We should be moving more quickly toward renewable and cleaner energy sources."
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q16"
        },
        {
            "vgroup": "Q17",
            "qtitle": "Please read the below statements and select the one that comes the closest to your own opinion.",
            "colTitle": null,
            "title": "Please read the below statements and select the one that comes the closest to your own opinion.",
            "rowTitle": null,
            "label": "Q17",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Fossil fuels are the most affordable source of energy, and renewables are usually less affordable once you factor hidden costs, like infrastructure and storage."
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Renewable energy is becoming more affordable, but fossil fuels are still cheaper in many cases."
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Renewable energy is the lowest-cost option, cheaper than fossil fuels in many cases."
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q17"
        },
        {
            "vgroup": "Q18",
            "qtitle": "Please read the below statements and select the one that comes the closest to your own opinion.",
            "colTitle": null,
            "title": "Please read the below statements and select the one that comes the closest to your own opinion.",
            "rowTitle": null,
            "label": "Q18",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Fossil fuels are the most reliable sources of energy because the U.S. has vast reserves capable of sustaining growing energy demands."
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Renewable energy is the most reliable because it is abundant and inexhaustible. The sun and wind will never run out."
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A mix of fossil fuels, nuclear, and renewables is the best way to create the most dependable energy system."
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q18"
        },
        {
            "vgroup": "Q19",
            "qtitle": "Please read the below statements and select the one that comes the closest to your own opinion.",
            "colTitle": null,
            "title": "Please read the below statements and select the one that comes the closest to your own opinion.",
            "rowTitle": null,
            "label": "Q19",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Fossil fuel industries create better jobs. They're higher-paying, more stable, and longer-term than renewable energy jobs."
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Renewable energy jobs are surging, and the industry will employ more Americans in the future than fossil fuels."
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q19"
        },
        {
            "vgroup": "Q20",
            "qtitle": "Please read the below statements and select the one that comes the closest to your own opinion.",
            "colTitle": null,
            "title": "Please read the below statements and select the one that comes the closest to your own opinion.",
            "rowTitle": null,
            "label": "Q20",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Fossil fuels strengthen U.S. energy security since they are proven and available domestically."
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Renewable energy strengthens U.S. security by reducing dependence on foreign oil and gas."
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "True energy security requires a balanced mix because both renewables and fossil fuels have vulnerabilities."
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q20"
        },
        {
            "vgroup": "Q21comment",
            "qtitle": "HIDDEN: Comment pipe for Q21",
            "colTitle": null,
            "title": "HIDDEN: Comment pipe for Q21",
            "rowTitle": null,
            "label": "Q21comment",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Tap each option in order of trust. Start with the one you trust most and end with the one you trust least."
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": ""
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q21comment"
        },
        {
            "vgroup": "Q21",
            "qtitle": "Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
            "colTitle": null,
            "title": "Industry leaders - Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
            "rowTitle": "Industry leaders",
            "label": "Q21r1",
            "values": [
                {
                    "label": "ch1",
                    "value": 1,
                    "title": "Trust the most"
                },
                {
                    "label": "ch2",
                    "value": 2,
                    "title": ""
                },
                {
                    "label": "ch3",
                    "value": 3,
                    "title": ""
                },
                {
                    "label": "ch4",
                    "value": 4,
                    "title": ""
                },
                {
                    "label": "ch5",
                    "value": 5,
                    "title": ""
                },
                {
                    "label": "ch6",
                    "value": 6,
                    "title": ""
                },
                {
                    "label": "ch7",
                    "value": 7,
                    "title": "Trust the least"
                }
            ],
            "row": "r1",
            "type": "single",
            "col": null,
            "qlabel": "Q21"
        },
        {
            "vgroup": "Q21",
            "qtitle": "Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
            "colTitle": null,
            "title": "Government agencies - Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
            "rowTitle": "Government agencies",
            "label": "Q21r2",
            "values": [
                {
                    "label": "ch1",
                    "value": 1,
                    "title": "Trust the most"
                },
                {
                    "label": "ch2",
                    "value": 2,
                    "title": ""
                },
                {
                    "label": "ch3",
                    "value": 3,
                    "title": ""
                },
                {
                    "label": "ch4",
                    "value": 4,
                    "title": ""
                },
                {
                    "label": "ch5",
                    "value": 5,
                    "title": ""
                },
                {
                    "label": "ch6",
                    "value": 6,
                    "title": ""
                },
                {
                    "label": "ch7",
                    "value": 7,
                    "title": "Trust the least"
                }
            ],
            "row": "r2",
            "type": "single",
            "col": null,
            "qlabel": "Q21"
        },
        {
            "vgroup": "Q21",
            "qtitle": "Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
            "colTitle": null,
            "title": "Environmental groups - Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
            "rowTitle": "Environmental groups",
            "label": "Q21r3",
            "values": [
                {
                    "label": "ch1",
                    "value": 1,
                    "title": "Trust the most"
                },
                {
                    "label": "ch2",
                    "value": 2,
                    "title": ""
                },
                {
                    "label": "ch3",
                    "value": 3,
                    "title": ""
                },
                {
                    "label": "ch4",
                    "value": 4,
                    "title": ""
                },
                {
                    "label": "ch5",
                    "value": 5,
                    "title": ""
                },
                {
                    "label": "ch6",
                    "value": 6,
                    "title": ""
                },
                {
                    "label": "ch7",
                    "value": 7,
                    "title": "Trust the least"
                }
            ],
            "row": "r3",
            "type": "single",
            "col": null,
            "qlabel": "Q21"
        },
        {
            "vgroup": "Q21",
            "qtitle": "Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
            "colTitle": null,
            "title": "Academics and other technical experts - Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
            "rowTitle": "Academics and other technical experts",
            "label": "Q21r4",
            "values": [
                {
                    "label": "ch1",
                    "value": 1,
                    "title": "Trust the most"
                },
                {
                    "label": "ch2",
                    "value": 2,
                    "title": ""
                },
                {
                    "label": "ch3",
                    "value": 3,
                    "title": ""
                },
                {
                    "label": "ch4",
                    "value": 4,
                    "title": ""
                },
                {
                    "label": "ch5",
                    "value": 5,
                    "title": ""
                },
                {
                    "label": "ch6",
                    "value": 6,
                    "title": ""
                },
                {
                    "label": "ch7",
                    "value": 7,
                    "title": "Trust the least"
                }
            ],
            "row": "r4",
            "type": "single",
            "col": null,
            "qlabel": "Q21"
        },
        {
            "vgroup": "Q21",
            "qtitle": "Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
            "colTitle": null,
            "title": "Local community members - Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
            "rowTitle": "Local community members",
            "label": "Q21r5",
            "values": [
                {
                    "label": "ch1",
                    "value": 1,
                    "title": "Trust the most"
                },
                {
                    "label": "ch2",
                    "value": 2,
                    "title": ""
                },
                {
                    "label": "ch3",
                    "value": 3,
                    "title": ""
                },
                {
                    "label": "ch4",
                    "value": 4,
                    "title": ""
                },
                {
                    "label": "ch5",
                    "value": 5,
                    "title": ""
                },
                {
                    "label": "ch6",
                    "value": 6,
                    "title": ""
                },
                {
                    "label": "ch7",
                    "value": 7,
                    "title": "Trust the least"
                }
            ],
            "row": "r5",
            "type": "single",
            "col": null,
            "qlabel": "Q21"
        },
        {
            "vgroup": "Q21",
            "qtitle": "Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
            "colTitle": null,
            "title": "Energy workers - Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
            "rowTitle": "Energy workers",
            "label": "Q21r6",
            "values": [
                {
                    "label": "ch1",
                    "value": 1,
                    "title": "Trust the most"
                },
                {
                    "label": "ch2",
                    "value": 2,
                    "title": ""
                },
                {
                    "label": "ch3",
                    "value": 3,
                    "title": ""
                },
                {
                    "label": "ch4",
                    "value": 4,
                    "title": ""
                },
                {
                    "label": "ch5",
                    "value": 5,
                    "title": ""
                },
                {
                    "label": "ch6",
                    "value": 6,
                    "title": ""
                },
                {
                    "label": "ch7",
                    "value": 7,
                    "title": "Trust the least"
                }
            ],
            "row": "r6",
            "type": "single",
            "col": null,
            "qlabel": "Q21"
        },
        {
            "vgroup": "Q21",
            "qtitle": "Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
            "colTitle": null,
            "title": "National and local energy media - Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
            "rowTitle": "National and local energy media",
            "label": "Q21r7",
            "values": [
                {
                    "label": "ch1",
                    "value": 1,
                    "title": "Trust the most"
                },
                {
                    "label": "ch2",
                    "value": 2,
                    "title": ""
                },
                {
                    "label": "ch3",
                    "value": 3,
                    "title": ""
                },
                {
                    "label": "ch4",
                    "value": 4,
                    "title": ""
                },
                {
                    "label": "ch5",
                    "value": 5,
                    "title": ""
                },
                {
                    "label": "ch6",
                    "value": 6,
                    "title": ""
                },
                {
                    "label": "ch7",
                    "value": 7,
                    "title": "Trust the least"
                }
            ],
            "row": "r7",
            "type": "single",
            "col": null,
            "qlabel": "Q21"
        },
        {
            "vgroup": "Q22",
            "qtitle": "Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is most convincing to you and the ONE that is least convincing.",
            "colTitle": "Most convincing",
            "title": "Most convincing - Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is most convincing to you and the ONE that is least convincing.",
            "rowTitle": null,
            "label": "Q22c1",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "row": null,
            "type": "single",
            "col": "c1",
            "qlabel": "Q22"
        },
        {
            "vgroup": "Q22",
            "qtitle": "Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is most convincing to you and the ONE that is least convincing.",
            "colTitle": "Least convincing",
            "title": "Least convincing - Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is most convincing to you and the ONE that is least convincing.",
            "rowTitle": null,
            "label": "Q22c2",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "row": null,
            "type": "single",
            "col": "c2",
            "qlabel": "Q22"
        },
        {
            "vgroup": "Q22_score",
            "qtitle": "MaxDiff Score (0-100 scale)",
            "colTitle": null,
            "title": "Creates good-paying jobs, and strengthens America’s economy - MaxDiff Score (0-100 scale)",
            "rowTitle": "Creates good-paying jobs, and strengthens America’s economy",
            "label": "Q22_scorer1",
            "row": "r1",
            "type": "float",
            "col": null,
            "qlabel": "Q22_score"
        },
        {
            "vgroup": "Q22_score",
            "qtitle": "MaxDiff Score (0-100 scale)",
            "colTitle": null,
            "title": "Homegrown power that frees us from dependence on foreign countries - MaxDiff Score (0-100 scale)",
            "rowTitle": "Homegrown power that frees us from dependence on foreign countries",
            "label": "Q22_scorer2",
            "row": "r2",
            "type": "float",
            "col": null,
            "qlabel": "Q22_score"
        },
        {
            "vgroup": "Q22_score",
            "qtitle": "MaxDiff Score (0-100 scale)",
            "colTitle": null,
            "title": "A dependable and predictable source of power that will always be available when we need it - MaxDiff Score (0-100 scale)",
            "rowTitle": "A dependable and predictable source of power that will always be available when we need it",
            "label": "Q22_scorer3",
            "row": "r3",
            "type": "float",
            "col": null,
            "qlabel": "Q22_score"
        },
        {
            "vgroup": "Q22_score",
            "qtitle": "MaxDiff Score (0-100 scale)",
            "colTitle": null,
            "title": "Healthy energy that reduces air pollution and makes our communities safer to live in - MaxDiff Score (0-100 scale)",
            "rowTitle": "Healthy energy that reduces air pollution and makes our communities safer to live in",
            "label": "Q22_scorer4",
            "row": "r4",
            "type": "float",
            "col": null,
            "qlabel": "Q22_score"
        },
        {
            "vgroup": "Q22_score",
            "qtitle": "MaxDiff Score (0-100 scale)",
            "colTitle": null,
            "title": "A critical part of reducing greenhouse gas emissions and combating climate change - MaxDiff Score (0-100 scale)",
            "rowTitle": "A critical part of reducing greenhouse gas emissions and combating climate change",
            "label": "Q22_scorer5",
            "row": "r5",
            "type": "float",
            "col": null,
            "qlabel": "Q22_score"
        },
        {
            "vgroup": "Q22_score",
            "qtitle": "MaxDiff Score (0-100 scale)",
            "colTitle": null,
            "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes - MaxDiff Score (0-100 scale)",
            "rowTitle": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes",
            "label": "Q22_scorer6",
            "row": "r6",
            "type": "float",
            "col": null,
            "qlabel": "Q22_score"
        },
        {
            "vgroup": "Q22_score",
            "qtitle": "MaxDiff Score (0-100 scale)",
            "colTitle": null,
            "title": "A critical energy source for America to lead in the global technology and manufacturing race - MaxDiff Score (0-100 scale)",
            "rowTitle": "A critical energy source for America to lead in the global technology and manufacturing race",
            "label": "Q22_scorer7",
            "row": "r7",
            "type": "float",
            "col": null,
            "qlabel": "Q22_score"
        },
        {
            "vgroup": "Q22_score",
            "qtitle": "MaxDiff Score (0-100 scale)",
            "colTitle": null,
            "title": "The power source that can fuel America’s growth in AI - MaxDiff Score (0-100 scale)",
            "rowTitle": "The power source that can fuel America’s growth in AI",
            "label": "Q22_scorer8",
            "row": "r8",
            "type": "float",
            "col": null,
            "qlabel": "Q22_score"
        },
        {
            "vgroup": "Q22_score",
            "qtitle": "MaxDiff Score (0-100 scale)",
            "colTitle": null,
            "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out - MaxDiff Score (0-100 scale)",
            "rowTitle": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out",
            "label": "Q22_scorer9",
            "row": "r9",
            "type": "float",
            "col": null,
            "qlabel": "Q22_score"
        },
        {
            "vgroup": "Q22_version",
            "qtitle": "Version Selected",
            "colTitle": null,
            "title": "Version Selected",
            "rowTitle": null,
            "label": "Q22_version",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Version 1: 1 2 7 8; 2 8 1 4; 5 1 9 6; 9 3 4 1; 7 5 2 3; 3 9 8 6; 6 7 5 2; 8 4 3 5; 4 6 7 9"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Version 2: 5 2 6 4; 2 5 8 9; 6 8 4 1; 3 1 5 7; 1 4 8 5; 8 7 2 9; 7 6 3 4; 9 3 1 7; 2 9 6 3"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Version 3: 6 1 7 8; 8 6 5 3; 4 5 9 2; 3 7 4 2; 5 3 6 1; 1 2 9 6; 1 8 2 3; 9 4 8 7; 4 9 7 5"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Version 4: 7 9 1 5; 6 7 5 8; 4 6 1 2; 2 4 3 1; 3 2 6 7; 5 1 4 9; 8 5 9 3; 9 8 2 6; 7 3 8 4"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "Version 5: 2 7 9 4; 4 2 3 6; 3 9 2 5; 1 2 5 8; 7 6 1 9; 5 3 7 1; 6 8 4 5; 8 1 3 9; 8 4 6 7"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Version 6: 3 5 7 2; 5 1 4 6; 9 4 1 2; 7 9 5 8; 6 3 9 4; 9 6 3 8; 4 8 2 3; 5 7 6 1; 1 8 2 7"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "Version 7: 2 9 7 6; 9 7 8 3; 8 5 9 4; 4 3 8 1; 1 5 6 2; 3 4 5 7; 6 1 2 3; 7 1 4 9; 2 6 8 5"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "Version 8: 4 3 1 5; 7 2 4 8; 1 7 9 8; 2 4 5 9; 6 8 7 1; 5 9 3 6; 2 6 7 4; 9 3 6 1; 3 2 5 8"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Version 9: 8 3 1 7; 1 7 3 4; 4 5 6 7; 9 5 1 2; 6 4 2 5; 8 2 9 1; 3 8 6 9; 9 6 8 4; 5 7 3 2"
                },
                {
                    "label": "r10",
                    "value": 10,
                    "title": "Version 10: 7 8 4 5; 8 2 4 6; 8 9 2 3; 6 9 7 2; 5 4 3 9; 5 1 9 7; 2 4 1 3; 3 6 7 1; 1 5 8 6"
                },
                {
                    "label": "r11",
                    "value": 11,
                    "title": "Version 11: 7 1 4 2; 2 7 5 8; 4 8 3 9; 1 2 9 6; 6 9 1 4; 1 5 4 8; 8 3 5 6; 7 6 2 3; 3 7 9 5"
                },
                {
                    "label": "r12",
                    "value": 12,
                    "title": "Version 12: 4 1 3 7; 9 1 2 5; 5 6 8 2; 3 5 1 8; 2 8 3 1; 7 4 6 8; 9 5 7 6; 6 3 4 9; 4 9 2 7"
                },
                {
                    "label": "r13",
                    "value": 13,
                    "title": "Version 13: 4 2 5 3; 1 9 8 4; 2 8 7 3; 3 1 6 2; 6 3 4 7; 9 6 1 7; 7 8 5 9; 5 4 9 2; 8 1 6 5"
                },
                {
                    "label": "r14",
                    "value": 14,
                    "title": "Version 14: 7 2 8 9; 9 2 8 3; 1 3 9 4; 3 7 6 5; 5 9 3 6; 8 6 4 1; 4 5 1 7; 2 7 5 1; 6 4 2 8"
                },
                {
                    "label": "r15",
                    "value": 15,
                    "title": "Version 15: 2 6 7 4; 7 8 6 3; 3 1 9 5; 5 4 8 6; 4 5 3 9; 3 2 5 4; 8 7 1 2; 6 9 2 1; 9 1 7 8"
                },
                {
                    "label": "r16",
                    "value": 16,
                    "title": "Version 16: 1 2 4 7; 2 3 6 9; 1 6 2 3; 6 4 1 5; 4 9 7 8; 8 5 6 1; 5 7 9 2; 9 3 8 4; 7 3 5 8"
                },
                {
                    "label": "r17",
                    "value": 17,
                    "title": "Version 17: 5 1 3 7; 2 8 5 6; 7 5 4 6; 1 7 6 9; 6 9 7 3; 9 4 1 8; 8 3 2 4; 4 2 9 5; 3 8 1 2"
                },
                {
                    "label": "r18",
                    "value": 18,
                    "title": "Version 18: 5 4 3 1; 3 1 4 7; 4 6 8 9; 7 8 2 1; 1 6 3 2; 2 9 5 8; 8 5 9 6; 6 7 3 4; 9 2 7 5"
                },
                {
                    "label": "r19",
                    "value": 19,
                    "title": "Version 19: 5 7 8 3; 6 5 4 1; 1 4 8 2; 2 3 9 4; 9 1 5 3; 3 6 7 8; 8 9 1 6; 7 5 2 9; 4 2 6 7"
                },
                {
                    "label": "r20",
                    "value": 20,
                    "title": "Version 20: 3 8 2 5; 5 2 6 1; 8 6 3 4; 1 3 7 9; 2 9 6 3; 6 4 9 2; 7 8 5 1; 4 1 9 7; 7 8 4 5"
                },
                {
                    "label": "r21",
                    "value": 21,
                    "title": "Version 21: 8 4 1 2; 2 1 5 3; 4 5 3 6; 9 7 8 6; 2 9 8 7; 5 6 1 9; 6 7 4 5; 9 3 8 4; 1 2 7 3"
                },
                {
                    "label": "r22",
                    "value": 22,
                    "title": "Version 22: 3 6 4 7; 6 5 2 8; 8 7 6 1; 5 2 9 4; 9 3 1 6; 1 4 2 7; 2 8 3 9; 4 1 5 8; 7 3 9 5"
                },
                {
                    "label": "r23",
                    "value": 23,
                    "title": "Version 23: 3 9 8 1; 6 1 3 2; 5 6 7 2; 1 5 4 9; 9 2 6 4; 8 9 7 6; 7 1 2 4; 3 7 5 8; 4 8 3 5"
                },
                {
                    "label": "r24",
                    "value": 24,
                    "title": "Version 24: 9 6 7 3; 6 3 1 8; 7 4 2 3; 2 4 9 5; 8 5 6 2; 1 9 5 6; 3 7 8 4; 5 2 1 7; 4 8 9 1"
                },
                {
                    "label": "r25",
                    "value": 25,
                    "title": "Version 25: 8 1 4 6; 5 4 7 9; 6 9 1 7; 3 8 5 2; 9 2 7 8; 1 3 6 5; 7 5 2 1; 4 6 3 2; 4 9 8 3"
                },
                {
                    "label": "r26",
                    "value": 26,
                    "title": "Version 26: 2 7 1 8; 5 2 6 9; 9 5 3 1; 3 7 4 5; 6 4 8 7; 7 6 5 8; 8 1 2 9; 2 3 4 6; 1 9 3 4"
                },
                {
                    "label": "r27",
                    "value": 27,
                    "title": "Version 27: 5 8 4 1; 8 4 9 2; 9 5 8 6; 6 2 1 3; 3 7 5 4; 1 4 7 6; 2 3 9 7; 8 1 2 3; 7 6 5 9"
                },
                {
                    "label": "r28",
                    "value": 28,
                    "title": "Version 28: 3 8 6 2; 4 1 2 5; 6 8 1 7; 7 3 6 9; 5 7 3 8; 4 2 6 5; 2 9 7 1; 9 4 8 3; 1 9 4 5"
                },
                {
                    "label": "r29",
                    "value": 29,
                    "title": "Version 29: 6 5 9 8; 1 3 2 4; 9 2 5 3; 5 8 1 3; 4 6 9 1; 2 6 4 7; 8 7 9 4; 3 1 7 6; 7 5 8 2"
                },
                {
                    "label": "r30",
                    "value": 30,
                    "title": "Version 30: 7 5 3 9; 3 2 5 6; 6 4 2 8; 2 7 3 9; 5 6 8 1; 4 8 7 1; 1 9 8 2; 9 1 4 7; 5 3 6 4"
                },
                {
                    "label": "r31",
                    "value": 31,
                    "title": "Version 31: 9 3 1 5; 1 4 3 6; 4 6 7 2; 8 6 9 3; 2 8 4 5; 6 2 7 9; 7 3 1 8; 8 9 5 4; 5 7 2 1"
                },
                {
                    "label": "r32",
                    "value": 32,
                    "title": "Version 32: 8 1 6 5; 9 8 6 7; 1 5 9 6; 3 9 1 2; 2 6 3 4; 7 2 8 3; 4 9 2 8; 1 7 5 4; 3 4 5 7"
                },
                {
                    "label": "r33",
                    "value": 33,
                    "title": "Version 33: 2 1 4 9; 4 5 8 3; 6 5 9 3; 5 1 2 7; 6 4 1 8; 9 2 7 5; 3 8 2 1; 4 7 6 9; 7 3 8 6"
                },
                {
                    "label": "r34",
                    "value": 34,
                    "title": "Version 34: 6 1 9 2; 7 4 3 5; 8 9 4 7; 5 3 1 8; 3 2 4 9; 9 7 3 1; 1 6 7 4; 8 5 6 2; 2 8 5 6"
                },
                {
                    "label": "r35",
                    "value": 35,
                    "title": "Version 35: 3 1 7 2; 1 8 9 5; 7 9 2 6; 5 3 6 9; 6 7 8 1; 8 2 3 4; 9 5 4 8; 4 2 5 7; 4 6 1 3"
                },
                {
                    "label": "r36",
                    "value": 36,
                    "title": "Version 36: 5 4 7 6; 3 4 1 9; 2 3 8 7; 1 7 9 5; 6 5 2 3; 8 6 4 9; 7 8 2 1; 2 1 5 4; 9 3 6 8"
                },
                {
                    "label": "r37",
                    "value": 37,
                    "title": "Version 37: 4 9 5 2; 1 4 3 6; 6 2 8 7; 9 1 7 3; 5 7 3 4; 8 3 7 5; 6 8 1 5; 2 9 4 8; 1 6 9 2"
                },
                {
                    "label": "r38",
                    "value": 38,
                    "title": "Version 38: 2 8 4 1; 7 5 1 4; 3 7 8 9; 7 2 6 5; 5 1 9 8; 4 8 6 3; 9 6 4 7; 3 5 2 6; 2 9 3 1"
                },
                {
                    "label": "r39",
                    "value": 39,
                    "title": "Version 39: 9 4 5 3; 3 6 1 7; 8 7 9 2; 5 9 6 2; 8 5 7 6; 3 4 8 7; 4 1 2 6; 1 2 9 4; 5 3 1 8"
                },
                {
                    "label": "r40",
                    "value": 40,
                    "title": "Version 40: 6 2 3 9; 7 3 2 1; 2 1 5 8; 9 5 7 4; 4 8 6 5; 8 4 3 2; 6 9 5 3; 7 6 4 1; 1 7 8 9"
                },
                {
                    "label": "r41",
                    "value": 41,
                    "title": "Version 41: 1 6 4 8; 5 1 2 3; 6 5 1 9; 4 8 9 3; 8 2 9 7; 9 4 6 7; 7 5 4 2; 8 3 5 1; 3 7 2 6"
                },
                {
                    "label": "r42",
                    "value": 42,
                    "title": "Version 42: 2 9 5 4; 1 9 3 6; 9 7 8 1; 6 2 3 4; 3 4 7 5; 4 1 8 6; 2 6 7 8; 7 3 9 5; 5 8 1 2"
                },
                {
                    "label": "r43",
                    "value": 43,
                    "title": "Version 43: 8 2 6 3; 3 1 7 4; 2 1 6 9; 9 8 3 7; 6 9 2 5; 1 7 4 2; 7 5 1 6; 4 3 8 5; 5 4 8 9"
                },
                {
                    "label": "r44",
                    "value": 44,
                    "title": "Version 44: 3 6 9 8; 6 7 5 1; 5 3 2 4; 1 9 3 4; 9 2 7 3; 4 5 1 6; 2 8 1 9; 8 6 4 7; 8 7 5 2"
                },
                {
                    "label": "r45",
                    "value": 45,
                    "title": "Version 45: 7 5 6 3; 2 4 7 1; 4 2 9 7; 1 9 5 8; 5 3 6 9; 6 4 3 1; 9 7 4 8; 3 1 2 8; 5 8 6 2"
                },
                {
                    "label": "r46",
                    "value": 46,
                    "title": "Version 46: 7 1 2 3; 1 9 4 5; 2 4 8 5; 8 6 1 9; 3 5 7 2; 6 3 8 4; 7 8 3 6; 9 7 5 1; 4 6 2 9"
                },
                {
                    "label": "r47",
                    "value": 47,
                    "title": "Version 47: 8 6 9 7; 3 2 8 1; 7 2 6 5; 5 3 9 4; 4 8 7 3; 1 5 7 8; 2 4 5 6; 9 1 3 2; 6 4 1 9"
                },
                {
                    "label": "r48",
                    "value": 48,
                    "title": "Version 48: 6 9 2 7; 7 9 8 5; 1 7 4 3; 4 1 6 7; 3 6 1 5; 9 2 4 8; 5 8 3 9; 2 5 8 4; 6 3 1 2"
                },
                {
                    "label": "r49",
                    "value": 49,
                    "title": "Version 49: 8 2 9 1; 2 3 5 6; 8 6 5 1; 3 9 6 4; 7 4 8 6; 1 8 3 7; 5 4 9 2; 9 7 2 3; 4 1 5 7"
                },
                {
                    "label": "r50",
                    "value": 50,
                    "title": "Version 50: 6 9 3 8; 9 6 4 1; 4 1 7 9; 7 5 9 3; 8 5 3 1; 5 7 6 2; 1 2 4 5; 3 8 2 4; 2 6 7 8"
                },
                {
                    "label": "r51",
                    "value": 51,
                    "title": "Version 51: 8 2 7 4; 5 7 8 6; 4 3 9 8; 6 8 1 2; 3 5 4 6; 1 9 6 7; 2 1 5 9; 9 4 5 3; 7 3 2 1"
                },
                {
                    "label": "r52",
                    "value": 52,
                    "title": "Version 52: 9 2 6 5; 2 9 3 8; 8 5 9 7; 5 8 1 4; 1 6 8 9; 4 3 7 6; 3 7 2 1; 7 1 4 5; 6 4 2 3"
                },
                {
                    "label": "r53",
                    "value": 53,
                    "title": "Version 53: 8 3 1 4; 3 9 1 2; 1 6 3 5; 4 7 9 6; 7 8 4 2; 5 7 6 9; 2 9 4 5; 6 2 1 8; 8 5 7 3"
                },
                {
                    "label": "r54",
                    "value": 54,
                    "title": "Version 54: 2 3 5 6; 9 5 8 3; 1 4 9 7; 4 8 2 6; 6 4 8 9; 5 1 7 8; 7 1 9 3; 1 2 5 4; 3 6 7 2"
                },
                {
                    "label": "r55",
                    "value": 55,
                    "title": "Version 55: 8 5 6 7; 5 8 3 4; 4 6 3 1; 9 7 5 2; 9 3 6 7; 2 9 1 5; 3 1 2 4; 1 6 8 9; 7 4 2 8"
                },
                {
                    "label": "r56",
                    "value": 56,
                    "title": "Version 56: 6 2 4 7; 4 9 5 3; 9 2 3 8; 9 4 8 1; 3 5 6 7; 6 1 4 5; 7 8 1 3; 8 7 9 2; 2 6 5 1"
                },
                {
                    "label": "r57",
                    "value": 57,
                    "title": "Version 57: 5 8 1 6; 4 5 2 9; 1 3 7 2; 5 4 7 1; 8 3 4 6; 6 2 8 9; 7 9 3 4; 6 1 9 7; 2 5 3 8"
                },
                {
                    "label": "r58",
                    "value": 58,
                    "title": "Version 58: 3 9 6 5; 5 7 9 1; 9 8 5 4; 3 6 4 2; 8 1 2 6; 1 3 2 9; 2 4 7 6; 8 7 3 5; 7 4 8 1"
                },
                {
                    "label": "r59",
                    "value": 59,
                    "title": "Version 59: 5 2 1 8; 4 2 6 9; 9 1 6 3; 3 8 6 5; 6 9 4 7; 7 5 1 3; 1 3 8 4; 4 7 5 2; 7 2 9 8"
                },
                {
                    "label": "r60",
                    "value": 60,
                    "title": "Version 60: 4 6 1 8; 2 6 7 1; 8 4 2 5; 2 1 5 9; 1 9 4 3; 9 7 3 2; 5 3 6 4; 6 8 5 7; 3 9 7 8"
                },
                {
                    "label": "r61",
                    "value": 61,
                    "title": "Version 61: 2 1 8 3; 4 5 9 6; 1 5 9 6; 5 2 1 7; 3 6 7 5; 8 3 2 6; 7 4 3 2; 9 8 4 7; 8 9 4 1"
                },
                {
                    "label": "r62",
                    "value": 62,
                    "title": "Version 62: 5 7 8 3; 6 5 8 9; 9 8 5 2; 9 2 3 4; 1 4 7 5; 6 1 9 3; 2 6 1 7; 7 3 1 4; 2 4 6 8"
                },
                {
                    "label": "r63",
                    "value": 63,
                    "title": "Version 63: 6 7 2 9; 3 8 2 1; 3 9 6 1; 1 7 9 8; 5 3 8 9; 4 8 7 6; 7 5 4 6; 4 2 3 5; 2 1 5 4"
                },
                {
                    "label": "r64",
                    "value": 64,
                    "title": "Version 64: 4 1 3 2; 8 6 2 3; 8 7 1 5; 7 5 9 1; 5 2 7 3; 9 4 8 7; 3 9 6 4; 6 9 5 2; 1 6 4 8"
                },
                {
                    "label": "r65",
                    "value": 65,
                    "title": "Version 65: 2 8 1 9; 1 6 8 7; 9 2 5 4; 6 5 9 8; 7 3 6 2; 3 7 4 9; 5 3 6 1; 7 1 2 4; 4 3 8 5"
                },
                {
                    "label": "r66",
                    "value": 66,
                    "title": "Version 66: 3 1 7 6; 8 9 3 1; 9 4 7 6; 8 7 2 5; 3 2 9 7; 2 4 6 8; 6 1 4 5; 8 5 3 4; 1 2 5 9"
                },
                {
                    "label": "r67",
                    "value": 67,
                    "title": "Version 67: 6 8 7 2; 5 6 9 3; 4 9 2 7; 2 6 1 9; 1 5 4 2; 5 3 1 4; 3 8 1 6; 4 9 7 8; 7 5 3 8"
                },
                {
                    "label": "r68",
                    "value": 68,
                    "title": "Version 68: 2 4 6 3; 4 7 5 3; 4 3 8 1; 7 2 5 6; 9 4 8 6; 6 1 5 7; 9 8 2 1; 1 7 3 9; 5 8 9 2"
                },
                {
                    "label": "r69",
                    "value": 69,
                    "title": "Version 69: 9 3 4 5; 7 6 4 1; 8 9 1 7; 1 4 9 5; 6 7 5 3; 3 2 7 8; 5 6 2 8; 2 3 6 9; 8 1 4 2"
                },
                {
                    "label": "r70",
                    "value": 70,
                    "title": "Version 70: 7 1 2 4; 3 7 8 9; 4 2 7 6; 1 5 3 2; 6 8 9 5; 9 6 1 5; 5 4 8 7; 4 8 6 3; 2 9 3 1"
                },
                {
                    "label": "r71",
                    "value": 71,
                    "title": "Version 71: 8 5 7 1; 2 5 8 4; 8 4 3 9; 3 2 5 6; 7 3 2 9; 9 7 4 5; 1 6 2 7; 6 3 1 8; 1 9 6 4"
                },
                {
                    "label": "r72",
                    "value": 72,
                    "title": "Version 72: 5 1 8 2; 5 7 9 3; 2 9 6 4; 4 2 1 7; 8 4 3 1; 9 8 7 6; 5 6 9 2; 3 7 6 8; 1 5 4 3"
                },
                {
                    "label": "r73",
                    "value": 73,
                    "title": "Version 73: 7 1 5 9; 6 1 7 3; 3 6 4 2; 6 8 1 7; 9 4 3 5; 4 5 8 6; 8 9 2 4; 8 2 9 1; 7 2 5 3"
                },
                {
                    "label": "r74",
                    "value": 74,
                    "title": "Version 74: 1 3 6 4; 9 1 3 8; 2 3 9 7; 2 7 8 5; 4 6 2 5; 7 4 1 6; 5 9 6 1; 9 4 7 8; 8 5 3 2"
                },
                {
                    "label": "r75",
                    "value": 75,
                    "title": "Version 75: 3 6 2 9; 3 8 1 2; 6 8 5 7; 9 1 4 3; 5 9 1 6; 1 5 4 2; 4 3 5 7; 7 6 9 8; 2 7 8 4"
                },
                {
                    "label": "r76",
                    "value": 76,
                    "title": "Version 76: 3 2 8 9; 4 8 3 1; 2 1 7 9; 7 4 9 5; 6 3 7 1; 7 2 4 6; 1 9 5 4; 6 5 8 3; 8 5 6 2"
                },
                {
                    "label": "r77",
                    "value": 77,
                    "title": "Version 77: 5 9 2 1; 9 6 4 8; 5 4 6 3; 8 7 9 4; 6 7 3 9; 2 8 5 1; 3 2 4 7; 1 3 7 5; 6 1 2 8"
                },
                {
                    "label": "r78",
                    "value": 78,
                    "title": "Version 78: 7 2 5 9; 4 9 2 3; 4 8 1 6; 5 3 8 4; 8 6 1 7; 9 3 6 2; 1 5 9 6; 3 5 7 8; 1 7 2 4"
                },
                {
                    "label": "r79",
                    "value": 79,
                    "title": "Version 79: 9 4 3 1; 2 8 9 5; 4 2 5 6; 3 1 6 2; 5 1 4 7; 8 9 1 7; 7 6 3 5; 2 7 8 3; 6 8 4 9"
                },
                {
                    "label": "r80",
                    "value": 80,
                    "title": "Version 80: 2 6 1 8; 1 2 5 3; 8 5 7 9; 5 4 8 3; 3 1 9 5; 4 9 6 8; 6 3 7 9; 7 4 2 6; 4 7 2 1"
                },
                {
                    "label": "r81",
                    "value": 81,
                    "title": "Version 81: 9 6 7 1; 7 9 8 4; 9 4 3 2; 6 2 9 5; 2 8 3 7; 5 7 6 4; 1 5 8 2; 3 1 5 6; 8 3 4 1"
                },
                {
                    "label": "r82",
                    "value": 82,
                    "title": "Version 82: 7 9 3 8; 9 2 1 4; 4 7 2 6; 6 3 7 5; 3 4 5 8; 2 6 9 3; 1 5 4 9; 5 8 1 7; 8 1 6 2"
                },
                {
                    "label": "r83",
                    "value": 83,
                    "title": "Version 83: 2 6 8 5; 5 2 4 7; 4 8 6 9; 8 7 1 3; 1 9 7 4; 6 5 9 8; 4 1 3 6; 3 7 2 1; 9 3 5 2"
                },
                {
                    "label": "r84",
                    "value": 84,
                    "title": "Version 84: 8 4 1 6; 7 8 5 2; 6 1 8 3; 3 4 9 5; 4 3 2 8; 5 9 7 1; 1 2 9 7; 9 2 3 6; 5 6 4 7"
                },
                {
                    "label": "r85",
                    "value": 85,
                    "title": "Version 85: 8 5 1 9; 7 9 6 3; 2 9 8 4; 1 4 5 3; 3 5 2 9; 7 1 6 8; 8 3 7 4; 2 6 7 5; 2 6 4 1"
                },
                {
                    "label": "r86",
                    "value": 86,
                    "title": "Version 86: 6 8 3 4; 6 7 4 2; 9 7 5 1; 1 2 3 7; 9 1 8 2; 5 8 1 3; 5 4 6 9; 3 7 9 6; 4 5 2 8"
                },
                {
                    "label": "r87",
                    "value": 87,
                    "title": "Version 87: 2 8 6 5; 6 3 5 1; 7 3 4 5; 1 6 2 9; 4 1 7 2; 9 8 3 7; 8 9 3 2; 9 4 1 6; 7 5 8 4"
                },
                {
                    "label": "r88",
                    "value": 88,
                    "title": "Version 88: 3 2 7 6; 5 4 9 8; 6 3 8 7; 3 9 4 1; 8 5 6 9; 4 1 2 3; 2 7 9 4; 1 6 5 8; 7 2 1 5"
                },
                {
                    "label": "r89",
                    "value": 89,
                    "title": "Version 89: 2 4 5 8; 8 5 2 3; 7 8 1 9; 5 9 7 6; 3 7 6 9; 6 3 4 5; 9 2 3 1; 4 6 1 2; 1 4 8 7"
                },
                {
                    "label": "r90",
                    "value": 90,
                    "title": "Version 90: 6 3 9 4; 4 6 2 7; 3 1 7 5; 1 8 6 3; 5 1 8 2; 8 7 4 3; 8 2 9 6; 2 9 7 5; 9 5 4 1"
                },
                {
                    "label": "r91",
                    "value": 91,
                    "title": "Version 91: 2 9 3 8; 6 8 1 4; 7 3 5 9; 7 6 5 4; 5 4 3 1; 4 2 1 6; 3 5 2 6; 9 7 8 2; 1 7 9 8"
                },
                {
                    "label": "r92",
                    "value": 92,
                    "title": "Version 92: 3 2 9 4; 4 8 6 7; 7 1 2 4; 8 1 5 9; 1 3 7 8; 5 6 7 2; 2 4 3 5; 6 9 5 1; 6 9 8 3"
                },
                {
                    "label": "r93",
                    "value": 93,
                    "title": "Version 93: 9 4 6 7; 9 8 4 2; 1 7 9 3; 7 5 6 1; 2 3 1 6; 8 6 2 7; 4 5 8 9; 5 3 4 8; 3 1 2 5"
                },
                {
                    "label": "r94",
                    "value": 94,
                    "title": "Version 94: 6 2 1 9; 7 2 3 4; 3 7 8 1; 9 4 7 5; 1 5 9 2; 5 6 3 8; 4 9 6 1; 2 8 5 7; 8 3 4 6"
                },
                {
                    "label": "r95",
                    "value": 95,
                    "title": "Version 95: 5 1 4 6; 6 8 2 7; 2 6 5 9; 8 4 1 3; 9 2 8 4; 1 9 7 3; 4 7 1 8; 3 5 9 6; 7 2 3 5"
                },
                {
                    "label": "r96",
                    "value": 96,
                    "title": "Version 96: 8 1 6 2; 1 3 4 5; 7 8 5 1; 4 7 3 9; 6 4 5 7; 5 9 8 2; 9 2 7 4; 3 9 6 8; 2 6 1 3"
                },
                {
                    "label": "r97",
                    "value": 97,
                    "title": "Version 97: 4 5 2 3; 5 1 4 6; 1 6 9 8; 6 3 2 7; 9 1 7 2; 8 4 3 2; 3 5 9 1; 7 8 9 4; 7 8 6 5"
                },
                {
                    "label": "r98",
                    "value": 98,
                    "title": "Version 98: 5 3 1 9; 2 7 8 3; 3 9 7 6; 1 5 8 2; 9 6 3 4; 6 1 4 7; 2 4 6 8; 4 2 5 9; 8 7 5 1"
                },
                {
                    "label": "r99",
                    "value": 99,
                    "title": "Version 99: 9 8 4 1; 4 7 2 5; 1 4 2 3; 2 9 1 6; 7 1 5 4; 6 3 8 2; 5 6 3 8; 3 8 9 7; 7 5 6 9"
                },
                {
                    "label": "r100",
                    "value": 100,
                    "title": "Version 100: 9 2 1 3; 1 2 7 6; 9 7 6 5; 8 9 6 4; 5 2 8 1; 2 6 4 5; 4 3 9 7; 3 4 1 8; 8 5 7 3"
                },
                {
                    "label": "r101",
                    "value": 101,
                    "title": "Version 101: 4 5 2 7; 6 1 3 7; 7 4 3 2; 3 6 4 1; 2 8 4 9; 5 9 2 8; 8 1 9 5; 6 3 5 9; 1 7 8 6"
                },
                {
                    "label": "r102",
                    "value": 102,
                    "title": "Version 102: 5 8 3 4; 4 9 8 6; 2 6 7 1; 7 2 9 8; 1 4 5 6; 8 1 7 3; 6 3 2 5; 9 7 1 4; 3 5 2 9"
                },
                {
                    "label": "r103",
                    "value": 103,
                    "title": "Version 103: 1 4 5 9; 4 9 3 7; 3 1 8 2; 8 3 6 4; 5 7 6 8; 8 5 1 2; 9 2 3 1; 7 6 9 5; 6 2 7 4"
                },
                {
                    "label": "r104",
                    "value": 104,
                    "title": "Version 104: 2 6 4 3; 3 1 5 7; 2 8 7 9; 5 7 2 3; 6 8 1 9; 9 3 6 8; 7 4 8 1; 4 5 1 6; 5 9 4 2"
                },
                {
                    "label": "r105",
                    "value": 105,
                    "title": "Version 105: 7 8 9 5; 8 5 2 4; 6 2 8 7; 1 4 6 3; 4 3 5 8; 9 6 2 1; 1 9 7 4; 3 5 9 6; 2 1 7 3"
                },
                {
                    "label": "r106",
                    "value": 106,
                    "title": "Version 106: 1 2 3 5; 9 3 4 8; 6 7 4 2; 2 6 9 1; 4 9 1 2; 8 7 5 3; 3 5 9 7; 4 8 6 7; 5 1 8 6"
                },
                {
                    "label": "r107",
                    "value": 107,
                    "title": "Version 107: 6 4 2 5; 7 4 3 1; 1 2 7 8; 5 1 4 8; 8 3 6 9; 3 7 1 9; 7 9 5 6; 2 8 3 6; 9 5 4 2"
                },
                {
                    "label": "r108",
                    "value": 108,
                    "title": "Version 108: 2 3 7 4; 4 6 8 1; 8 2 9 4; 2 1 3 5; 6 9 5 1; 9 7 4 5; 6 8 2 3; 7 6 3 5; 1 8 7 9"
                },
                {
                    "label": "r109",
                    "value": 109,
                    "title": "Version 109: 5 3 6 4; 8 5 1 9; 3 4 8 7; 1 4 8 5; 7 9 6 2; 9 1 2 3; 4 6 3 9; 1 7 6 2; 5 2 8 7"
                },
                {
                    "label": "r110",
                    "value": 110,
                    "title": "Version 110: 3 6 5 8; 8 2 9 6; 2 5 7 4; 6 5 1 7; 7 8 1 3; 5 9 2 3; 4 1 7 6; 3 4 9 1; 9 2 4 8"
                },
                {
                    "label": "r111",
                    "value": 111,
                    "title": "Version 111: 9 8 1 6; 3 7 8 9; 1 6 4 2; 2 6 5 8; 6 3 7 4; 5 1 8 4; 1 3 2 5; 7 9 3 2; 4 7 9 5"
                },
                {
                    "label": "r112",
                    "value": 112,
                    "title": "Version 112: 8 4 5 2; 3 9 6 1; 6 1 2 7; 5 3 6 9; 4 7 5 9; 9 4 2 1; 7 5 6 8; 2 8 4 3; 8 1 3 7"
                },
                {
                    "label": "r113",
                    "value": 113,
                    "title": "Version 113: 4 8 1 3; 1 3 5 7; 7 4 9 6; 8 2 7 9; 6 7 5 2; 5 9 1 8; 9 2 4 1; 3 5 6 4; 3 6 8 2"
                },
                {
                    "label": "r114",
                    "value": 114,
                    "title": "Version 114: 7 4 8 6; 8 6 9 1; 9 6 3 5; 2 7 1 5; 6 9 4 7; 2 1 7 8; 1 2 3 4; 2 3 9 5; 5 8 4 3"
                },
                {
                    "label": "r115",
                    "value": 115,
                    "title": "Version 115: 1 5 7 3; 7 1 9 6; 8 3 2 7; 4 9 8 5; 6 2 8 9; 5 1 2 6; 3 9 7 4; 4 8 5 2; 3 6 1 4"
                },
                {
                    "label": "r116",
                    "value": 116,
                    "title": "Version 116: 9 5 3 8; 2 7 6 1; 9 2 3 7; 2 4 6 3; 5 7 2 4; 8 3 1 9; 4 8 7 6; 1 4 9 5; 6 5 1 8"
                },
                {
                    "label": "r117",
                    "value": 117,
                    "title": "Version 117: 3 6 8 2; 7 8 5 9; 6 7 3 5; 9 6 4 1; 5 3 4 1; 8 2 7 3; 7 1 4 8; 9 5 6 2; 4 9 1 2"
                },
                {
                    "label": "r118",
                    "value": 118,
                    "title": "Version 118: 3 4 2 6; 1 2 5 7; 6 3 9 8; 8 7 9 1; 4 8 3 1; 1 6 5 7; 5 8 6 4; 5 9 2 3; 2 4 7 9"
                },
                {
                    "label": "r119",
                    "value": 119,
                    "title": "Version 119: 8 1 5 4; 7 5 3 6; 3 1 8 2; 6 2 8 9; 9 5 1 2; 4 9 7 3; 1 4 6 3; 7 5 9 6; 2 7 4 8"
                },
                {
                    "label": "r120",
                    "value": 120,
                    "title": "Version 120: 8 4 6 7; 6 3 1 5; 5 3 2 9; 4 2 5 7; 2 8 5 6; 1 9 8 7; 3 1 9 8; 7 3 4 9; 1 6 2 4"
                },
                {
                    "label": "r121",
                    "value": 121,
                    "title": "Version 121: 2 4 8 5; 8 7 3 2; 9 7 4 6; 2 9 6 1; 4 8 9 5; 5 6 9 1; 7 2 1 3; 3 6 8 4; 3 5 7 1"
                },
                {
                    "label": "r122",
                    "value": 122,
                    "title": "Version 122: 6 5 3 7; 9 1 2 8; 9 7 1 4; 5 8 1 7; 1 2 4 6; 6 3 2 5; 8 5 3 4; 7 9 6 8; 4 2 3 9"
                },
                {
                    "label": "r123",
                    "value": 123,
                    "title": "Version 123: 3 1 7 2; 8 4 6 3; 7 4 5 1; 2 6 8 7; 5 3 4 9; 6 9 5 8; 1 2 9 6; 9 8 1 3; 4 7 2 5"
                },
                {
                    "label": "r124",
                    "value": 124,
                    "title": "Version 124: 4 5 7 9; 7 9 3 8; 5 4 9 2; 8 7 2 6; 8 1 5 2; 1 8 6 4; 3 1 6 4; 6 3 7 1; 9 5 2 3"
                },
                {
                    "label": "r125",
                    "value": 125,
                    "title": "Version 125: 3 6 9 5; 2 6 4 9; 2 4 3 7; 5 4 8 1; 4 2 1 3; 9 7 5 6; 9 8 1 2; 6 3 8 7; 1 8 7 5"
                },
                {
                    "label": "r126",
                    "value": 126,
                    "title": "Version 126: 7 2 4 8; 8 9 4 3; 3 5 8 2; 2 1 9 7; 5 3 6 1; 6 5 2 8; 7 9 4 6; 4 6 5 1; 1 7 3 9"
                },
                {
                    "label": "r127",
                    "value": 127,
                    "title": "Version 127: 8 1 9 3; 2 1 6 4; 4 8 9 5; 5 1 7 8; 1 2 7 5; 9 3 4 6; 7 6 3 2; 6 9 8 2; 7 4 5 3"
                },
                {
                    "label": "r128",
                    "value": 128,
                    "title": "Version 128: 4 7 8 9; 5 7 1 4; 3 5 1 6; 1 9 2 5; 6 8 5 4; 6 3 7 8; 3 8 2 9; 2 6 9 7; 3 4 2 1"
                },
                {
                    "label": "r129",
                    "value": 129,
                    "title": "Version 129: 9 2 7 5; 8 9 6 1; 9 1 3 4; 7 6 3 1; 8 7 5 3; 5 2 6 8; 1 4 8 7; 2 5 4 3; 4 2 6 9"
                },
                {
                    "label": "r130",
                    "value": 130,
                    "title": "Version 130: 8 7 1 6; 1 8 9 4; 9 6 1 5; 5 3 8 2; 7 3 5 9; 2 4 7 6; 4 5 6 3; 4 9 2 7; 3 1 2 8"
                },
                {
                    "label": "r131",
                    "value": 131,
                    "title": "Version 131: 6 8 4 2; 6 5 9 1; 2 9 3 1; 5 4 8 9; 1 3 4 2; 2 1 5 7; 7 6 5 8; 3 7 8 9; 7 6 3 4"
                },
                {
                    "label": "r132",
                    "value": 132,
                    "title": "Version 132: 5 4 1 6; 8 3 9 5; 1 2 6 8; 9 2 7 6; 8 7 4 1; 3 1 6 9; 4 8 2 3; 9 5 7 4; 3 7 5 2"
                },
                {
                    "label": "r133",
                    "value": 133,
                    "title": "Version 133: 6 9 3 7; 7 3 8 2; 2 6 1 5; 9 2 4 6; 5 8 6 3; 8 5 2 4; 1 9 4 5; 8 1 9 7; 4 1 3 7"
                },
                {
                    "label": "r134",
                    "value": 134,
                    "title": "Version 134: 2 4 7 5; 6 7 1 3; 6 4 1 8; 3 2 9 6; 7 6 8 4; 9 8 2 5; 5 9 3 4; 1 5 3 2; 9 8 7 1"
                },
                {
                    "label": "r135",
                    "value": 135,
                    "title": "Version 135: 4 3 1 6; 2 6 5 7; 7 9 2 8; 4 1 7 2; 6 3 4 9; 1 5 9 7; 5 4 8 9; 8 2 1 3; 3 5 6 8"
                },
                {
                    "label": "r136",
                    "value": 136,
                    "title": "Version 136: 6 7 8 9; 7 3 5 1; 1 6 4 2; 9 1 6 2; 3 8 9 5; 8 7 3 4; 2 9 4 3; 5 8 1 6; 4 2 5 7"
                },
                {
                    "label": "r137",
                    "value": 137,
                    "title": "Version 137: 5 4 7 6; 3 5 9 1; 7 4 9 1; 6 3 2 5; 5 2 7 8; 2 7 6 3; 4 1 3 8; 9 6 8 4; 1 9 2 8"
                },
                {
                    "label": "r138",
                    "value": 138,
                    "title": "Version 138: 7 6 3 9; 6 7 5 1; 8 2 6 4; 1 3 7 9; 4 5 8 3; 9 4 5 1; 8 1 4 2; 3 8 2 7; 2 9 6 5"
                },
                {
                    "label": "r139",
                    "value": 139,
                    "title": "Version 139: 2 5 1 7; 8 2 1 6; 6 4 3 9; 5 6 4 3; 4 7 1 8; 7 9 2 4; 3 9 5 2; 9 1 8 3; 6 8 7 5"
                },
                {
                    "label": "r140",
                    "value": 140,
                    "title": "Version 140: 2 8 9 6; 1 3 2 4; 8 3 7 5; 9 6 8 7; 7 2 9 4; 3 5 6 1; 1 2 5 9; 4 5 3 8; 1 4 7 6"
                },
                {
                    "label": "r141",
                    "value": 141,
                    "title": "Version 141: 5 7 4 9; 6 7 9 2; 9 1 3 8; 7 4 2 3; 3 1 6 7; 5 8 1 2; 4 8 5 1; 9 6 4 5; 8 2 3 6"
                },
                {
                    "label": "r142",
                    "value": 142,
                    "title": "Version 142: 7 3 8 9; 2 3 5 4; 3 9 2 1; 8 4 9 2; 4 6 8 3; 5 7 6 8; 2 5 1 7; 6 1 4 7; 1 9 5 6"
                },
                {
                    "label": "r143",
                    "value": 143,
                    "title": "Version 143: 2 3 4 6; 8 4 9 5; 4 8 7 1; 6 2 8 1; 1 7 3 9; 5 9 2 6; 3 6 1 4; 7 9 3 5; 2 5 7 8"
                },
                {
                    "label": "r144",
                    "value": 144,
                    "title": "Version 144: 9 1 4 2; 7 2 6 5; 2 4 7 3; 1 6 5 8; 3 5 8 9; 9 7 6 4; 4 8 5 7; 8 1 9 3; 6 1 2 3"
                },
                {
                    "label": "r145",
                    "value": 145,
                    "title": "Version 145: 5 3 4 2; 4 8 6 7; 5 3 9 6; 7 5 1 3; 9 7 2 1; 6 2 8 9; 9 4 1 5; 8 6 1 4; 3 8 7 2"
                },
                {
                    "label": "r146",
                    "value": 146,
                    "title": "Version 146: 4 6 3 8; 1 2 6 7; 3 4 8 2; 7 3 5 1; 2 5 4 1; 7 9 3 6; 5 9 6 4; 8 2 9 5; 1 7 8 9"
                },
                {
                    "label": "r147",
                    "value": 147,
                    "title": "Version 147: 6 1 3 8; 4 6 7 5; 3 8 2 7; 5 1 2 8; 7 3 4 9; 2 4 5 3; 6 7 1 9; 9 1 8 4; 2 9 5 6"
                },
                {
                    "label": "r148",
                    "value": 148,
                    "title": "Version 148: 8 5 6 3; 1 3 9 4; 9 6 3 2; 8 4 2 9; 3 5 7 1; 1 8 5 6; 4 2 1 7; 6 7 4 2; 5 9 7 8"
                },
                {
                    "label": "r149",
                    "value": 149,
                    "title": "Version 149: 8 7 9 6; 1 6 2 5; 7 8 3 5; 2 1 6 4; 4 9 1 8; 6 4 5 3; 3 2 8 7; 9 3 1 2; 5 7 4 9"
                },
                {
                    "label": "r150",
                    "value": 150,
                    "title": "Version 150: 3 5 7 6; 5 2 8 4; 8 3 6 1; 7 4 9 3; 4 1 7 8; 2 9 4 5; 9 6 3 1; 1 5 2 7; 6 8 9 2"
                },
                {
                    "label": "r151",
                    "value": 151,
                    "title": "Version 151: 4 6 7 1; 7 8 6 2; 6 7 4 3; 8 4 1 5; 2 9 3 7; 3 2 1 4; 9 5 8 3; 5 9 2 6; 5 1 9 8"
                },
                {
                    "label": "r152",
                    "value": 152,
                    "title": "Version 152: 4 6 5 9; 1 8 9 7; 9 1 7 2; 7 4 5 9; 8 3 4 2; 2 7 6 8; 3 2 1 5; 6 3 8 4; 1 5 3 6"
                },
                {
                    "label": "r153",
                    "value": 153,
                    "title": "Version 153: 4 8 2 5; 7 2 5 1; 1 6 9 3; 8 1 7 6; 5 7 4 3; 3 4 8 1; 6 9 5 7; 9 2 6 4; 2 3 9 8"
                },
                {
                    "label": "r154",
                    "value": 154,
                    "title": "Version 154: 7 5 6 4; 8 3 2 7; 2 6 3 8; 6 1 4 9; 1 9 3 2; 8 5 1 6; 9 7 3 5; 4 2 7 1; 4 8 5 9"
                },
                {
                    "label": "r155",
                    "value": 155,
                    "title": "Version 155: 5 6 8 1; 6 8 7 9; 5 9 2 6; 3 5 2 7; 7 4 8 1; 1 3 5 2; 2 4 6 3; 9 7 4 8; 3 1 9 4"
                },
                {
                    "label": "r156",
                    "value": 156,
                    "title": "Version 156: 6 9 2 8; 9 2 1 7; 1 4 9 5; 4 6 7 3; 3 1 8 9; 8 3 4 5; 2 5 8 4; 7 5 1 6; 3 7 6 2"
                },
                {
                    "label": "r157",
                    "value": 157,
                    "title": "Version 157: 5 8 6 2; 2 9 4 7; 9 1 3 5; 7 8 9 4; 8 3 5 7; 6 3 5 9; 2 7 1 8; 4 6 3 1; 1 2 4 6"
                },
                {
                    "label": "r158",
                    "value": 158,
                    "title": "Version 158: 5 7 2 6; 9 1 7 3; 1 5 7 8; 3 6 8 9; 6 4 3 7; 4 2 9 3; 8 4 6 5; 8 9 1 2; 5 2 4 1"
                },
                {
                    "label": "r159",
                    "value": 159,
                    "title": "Version 159: 6 9 1 4; 1 8 2 6; 4 5 9 2; 9 8 5 3; 3 1 2 8; 7 6 2 4; 7 9 6 5; 5 3 7 1; 7 4 8 3"
                },
                {
                    "label": "r160",
                    "value": 160,
                    "title": "Version 160: 6 8 1 9; 1 7 3 6; 2 7 5 1; 8 1 7 4; 5 3 4 2; 2 5 9 3; 4 6 8 5; 3 4 6 9; 9 2 7 8"
                },
                {
                    "label": "r161",
                    "value": 161,
                    "title": "Version 161: 4 8 3 7; 8 2 1 5; 7 3 9 6; 5 4 3 1; 9 5 1 7; 3 6 2 8; 6 5 8 9; 1 6 4 2; 2 7 9 4"
                },
                {
                    "label": "r162",
                    "value": 162,
                    "title": "Version 162: 3 8 7 2; 4 1 5 3; 2 7 6 5; 6 9 4 2; 7 5 6 8; 9 4 3 8; 5 9 1 4; 1 7 8 9; 3 2 6 1"
                },
                {
                    "label": "r163",
                    "value": 163,
                    "title": "Version 163: 8 9 2 6; 6 3 5 8; 8 1 5 4; 1 3 2 7; 4 6 7 1; 9 2 3 5; 2 8 4 9; 7 1 9 6; 5 4 7 3"
                },
                {
                    "label": "r164",
                    "value": 164,
                    "title": "Version 164: 9 3 5 1; 1 6 4 2; 6 9 3 1; 4 5 8 7; 5 7 9 6; 3 4 6 8; 8 7 2 3; 7 2 9 4; 2 8 1 5"
                },
                {
                    "label": "r165",
                    "value": 165,
                    "title": "Version 165: 2 4 5 7; 7 5 4 6; 5 6 2 3; 6 1 3 2; 7 3 8 9; 1 8 6 4; 8 9 7 1; 9 3 8 4; 2 1 9 5"
                },
                {
                    "label": "r166",
                    "value": 166,
                    "title": "Version 166: 4 2 3 8; 3 4 1 9; 5 2 6 7; 1 7 5 8; 4 1 2 7; 8 9 2 6; 9 5 4 3; 6 8 5 9; 3 1 7 6"
                },
                {
                    "label": "r167",
                    "value": 167,
                    "title": "Version 167: 9 6 4 7; 3 7 6 5; 4 5 9 2; 1 6 8 4; 7 2 1 8; 5 6 1 9; 8 4 3 2; 9 3 7 2; 3 8 5 1"
                },
                {
                    "label": "r168",
                    "value": 168,
                    "title": "Version 168: 7 9 1 4; 6 4 7 3; 2 1 3 6; 1 3 7 5; 2 9 4 1; 9 5 8 3; 6 8 4 5; 6 2 9 8; 8 7 5 2"
                },
                {
                    "label": "r169",
                    "value": 169,
                    "title": "Version 169: 4 5 8 1; 1 9 2 7; 5 4 2 7; 4 8 6 3; 2 6 5 4; 8 7 3 9; 2 1 9 3; 3 6 9 5; 1 8 6 7"
                },
                {
                    "label": "r170",
                    "value": 170,
                    "title": "Version 170: 4 3 8 1; 6 4 7 9; 5 9 1 8; 9 2 8 6; 7 5 2 9; 8 7 4 3; 3 2 1 5; 7 3 6 5; 6 1 4 2"
                },
                {
                    "label": "r171",
                    "value": 171,
                    "title": "Version 171: 7 2 3 9; 5 4 1 6; 2 3 7 4; 4 9 8 7; 5 6 2 8; 1 8 6 7; 9 1 3 6; 3 5 9 4; 8 2 5 1"
                },
                {
                    "label": "r172",
                    "value": 172,
                    "title": "Version 172: 1 3 4 2; 4 5 3 8; 8 7 1 9; 2 7 5 6; 6 8 9 7; 9 1 4 5; 9 4 2 6; 7 1 5 3; 3 6 8 2"
                },
                {
                    "label": "r173",
                    "value": 173,
                    "title": "Version 173: 5 9 6 3; 4 6 7 1; 1 9 3 2; 3 7 1 8; 2 8 6 3; 8 5 9 4; 5 4 7 2; 6 4 9 1; 7 2 8 5"
                },
                {
                    "label": "r174",
                    "value": 174,
                    "title": "Version 174: 8 3 6 4; 4 7 8 9; 7 1 2 4; 3 6 7 5; 1 7 3 6; 9 5 1 6; 5 3 4 2; 2 8 9 1; 5 2 8 9"
                },
                {
                    "label": "r175",
                    "value": 175,
                    "title": "Version 175: 4 9 2 3; 6 3 5 1; 7 3 2 8; 9 2 6 7; 8 4 1 5; 1 9 4 5; 3 5 7 9; 6 4 8 7; 1 8 2 6"
                },
                {
                    "label": "r176",
                    "value": 176,
                    "title": "Version 176: 5 8 3 4; 3 1 4 7; 2 6 1 4; 7 6 5 2; 2 1 5 8; 8 5 7 9; 2 7 9 1; 6 9 3 8; 9 4 6 3"
                },
                {
                    "label": "r177",
                    "value": 177,
                    "title": "Version 177: 4 5 9 6; 6 1 5 8; 9 6 4 7; 5 3 6 1; 4 2 3 8; 8 7 2 4; 1 9 2 3; 3 2 7 5; 7 8 1 9"
                },
                {
                    "label": "r178",
                    "value": 178,
                    "title": "Version 178: 7 5 6 2; 5 7 9 3; 6 3 8 9; 8 6 7 4; 9 8 1 2; 4 1 5 7; 2 4 9 5; 3 2 1 6; 1 8 4 3"
                },
                {
                    "label": "r179",
                    "value": 179,
                    "title": "Version 179: 4 2 3 7; 7 6 8 1; 6 9 2 4; 1 9 8 6; 8 7 3 5; 5 1 3 4; 3 2 9 8; 2 4 5 6; 9 5 7 1"
                },
                {
                    "label": "r180",
                    "value": 180,
                    "title": "Version 180: 1 3 8 7; 8 4 6 7; 3 1 4 2; 2 6 1 5; 1 7 4 9; 9 3 6 5; 7 9 2 3; 5 8 4 9; 6 5 2 8"
                },
                {
                    "label": "r181",
                    "value": 181,
                    "title": "Version 181: 6 8 5 3; 9 1 8 2; 3 9 5 8; 4 5 7 1; 4 7 6 9; 7 3 1 6; 8 4 2 1; 2 5 7 9; 6 2 3 4"
                },
                {
                    "label": "r182",
                    "value": 182,
                    "title": "Version 182: 8 6 7 2; 7 8 4 3; 4 3 9 1; 5 7 3 1; 2 4 5 8; 1 2 6 9; 9 4 8 5; 5 1 2 6; 3 9 6 7"
                },
                {
                    "label": "r183",
                    "value": 183,
                    "title": "Version 183: 8 6 9 3; 7 8 1 2; 1 3 8 5; 7 2 9 4; 4 7 3 6; 5 9 4 1; 2 5 7 6; 6 1 4 8; 9 3 5 2"
                },
                {
                    "label": "r184",
                    "value": 184,
                    "title": "Version 184: 9 6 5 4; 3 4 1 2; 3 9 2 8; 6 2 3 4; 5 8 1 7; 2 7 9 8; 8 5 7 6; 4 1 5 3; 1 6 9 7"
                },
                {
                    "label": "r185",
                    "value": 185,
                    "title": "Version 185: 3 7 1 9; 2 4 8 5; 7 2 3 5; 5 9 6 3; 1 8 6 9; 4 3 8 7; 9 1 4 7; 6 5 2 1; 8 6 4 2"
                },
                {
                    "label": "r186",
                    "value": 186,
                    "title": "Version 186: 5 6 7 4; 7 2 1 8; 1 8 5 9; 2 5 6 3; 9 4 8 5; 4 9 2 7; 3 1 9 2; 6 7 3 4; 8 6 3 1"
                },
                {
                    "label": "r187",
                    "value": 187,
                    "title": "Version 187: 2 1 4 6; 1 3 8 4; 6 4 1 9; 4 5 7 1; 8 7 5 2; 7 3 6 9; 9 2 5 3; 7 8 2 6; 5 9 3 8"
                },
                {
                    "label": "r188",
                    "value": 188,
                    "title": "Version 188: 4 6 9 5; 3 4 2 8; 8 9 7 4; 3 2 7 1; 6 5 8 3; 5 3 4 7; 9 1 6 2; 1 7 6 5; 9 8 1 2"
                },
                {
                    "label": "r189",
                    "value": 189,
                    "title": "Version 189: 2 4 8 6; 5 8 9 7; 6 9 2 7; 2 5 1 3; 1 6 4 8; 3 1 5 8; 4 2 9 5; 7 3 9 4; 1 7 3 6"
                },
                {
                    "label": "r190",
                    "value": 190,
                    "title": "Version 190: 9 5 7 1; 3 2 6 9; 8 7 5 2; 4 1 8 9; 5 4 2 1; 2 3 4 7; 7 6 8 5; 1 6 3 4; 8 9 3 6"
                },
                {
                    "label": "r191",
                    "value": 191,
                    "title": "Version 191: 6 8 7 1; 6 9 2 5; 9 4 7 3; 4 5 6 2; 8 3 1 9; 2 8 7 1; 7 1 2 3; 5 4 9 6; 3 5 4 8"
                },
                {
                    "label": "r192",
                    "value": 192,
                    "title": "Version 192: 3 2 5 8; 5 7 1 9; 1 3 5 6; 7 5 1 4; 8 6 3 9; 9 8 2 7; 6 8 4 7; 2 1 4 3; 4 9 6 2"
                },
                {
                    "label": "r193",
                    "value": 193,
                    "title": "Version 193: 3 2 8 6; 3 7 9 5; 2 9 5 1; 5 3 8 4; 1 6 5 8; 6 1 3 7; 9 4 1 8; 7 2 9 4; 4 7 6 2"
                },
                {
                    "label": "r194",
                    "value": 194,
                    "title": "Version 194: 8 4 7 6; 4 2 8 3; 8 7 3 9; 2 6 7 5; 9 8 2 1; 1 5 9 6; 7 1 4 5; 6 3 1 9; 5 2 3 4"
                },
                {
                    "label": "r195",
                    "value": 195,
                    "title": "Version 195: 1 8 7 2; 4 9 6 1; 8 6 2 5; 2 9 5 3; 6 1 8 4; 9 5 4 8; 5 3 6 7; 3 7 1 2; 7 4 9 3"
                },
                {
                    "label": "r196",
                    "value": 196,
                    "title": "Version 196: 6 4 5 1; 7 6 8 3; 8 5 7 9; 5 7 3 1; 1 8 2 5; 9 2 6 7; 3 9 4 8; 2 9 4 6; 4 1 3 2"
                },
                {
                    "label": "r197",
                    "value": 197,
                    "title": "Version 197: 5 1 9 8; 9 3 8 6; 3 8 7 4; 2 5 6 3; 7 6 1 9; 4 6 5 7; 5 7 2 4; 8 4 1 2; 1 2 9 3"
                },
                {
                    "label": "r198",
                    "value": 198,
                    "title": "Version 198: 6 1 8 9; 4 3 1 5; 3 4 5 7; 9 5 4 2; 1 3 6 4; 8 2 7 1; 7 8 9 5; 6 7 2 9; 6 2 3 8"
                },
                {
                    "label": "r199",
                    "value": 199,
                    "title": "Version 199: 4 8 7 6; 8 9 5 3; 9 4 1 7; 2 6 8 5; 7 8 2 4; 1 5 9 2; 3 1 7 2; 5 3 6 1; 9 4 3 6"
                },
                {
                    "label": "r200",
                    "value": 200,
                    "title": "Version 200: 1 7 6 5; 3 9 5 8; 2 9 4 3; 4 1 9 7; 5 6 8 7; 7 3 2 9; 6 5 2 4; 2 1 8 6; 8 3 1 4"
                },
                {
                    "label": "r201",
                    "value": 201,
                    "title": "Version 201: 2 7 3 1; 9 2 1 8; 8 7 4 5; 3 8 7 6; 4 2 5 8; 6 9 4 1; 4 6 9 2; 1 5 3 6; 7 9 5 3"
                },
                {
                    "label": "r202",
                    "value": 202,
                    "title": "Version 202: 5 1 2 7; 7 4 6 3; 1 3 4 8; 3 6 8 9; 5 8 9 4; 2 5 1 4; 6 7 9 2; 9 8 7 1; 3 2 6 5"
                },
                {
                    "label": "r203",
                    "value": 203,
                    "title": "Version 203: 8 4 7 2; 8 4 3 2; 1 7 4 9; 7 9 6 5; 6 1 5 4; 2 6 8 1; 6 3 1 7; 9 2 5 3; 5 9 3 8"
                },
                {
                    "label": "r204",
                    "value": 204,
                    "title": "Version 204: 7 5 8 3; 4 5 3 9; 5 4 8 6; 3 7 2 6; 9 2 7 6; 8 6 4 1; 4 1 2 9; 2 3 9 1; 1 8 7 5"
                },
                {
                    "label": "r205",
                    "value": 205,
                    "title": "Version 205: 4 5 6 2; 9 7 6 8; 8 2 1 5; 5 9 1 3; 2 3 9 8; 6 8 4 9; 4 1 3 7; 1 6 5 7; 3 4 7 2"
                },
                {
                    "label": "r206",
                    "value": 206,
                    "title": "Version 206: 3 8 1 4; 7 4 9 5; 7 9 4 3; 9 5 2 1; 8 2 1 6; 1 3 6 9; 2 7 5 4; 6 3 8 5; 7 6 2 8"
                },
                {
                    "label": "r207",
                    "value": 207,
                    "title": "Version 207: 5 1 9 6; 1 4 3 7; 3 6 4 2; 6 9 8 4; 8 7 3 1; 2 5 6 3; 9 2 7 8; 4 1 5 7; 5 8 2 9"
                },
                {
                    "label": "r208",
                    "value": 208,
                    "title": "Version 208: 9 2 6 4; 3 9 1 8; 7 4 9 5; 5 3 8 4; 6 7 1 9; 4 6 3 2; 1 8 7 2; 2 5 8 7; 3 1 5 6"
                },
                {
                    "label": "r209",
                    "value": 209,
                    "title": "Version 209: 8 6 4 1; 8 9 6 7; 4 8 2 1; 6 1 2 5; 2 8 5 3; 7 2 3 9; 9 3 7 4; 5 6 7 3; 5 4 9 1"
                },
                {
                    "label": "r210",
                    "value": 210,
                    "title": "Version 210: 1 5 4 2; 9 7 1 8; 7 1 2 6; 8 5 4 9; 2 9 6 4; 6 7 5 3; 8 3 9 5; 1 2 3 7; 4 3 8 6"
                },
                {
                    "label": "r211",
                    "value": 211,
                    "title": "Version 211: 3 4 2 7; 4 6 1 9; 3 9 6 1; 7 4 1 5; 5 7 4 8; 2 8 3 9; 9 2 5 6; 6 5 8 7; 1 3 2 8"
                },
                {
                    "label": "r212",
                    "value": 212,
                    "title": "Version 212: 3 4 6 2; 8 1 7 3; 6 5 4 3; 1 3 9 5; 2 1 8 5; 4 2 7 9; 9 7 5 2; 7 6 4 8; 1 9 8 6"
                },
                {
                    "label": "r213",
                    "value": 213,
                    "title": "Version 213: 5 7 9 6; 5 2 3 1; 9 6 7 2; 6 1 5 4; 3 4 1 7; 2 8 9 5; 8 9 3 4; 4 8 2 1; 7 6 8 3"
                },
                {
                    "label": "r214",
                    "value": 214,
                    "title": "Version 214: 2 7 6 8; 8 9 3 4; 4 8 6 1; 1 2 9 4; 6 3 1 9; 3 5 7 2; 5 4 8 7; 9 1 7 5; 3 5 2 6"
                },
                {
                    "label": "r215",
                    "value": 215,
                    "title": "Version 215: 7 2 4 6; 2 4 5 1; 6 3 2 8; 9 2 4 3; 5 8 3 9; 7 1 8 3; 1 7 9 5; 8 5 6 4; 6 9 1 7"
                },
                {
                    "label": "r216",
                    "value": 216,
                    "title": "Version 216: 4 7 1 3; 4 9 5 8; 1 6 9 2; 5 1 3 6; 3 5 4 6; 2 4 7 8; 7 5 2 3; 9 8 7 2; 8 6 9 1"
                },
                {
                    "label": "r217",
                    "value": 217,
                    "title": "Version 217: 1 3 8 2; 3 4 6 9; 4 9 5 1; 2 8 5 1; 6 2 4 9; 5 3 8 7; 9 7 3 4; 7 1 6 2; 8 6 7 5"
                },
                {
                    "label": "r218",
                    "value": 218,
                    "title": "Version 218: 4 7 1 8; 1 9 3 6; 9 8 6 7; 7 1 6 5; 5 4 9 8; 3 7 2 4; 2 5 9 3; 8 3 2 1; 6 2 4 5"
                },
                {
                    "label": "r219",
                    "value": 219,
                    "title": "Version 219: 6 1 5 8; 8 5 1 4; 2 9 3 7; 7 5 2 9; 4 3 1 7; 9 2 1 4; 5 6 7 3; 3 4 8 6; 8 6 9 2"
                },
                {
                    "label": "r220",
                    "value": 220,
                    "title": "Version 220: 6 3 4 7; 1 3 5 9; 7 8 4 9; 3 8 9 6; 1 7 6 2; 9 1 8 7; 2 4 5 1; 5 2 3 8; 4 6 2 5"
                },
                {
                    "label": "r221",
                    "value": 221,
                    "title": "Version 221: 8 1 7 2; 1 4 8 3; 2 8 1 4; 7 9 5 6; 9 7 3 5; 5 6 2 8; 4 2 9 3; 6 9 3 1; 6 5 7 4"
                },
                {
                    "label": "r222",
                    "value": 222,
                    "title": "Version 222: 3 7 4 5; 5 8 7 2; 4 8 6 9; 9 5 4 1; 1 4 3 7; 3 1 5 6; 8 2 7 9; 2 3 8 6; 2 6 1 9"
                },
                {
                    "label": "r223",
                    "value": 223,
                    "title": "Version 223: 5 9 8 3; 7 5 2 1; 1 2 6 3; 7 1 3 9; 9 4 2 5; 4 3 2 8; 8 6 4 5; 1 9 6 7; 6 7 4 8"
                },
                {
                    "label": "r224",
                    "value": 224,
                    "title": "Version 224: 6 1 5 7; 5 8 9 1; 3 5 1 8; 3 6 8 4; 1 4 7 2; 4 9 6 2; 2 7 6 3; 9 2 5 3; 7 8 9 4"
                },
                {
                    "label": "r225",
                    "value": 225,
                    "title": "Version 225: 8 9 7 5; 9 3 1 4; 2 3 9 6; 6 2 4 7; 4 6 1 5; 5 1 8 3; 4 5 7 2; 7 9 3 8; 8 1 2 6"
                },
                {
                    "label": "r226",
                    "value": 226,
                    "title": "Version 226: 3 7 5 6; 9 4 5 1; 5 6 8 9; 1 4 9 2; 7 8 6 1; 2 3 6 7; 3 5 2 4; 8 7 4 3; 9 2 1 8"
                },
                {
                    "label": "r227",
                    "value": 227,
                    "title": "Version 227: 4 8 3 9; 6 3 4 1; 8 6 5 4; 6 4 9 7; 7 1 8 2; 1 7 9 5; 3 2 7 1; 2 9 5 6; 5 3 2 8"
                },
                {
                    "label": "r228",
                    "value": 228,
                    "title": "Version 228: 4 2 1 9; 2 9 8 7; 8 5 7 1; 9 5 3 6; 7 8 6 4; 3 6 2 9; 5 4 7 2; 1 5 4 3; 6 1 3 8"
                },
                {
                    "label": "r229",
                    "value": 229,
                    "title": "Version 229: 9 7 6 5; 4 6 1 2; 7 9 1 6; 1 7 9 3; 2 6 5 8; 5 3 4 7; 8 4 3 2; 3 8 4 9; 8 2 1 5"
                },
                {
                    "label": "r230",
                    "value": 230,
                    "title": "Version 230: 9 7 8 5; 8 1 7 4; 6 1 5 3; 6 8 2 3; 3 6 1 7; 5 2 9 4; 4 9 8 6; 7 3 5 2; 2 4 9 1"
                },
                {
                    "label": "r231",
                    "value": 231,
                    "title": "Version 231: 1 9 3 8; 3 5 4 1; 7 1 2 8; 4 5 6 9; 2 3 7 5; 6 7 8 4; 9 4 3 7; 1 2 6 9; 5 8 2 6"
                },
                {
                    "label": "r232",
                    "value": 232,
                    "title": "Version 232: 8 1 9 6; 9 8 2 5; 6 2 4 3; 3 9 7 2; 1 6 5 4; 3 7 6 8; 5 8 1 9; 2 4 1 7; 4 3 7 5"
                },
                {
                    "label": "r233",
                    "value": 233,
                    "title": "Version 233: 7 6 9 1; 7 5 8 4; 5 4 2 9; 2 1 3 8; 1 3 4 8; 6 7 5 2; 8 9 2 3; 9 6 3 7; 4 5 6 1"
                },
                {
                    "label": "r234",
                    "value": 234,
                    "title": "Version 234: 7 2 8 6; 8 7 4 9; 2 3 5 1; 3 9 8 5; 6 4 3 9; 9 7 1 4; 5 8 6 3; 5 2 7 1; 1 6 4 2"
                },
                {
                    "label": "r235",
                    "value": 235,
                    "title": "Version 235: 4 8 2 6; 6 2 9 3; 9 4 3 2; 1 5 8 9; 8 1 3 7; 3 1 7 6; 7 9 5 2; 4 5 1 8; 6 7 4 5"
                },
                {
                    "label": "r236",
                    "value": 236,
                    "title": "Version 236: 8 6 9 1; 2 1 6 4; 9 3 6 5; 4 8 9 7; 5 3 2 1; 7 2 8 6; 1 9 2 7; 3 5 4 8; 5 4 7 3"
                },
                {
                    "label": "r237",
                    "value": 237,
                    "title": "Version 237: 2 8 3 4; 3 5 1 9; 9 4 5 2; 4 9 2 7; 6 7 9 5; 8 1 7 3; 1 6 3 4; 7 1 6 8; 2 8 5 6"
                },
                {
                    "label": "r238",
                    "value": 238,
                    "title": "Version 238: 3 2 8 9; 2 9 1 6; 1 2 7 4; 7 3 5 2; 8 3 4 6; 6 9 1 3; 5 4 8 1; 9 7 5 8; 4 5 6 7"
                },
                {
                    "label": "r239",
                    "value": 239,
                    "title": "Version 239: 2 4 8 7; 1 3 9 5; 5 6 9 8; 4 7 6 1; 3 6 1 5; 8 2 4 9; 7 9 3 4; 6 7 2 3; 1 5 8 2"
                },
                {
                    "label": "r240",
                    "value": 240,
                    "title": "Version 240: 2 8 6 5; 9 5 7 4; 7 1 9 8; 5 6 1 4; 4 1 2 9; 8 4 7 3; 9 8 3 6; 6 3 5 2; 3 1 2 7"
                },
                {
                    "label": "r241",
                    "value": 241,
                    "title": "Version 241: 9 2 6 7; 2 9 8 1; 1 7 5 8; 6 2 4 5; 7 5 9 3; 3 4 1 2; 8 5 7 6; 6 3 4 9; 4 8 3 1"
                },
                {
                    "label": "r242",
                    "value": 242,
                    "title": "Version 242: 5 9 1 2; 2 3 8 7; 1 4 9 5; 4 6 7 9; 3 1 7 5; 9 6 4 8; 7 2 6 3; 8 6 3 1; 5 8 2 4"
                },
                {
                    "label": "r243",
                    "value": 243,
                    "title": "Version 243: 4 7 9 3; 9 3 5 8; 2 8 3 6; 6 4 1 7; 1 9 5 7; 2 1 6 9; 5 8 4 6; 8 2 7 1; 3 5 2 4"
                },
                {
                    "label": "r244",
                    "value": 244,
                    "title": "Version 244: 7 1 8 9; 3 9 5 2; 1 3 9 6; 5 7 2 4; 8 5 7 6; 6 4 3 5; 4 2 9 8; 7 6 1 2; 1 8 4 3"
                },
                {
                    "label": "r245",
                    "value": 245,
                    "title": "Version 245: 9 4 6 2; 6 9 3 5; 4 7 5 1; 6 2 8 1; 7 3 4 8; 9 7 2 3; 5 1 8 4; 3 5 1 2; 8 6 7 9"
                },
                {
                    "label": "r246",
                    "value": 246,
                    "title": "Version 246: 1 3 4 7; 3 7 6 8; 4 6 3 9; 2 5 7 3; 8 1 5 9; 9 5 1 6; 4 2 6 1; 2 4 9 8; 5 2 8 7"
                },
                {
                    "label": "r247",
                    "value": 247,
                    "title": "Version 247: 6 8 5 4; 3 9 4 1; 7 8 3 9; 1 4 2 5; 9 6 4 7; 2 1 7 6; 5 3 6 8; 7 9 2 5; 8 1 2 3"
                },
                {
                    "label": "r248",
                    "value": 248,
                    "title": "Version 248: 3 4 8 2; 8 2 9 4; 4 7 6 2; 7 3 1 4; 1 6 3 5; 9 8 1 6; 5 7 6 8; 9 5 7 1; 2 9 5 3"
                },
                {
                    "label": "r249",
                    "value": 249,
                    "title": "Version 249: 1 8 9 2; 2 9 4 3; 6 1 8 7; 7 3 8 5; 5 2 3 6; 5 7 9 4; 4 3 8 1; 6 2 1 7; 4 5 6 9"
                },
                {
                    "label": "r250",
                    "value": 250,
                    "title": "Version 250: 6 4 3 1; 2 1 5 3; 3 6 7 9; 9 7 2 5; 8 5 1 4; 7 8 5 4; 6 4 2 7; 1 9 2 8; 8 6 3 9"
                },
                {
                    "label": "r251",
                    "value": 251,
                    "title": "Version 251: 3 1 4 7; 5 6 4 2; 3 7 9 1; 7 9 1 8; 2 4 8 7; 8 5 2 6; 8 2 6 3; 4 3 9 5; 9 5 1 6"
                },
                {
                    "label": "r252",
                    "value": 252,
                    "title": "Version 252: 1 6 7 2; 9 8 3 4; 2 8 7 9; 1 9 6 4; 4 2 9 6; 3 4 5 1; 5 3 7 8; 6 1 8 5; 7 5 2 3"
                },
                {
                    "label": "r253",
                    "value": 253,
                    "title": "Version 253: 6 7 4 8; 9 6 5 2; 5 9 4 7; 8 4 3 2; 2 7 1 3; 3 8 6 5; 4 1 7 6; 1 5 9 8; 3 2 1 9"
                },
                {
                    "label": "r254",
                    "value": 254,
                    "title": "Version 254: 7 2 5 1; 1 7 8 9; 5 9 8 6; 2 1 5 4; 9 4 8 2; 6 3 4 1; 8 3 2 6; 9 6 3 7; 4 3 7 5"
                },
                {
                    "label": "r255",
                    "value": 255,
                    "title": "Version 255: 1 6 9 2; 7 8 5 3; 3 1 2 8; 8 9 3 4; 2 7 6 9; 6 4 1 7; 7 2 4 5; 5 9 6 3; 4 5 8 1"
                },
                {
                    "label": "r256",
                    "value": 256,
                    "title": "Version 256: 1 2 9 3; 2 8 5 6; 6 1 3 5; 9 5 2 4; 8 4 7 2; 7 3 9 4; 4 6 1 8; 3 8 6 7; 5 7 1 9"
                },
                {
                    "label": "r257",
                    "value": 257,
                    "title": "Version 257: 9 7 4 6; 5 9 3 8; 6 5 4 8; 7 3 5 2; 8 9 5 1; 1 2 4 3; 2 3 6 7; 6 4 9 1; 7 8 2 1"
                },
                {
                    "label": "r258",
                    "value": 258,
                    "title": "Version 258: 4 6 2 5; 3 4 8 2; 5 2 7 9; 4 8 9 7; 5 1 3 4; 1 5 7 6; 8 1 7 9; 2 6 9 3; 3 6 1 8"
                },
                {
                    "label": "r259",
                    "value": 259,
                    "title": "Version 259: 1 4 8 2; 8 7 6 5; 7 5 1 3; 9 1 4 3; 4 7 2 6; 2 8 9 1; 3 9 6 7; 9 3 5 4; 6 2 8 5"
                },
                {
                    "label": "r260",
                    "value": 260,
                    "title": "Version 260: 1 7 3 8; 2 8 5 9; 3 2 1 6; 6 9 2 3; 9 5 1 2; 7 3 8 4; 4 6 7 5; 5 1 4 7; 8 4 6 9"
                },
                {
                    "label": "r261",
                    "value": 261,
                    "title": "Version 261: 2 5 3 4; 6 4 2 1; 8 2 9 7; 9 1 8 3; 3 8 4 5; 5 6 7 9; 4 9 7 1; 7 3 6 2; 1 8 5 6"
                },
                {
                    "label": "r262",
                    "value": 262,
                    "title": "Version 262: 6 4 3 9; 5 6 3 8; 3 7 1 2; 9 7 5 3; 4 1 8 6; 2 4 8 7; 8 2 4 9; 7 5 6 1; 1 9 2 5"
                },
                {
                    "label": "r263",
                    "value": 263,
                    "title": "Version 263: 7 5 2 4; 4 7 9 6; 5 3 4 1; 9 6 5 2; 5 4 1 8; 3 2 7 8; 2 3 1 6; 6 8 3 9; 1 9 8 7"
                },
                {
                    "label": "r264",
                    "value": 264,
                    "title": "Version 264: 8 2 9 4; 9 1 6 7; 2 1 8 5; 6 5 2 4; 8 6 7 3; 7 9 4 3; 3 9 5 1; 2 8 3 5; 1 7 6 4"
                },
                {
                    "label": "r265",
                    "value": 265,
                    "title": "Version 265: 1 3 9 5; 9 6 1 8; 6 7 3 2; 4 5 7 8; 8 1 2 7; 8 4 9 6; 3 2 4 1; 5 3 6 4; 7 5 2 9"
                },
                {
                    "label": "r266",
                    "value": 266,
                    "title": "Version 266: 4 8 5 9; 4 8 3 7; 1 9 4 2; 3 9 8 6; 6 2 5 8; 2 1 7 6; 5 6 1 7; 7 3 9 5; 4 2 3 1"
                },
                {
                    "label": "r267",
                    "value": 267,
                    "title": "Version 267: 9 4 6 1; 1 7 8 5; 9 8 7 2; 9 1 2 3; 6 3 7 4; 2 4 6 5; 7 4 8 3; 8 5 1 6; 5 3 9 2"
                },
                {
                    "label": "r268",
                    "value": 268,
                    "title": "Version 268: 4 6 5 9; 3 7 4 5; 3 2 6 8; 5 8 3 1; 1 4 9 8; 6 1 7 3; 7 9 2 8; 2 5 6 9; 1 7 4 2"
                },
                {
                    "label": "r269",
                    "value": 269,
                    "title": "Version 269: 2 6 3 4; 3 9 5 7; 8 2 1 4; 4 5 9 2; 6 3 1 8; 9 1 4 5; 8 7 2 6; 5 8 7 1; 7 6 3 9"
                },
                {
                    "label": "r270",
                    "value": 270,
                    "title": "Version 270: 8 4 5 3; 5 3 2 1; 4 2 1 7; 7 6 8 4; 1 9 2 3; 9 8 5 6; 2 7 6 5; 8 3 4 9; 6 1 9 7"
                },
                {
                    "label": "r271",
                    "value": 271,
                    "title": "Version 271: 7 9 8 2; 3 6 4 1; 4 5 3 2; 6 8 2 3; 9 4 6 1; 1 3 9 7; 2 7 5 4; 5 1 8 6; 7 5 8 9"
                },
                {
                    "label": "r272",
                    "value": 272,
                    "title": "Version 272: 3 4 7 8; 6 2 1 7; 1 2 9 8; 2 7 3 5; 3 9 4 8; 9 6 4 2; 4 1 5 7; 3 5 6 9; 8 5 1 6"
                },
                {
                    "label": "r273",
                    "value": 273,
                    "title": "Version 273: 6 4 2 3; 5 6 7 9; 9 8 1 2; 1 8 7 4; 7 5 9 4; 5 1 3 6; 8 2 6 4; 9 7 1 3; 3 8 5 2"
                },
                {
                    "label": "r274",
                    "value": 274,
                    "title": "Version 274: 2 9 7 6; 2 3 9 1; 4 1 3 9; 1 2 4 5; 5 2 8 7; 6 7 8 3; 4 7 6 8; 4 9 5 6; 8 3 5 1"
                },
                {
                    "label": "r275",
                    "value": 275,
                    "title": "Version 275: 3 6 4 8; 6 4 2 1; 7 3 9 4; 7 1 6 5; 5 6 2 8; 8 4 5 9; 9 5 7 3; 9 8 1 2; 2 3 1 7"
                },
                {
                    "label": "r276",
                    "value": 276,
                    "title": "Version 276: 2 9 8 4; 1 7 4 5; 7 8 3 1; 3 1 4 6; 1 6 8 9; 6 2 7 9; 8 9 3 5; 4 5 2 7; 5 6 3 2"
                },
                {
                    "label": "r277",
                    "value": 277,
                    "title": "Version 277: 8 5 2 3; 6 2 9 7; 5 4 8 1; 3 4 7 8; 9 1 6 5; 4 3 6 9; 7 9 1 2; 2 5 4 3; 1 8 7 6"
                },
                {
                    "label": "r278",
                    "value": 278,
                    "title": "Version 278: 1 9 5 4; 4 7 8 6; 2 8 9 3; 5 6 1 2; 7 4 2 8; 3 7 9 1; 6 3 5 7; 1 2 3 4; 8 9 6 5"
                },
                {
                    "label": "r279",
                    "value": 279,
                    "title": "Version 279: 9 5 7 8; 5 2 9 4; 4 1 2 8; 9 1 5 3; 2 4 6 7; 8 1 3 2; 3 6 7 5; 7 8 1 6; 6 3 4 9"
                },
                {
                    "label": "r280",
                    "value": 280,
                    "title": "Version 280: 5 7 8 9; 8 5 3 2; 3 7 8 4; 2 7 5 1; 9 2 6 3; 6 4 1 5; 1 6 2 9; 7 3 4 1; 8 9 4 6"
                },
                {
                    "label": "r281",
                    "value": 281,
                    "title": "Version 281: 6 8 3 7; 7 5 2 1; 4 7 9 5; 1 8 6 3; 2 6 5 8; 9 3 7 2; 4 9 1 2; 8 1 9 4; 5 4 3 6"
                },
                {
                    "label": "r282",
                    "value": 282,
                    "title": "Version 282: 6 2 4 7; 9 6 8 1; 4 8 2 5; 7 5 1 4; 3 1 9 7; 4 9 6 3; 3 5 8 1; 2 9 7 8; 5 2 3 6"
                },
                {
                    "label": "r283",
                    "value": 283,
                    "title": "Version 283: 2 3 4 7; 1 7 5 6; 3 4 1 9; 1 2 6 8; 9 7 5 8; 5 3 2 9; 7 8 3 2; 6 4 9 5; 8 1 6 4"
                },
                {
                    "label": "r284",
                    "value": 284,
                    "title": "Version 284: 1 2 8 4; 2 5 1 3; 3 6 8 9; 8 9 5 2; 8 3 7 4; 9 6 7 2; 6 1 3 5; 4 9 6 7; 7 4 5 1"
                },
                {
                    "label": "r285",
                    "value": 285,
                    "title": "Version 285: 5 8 7 6; 7 5 8 3; 9 2 4 1; 1 3 9 7; 5 6 2 4; 1 8 9 5; 4 8 2 3; 6 4 3 9; 2 1 7 6"
                },
                {
                    "label": "r286",
                    "value": 286,
                    "title": "Version 286: 3 9 2 6; 4 7 1 5; 6 1 2 7; 9 5 1 3; 7 9 4 8; 5 6 8 4; 7 2 9 8; 2 4 3 5; 3 8 6 1"
                },
                {
                    "label": "r287",
                    "value": 287,
                    "title": "Version 287: 7 3 5 2; 8 5 4 6; 3 7 6 1; 5 2 6 9; 4 3 8 1; 1 9 8 2; 8 7 9 5; 6 1 4 9; 2 4 7 3"
                },
                {
                    "label": "r288",
                    "value": 288,
                    "title": "Version 288: 9 5 1 2; 9 3 5 8; 2 8 9 7; 3 6 2 4; 5 4 3 6; 1 6 2 8; 4 7 6 9; 8 1 7 3; 4 1 5 7"
                },
                {
                    "label": "r289",
                    "value": 289,
                    "title": "Version 289: 8 4 1 5; 6 8 4 7; 5 2 7 1; 1 5 9 3; 3 6 1 8; 9 2 5 4; 2 3 8 6; 7 9 4 2; 6 7 3 9"
                },
                {
                    "label": "r290",
                    "value": 290,
                    "title": "Version 290: 3 7 5 4; 4 3 1 2; 2 4 7 1; 5 6 9 8; 8 5 2 6; 9 8 4 3; 7 9 3 6; 1 2 8 9; 6 1 7 5"
                },
                {
                    "label": "r291",
                    "value": 291,
                    "title": "Version 291: 1 2 6 4; 8 3 5 7; 3 8 2 7; 4 5 8 6; 7 4 9 2; 9 4 1 8; 6 1 7 9; 2 6 3 5; 5 3 9 1"
                },
                {
                    "label": "r292",
                    "value": 292,
                    "title": "Version 292: 8 7 5 2; 2 9 6 3; 3 9 4 1; 6 8 4 1; 5 6 7 9; 4 9 2 5; 7 1 6 5; 1 2 8 3; 8 7 3 4"
                },
                {
                    "label": "r293",
                    "value": 293,
                    "title": "Version 293: 6 3 2 7; 9 7 1 8; 9 5 1 3; 5 8 4 2; 9 4 8 6; 7 6 1 2; 1 6 3 4; 4 5 9 7; 2 3 5 8"
                },
                {
                    "label": "r294",
                    "value": 294,
                    "title": "Version 294: 3 4 5 9; 3 8 4 7; 4 2 6 9; 5 1 2 4; 7 5 6 1; 2 9 8 1; 6 2 3 5; 8 7 9 6; 1 3 7 8"
                },
                {
                    "label": "r295",
                    "value": 295,
                    "title": "Version 295: 2 7 5 9; 7 8 6 4; 7 4 2 3; 4 2 8 5; 5 1 9 3; 3 1 7 4; 6 5 1 8; 8 6 3 9; 9 1 2 6"
                },
                {
                    "label": "r296",
                    "value": 296,
                    "title": "Version 296: 1 3 4 2; 2 9 3 6; 5 6 8 7; 1 2 7 8; 3 8 6 2; 4 5 1 7; 9 7 5 3; 8 9 4 5; 6 4 9 1"
                },
                {
                    "label": "r297",
                    "value": 297,
                    "title": "Version 297: 6 9 4 8; 9 7 2 3; 2 6 5 1; 3 4 6 5; 7 2 4 6; 5 1 7 3; 1 8 9 7; 4 8 9 2; 8 3 5 1"
                },
                {
                    "label": "r298",
                    "value": 298,
                    "title": "Version 298: 6 5 1 4; 8 4 3 6; 2 5 1 9; 5 2 8 7; 1 4 8 2; 4 3 7 9; 9 1 6 7; 7 6 2 3; 3 9 8 5"
                },
                {
                    "label": "r299",
                    "value": 299,
                    "title": "Version 299: 4 7 5 8; 6 7 3 1; 2 5 6 4; 1 2 3 8; 5 7 4 9; 9 6 2 8; 3 9 5 6; 7 1 9 2; 8 3 1 4"
                },
                {
                    "label": "r300",
                    "value": 300,
                    "title": "Version 300: 2 9 7 4; 3 8 9 5; 5 2 6 1; 6 5 8 7; 4 3 2 5; 8 6 1 9; 7 8 3 2; 9 4 1 3; 1 4 7 6"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q22_version"
        },
        {
            "vgroup": "Q22_1",
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "colTitle": "Most convincing",
            "title": "Most convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "rowTitle": null,
            "label": "Q22_1c1",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "row": null,
            "type": "single",
            "col": "c1",
            "qlabel": "Q22_1"
        },
        {
            "vgroup": "Q22_1",
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "colTitle": "Least convincing",
            "title": "Least convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "rowTitle": null,
            "label": "Q22_1c2",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "row": null,
            "type": "single",
            "col": "c2",
            "qlabel": "Q22_1"
        },
        {
            "vgroup": "Q22_2",
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "colTitle": "Most convincing",
            "title": "Most convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "rowTitle": null,
            "label": "Q22_2c1",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "row": null,
            "type": "single",
            "col": "c1",
            "qlabel": "Q22_2"
        },
        {
            "vgroup": "Q22_2",
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "colTitle": "Least convincing",
            "title": "Least convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "rowTitle": null,
            "label": "Q22_2c2",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "row": null,
            "type": "single",
            "col": "c2",
            "qlabel": "Q22_2"
        },
        {
            "vgroup": "Q22_3",
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "colTitle": "Most convincing",
            "title": "Most convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "rowTitle": null,
            "label": "Q22_3c1",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "row": null,
            "type": "single",
            "col": "c1",
            "qlabel": "Q22_3"
        },
        {
            "vgroup": "Q22_3",
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "colTitle": "Least convincing",
            "title": "Least convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "rowTitle": null,
            "label": "Q22_3c2",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "row": null,
            "type": "single",
            "col": "c2",
            "qlabel": "Q22_3"
        },
        {
            "vgroup": "Q22_4",
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "colTitle": "Most convincing",
            "title": "Most convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "rowTitle": null,
            "label": "Q22_4c1",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "row": null,
            "type": "single",
            "col": "c1",
            "qlabel": "Q22_4"
        },
        {
            "vgroup": "Q22_4",
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "colTitle": "Least convincing",
            "title": "Least convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "rowTitle": null,
            "label": "Q22_4c2",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "row": null,
            "type": "single",
            "col": "c2",
            "qlabel": "Q22_4"
        },
        {
            "vgroup": "Q22_5",
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "colTitle": "Most convincing",
            "title": "Most convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "rowTitle": null,
            "label": "Q22_5c1",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "row": null,
            "type": "single",
            "col": "c1",
            "qlabel": "Q22_5"
        },
        {
            "vgroup": "Q22_5",
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "colTitle": "Least convincing",
            "title": "Least convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "rowTitle": null,
            "label": "Q22_5c2",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "row": null,
            "type": "single",
            "col": "c2",
            "qlabel": "Q22_5"
        },
        {
            "vgroup": "Q22_6",
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "colTitle": "Most convincing",
            "title": "Most convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "rowTitle": null,
            "label": "Q22_6c1",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "row": null,
            "type": "single",
            "col": "c1",
            "qlabel": "Q22_6"
        },
        {
            "vgroup": "Q22_6",
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "colTitle": "Least convincing",
            "title": "Least convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "rowTitle": null,
            "label": "Q22_6c2",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "row": null,
            "type": "single",
            "col": "c2",
            "qlabel": "Q22_6"
        },
        {
            "vgroup": "Q22_7",
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "colTitle": "Most convincing",
            "title": "Most convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "rowTitle": null,
            "label": "Q22_7c1",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "row": null,
            "type": "single",
            "col": "c1",
            "qlabel": "Q22_7"
        },
        {
            "vgroup": "Q22_7",
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "colTitle": "Least convincing",
            "title": "Least convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "rowTitle": null,
            "label": "Q22_7c2",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "row": null,
            "type": "single",
            "col": "c2",
            "qlabel": "Q22_7"
        },
        {
            "vgroup": "Q22_8",
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "colTitle": "Most convincing",
            "title": "Most convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "rowTitle": null,
            "label": "Q22_8c1",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "row": null,
            "type": "single",
            "col": "c1",
            "qlabel": "Q22_8"
        },
        {
            "vgroup": "Q22_8",
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "colTitle": "Least convincing",
            "title": "Least convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "rowTitle": null,
            "label": "Q22_8c2",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "row": null,
            "type": "single",
            "col": "c2",
            "qlabel": "Q22_8"
        },
        {
            "vgroup": "Q22_9",
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "colTitle": "Most convincing",
            "title": "Most convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "rowTitle": null,
            "label": "Q22_9c1",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "row": null,
            "type": "single",
            "col": "c1",
            "qlabel": "Q22_9"
        },
        {
            "vgroup": "Q22_9",
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "colTitle": "Least convincing",
            "title": "Least convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "rowTitle": null,
            "label": "Q22_9c2",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "row": null,
            "type": "single",
            "col": "c2",
            "qlabel": "Q22_9"
        },
        {
            "vgroup": "Q23",
            "qtitle": "When you hear the term \"clean energy,\" which of the following comes closest to your view?",
            "colTitle": null,
            "title": "When you hear the term \"clean energy,\" which of the following comes closest to your view?",
            "rowTitle": null,
            "label": "Q23",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "It is strongly associated with the Democratic Party"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "It is somewhat associated with the Democratic Party"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "It is associated with both parties equally"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "It is somewhat associated with the Republican Party"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "It is strongly associated with the Republican Party"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q23"
        },
        {
            "vgroup": "Q24",
            "qtitle": "When you hear the term \"clean energy,\" what does it mean to you personally?",
            "colTitle": null,
            "title": "When you hear the term \"clean energy,\" what does it mean to you personally?",
            "rowTitle": null,
            "label": "Q24",
            "row": null,
            "type": "text",
            "col": null,
            "qlabel": "Q24"
        },
        {
            "vgroup": "Q30",
            "qtitle": "Which of the following do you see as the biggest threat to the growth of clean energy in the U.S.?",
            "colTitle": null,
            "title": "Which of the following do you see as the biggest threat to the growth of clean energy in the U.S.?",
            "rowTitle": null,
            "label": "Q30",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Higher costs for consumers"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Unreliable and inconsistent supply"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Dependence on foreign countries for energy or materials"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Political opposition and polarization"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "Lack of technological innovation"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Other, please specify"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q30"
        },
        {
            "vgroup": "Q30r6oe",
            "qtitle": "Which of the following do you see as the biggest threat to the growth of clean energy in the U.S.?",
            "colTitle": null,
            "title": "Which of the following do you see as the biggest threat to the growth of clean energy in the U.S.? - Other, please specify",
            "rowTitle": "Other, please specify",
            "label": "Q30r6oe",
            "row": "r6",
            "type": "text",
            "col": null,
            "qlabel": "Q30"
        },
        {
            "vgroup": "Q31",
            "qtitle": "Do you think adding more clean energy to the grid makes the system...",
            "colTitle": null,
            "title": "Do you think adding more clean energy to the grid makes the system...",
            "rowTitle": null,
            "label": "Q31",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Stronger and more reliable overall because it adds new supply, reduces dependence on fossil fuels, and modernizes the grid."
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Stronger in some ways but more strained in others, because it provides more supply but also puts pressure on the grid and requires major new infrastructure."
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Weaker and less reliable overall because renewables make the grid more vulnerable to shortages and disruptions."
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q31"
        },
        {
            "vgroup": "Q32",
            "qtitle": "Please read the following statements and select the one that comes the closest to your own opinion.",
            "colTitle": null,
            "title": "Please read the following statements and select the one that comes the closest to your own opinion.",
            "rowTitle": null,
            "label": "Q32",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "I fully support all types of clean energy projects being built in my community. Clean energy infrastructure from wind turbines to solar farms will only serve to benefit my local community and the environment by reducing our reliance on fossil fuels."
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "I have mixed feelings about clean energy projects being built in my community. I recognize the importance of transitioning away from fossil fuels to more clean energy sources, but I worry about how it will look, the noise it may produce, and impacts on local infrastructure."
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "I have mixed feelings about clean energy projects being built near me. I don't worry about how they look or the noise they make, but I'm most concerned with whether the energy generated from that project will benefit me directly, or if the energy produced will get transported elsewhere. I don't want an energy project built near me if I won't benefit directly from it."
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "I am fully opposed to any and all clean energy infrastructure projects being built near me. There is nothing companies can say about the jobs they will produce, their positive impact on our local climate, and positive impacts on local energy prices that would persuade me to support it."
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q32"
        },
        {
            "vgroup": "Q33",
            "qtitle": "Please read the below statements and select the one that comes the closest to your own opinion.",
            "colTitle": null,
            "title": "Please read the below statements and select the one that comes the closest to your own opinion.",
            "rowTitle": null,
            "label": "Q33",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Once an energy project has already been permitted, it should be allowed to move forward. Reversing or cancelling permitted projects deters investment by reducing business leaders' confidence in the reliability of America's government."
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Presidential administrations should re-examine and, if necessary, stop energy projects that, in their view, don't benefit America, even if those projects have already received permits from a prior administration and begun construction."
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q33"
        },
        {
            "vgroup": "Q34",
            "qtitle": "What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
            "colTitle": null,
            "title": "Lower energy bills or guaranteed local energy savings - What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
            "rowTitle": "Lower energy bills or guaranteed local energy savings",
            "label": "Q34r1",
            "value": 1,
            "row": "r1",
            "type": "multiple",
            "col": null,
            "qlabel": "Q34"
        },
        {
            "vgroup": "Q34",
            "qtitle": "What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
            "colTitle": null,
            "title": "More local jobs created by the project - What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
            "rowTitle": "More local jobs created by the project",
            "label": "Q34r2",
            "value": 1,
            "row": "r2",
            "type": "multiple",
            "col": null,
            "qlabel": "Q34"
        },
        {
            "vgroup": "Q34",
            "qtitle": "What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
            "colTitle": null,
            "title": "Clear evidence that the project will be safe, quiet, and not disruptive - What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
            "rowTitle": "Clear evidence that the project will be safe, quiet, and not disruptive",
            "label": "Q34r3",
            "value": 1,
            "row": "r3",
            "type": "multiple",
            "col": null,
            "qlabel": "Q34"
        },
        {
            "vgroup": "Q34",
            "qtitle": "What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
            "colTitle": null,
            "title": "Strong protections for property values and local land use - What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
            "rowTitle": "Strong protections for property values and local land use",
            "label": "Q34r4",
            "value": 1,
            "row": "r4",
            "type": "multiple",
            "col": null,
            "qlabel": "Q34"
        },
        {
            "vgroup": "Q34",
            "qtitle": "What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
            "colTitle": null,
            "title": "Reduced pollution in the area - What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
            "rowTitle": "Reduced pollution in the area",
            "label": "Q34r5",
            "value": 1,
            "row": "r5",
            "type": "multiple",
            "col": null,
            "qlabel": "Q34"
        },
        {
            "vgroup": "Q34",
            "qtitle": "What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
            "colTitle": null,
            "title": "Local ownership or community investment opportunities - What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
            "rowTitle": "Local ownership or community investment opportunities",
            "label": "Q34r6",
            "value": 1,
            "row": "r6",
            "type": "multiple",
            "col": null,
            "qlabel": "Q34"
        },
        {
            "vgroup": "Q34",
            "qtitle": "What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
            "colTitle": null,
            "title": "Assurance that the energy generated will directly benefit my community - What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
            "rowTitle": "Assurance that the energy generated will directly benefit my community",
            "label": "Q34r7",
            "value": 1,
            "row": "r7",
            "type": "multiple",
            "col": null,
            "qlabel": "Q34"
        },
        {
            "vgroup": "Q34",
            "qtitle": "What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
            "colTitle": null,
            "title": "Transparency and open communication from developers and government officials - What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
            "rowTitle": "Transparency and open communication from developers and government officials",
            "label": "Q34r8",
            "value": 1,
            "row": "r8",
            "type": "multiple",
            "col": null,
            "qlabel": "Q34"
        },
        {
            "vgroup": "Q34",
            "qtitle": "What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
            "colTitle": null,
            "title": "None of the above - What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
            "rowTitle": "None of the above",
            "label": "Q34r9",
            "value": 1,
            "row": "r9",
            "type": "multiple",
            "col": null,
            "qlabel": "Q34"
        },
        {
            "vgroup": "Q35",
            "qtitle": "Personally, do you consider yourself to be a(n)",
            "colTitle": null,
            "title": "Personally, do you consider yourself to be a(n)",
            "rowTitle": null,
            "label": "Q35",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Strong Republican"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Moderate Republican"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Independent"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Moderate Democrat"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "Strong Democrat"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Other"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q35"
        },
        {
            "vgroup": "Q35r6oe",
            "qtitle": "Personally, do you consider yourself to be a(n)",
            "colTitle": null,
            "title": "Personally, do you consider yourself to be a(n) - Other",
            "rowTitle": "Other",
            "label": "Q35r6oe",
            "row": "r6",
            "type": "text",
            "col": null,
            "qlabel": "Q35"
        },
        {
            "vgroup": "Q36",
            "qtitle": "Which of the following best describes you?",
            "colTitle": null,
            "title": "Which of the following best describes you?",
            "rowTitle": null,
            "label": "Q36",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Emphasizes strong national borders, America-first policies, economic nationalism, and a focus on reducing government regulation."
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Emphasizes limited government, free-market principles, and a strong national defense."
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Emphasizes preserving traditional values, promoting family-oriented policies, and advocating for religious freedoms."
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Emphasizes individual liberties, minimal government intervention, and free-market solutions."
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "Emphasizes a middle ground on various issues, advocating for bipartisan solutions and cooperation."
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q36"
        },
        {
            "vgroup": "Q37",
            "qtitle": "Which of the following best describes you?",
            "colTitle": null,
            "title": "Which of the following best describes you?",
            "rowTitle": null,
            "label": "Q37",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Emphasizes social justice, climate action, economic equality, and comprehensive healthcare reform."
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Emphasizes pragmatic policies, maintaining party unity, and incremental reforms."
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Emphasizes expanding social welfare programs, workers' rights, and reducing income inequality."
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Emphasizes centrist policies, bipartisan cooperation, and practical solutions to issues like healthcare, education, and economic stability."
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "Emphasizes civil rights, immigration reform, and policies that support minority communities."
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q37"
        },
        {
            "vgroup": "Q38",
            "qtitle": "What type of community do you live in?",
            "colTitle": null,
            "title": "What type of community do you live in?",
            "rowTitle": null,
            "label": "Q38",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Large city"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Suburb near a large city"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Small city or town"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Rural area"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q38"
        },
        {
            "vgroup": "Q39",
            "qtitle": "How frequently do others come to you for your opinion or advice on the following topics?",
            "colTitle": null,
            "title": "Geopolitical issues (e.g., US-China issues, trade tensions, rise in populism) - How frequently do others come to you for your opinion or advice on the following topics?",
            "rowTitle": "Geopolitical issues (e.g., US-China issues, trade tensions, rise in populism)",
            "label": "Q39r1",
            "values": [
                {
                    "label": "c1",
                    "value": 1,
                    "title": "All the time"
                },
                {
                    "label": "c2",
                    "value": 2,
                    "title": "Quite often"
                },
                {
                    "label": "c3",
                    "value": 3,
                    "title": "Sometimes"
                },
                {
                    "label": "c4",
                    "value": 4,
                    "title": "Seldom or rarely"
                },
                {
                    "label": "c5",
                    "value": 5,
                    "title": "Never"
                }
            ],
            "row": "r1",
            "type": "single",
            "col": null,
            "qlabel": "Q39"
        },
        {
            "vgroup": "Q39",
            "qtitle": "How frequently do others come to you for your opinion or advice on the following topics?",
            "colTitle": null,
            "title": "Domestic policy and regulation - How frequently do others come to you for your opinion or advice on the following topics?",
            "rowTitle": "Domestic policy and regulation",
            "label": "Q39r2",
            "values": [
                {
                    "label": "c1",
                    "value": 1,
                    "title": "All the time"
                },
                {
                    "label": "c2",
                    "value": 2,
                    "title": "Quite often"
                },
                {
                    "label": "c3",
                    "value": 3,
                    "title": "Sometimes"
                },
                {
                    "label": "c4",
                    "value": 4,
                    "title": "Seldom or rarely"
                },
                {
                    "label": "c5",
                    "value": 5,
                    "title": "Never"
                }
            ],
            "row": "r2",
            "type": "single",
            "col": null,
            "qlabel": "Q39"
        },
        {
            "vgroup": "Q39",
            "qtitle": "How frequently do others come to you for your opinion or advice on the following topics?",
            "colTitle": null,
            "title": "Economic issues (e.g., Overall state of the economy, tax policy, inflation) - How frequently do others come to you for your opinion or advice on the following topics?",
            "rowTitle": "Economic issues (e.g., Overall state of the economy, tax policy, inflation)",
            "label": "Q39r3",
            "values": [
                {
                    "label": "c1",
                    "value": 1,
                    "title": "All the time"
                },
                {
                    "label": "c2",
                    "value": 2,
                    "title": "Quite often"
                },
                {
                    "label": "c3",
                    "value": 3,
                    "title": "Sometimes"
                },
                {
                    "label": "c4",
                    "value": 4,
                    "title": "Seldom or rarely"
                },
                {
                    "label": "c5",
                    "value": 5,
                    "title": "Never"
                }
            ],
            "row": "r3",
            "type": "single",
            "col": null,
            "qlabel": "Q39"
        },
        {
            "vgroup": "Q39",
            "qtitle": "How frequently do others come to you for your opinion or advice on the following topics?",
            "colTitle": null,
            "title": "Environmental sustainability/climate change - How frequently do others come to you for your opinion or advice on the following topics?",
            "rowTitle": "Environmental sustainability/climate change",
            "label": "Q39r4",
            "values": [
                {
                    "label": "c1",
                    "value": 1,
                    "title": "All the time"
                },
                {
                    "label": "c2",
                    "value": 2,
                    "title": "Quite often"
                },
                {
                    "label": "c3",
                    "value": 3,
                    "title": "Sometimes"
                },
                {
                    "label": "c4",
                    "value": 4,
                    "title": "Seldom or rarely"
                },
                {
                    "label": "c5",
                    "value": 5,
                    "title": "Never"
                }
            ],
            "row": "r4",
            "type": "single",
            "col": null,
            "qlabel": "Q39"
        },
        {
            "vgroup": "Q39",
            "qtitle": "How frequently do others come to you for your opinion or advice on the following topics?",
            "colTitle": null,
            "title": "Energy - How frequently do others come to you for your opinion or advice on the following topics?",
            "rowTitle": "Energy",
            "label": "Q39r5",
            "values": [
                {
                    "label": "c1",
                    "value": 1,
                    "title": "All the time"
                },
                {
                    "label": "c2",
                    "value": 2,
                    "title": "Quite often"
                },
                {
                    "label": "c3",
                    "value": 3,
                    "title": "Sometimes"
                },
                {
                    "label": "c4",
                    "value": 4,
                    "title": "Seldom or rarely"
                },
                {
                    "label": "c5",
                    "value": 5,
                    "title": "Never"
                }
            ],
            "row": "r5",
            "type": "single",
            "col": null,
            "qlabel": "Q39"
        },
        {
            "vgroup": "Q40",
            "qtitle": "Which, if any, of the following generally describe you?",
            "colTitle": null,
            "title": "Business entrepreneur (someone who has set up a business which uses new ideas or new techniques or targets a new market) - Which, if any, of the following generally describe you?",
            "rowTitle": "Business entrepreneur (someone who has set up a business which uses new ideas or new techniques or targets a new market)",
            "label": "Q40r1",
            "value": 1,
            "row": "r1",
            "type": "multiple",
            "col": null,
            "qlabel": "Q40"
        },
        {
            "vgroup": "Q40",
            "qtitle": "Which, if any, of the following generally describe you?",
            "colTitle": null,
            "title": "Social entrepreneur (someone who has set up a charity or not-for-profit organization which uses new ideas or new techniques or helps a new group) - Which, if any, of the following generally describe you?",
            "rowTitle": "Social entrepreneur (someone who has set up a charity or not-for-profit organization which uses new ideas or new techniques or helps a new group)",
            "label": "Q40r2",
            "value": 1,
            "row": "r2",
            "type": "multiple",
            "col": null,
            "qlabel": "Q40"
        },
        {
            "vgroup": "Q40",
            "qtitle": "Which, if any, of the following generally describe you?",
            "colTitle": null,
            "title": "Religious leader (priest, rabbi, imam, guru, etc.) - Which, if any, of the following generally describe you?",
            "rowTitle": "Religious leader (priest, rabbi, imam, guru, etc.)",
            "label": "Q40r3",
            "value": 1,
            "row": "r3",
            "type": "multiple",
            "col": null,
            "qlabel": "Q40"
        },
        {
            "vgroup": "Q40",
            "qtitle": "Which, if any, of the following generally describe you?",
            "colTitle": null,
            "title": "Organizer of national or local civic activities (e.g., public or community events, community action) - Which, if any, of the following generally describe you?",
            "rowTitle": "Organizer of national or local civic activities (e.g., public or community events, community action)",
            "label": "Q40r4",
            "value": 1,
            "row": "r4",
            "type": "multiple",
            "col": null,
            "qlabel": "Q40"
        },
        {
            "vgroup": "Q40",
            "qtitle": "Which, if any, of the following generally describe you?",
            "colTitle": null,
            "title": "Organizer of national or local social activities (e.g., children's group, sports club, voluntary group) - Which, if any, of the following generally describe you?",
            "rowTitle": "Organizer of national or local social activities (e.g., children's group, sports club, voluntary group)",
            "label": "Q40r5",
            "value": 1,
            "row": "r5",
            "type": "multiple",
            "col": null,
            "qlabel": "Q40"
        },
        {
            "vgroup": "Q40",
            "qtitle": "Which, if any, of the following generally describe you?",
            "colTitle": null,
            "title": "Journalist, writer or blogger (at least weekly) on news, public affairs, business or community issues - Which, if any, of the following generally describe you?",
            "rowTitle": "Journalist, writer or blogger (at least weekly) on news, public affairs, business or community issues",
            "label": "Q40r6",
            "value": 1,
            "row": "r6",
            "type": "multiple",
            "col": null,
            "qlabel": "Q40"
        },
        {
            "vgroup": "Q40",
            "qtitle": "Which, if any, of the following generally describe you?",
            "colTitle": null,
            "title": "Stood for public office in the past 10 years (e.g., election to local council, MP, magistrate) - Which, if any, of the following generally describe you?",
            "rowTitle": "Stood for public office in the past 10 years (e.g., election to local council, MP, magistrate)",
            "label": "Q40r7",
            "value": 1,
            "row": "r7",
            "type": "multiple",
            "col": null,
            "qlabel": "Q40"
        },
        {
            "vgroup": "Q40",
            "qtitle": "Which, if any, of the following generally describe you?",
            "colTitle": null,
            "title": "Community leader - Which, if any, of the following generally describe you?",
            "rowTitle": "Community leader",
            "label": "Q40r8",
            "value": 1,
            "row": "r8",
            "type": "multiple",
            "col": null,
            "qlabel": "Q40"
        },
        {
            "vgroup": "Q40",
            "qtitle": "Which, if any, of the following generally describe you?",
            "colTitle": null,
            "title": "None of these - Which, if any, of the following generally describe you?",
            "rowTitle": "None of these",
            "label": "Q40r9",
            "value": 1,
            "row": "r9",
            "type": "multiple",
            "col": null,
            "qlabel": "Q40"
        },
        {
            "vgroup": "Q41",
            "qtitle": "And which, if any, of the following also generally describe you?",
            "colTitle": null,
            "title": "Active member of a large society, business association or professional body - And which, if any, of the following also generally describe you?",
            "rowTitle": "Active member of a large society, business association or professional body",
            "label": "Q41r1",
            "value": 1,
            "row": "r1",
            "type": "multiple",
            "col": null,
            "qlabel": "Q41"
        },
        {
            "vgroup": "Q41",
            "qtitle": "And which, if any, of the following also generally describe you?",
            "colTitle": null,
            "title": "Director of a large business (more than 250 employees) - And which, if any, of the following also generally describe you?",
            "rowTitle": "Director of a large business (more than 250 employees)",
            "label": "Q41r2",
            "value": 1,
            "row": "r2",
            "type": "multiple",
            "col": null,
            "qlabel": "Q41"
        },
        {
            "vgroup": "Q41",
            "qtitle": "And which, if any, of the following also generally describe you?",
            "colTitle": null,
            "title": "Director of a small or medium sized business (less than 250 employees) - And which, if any, of the following also generally describe you?",
            "rowTitle": "Director of a small or medium sized business (less than 250 employees)",
            "label": "Q41r3",
            "value": 1,
            "row": "r3",
            "type": "multiple",
            "col": null,
            "qlabel": "Q41"
        },
        {
            "vgroup": "Q41",
            "qtitle": "And which, if any, of the following also generally describe you?",
            "colTitle": null,
            "title": "Director of a charity, NGO or non-governmental education or health organization (e.g., university, private school) - And which, if any, of the following also generally describe you?",
            "rowTitle": "Director of a charity, NGO or non-governmental education or health organization (e.g., university, private school)",
            "label": "Q41r4",
            "value": 1,
            "row": "r4",
            "type": "multiple",
            "col": null,
            "qlabel": "Q41"
        },
        {
            "vgroup": "Q41",
            "qtitle": "And which, if any, of the following also generally describe you?",
            "colTitle": null,
            "title": "Director of a public sector organization (e.g., central or local government department, agency, service, hospital, school, CCG) - And which, if any, of the following also generally describe you?",
            "rowTitle": "Director of a public sector organization (e.g., central or local government department, agency, service, hospital, school, CCG)",
            "label": "Q41r5",
            "value": 1,
            "row": "r5",
            "type": "multiple",
            "col": null,
            "qlabel": "Q41"
        },
        {
            "vgroup": "Q41",
            "qtitle": "And which, if any, of the following also generally describe you?",
            "colTitle": null,
            "title": "Been publicly recognized for my work (e.g., finalist or winner of a major award) - And which, if any, of the following also generally describe you?",
            "rowTitle": "Been publicly recognized for my work (e.g., finalist or winner of a major award)",
            "label": "Q41r6",
            "value": 1,
            "row": "r6",
            "type": "multiple",
            "col": null,
            "qlabel": "Q41"
        },
        {
            "vgroup": "Q41",
            "qtitle": "And which, if any, of the following also generally describe you?",
            "colTitle": null,
            "title": "Hold a trustee or governor's role of a significant organization (e.g., large charity, school) - And which, if any, of the following also generally describe you?",
            "rowTitle": "Hold a trustee or governor's role of a significant organization (e.g., large charity, school)",
            "label": "Q41r7",
            "value": 1,
            "row": "r7",
            "type": "multiple",
            "col": null,
            "qlabel": "Q41"
        },
        {
            "vgroup": "Q41",
            "qtitle": "And which, if any, of the following also generally describe you?",
            "colTitle": null,
            "title": "None of these - And which, if any, of the following also generally describe you?",
            "rowTitle": "None of these",
            "label": "Q41r8",
            "value": 1,
            "row": "r8",
            "type": "multiple",
            "col": null,
            "qlabel": "Q41"
        },
        {
            "vgroup": "Q42",
            "qtitle": "And again which, if any, of the following apply to you personally?",
            "colTitle": null,
            "title": "Have over 500 connections on LinkedIn - And again which, if any, of the following apply to you personally?",
            "rowTitle": "Have over 500 connections on LinkedIn",
            "label": "Q42r1",
            "value": 1,
            "row": "r1",
            "type": "multiple",
            "col": null,
            "qlabel": "Q42"
        },
        {
            "vgroup": "Q42",
            "qtitle": "And again which, if any, of the following apply to you personally?",
            "colTitle": null,
            "title": "Have over 500 friends on Facebook - And again which, if any, of the following apply to you personally?",
            "rowTitle": "Have over 500 friends on Facebook",
            "label": "Q42r2",
            "value": 1,
            "row": "r2",
            "type": "multiple",
            "col": null,
            "qlabel": "Q42"
        },
        {
            "vgroup": "Q42",
            "qtitle": "And again which, if any, of the following apply to you personally?",
            "colTitle": null,
            "title": "Use Twitter at least daily to read tweets about news, public affairs, politics, business or community issues - And again which, if any, of the following apply to you personally?",
            "rowTitle": "Use Twitter at least daily to read tweets about news, public affairs, politics, business or community issues",
            "label": "Q42r3",
            "value": 1,
            "row": "r3",
            "type": "multiple",
            "col": null,
            "qlabel": "Q42"
        },
        {
            "vgroup": "Q42",
            "qtitle": "And again which, if any, of the following apply to you personally?",
            "colTitle": null,
            "title": "Use Twitter at least daily to tweet about news, public affairs, politics, business or community issues - And again which, if any, of the following apply to you personally?",
            "rowTitle": "Use Twitter at least daily to tweet about news, public affairs, politics, business or community issues",
            "label": "Q42r4",
            "value": 1,
            "row": "r4",
            "type": "multiple",
            "col": null,
            "qlabel": "Q42"
        },
        {
            "vgroup": "Q42",
            "qtitle": "And again which, if any, of the following apply to you personally?",
            "colTitle": null,
            "title": "Read a national newspaper at least three times a week - And again which, if any, of the following apply to you personally?",
            "rowTitle": "Read a national newspaper at least three times a week",
            "label": "Q42r5",
            "value": 1,
            "row": "r5",
            "type": "multiple",
            "col": null,
            "qlabel": "Q42"
        },
        {
            "vgroup": "Q42",
            "qtitle": "And again which, if any, of the following apply to you personally?",
            "colTitle": null,
            "title": "Read a business, news or current affairs magazine at least once a month - And again which, if any, of the following apply to you personally?",
            "rowTitle": "Read a business, news or current affairs magazine at least once a month",
            "label": "Q42r6",
            "value": 1,
            "row": "r6",
            "type": "multiple",
            "col": null,
            "qlabel": "Q42"
        },
        {
            "vgroup": "Q42",
            "qtitle": "And again which, if any, of the following apply to you personally?",
            "colTitle": null,
            "title": "Watch the news on TV or listen on the radio every day - And again which, if any, of the following apply to you personally?",
            "rowTitle": "Watch the news on TV or listen on the radio every day",
            "label": "Q42r7",
            "value": 1,
            "row": "r7",
            "type": "multiple",
            "col": null,
            "qlabel": "Q42"
        },
        {
            "vgroup": "Q42",
            "qtitle": "And again which, if any, of the following apply to you personally?",
            "colTitle": null,
            "title": "Written a published paper, article or book (excluding self-published items such as blogs or eBooks) - And again which, if any, of the following apply to you personally?",
            "rowTitle": "Written a published paper, article or book (excluding self-published items such as blogs or eBooks)",
            "label": "Q42r8",
            "value": 1,
            "row": "r8",
            "type": "multiple",
            "col": null,
            "qlabel": "Q42"
        },
        {
            "vgroup": "Q42",
            "qtitle": "And again which, if any, of the following apply to you personally?",
            "colTitle": null,
            "title": "None of these - And again which, if any, of the following apply to you personally?",
            "rowTitle": "None of these",
            "label": "Q42r9",
            "value": 1,
            "row": "r9",
            "type": "multiple",
            "col": null,
            "qlabel": "Q42"
        },
        {
            "vgroup": "Q43",
            "qtitle": "Regardless of how you feel about the candidates today, for whom did you vote for in the 2024 presidential election?",
            "colTitle": null,
            "title": "Regardless of how you feel about the candidates today, for whom did you vote for in the 2024 presidential election?",
            "rowTitle": null,
            "label": "Q43",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Donald Trump, the Republican candidate"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Kamala Harris, the Democratic candidate"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Someone else"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "I did not vote"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "Q43"
        },
        {
            "vgroup": "dvfail",
            "qtitle": "FINAL DATA VALIDITY STATUS (QUALITY CONTROL)",
            "colTitle": null,
            "title": "FINAL DATA VALIDITY STATUS (QUALITY CONTROL)",
            "rowTitle": null,
            "label": "dvfail",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Data Validity Fail"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Data Validity Pass"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "dvfail"
        },
        {
            "vgroup": "vlist",
            "qtitle": "Participant source",
            "colTitle": null,
            "title": "Participant source",
            "rowTitle": null,
            "label": "vlist",
            "values": [
                {
                    "label": "22",
                    "value": 1,
                    "title": "Client Test Source (list=22)"
                },
                {
                    "label": "1",
                    "value": 2,
                    "title": "NAV (list=1)"
                },
                {
                    "label": "1t",
                    "value": 3,
                    "title": "NAV - SURVEY TESTING PORTAL ONLY (list=1t)"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "vlist"
        },
        {
            "vgroup": "qtime",
            "qtitle": "Total Interview Time",
            "colTitle": null,
            "title": "Total Interview Time",
            "rowTitle": null,
            "label": "qtime",
            "row": null,
            "type": "float",
            "col": null,
            "qlabel": "qtime"
        },
        {
            "vgroup": "vos",
            "qtitle": "Operating System",
            "colTitle": null,
            "title": "Operating System",
            "rowTitle": null,
            "label": "vos",
            "values": [
                {
                    "label": "r0",
                    "value": 1,
                    "title": "Windows 95"
                },
                {
                    "label": "r1",
                    "value": 2,
                    "title": "Windows 98"
                },
                {
                    "label": "r2",
                    "value": 3,
                    "title": "Windows 8"
                },
                {
                    "label": "r3",
                    "value": 4,
                    "title": "Windows 10"
                },
                {
                    "label": "r4",
                    "value": 5,
                    "title": "Windows 7"
                },
                {
                    "label": "r5",
                    "value": 6,
                    "title": "Windows Vista"
                },
                {
                    "label": "r6",
                    "value": 7,
                    "title": "Windows 2003"
                },
                {
                    "label": "r7",
                    "value": 8,
                    "title": "Windows XP"
                },
                {
                    "label": "r8",
                    "value": 9,
                    "title": "Windows 2000"
                },
                {
                    "label": "r9",
                    "value": 10,
                    "title": "Microsoft Windows NT 4.0"
                },
                {
                    "label": "r10",
                    "value": 11,
                    "title": "Windows ME"
                },
                {
                    "label": "r11",
                    "value": 12,
                    "title": "iPhone/iPad"
                },
                {
                    "label": "r12",
                    "value": 13,
                    "title": "Mac OS X or older"
                },
                {
                    "label": "r13",
                    "value": 14,
                    "title": "Other Mobile"
                },
                {
                    "label": "r14",
                    "value": 15,
                    "title": "Linux, UNIX"
                },
                {
                    "label": "r15",
                    "value": 16,
                    "title": "Other"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "vos"
        },
        {
            "vgroup": "vosr15oe",
            "qtitle": "Operating System",
            "colTitle": null,
            "title": "Operating System - Other",
            "rowTitle": "Other",
            "label": "vosr15oe",
            "row": "r15",
            "type": "text",
            "col": null,
            "qlabel": "vos"
        },
        {
            "vgroup": "vbrowser",
            "qtitle": "Browser",
            "colTitle": null,
            "title": "Browser",
            "rowTitle": null,
            "label": "vbrowser",
            "values": [
                {
                    "label": "r0",
                    "value": 1,
                    "title": "Opera"
                },
                {
                    "label": "r1",
                    "value": 2,
                    "title": "MS Edge"
                },
                {
                    "label": "r2",
                    "value": 3,
                    "title": "MSIE 11"
                },
                {
                    "label": "r3",
                    "value": 4,
                    "title": "MSIE 10.x"
                },
                {
                    "label": "r4",
                    "value": 5,
                    "title": "MSIE 9.x"
                },
                {
                    "label": "r5",
                    "value": 6,
                    "title": "MSIE 8.x"
                },
                {
                    "label": "r6",
                    "value": 7,
                    "title": "MSIE 7.x"
                },
                {
                    "label": "r7",
                    "value": 8,
                    "title": "MSIE 6.x"
                },
                {
                    "label": "r8",
                    "value": 9,
                    "title": "MSIE 5.x or older"
                },
                {
                    "label": "r9",
                    "value": 10,
                    "title": "Chrome"
                },
                {
                    "label": "r10",
                    "value": 11,
                    "title": "Safari"
                },
                {
                    "label": "r11",
                    "value": 12,
                    "title": "Firefox"
                },
                {
                    "label": "r12",
                    "value": 13,
                    "title": "Other Mozilla or Netscape"
                },
                {
                    "label": "r13",
                    "value": 14,
                    "title": "Mobile"
                },
                {
                    "label": "r14",
                    "value": 15,
                    "title": "Text Browser"
                },
                {
                    "label": "r15",
                    "value": 16,
                    "title": "Other"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "vbrowser"
        },
        {
            "vgroup": "vbrowserr15oe",
            "qtitle": "Browser",
            "colTitle": null,
            "title": "Browser - Other",
            "rowTitle": "Other",
            "label": "vbrowserr15oe",
            "row": "r15",
            "type": "text",
            "col": null,
            "qlabel": "vbrowser"
        },
        {
            "vgroup": "vmobiledevice",
            "qtitle": "Mobile device category",
            "colTitle": null,
            "title": "Mobile device category",
            "rowTitle": null,
            "label": "vmobiledevice",
            "values": [
                {
                    "label": "r0",
                    "value": 1,
                    "title": "Smartphone"
                },
                {
                    "label": "r1",
                    "value": 2,
                    "title": "Featurephone"
                },
                {
                    "label": "r2",
                    "value": 3,
                    "title": "Tablet"
                },
                {
                    "label": "r3",
                    "value": 4,
                    "title": "Other mobile"
                },
                {
                    "label": "r4",
                    "value": 5,
                    "title": "Desktop"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "vmobiledevice"
        },
        {
            "vgroup": "vmobileos",
            "qtitle": "Mobile OS",
            "colTitle": null,
            "title": "Mobile OS",
            "rowTitle": null,
            "label": "vmobileos",
            "values": [
                {
                    "label": "r0",
                    "value": 1,
                    "title": "iOS"
                },
                {
                    "label": "r1",
                    "value": 2,
                    "title": "Android"
                },
                {
                    "label": "r2",
                    "value": 3,
                    "title": "Symbian"
                },
                {
                    "label": "r3",
                    "value": 4,
                    "title": "Windows Phone"
                },
                {
                    "label": "r4",
                    "value": 5,
                    "title": "Blackberry"
                },
                {
                    "label": "r5",
                    "value": 6,
                    "title": "Other/Desktop"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "vmobileos"
        },
        {
            "vgroup": "start_date",
            "qtitle": "Survey start time",
            "colTitle": null,
            "title": "Survey start time",
            "rowTitle": null,
            "label": "start_date",
            "row": null,
            "type": "text",
            "col": null,
            "qlabel": "start_date"
        },
        {
            "vgroup": "vdropout",
            "qtitle": "Last seen question",
            "colTitle": null,
            "title": "Last seen question",
            "rowTitle": null,
            "label": "vdropout",
            "values": [
                {
                    "label": "Q1",
                    "value": 1,
                    "title": "(Q1) In what year were you born?"
                },
                {
                    "label": "Q2",
                    "value": 2,
                    "title": "(Q2) What is your gender?"
                },
                {
                    "label": "Q3",
                    "value": 3,
                    "title": "(Q3) In what state do you reside?"
                },
                {
                    "label": "Q4",
                    "value": 4,
                    "title": "(Q4) Which of the following best describes your racial and ethnic heritage?"
                },
                {
                    "label": "Q5",
                    "value": 5,
                    "title": "(Q5) What is the highest level of education you have completed?"
                },
                {
                    "label": "Q6",
                    "value": 6,
                    "title": "(Q6) Which of the following ranges includes your household's TOTAL annual income?"
                },
                {
                    "label": "Q7",
                    "value": 7,
                    "title": "(Q7) Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?"
                },
                {
                    "label": "Q8",
                    "value": 8,
                    "title": "(Q8) Thinking about the past year, how has what you pay for each of the following changed, if at all?"
                },
                {
                    "label": "Q9",
                    "value": 9,
                    "title": "(Q9) When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?"
                },
                {
                    "label": "Q10",
                    "value": 10,
                    "title": "(Q10) Which do you prioritize more when thinking about America's energy future?"
                },
                {
                    "label": "Q11",
                    "value": 11,
                    "title": "(Q11) Which statement comes closest to your view of the U.S. renewable energy industry?"
                },
                {
                    "label": "Q12",
                    "value": 12,
                    "title": "(Q12) Do you think a focus on growing renewable energy helps or hurts America's ability to compete globally?"
                },
                {
                    "label": "Q13",
                    "value": 13,
                    "title": "(Q13) Thinking about the future of electricity demand in the U.S., which of the following do you think is most likely in the next 10 years?"
                },
                {
                    "label": "Q14",
                    "value": 14,
                    "title": "(Q14) Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%."
                },
                {
                    "label": "Q15",
                    "value": 15,
                    "title": "(Q15) Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?"
                },
                {
                    "label": "Q16",
                    "value": 16,
                    "title": "(Q16) Please read the below statements and select the one that comes the closest to your own opinion."
                },
                {
                    "label": "Q17",
                    "value": 17,
                    "title": "(Q17) Please read the below statements and select the one that comes the closest to your own opinion."
                },
                {
                    "label": "Q18",
                    "value": 18,
                    "title": "(Q18) Please read the below statements and select the one that comes the closest to your own opinion."
                },
                {
                    "label": "Q19",
                    "value": 19,
                    "title": "(Q19) Please read the below statements and select the one that comes the closest to your own opinion."
                },
                {
                    "label": "Q20",
                    "value": 20,
                    "title": "(Q20) Please read the below statements and select the one that comes the closest to your own opinion."
                },
                {
                    "label": "Q21",
                    "value": 21,
                    "title": "(Q21) Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future."
                },
                {
                    "label": "Q22_1",
                    "value": 22,
                    "title": "(Q22_1) ${Q22.title}"
                },
                {
                    "label": "Q22_2",
                    "value": 23,
                    "title": "(Q22_2) ${Q22.title}"
                },
                {
                    "label": "Q22_3",
                    "value": 24,
                    "title": "(Q22_3) ${Q22.title}"
                },
                {
                    "label": "Q22_4",
                    "value": 25,
                    "title": "(Q22_4) ${Q22.title}"
                },
                {
                    "label": "Q22_5",
                    "value": 26,
                    "title": "(Q22_5) ${Q22.title}"
                },
                {
                    "label": "Q22_6",
                    "value": 27,
                    "title": "(Q22_6) ${Q22.title}"
                },
                {
                    "label": "Q22_7",
                    "value": 28,
                    "title": "(Q22_7) ${Q22.title}"
                },
                {
                    "label": "Q22_8",
                    "value": 29,
                    "title": "(Q22_8) ${Q22.title}"
                },
                {
                    "label": "Q22_9",
                    "value": 30,
                    "title": "(Q22_9) ${Q22.title}"
                },
                {
                    "label": "Q23",
                    "value": 31,
                    "title": "(Q23) When you hear the term \"clean energy,\" which of the following comes closest to your view?"
                },
                {
                    "label": "preQ24",
                    "value": 32,
                    "title": "(preQ24) Comment element"
                },
                {
                    "label": "Q24",
                    "value": 33,
                    "title": "(Q24) When you hear the term \"clean energy,\" what does it mean to you personally?"
                },
                {
                    "label": "Q30",
                    "value": 34,
                    "title": "(Q30) Which of the following do you see as the biggest threat to the growth of clean energy in the U.S.?"
                },
                {
                    "label": "Q31",
                    "value": 35,
                    "title": "(Q31) Do you think adding more clean energy to the grid makes the system..."
                },
                {
                    "label": "Q32",
                    "value": 36,
                    "title": "(Q32) Please read the following statements and select the one that comes the closest to your own opinion."
                },
                {
                    "label": "Q33",
                    "value": 37,
                    "title": "(Q33) Please read the below statements and select the one that comes the closest to your own opinion."
                },
                {
                    "label": "Q34",
                    "value": 38,
                    "title": "(Q34) What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?"
                },
                {
                    "label": "Q35",
                    "value": 39,
                    "title": "(Q35) Personally, do you consider yourself to be a(n)"
                },
                {
                    "label": "Q36",
                    "value": 40,
                    "title": "(Q36) Which of the following best describes you?"
                },
                {
                    "label": "Q37",
                    "value": 41,
                    "title": "(Q37) Which of the following best describes you?"
                },
                {
                    "label": "Q38",
                    "value": 42,
                    "title": "(Q38) What type of community do you live in?"
                },
                {
                    "label": "Q39",
                    "value": 43,
                    "title": "(Q39) How frequently do others come to you for your opinion or advice on the following topics?"
                },
                {
                    "label": "Q40",
                    "value": 44,
                    "title": "(Q40) Which, if any, of the following generally describe you?"
                },
                {
                    "label": "Q41",
                    "value": 45,
                    "title": "(Q41) And which, if any, of the following also generally describe you?"
                },
                {
                    "label": "Q42",
                    "value": 46,
                    "title": "(Q42) And again which, if any, of the following apply to you personally?"
                },
                {
                    "label": "Q43",
                    "value": 47,
                    "title": "(Q43) Regardless of how you feel about the candidates today, for whom did you vote for in the 2024 presidential election?"
                },
                {
                    "label": "V2outtro",
                    "value": 48,
                    "title": "(V2outtro) Comment element"
                }
            ],
            "row": null,
            "type": "single",
            "col": null,
            "qlabel": "vdropout"
        },
        {
            "vgroup": "source",
            "qtitle": "Captured variable",
            "colTitle": null,
            "title": "Captured variable",
            "rowTitle": null,
            "label": "source",
            "row": null,
            "type": "text",
            "col": null,
            "qlabel": null
        },
        {
            "vgroup": "decLang",
            "qtitle": "Captured variable",
            "colTitle": null,
            "title": "Captured variable",
            "rowTitle": null,
            "label": "decLang",
            "row": null,
            "type": "text",
            "col": null,
            "qlabel": null
        },
        {
            "vgroup": "list",
            "qtitle": "Captured variable",
            "colTitle": null,
            "title": "Captured variable",
            "rowTitle": null,
            "label": "list",
            "row": null,
            "type": "text",
            "col": null,
            "qlabel": null
        },
        {
            "vgroup": "userAgent",
            "qtitle": "Captured variable",
            "colTitle": null,
            "title": "Captured variable",
            "rowTitle": null,
            "label": "userAgent",
            "row": null,
            "type": "text",
            "col": null,
            "qlabel": null
        },
        {
            "vgroup": "dcua",
            "qtitle": "Captured variable",
            "colTitle": null,
            "title": "Captured variable",
            "rowTitle": null,
            "label": "dcua",
            "row": null,
            "type": "text",
            "col": null,
            "qlabel": null
        },
        {
            "vgroup": "url",
            "qtitle": "Captured variable",
            "colTitle": null,
            "title": "Captured variable",
            "rowTitle": null,
            "label": "url",
            "row": null,
            "type": "text",
            "col": null,
            "qlabel": null
        },
        {
            "vgroup": "session",
            "qtitle": "Captured variable",
            "colTitle": null,
            "title": "Captured variable",
            "rowTitle": null,
            "label": "session",
            "row": null,
            "type": "text",
            "col": null,
            "qlabel": null
        },
        {
            "vgroup": "s2",
            "qtitle": "Captured variable",
            "colTitle": null,
            "title": "Captured variable",
            "rowTitle": null,
            "label": "s2",
            "row": null,
            "type": "text",
            "col": null,
            "qlabel": null
        },
        {
            "vgroup": "s5",
            "qtitle": "Captured variable",
            "colTitle": null,
            "title": "Captured variable",
            "rowTitle": null,
            "label": "s5",
            "row": null,
            "type": "text",
            "col": null,
            "qlabel": null
        },
        {
            "vgroup": "or1",
            "qtitle": "Captured variable",
            "colTitle": null,
            "title": "Captured variable",
            "rowTitle": null,
            "label": "or1",
            "row": null,
            "type": "text",
            "col": null,
            "qlabel": null
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "Total",
            "title": "Total - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c1",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c1",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "Trump",
            "title": "Trump - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c2",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c2",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "Harris",
            "title": "Harris - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c3",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c3",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "Independent",
            "title": "Independent - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c4",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c4",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "Dem",
            "title": "Dem - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c5",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c5",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "GOP",
            "title": "GOP - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c6",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c6",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "MAGA/Trump Republican",
            "title": "MAGA/Trump Republican - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c7",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c7",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "Non-MAGA GOP",
            "title": "Non-MAGA GOP - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c8",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c8",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "Traditional Republican",
            "title": "Traditional Republican - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c9",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c9",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "Social Conservative",
            "title": "Social Conservative - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c10",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c10",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "Libertarian Republican",
            "title": "Libertarian Republican - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c11",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c11",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "Moderate Republican",
            "title": "Moderate Republican - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c12",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c12",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "Progressive Democrat",
            "title": "Progressive Democrat - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c13",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c13",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "Establishment Democrat",
            "title": "Establishment Democrat - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c14",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c14",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "Social Democrat",
            "title": "Social Democrat - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c15",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c15",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "Moderate Democrat",
            "title": "Moderate Democrat - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c16",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c16",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "Identity-focused Democrat",
            "title": "Identity-focused Democrat - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c17",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c17",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "Opinion Leader",
            "title": "Opinion Leader - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c18",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c18",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "Gen Z",
            "title": "Gen Z - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c19",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c19",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "Millennial",
            "title": "Millennial - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c20",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c20",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "Gen X",
            "title": "Gen X - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c21",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c21",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "Boomer",
            "title": "Boomer - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c22",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c22",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "Silent",
            "title": "Silent - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c23",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c23",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "Male",
            "title": "Male - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c24",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c24",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "vctq1",
            "qtitle": "Crosstabs - Oct 2025",
            "colTitle": "Female",
            "title": "Female - Crosstabs - Oct 2025",
            "rowTitle": null,
            "label": "vctq1c25",
            "value": 1,
            "row": null,
            "type": "multiple",
            "col": "c25",
            "qlabel": "vctq1"
        },
        {
            "vgroup": "Q24_summary",
            "qtitle": "Q24_summary",
            "colTitle": null,
            "title": "Q24_summary",
            "rowTitle": null,
            "label": "Q24_summary",
            "row": null,
            "type": "text",
            "col": null,
            "qlabel": "Q24_summary"
        },
        {
            "vgroup": "Q24_sentiment",
            "qtitle": "Q24_sentiment",
            "colTitle": null,
            "title": "Q24_sentiment",
            "rowTitle": null,
            "label": "Q24_sentiment",
            "row": null,
            "type": "text",
            "col": null,
            "qlabel": "Q24_sentiment"
        },
        {
            "vgroup": "isSynthetic",
            "qtitle": "Captured variable",
            "colTitle": null,
            "title": "Captured variable",
            "rowTitle": null,
            "label": "isSynthetic",
            "row": null,
            "type": "text",
            "col": null,
            "qlabel": null
        }
    ],
    "questions": [
        {
            "qtitle": "Exit Status",
            "variables": [
                {
                    "vgroup": "ExitStatus",
                    "qtitle": "Exit Status",
                    "colTitle": null,
                    "title": "Exit Status",
                    "rowTitle": null,
                    "label": "ExitStatus",
                    "row": null,
                    "type": "text",
                    "col": null,
                    "qlabel": "ExitStatus"
                }
            ],
            "flags": "x",
            "qlabel": "ExitStatus",
            "type": "text",
            "grouping": "rows"
        },
        {
            "qtitle": "Vendor State",
            "variables": [
                {
                    "vgroup": "VendorState",
                    "qtitle": "Vendor State",
                    "colTitle": null,
                    "title": "Vendor State",
                    "rowTitle": null,
                    "label": "VendorState",
                    "row": null,
                    "type": "text",
                    "col": null,
                    "qlabel": "VendorState"
                }
            ],
            "flags": "x",
            "qlabel": "VendorState",
            "type": "text",
            "grouping": "rows"
        },
        {
            "qtitle": "QC Removal Reason",
            "variables": [
                {
                    "vgroup": "QCRemovalReason",
                    "qtitle": "QC Removal Reason",
                    "colTitle": null,
                    "title": "QC Removal Reason",
                    "rowTitle": null,
                    "label": "QCRemovalReason",
                    "row": null,
                    "type": "text",
                    "col": null,
                    "qlabel": "QCRemovalReason"
                }
            ],
            "flags": "x",
            "qlabel": "QCRemovalReason",
            "type": "text",
            "grouping": "rows"
        },
        {
            "qtitle": "Data Validation Flags",
            "variables": [
                {
                    "vgroup": "dvflag",
                    "qtitle": "Data Validation Flags",
                    "colTitle": null,
                    "title": "Q8 Straightline - Data Validation Flags",
                    "rowTitle": "Q8 Straightline",
                    "label": "dvflagr1",
                    "value": 1,
                    "row": "r1",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "dvflag"
                },
                {
                    "vgroup": "dvflag",
                    "qtitle": "Data Validation Flags",
                    "colTitle": null,
                    "title": "Q9 Straightline - Data Validation Flags",
                    "rowTitle": "Q9 Straightline",
                    "label": "dvflagr2",
                    "value": 1,
                    "row": "r2",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "dvflag"
                },
                {
                    "vgroup": "dvflag",
                    "qtitle": "Data Validation Flags",
                    "colTitle": null,
                    "title": "Q15 Straightline - Data Validation Flags",
                    "rowTitle": "Q15 Straightline",
                    "label": "dvflagr3",
                    "value": 1,
                    "row": "r3",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "dvflag"
                },
                {
                    "vgroup": "dvflag",
                    "qtitle": "Data Validation Flags",
                    "colTitle": null,
                    "title": "RIDResult High - Data Validation Flags",
                    "rowTitle": "RIDResult High",
                    "label": "dvflagr96",
                    "value": 1,
                    "row": "r96",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "dvflag"
                },
                {
                    "vgroup": "dvflag",
                    "qtitle": "Data Validation Flags",
                    "colTitle": null,
                    "title": "SURVEY TESTING PORTAL - Data Validation Flags",
                    "rowTitle": "SURVEY TESTING PORTAL",
                    "label": "dvflagr97",
                    "value": 1,
                    "row": "r97",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "dvflag"
                },
                {
                    "vgroup": "dvflag",
                    "qtitle": "Data Validation Flags",
                    "colTitle": null,
                    "title": "Speeder - Data Validation Flags",
                    "rowTitle": "Speeder",
                    "label": "dvflagr98",
                    "value": 1,
                    "row": "r98",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "dvflag"
                },
                {
                    "vgroup": "dvflag",
                    "qtitle": "Data Validation Flags",
                    "colTitle": null,
                    "title": "Manual QC Removal - Data Validation Flags",
                    "rowTitle": "Manual QC Removal",
                    "label": "dvflagr99",
                    "value": 1,
                    "row": "r99",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "dvflag"
                }
            ],
            "flags": "x",
            "qlabel": "dvflag",
            "type": "multiple",
            "grouping": "cols"
        },
        {
            "qtitle": "HOLDS FINAL DVSCORE",
            "variables": [
                {
                    "vgroup": "dvscore",
                    "qtitle": "HOLDS FINAL DVSCORE",
                    "colTitle": null,
                    "title": "HOLDS FINAL DVSCORE",
                    "rowTitle": null,
                    "label": "dvscore",
                    "row": null,
                    "type": "number",
                    "col": null,
                    "qlabel": "dvscore"
                }
            ],
            "flags": "x",
            "qlabel": "dvscore",
            "type": "number",
            "grouping": "rows"
        },
        {
            "qtitle": "Holds LOI&nbsp;of sections",
            "variables": [
                {
                    "vgroup": "sectionLOI",
                    "qtitle": "Holds LOI&nbsp;of sections",
                    "colTitle": null,
                    "title": "Total - Holds LOI&nbsp;of sections",
                    "rowTitle": "Total",
                    "label": "sectionLOIr1",
                    "row": "r1",
                    "type": "text",
                    "col": null,
                    "qlabel": "sectionLOI"
                },
                {
                    "vgroup": "sectionLOI",
                    "qtitle": "Holds LOI&nbsp;of sections",
                    "colTitle": null,
                    "title": "Screener - Holds LOI&nbsp;of sections",
                    "rowTitle": "Screener",
                    "label": "sectionLOIr2",
                    "row": "r2",
                    "type": "text",
                    "col": null,
                    "qlabel": "sectionLOI"
                },
                {
                    "vgroup": "sectionLOI",
                    "qtitle": "Holds LOI&nbsp;of sections",
                    "colTitle": null,
                    "title": "Main - Holds LOI&nbsp;of sections",
                    "rowTitle": "Main",
                    "label": "sectionLOIr3",
                    "row": "r3",
                    "type": "text",
                    "col": null,
                    "qlabel": "sectionLOI"
                },
                {
                    "vgroup": "sectionLOI",
                    "qtitle": "Holds LOI&nbsp;of sections",
                    "colTitle": null,
                    "title": "Demographics - Holds LOI&nbsp;of sections",
                    "rowTitle": "Demographics",
                    "label": "sectionLOIr4",
                    "row": "r4",
                    "type": "text",
                    "col": null,
                    "qlabel": "sectionLOI"
                }
            ],
            "flags": "x",
            "qlabel": "sectionLOI",
            "type": "text",
            "grouping": "cols"
        },
        {
            "qtitle": "Device Type",
            "variables": [
                {
                    "vgroup": "DevType",
                    "qtitle": "Device Type",
                    "colTitle": null,
                    "title": "Device Type",
                    "rowTitle": null,
                    "label": "DevType",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Laptop"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Mobile"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "DevType"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Laptop"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Mobile"
                }
            ],
            "flags": "x",
            "qlabel": "DevType",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "SAMPLE SOURCE",
            "variables": [
                {
                    "vgroup": "SampSource",
                    "qtitle": "SAMPLE SOURCE",
                    "colTitle": null,
                    "title": "SAMPLE SOURCE",
                    "rowTitle": null,
                    "label": "SampSource",
                    "row": null,
                    "type": "number",
                    "col": null,
                    "qlabel": "SampSource"
                }
            ],
            "flags": "x",
            "qlabel": "SampSource",
            "type": "number",
            "grouping": "rows"
        },
        {
            "qtitle": "Hidden: location details",
            "variables": [
                {
                    "vgroup": "GeoIP_Details",
                    "qtitle": "Hidden: location details",
                    "colTitle": null,
                    "title": "country_code - Hidden: location details",
                    "rowTitle": "country_code",
                    "label": "GeoIP_Detailsr1",
                    "row": "r1",
                    "type": "text",
                    "col": null,
                    "qlabel": "GeoIP_Details"
                },
                {
                    "vgroup": "GeoIP_Details",
                    "qtitle": "Hidden: location details",
                    "colTitle": null,
                    "title": "country_name - Hidden: location details",
                    "rowTitle": "country_name",
                    "label": "GeoIP_Detailsr2",
                    "row": "r2",
                    "type": "text",
                    "col": null,
                    "qlabel": "GeoIP_Details"
                },
                {
                    "vgroup": "GeoIP_Details",
                    "qtitle": "Hidden: location details",
                    "colTitle": null,
                    "title": "dma_code - Hidden: location details",
                    "rowTitle": "dma_code",
                    "label": "GeoIP_Detailsr3",
                    "row": "r3",
                    "type": "text",
                    "col": null,
                    "qlabel": "GeoIP_Details"
                },
                {
                    "vgroup": "GeoIP_Details",
                    "qtitle": "Hidden: location details",
                    "colTitle": null,
                    "title": "region - Hidden: location details",
                    "rowTitle": "region",
                    "label": "GeoIP_Detailsr4",
                    "row": "r4",
                    "type": "text",
                    "col": null,
                    "qlabel": "GeoIP_Details"
                },
                {
                    "vgroup": "GeoIP_Details",
                    "qtitle": "Hidden: location details",
                    "colTitle": null,
                    "title": "region_name - Hidden: location details",
                    "rowTitle": "region_name",
                    "label": "GeoIP_Detailsr5",
                    "row": "r5",
                    "type": "text",
                    "col": null,
                    "qlabel": "GeoIP_Details"
                }
            ],
            "flags": "x",
            "qlabel": "GeoIP_Details",
            "type": "text",
            "grouping": "cols"
        },
        {
            "qtitle": "HIDDEN: HOLDS Rotate Selection ORDER",
            "variables": [
                {
                    "vgroup": "RotateSelect",
                    "qtitle": "HIDDEN: HOLDS Rotate Selection ORDER",
                    "colTitle": null,
                    "title": "HIDDEN: HOLDS Rotate Selection ORDER",
                    "rowTitle": null,
                    "label": "RotateSelect",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Top to bottom"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Bottom to top"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "RotateSelect"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Top to bottom"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Bottom to top"
                }
            ],
            "flags": "x",
            "qlabel": "RotateSelect",
            "type": "single",
            "grouping": "cols"
        },
        {
            "variables": [
                {
                    "vgroup": "Q1",
                    "qtitle": "In what year were you born?",
                    "colTitle": null,
                    "title": "In what year were you born?",
                    "rowTitle": null,
                    "label": "Q1",
                    "row": null,
                    "type": "number",
                    "col": null,
                    "qlabel": "Q1"
                }
            ],
            "grouping": "rows",
            "type": "number",
            "qtitle": "In what year were you born?",
            "qlabel": "Q1"
        },
        {
            "qtitle": "HIDDEN: Age recode 1",
            "variables": [
                {
                    "vgroup": "HIDAge",
                    "qtitle": "HIDDEN: Age recode 1",
                    "colTitle": null,
                    "title": "HIDDEN: Age recode 1",
                    "rowTitle": null,
                    "label": "HIDAge",
                    "row": null,
                    "type": "number",
                    "col": null,
                    "qlabel": "HIDAge"
                }
            ],
            "flags": "x",
            "qlabel": "HIDAge",
            "type": "number",
            "grouping": "rows"
        },
        {
            "qtitle": "HIDDEN: Age recode",
            "variables": [
                {
                    "vgroup": "HIDAge2",
                    "qtitle": "HIDDEN: Age recode",
                    "colTitle": null,
                    "title": "HIDDEN: Age recode",
                    "rowTitle": null,
                    "label": "HIDAge2",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "18-24"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "25-34"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "35-44"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "45-54"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "55-64"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "65 plus"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "HIDAge2"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "18-24"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "25-34"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "35-44"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "45-54"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "55-64"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "65 plus"
                }
            ],
            "flags": "x",
            "qlabel": "HIDAge2",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "What is your gender?",
            "variables": [
                {
                    "vgroup": "Q2",
                    "qtitle": "What is your gender?",
                    "colTitle": null,
                    "title": "What is your gender?",
                    "rowTitle": null,
                    "label": "Q2",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Male"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Female"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "Non-binary"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Prefer to self-describe"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q2"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Male"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Female"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Non-binary"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Prefer to self-describe"
                }
            ],
            "qlabel": "Q2",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "In what state do you reside?",
            "variables": [
                {
                    "vgroup": "Q3",
                    "qtitle": "In what state do you reside?",
                    "colTitle": null,
                    "title": "In what state do you reside?",
                    "rowTitle": null,
                    "label": "Q3",
                    "values": [
                        {
                            "label": "AL",
                            "value": 1,
                            "title": "Alabama"
                        },
                        {
                            "label": "AK",
                            "value": 2,
                            "title": "Alaska"
                        },
                        {
                            "label": "AZ",
                            "value": 3,
                            "title": "Arizona"
                        },
                        {
                            "label": "AR",
                            "value": 4,
                            "title": "Arkansas"
                        },
                        {
                            "label": "CA",
                            "value": 5,
                            "title": "California"
                        },
                        {
                            "label": "CO",
                            "value": 6,
                            "title": "Colorado"
                        },
                        {
                            "label": "CT",
                            "value": 7,
                            "title": "Connecticut"
                        },
                        {
                            "label": "DE",
                            "value": 8,
                            "title": "Delaware"
                        },
                        {
                            "label": "DC",
                            "value": 9,
                            "title": "District of Columbia (DC)"
                        },
                        {
                            "label": "FL",
                            "value": 10,
                            "title": "Florida"
                        },
                        {
                            "label": "GA",
                            "value": 11,
                            "title": "Georgia"
                        },
                        {
                            "label": "HI",
                            "value": 12,
                            "title": "Hawaii"
                        },
                        {
                            "label": "ID",
                            "value": 13,
                            "title": "Idaho"
                        },
                        {
                            "label": "IL",
                            "value": 14,
                            "title": "Illinois"
                        },
                        {
                            "label": "IN",
                            "value": 15,
                            "title": "Indiana"
                        },
                        {
                            "label": "IA",
                            "value": 16,
                            "title": "Iowa"
                        },
                        {
                            "label": "KS",
                            "value": 17,
                            "title": "Kansas"
                        },
                        {
                            "label": "KY",
                            "value": 18,
                            "title": "Kentucky"
                        },
                        {
                            "label": "LA",
                            "value": 19,
                            "title": "Louisiana"
                        },
                        {
                            "label": "ME",
                            "value": 20,
                            "title": "Maine"
                        },
                        {
                            "label": "MD",
                            "value": 21,
                            "title": "Maryland"
                        },
                        {
                            "label": "MA",
                            "value": 22,
                            "title": "Massachusetts"
                        },
                        {
                            "label": "MI",
                            "value": 23,
                            "title": "Michigan"
                        },
                        {
                            "label": "MN",
                            "value": 24,
                            "title": "Minnesota"
                        },
                        {
                            "label": "MS",
                            "value": 25,
                            "title": "Mississippi"
                        },
                        {
                            "label": "MO",
                            "value": 26,
                            "title": "Missouri"
                        },
                        {
                            "label": "MT",
                            "value": 27,
                            "title": "Montana"
                        },
                        {
                            "label": "NE",
                            "value": 28,
                            "title": "Nebraska"
                        },
                        {
                            "label": "NV",
                            "value": 29,
                            "title": "Nevada"
                        },
                        {
                            "label": "NH",
                            "value": 30,
                            "title": "New Hampshire"
                        },
                        {
                            "label": "NJ",
                            "value": 31,
                            "title": "New Jersey"
                        },
                        {
                            "label": "NM",
                            "value": 32,
                            "title": "New Mexico"
                        },
                        {
                            "label": "NY",
                            "value": 33,
                            "title": "New York"
                        },
                        {
                            "label": "NC",
                            "value": 34,
                            "title": "North Carolina"
                        },
                        {
                            "label": "ND",
                            "value": 35,
                            "title": "North Dakota"
                        },
                        {
                            "label": "OH",
                            "value": 36,
                            "title": "Ohio"
                        },
                        {
                            "label": "OK",
                            "value": 37,
                            "title": "Oklahoma"
                        },
                        {
                            "label": "OR",
                            "value": 38,
                            "title": "Oregon"
                        },
                        {
                            "label": "PA",
                            "value": 39,
                            "title": "Pennsylvania"
                        },
                        {
                            "label": "RI",
                            "value": 40,
                            "title": "Rhode Island"
                        },
                        {
                            "label": "SC",
                            "value": 41,
                            "title": "South Carolina"
                        },
                        {
                            "label": "SD",
                            "value": 42,
                            "title": "South Dakota"
                        },
                        {
                            "label": "TN",
                            "value": 43,
                            "title": "Tennessee"
                        },
                        {
                            "label": "TX",
                            "value": 44,
                            "title": "Texas"
                        },
                        {
                            "label": "UT",
                            "value": 45,
                            "title": "Utah"
                        },
                        {
                            "label": "VT",
                            "value": 46,
                            "title": "Vermont"
                        },
                        {
                            "label": "VA",
                            "value": 47,
                            "title": "Virginia"
                        },
                        {
                            "label": "WA",
                            "value": 48,
                            "title": "Washington"
                        },
                        {
                            "label": "WV",
                            "value": 49,
                            "title": "West Virginia"
                        },
                        {
                            "label": "WI",
                            "value": 50,
                            "title": "Wisconsin"
                        },
                        {
                            "label": "WY",
                            "value": 51,
                            "title": "Wyoming"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q3"
                }
            ],
            "values": [
                {
                    "label": "AL",
                    "value": 1,
                    "title": "Alabama"
                },
                {
                    "label": "AK",
                    "value": 2,
                    "title": "Alaska"
                },
                {
                    "label": "AZ",
                    "value": 3,
                    "title": "Arizona"
                },
                {
                    "label": "AR",
                    "value": 4,
                    "title": "Arkansas"
                },
                {
                    "label": "CA",
                    "value": 5,
                    "title": "California"
                },
                {
                    "label": "CO",
                    "value": 6,
                    "title": "Colorado"
                },
                {
                    "label": "CT",
                    "value": 7,
                    "title": "Connecticut"
                },
                {
                    "label": "DE",
                    "value": 8,
                    "title": "Delaware"
                },
                {
                    "label": "DC",
                    "value": 9,
                    "title": "District of Columbia (DC)"
                },
                {
                    "label": "FL",
                    "value": 10,
                    "title": "Florida"
                },
                {
                    "label": "GA",
                    "value": 11,
                    "title": "Georgia"
                },
                {
                    "label": "HI",
                    "value": 12,
                    "title": "Hawaii"
                },
                {
                    "label": "ID",
                    "value": 13,
                    "title": "Idaho"
                },
                {
                    "label": "IL",
                    "value": 14,
                    "title": "Illinois"
                },
                {
                    "label": "IN",
                    "value": 15,
                    "title": "Indiana"
                },
                {
                    "label": "IA",
                    "value": 16,
                    "title": "Iowa"
                },
                {
                    "label": "KS",
                    "value": 17,
                    "title": "Kansas"
                },
                {
                    "label": "KY",
                    "value": 18,
                    "title": "Kentucky"
                },
                {
                    "label": "LA",
                    "value": 19,
                    "title": "Louisiana"
                },
                {
                    "label": "ME",
                    "value": 20,
                    "title": "Maine"
                },
                {
                    "label": "MD",
                    "value": 21,
                    "title": "Maryland"
                },
                {
                    "label": "MA",
                    "value": 22,
                    "title": "Massachusetts"
                },
                {
                    "label": "MI",
                    "value": 23,
                    "title": "Michigan"
                },
                {
                    "label": "MN",
                    "value": 24,
                    "title": "Minnesota"
                },
                {
                    "label": "MS",
                    "value": 25,
                    "title": "Mississippi"
                },
                {
                    "label": "MO",
                    "value": 26,
                    "title": "Missouri"
                },
                {
                    "label": "MT",
                    "value": 27,
                    "title": "Montana"
                },
                {
                    "label": "NE",
                    "value": 28,
                    "title": "Nebraska"
                },
                {
                    "label": "NV",
                    "value": 29,
                    "title": "Nevada"
                },
                {
                    "label": "NH",
                    "value": 30,
                    "title": "New Hampshire"
                },
                {
                    "label": "NJ",
                    "value": 31,
                    "title": "New Jersey"
                },
                {
                    "label": "NM",
                    "value": 32,
                    "title": "New Mexico"
                },
                {
                    "label": "NY",
                    "value": 33,
                    "title": "New York"
                },
                {
                    "label": "NC",
                    "value": 34,
                    "title": "North Carolina"
                },
                {
                    "label": "ND",
                    "value": 35,
                    "title": "North Dakota"
                },
                {
                    "label": "OH",
                    "value": 36,
                    "title": "Ohio"
                },
                {
                    "label": "OK",
                    "value": 37,
                    "title": "Oklahoma"
                },
                {
                    "label": "OR",
                    "value": 38,
                    "title": "Oregon"
                },
                {
                    "label": "PA",
                    "value": 39,
                    "title": "Pennsylvania"
                },
                {
                    "label": "RI",
                    "value": 40,
                    "title": "Rhode Island"
                },
                {
                    "label": "SC",
                    "value": 41,
                    "title": "South Carolina"
                },
                {
                    "label": "SD",
                    "value": 42,
                    "title": "South Dakota"
                },
                {
                    "label": "TN",
                    "value": 43,
                    "title": "Tennessee"
                },
                {
                    "label": "TX",
                    "value": 44,
                    "title": "Texas"
                },
                {
                    "label": "UT",
                    "value": 45,
                    "title": "Utah"
                },
                {
                    "label": "VT",
                    "value": 46,
                    "title": "Vermont"
                },
                {
                    "label": "VA",
                    "value": 47,
                    "title": "Virginia"
                },
                {
                    "label": "WA",
                    "value": 48,
                    "title": "Washington"
                },
                {
                    "label": "WV",
                    "value": 49,
                    "title": "West Virginia"
                },
                {
                    "label": "WI",
                    "value": 50,
                    "title": "Wisconsin"
                },
                {
                    "label": "WY",
                    "value": 51,
                    "title": "Wyoming"
                }
            ],
            "qlabel": "Q3",
            "type": "single",
            "grouping": "rows"
        },
        {
            "qtitle": "DIVISION",
            "variables": [
                {
                    "vgroup": "DIVISION",
                    "qtitle": "DIVISION",
                    "colTitle": null,
                    "title": "DIVISION",
                    "rowTitle": null,
                    "label": "DIVISION",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "New England"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Mid-Atlantic"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "East North Central"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "West North Central"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "South Atlantic"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "East South Central"
                        },
                        {
                            "label": "r7",
                            "value": 7,
                            "title": "West South Central"
                        },
                        {
                            "label": "r8",
                            "value": 8,
                            "title": "Mountain"
                        },
                        {
                            "label": "r9",
                            "value": 9,
                            "title": "Pacific"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "DIVISION"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "New England"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Mid-Atlantic"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "East North Central"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "West North Central"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "South Atlantic"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "East South Central"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "West South Central"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "Mountain"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Pacific"
                }
            ],
            "flags": "x",
            "qlabel": "DIVISION",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "REGION",
            "variables": [
                {
                    "vgroup": "HQREGION",
                    "qtitle": "REGION",
                    "colTitle": null,
                    "title": "REGION",
                    "rowTitle": null,
                    "label": "HQREGION",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Northeast"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Midwest"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "South"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "West"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "NONE OF THESE"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "HQREGION"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Northeast"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Midwest"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "South"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "West"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "NONE OF THESE"
                }
            ],
            "flags": "x",
            "qlabel": "HQREGION",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "Which of the following best describes your racial and ethnic heritage?",
            "variables": [
                {
                    "vgroup": "Q4",
                    "qtitle": "Which of the following best describes your racial and ethnic heritage?",
                    "colTitle": null,
                    "title": "Which of the following best describes your racial and ethnic heritage?",
                    "rowTitle": null,
                    "label": "Q4",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "American Indian or Alaskan Native"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Asian"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "Black or African American"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Hispanic or Latino"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "Middle Eastern or North African"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Native Hawaiian or Pacific Islander"
                        },
                        {
                            "label": "r7",
                            "value": 7,
                            "title": "White"
                        },
                        {
                            "label": "r8",
                            "value": 8,
                            "title": "Some other race"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q4"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "American Indian or Alaskan Native"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Asian"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Black or African American"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Hispanic or Latino"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "Middle Eastern or North African"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Native Hawaiian or Pacific Islander"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "White"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "Some other race"
                }
            ],
            "qlabel": "Q4",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "What is the highest level of education you have completed?",
            "variables": [
                {
                    "vgroup": "Q5",
                    "qtitle": "What is the highest level of education you have completed?",
                    "colTitle": null,
                    "title": "What is the highest level of education you have completed?",
                    "rowTitle": null,
                    "label": "Q5",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Did not graduate from high school"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "High school diploma or GED equivalent"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "Some college or a two-year associates degree"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Four-year college degree"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "Two-year master's degree"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Doctoral degree"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q5"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Did not graduate from high school"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "High school diploma or GED equivalent"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Some college or a two-year associates degree"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Four-year college degree"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "Two-year master's degree"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Doctoral degree"
                }
            ],
            "qlabel": "Q5",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "Which of the following ranges includes your household's TOTAL annual income?",
            "variables": [
                {
                    "vgroup": "Q6",
                    "qtitle": "Which of the following ranges includes your household's TOTAL annual income?",
                    "colTitle": null,
                    "title": "Which of the following ranges includes your household's TOTAL annual income?",
                    "rowTitle": null,
                    "label": "Q6",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Less than $25,000"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "$25,000 - $49,999"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "$50,000 - $74,999"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "$75,000 - $99,999"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "$100,000 - $149,999"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "$150,000 - $199,999"
                        },
                        {
                            "label": "r7",
                            "value": 7,
                            "title": "$200,000 - $299,999"
                        },
                        {
                            "label": "r8",
                            "value": 8,
                            "title": "$300,000 - $399,999"
                        },
                        {
                            "label": "r9",
                            "value": 9,
                            "title": "$400,000 or more"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q6"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Less than $25,000"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "$25,000 - $49,999"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "$50,000 - $74,999"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "$75,000 - $99,999"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "$100,000 - $149,999"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "$150,000 - $199,999"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "$200,000 - $299,999"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "$300,000 - $399,999"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "$400,000 or more"
                }
            ],
            "qlabel": "Q6",
            "type": "single",
            "grouping": "cols"
        },
        {
            "variables": [
                {
                    "vgroup": "Q7",
                    "qtitle": "Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
                    "colTitle": null,
                    "title": "The economy and job creation - Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
                    "rowTitle": "The economy and job creation",
                    "label": "Q7r1",
                    "value": 1,
                    "row": "r1",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q7"
                },
                {
                    "vgroup": "Q7",
                    "qtitle": "Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
                    "colTitle": null,
                    "title": "National defense and security - Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
                    "rowTitle": "National defense and security",
                    "label": "Q7r2",
                    "value": 1,
                    "row": "r2",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q7"
                },
                {
                    "vgroup": "Q7",
                    "qtitle": "Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
                    "colTitle": null,
                    "title": "Energy availability and reliability - Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
                    "rowTitle": "Energy availability and reliability",
                    "label": "Q7r3",
                    "value": 1,
                    "row": "r3",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q7"
                },
                {
                    "vgroup": "Q7",
                    "qtitle": "Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
                    "colTitle": null,
                    "title": "Increase use of clean energy - Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
                    "rowTitle": "Increase use of clean energy",
                    "label": "Q7r4",
                    "value": 1,
                    "row": "r4",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q7"
                },
                {
                    "vgroup": "Q7",
                    "qtitle": "Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
                    "colTitle": null,
                    "title": "Education and workforce development - Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
                    "rowTitle": "Education and workforce development",
                    "label": "Q7r5",
                    "value": 1,
                    "row": "r5",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q7"
                },
                {
                    "vgroup": "Q7",
                    "qtitle": "Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
                    "colTitle": null,
                    "title": "Cost of living / inflation - Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
                    "rowTitle": "Cost of living / inflation",
                    "label": "Q7r6",
                    "value": 1,
                    "row": "r6",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q7"
                },
                {
                    "vgroup": "Q7",
                    "qtitle": "Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
                    "colTitle": null,
                    "title": "Technological leadership and competitiveness - Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
                    "rowTitle": "Technological leadership and competitiveness",
                    "label": "Q7r7",
                    "value": 1,
                    "row": "r7",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q7"
                },
                {
                    "vgroup": "Q7",
                    "qtitle": "Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
                    "colTitle": null,
                    "title": "Infrastructure - Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
                    "rowTitle": "Infrastructure",
                    "label": "Q7r8",
                    "value": 1,
                    "row": "r8",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q7"
                }
            ],
            "grouping": "cols",
            "type": "multiple",
            "qtitle": "Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?",
            "qlabel": "Q7"
        },
        {
            "qtitle": "Thinking about the past year, how has what you pay for each of the following changed, if at all?",
            "variables": [
                {
                    "vgroup": "Q8",
                    "qtitle": "Thinking about the past year, how has what you pay for each of the following changed, if at all?",
                    "colTitle": null,
                    "title": "Electricity bills - Thinking about the past year, how has what you pay for each of the following changed, if at all?",
                    "rowTitle": "Electricity bills",
                    "label": "Q8r1",
                    "values": [
                        {
                            "label": "c1",
                            "value": 1,
                            "title": "Increased a lot"
                        },
                        {
                            "label": "c2",
                            "value": 2,
                            "title": "Increased somewhat"
                        },
                        {
                            "label": "c3",
                            "value": 3,
                            "title": "Stayed about the same"
                        },
                        {
                            "label": "c4",
                            "value": 4,
                            "title": "Decreased somewhat"
                        },
                        {
                            "label": "c5",
                            "value": 5,
                            "title": "Decreased a lot"
                        },
                        {
                            "label": "c6",
                            "value": 6,
                            "title": "Not sure"
                        }
                    ],
                    "row": "r1",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q8"
                },
                {
                    "vgroup": "Q8",
                    "qtitle": "Thinking about the past year, how has what you pay for each of the following changed, if at all?",
                    "colTitle": null,
                    "title": "Gas prices at the pump - Thinking about the past year, how has what you pay for each of the following changed, if at all?",
                    "rowTitle": "Gas prices at the pump",
                    "label": "Q8r2",
                    "values": [
                        {
                            "label": "c1",
                            "value": 1,
                            "title": "Increased a lot"
                        },
                        {
                            "label": "c2",
                            "value": 2,
                            "title": "Increased somewhat"
                        },
                        {
                            "label": "c3",
                            "value": 3,
                            "title": "Stayed about the same"
                        },
                        {
                            "label": "c4",
                            "value": 4,
                            "title": "Decreased somewhat"
                        },
                        {
                            "label": "c5",
                            "value": 5,
                            "title": "Decreased a lot"
                        },
                        {
                            "label": "c6",
                            "value": 6,
                            "title": "Not sure"
                        }
                    ],
                    "row": "r2",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q8"
                },
                {
                    "vgroup": "Q8",
                    "qtitle": "Thinking about the past year, how has what you pay for each of the following changed, if at all?",
                    "colTitle": null,
                    "title": "Groceries - Thinking about the past year, how has what you pay for each of the following changed, if at all?",
                    "rowTitle": "Groceries",
                    "label": "Q8r3",
                    "values": [
                        {
                            "label": "c1",
                            "value": 1,
                            "title": "Increased a lot"
                        },
                        {
                            "label": "c2",
                            "value": 2,
                            "title": "Increased somewhat"
                        },
                        {
                            "label": "c3",
                            "value": 3,
                            "title": "Stayed about the same"
                        },
                        {
                            "label": "c4",
                            "value": 4,
                            "title": "Decreased somewhat"
                        },
                        {
                            "label": "c5",
                            "value": 5,
                            "title": "Decreased a lot"
                        },
                        {
                            "label": "c6",
                            "value": 6,
                            "title": "Not sure"
                        }
                    ],
                    "row": "r3",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q8"
                },
                {
                    "vgroup": "Q8",
                    "qtitle": "Thinking about the past year, how has what you pay for each of the following changed, if at all?",
                    "colTitle": null,
                    "title": "Rent or mortgage - Thinking about the past year, how has what you pay for each of the following changed, if at all?",
                    "rowTitle": "Rent or mortgage",
                    "label": "Q8r4",
                    "values": [
                        {
                            "label": "c1",
                            "value": 1,
                            "title": "Increased a lot"
                        },
                        {
                            "label": "c2",
                            "value": 2,
                            "title": "Increased somewhat"
                        },
                        {
                            "label": "c3",
                            "value": 3,
                            "title": "Stayed about the same"
                        },
                        {
                            "label": "c4",
                            "value": 4,
                            "title": "Decreased somewhat"
                        },
                        {
                            "label": "c5",
                            "value": 5,
                            "title": "Decreased a lot"
                        },
                        {
                            "label": "c6",
                            "value": 6,
                            "title": "Not sure"
                        }
                    ],
                    "row": "r4",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q8"
                },
                {
                    "vgroup": "Q8",
                    "qtitle": "Thinking about the past year, how has what you pay for each of the following changed, if at all?",
                    "colTitle": null,
                    "title": "Prescription drugs - Thinking about the past year, how has what you pay for each of the following changed, if at all?",
                    "rowTitle": "Prescription drugs",
                    "label": "Q8r5",
                    "values": [
                        {
                            "label": "c1",
                            "value": 1,
                            "title": "Increased a lot"
                        },
                        {
                            "label": "c2",
                            "value": 2,
                            "title": "Increased somewhat"
                        },
                        {
                            "label": "c3",
                            "value": 3,
                            "title": "Stayed about the same"
                        },
                        {
                            "label": "c4",
                            "value": 4,
                            "title": "Decreased somewhat"
                        },
                        {
                            "label": "c5",
                            "value": 5,
                            "title": "Decreased a lot"
                        },
                        {
                            "label": "c6",
                            "value": 6,
                            "title": "Not sure"
                        }
                    ],
                    "row": "r5",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q8"
                },
                {
                    "vgroup": "Q8",
                    "qtitle": "Thinking about the past year, how has what you pay for each of the following changed, if at all?",
                    "colTitle": null,
                    "title": "Internet and phone bills - Thinking about the past year, how has what you pay for each of the following changed, if at all?",
                    "rowTitle": "Internet and phone bills",
                    "label": "Q8r6",
                    "values": [
                        {
                            "label": "c1",
                            "value": 1,
                            "title": "Increased a lot"
                        },
                        {
                            "label": "c2",
                            "value": 2,
                            "title": "Increased somewhat"
                        },
                        {
                            "label": "c3",
                            "value": 3,
                            "title": "Stayed about the same"
                        },
                        {
                            "label": "c4",
                            "value": 4,
                            "title": "Decreased somewhat"
                        },
                        {
                            "label": "c5",
                            "value": 5,
                            "title": "Decreased a lot"
                        },
                        {
                            "label": "c6",
                            "value": 6,
                            "title": "Not sure"
                        }
                    ],
                    "row": "r6",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q8"
                }
            ],
            "values": [
                {
                    "label": "c1",
                    "value": 1,
                    "title": "Increased a lot"
                },
                {
                    "label": "c2",
                    "value": 2,
                    "title": "Increased somewhat"
                },
                {
                    "label": "c3",
                    "value": 3,
                    "title": "Stayed about the same"
                },
                {
                    "label": "c4",
                    "value": 4,
                    "title": "Decreased somewhat"
                },
                {
                    "label": "c5",
                    "value": 5,
                    "title": "Decreased a lot"
                },
                {
                    "label": "c6",
                    "value": 6,
                    "title": "Not sure"
                }
            ],
            "qlabel": "Q8",
            "type": "single",
            "grouping": "rows"
        },
        {
            "qtitle": "When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
            "variables": [
                {
                    "vgroup": "Q9",
                    "qtitle": "When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
                    "colTitle": null,
                    "title": "Rising fuel costs for oil and gas - When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
                    "rowTitle": "Rising fuel costs for oil and gas",
                    "label": "Q9r1",
                    "values": [
                        {
                            "label": "c1",
                            "value": 1,
                            "title": "A great deal"
                        },
                        {
                            "label": "c2",
                            "value": 2,
                            "title": "Quite a bit"
                        },
                        {
                            "label": "c3",
                            "value": 3,
                            "title": "Some"
                        },
                        {
                            "label": "c4",
                            "value": 4,
                            "title": "Very little"
                        },
                        {
                            "label": "c5",
                            "value": 5,
                            "title": "Not at all"
                        }
                    ],
                    "row": "r1",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q9"
                },
                {
                    "vgroup": "Q9",
                    "qtitle": "When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
                    "colTitle": null,
                    "title": "The cost of building new renewable energy projects - When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
                    "rowTitle": "The cost of building new renewable energy projects",
                    "label": "Q9r2",
                    "values": [
                        {
                            "label": "c1",
                            "value": 1,
                            "title": "A great deal"
                        },
                        {
                            "label": "c2",
                            "value": 2,
                            "title": "Quite a bit"
                        },
                        {
                            "label": "c3",
                            "value": 3,
                            "title": "Some"
                        },
                        {
                            "label": "c4",
                            "value": 4,
                            "title": "Very little"
                        },
                        {
                            "label": "c5",
                            "value": 5,
                            "title": "Not at all"
                        }
                    ],
                    "row": "r2",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q9"
                },
                {
                    "vgroup": "Q9",
                    "qtitle": "When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
                    "colTitle": null,
                    "title": "Upgrades to the electric grid and transmission lines - When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
                    "rowTitle": "Upgrades to the electric grid and transmission lines",
                    "label": "Q9r3",
                    "values": [
                        {
                            "label": "c1",
                            "value": 1,
                            "title": "A great deal"
                        },
                        {
                            "label": "c2",
                            "value": 2,
                            "title": "Quite a bit"
                        },
                        {
                            "label": "c3",
                            "value": 3,
                            "title": "Some"
                        },
                        {
                            "label": "c4",
                            "value": 4,
                            "title": "Very little"
                        },
                        {
                            "label": "c5",
                            "value": 5,
                            "title": "Not at all"
                        }
                    ],
                    "row": "r3",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q9"
                },
                {
                    "vgroup": "Q9",
                    "qtitle": "When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
                    "colTitle": null,
                    "title": "Government regulations - When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
                    "rowTitle": "Government regulations",
                    "label": "Q9r4",
                    "values": [
                        {
                            "label": "c1",
                            "value": 1,
                            "title": "A great deal"
                        },
                        {
                            "label": "c2",
                            "value": 2,
                            "title": "Quite a bit"
                        },
                        {
                            "label": "c3",
                            "value": 3,
                            "title": "Some"
                        },
                        {
                            "label": "c4",
                            "value": 4,
                            "title": "Very little"
                        },
                        {
                            "label": "c5",
                            "value": 5,
                            "title": "Not at all"
                        }
                    ],
                    "row": "r4",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q9"
                },
                {
                    "vgroup": "Q9",
                    "qtitle": "When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
                    "colTitle": null,
                    "title": "Utility company profits - When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
                    "rowTitle": "Utility company profits",
                    "label": "Q9r5",
                    "values": [
                        {
                            "label": "c1",
                            "value": 1,
                            "title": "A great deal"
                        },
                        {
                            "label": "c2",
                            "value": 2,
                            "title": "Quite a bit"
                        },
                        {
                            "label": "c3",
                            "value": 3,
                            "title": "Some"
                        },
                        {
                            "label": "c4",
                            "value": 4,
                            "title": "Very little"
                        },
                        {
                            "label": "c5",
                            "value": 5,
                            "title": "Not at all"
                        }
                    ],
                    "row": "r5",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q9"
                },
                {
                    "vgroup": "Q9",
                    "qtitle": "When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
                    "colTitle": null,
                    "title": "Increased electricity demand from data centers - When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?",
                    "rowTitle": "Increased electricity demand from data centers",
                    "label": "Q9r6",
                    "values": [
                        {
                            "label": "c1",
                            "value": 1,
                            "title": "A great deal"
                        },
                        {
                            "label": "c2",
                            "value": 2,
                            "title": "Quite a bit"
                        },
                        {
                            "label": "c3",
                            "value": 3,
                            "title": "Some"
                        },
                        {
                            "label": "c4",
                            "value": 4,
                            "title": "Very little"
                        },
                        {
                            "label": "c5",
                            "value": 5,
                            "title": "Not at all"
                        }
                    ],
                    "row": "r6",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q9"
                }
            ],
            "values": [
                {
                    "label": "c1",
                    "value": 1,
                    "title": "A great deal"
                },
                {
                    "label": "c2",
                    "value": 2,
                    "title": "Quite a bit"
                },
                {
                    "label": "c3",
                    "value": 3,
                    "title": "Some"
                },
                {
                    "label": "c4",
                    "value": 4,
                    "title": "Very little"
                },
                {
                    "label": "c5",
                    "value": 5,
                    "title": "Not at all"
                }
            ],
            "qlabel": "Q9",
            "type": "single",
            "grouping": "rows"
        },
        {
            "qtitle": "Which do you prioritize more when thinking about America's energy future?",
            "variables": [
                {
                    "vgroup": "Q10",
                    "qtitle": "Which do you prioritize more when thinking about America's energy future?",
                    "colTitle": null,
                    "title": "Which do you prioritize more when thinking about America's energy future?",
                    "rowTitle": null,
                    "label": "Q10",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Economic growth"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Energy security"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "Environmental protection"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Energy affordability"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "All equally"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q10"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Economic growth"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Energy security"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Environmental protection"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Energy affordability"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "All equally"
                }
            ],
            "qlabel": "Q10",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "Which statement comes closest to your view of the U.S. renewable energy industry?",
            "variables": [
                {
                    "vgroup": "Q11",
                    "qtitle": "Which statement comes closest to your view of the U.S. renewable energy industry?",
                    "colTitle": null,
                    "title": "Which statement comes closest to your view of the U.S. renewable energy industry?",
                    "rowTitle": null,
                    "label": "Q11",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "It's an innovative industry that delivers affordable, reliable energy."
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "It's a promising industry but often over-promises and under-delivers."
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "It's an industry that depends too much on government subsidies."
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "It mostly benefits big companies more than consumers or communities."
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q11"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "It's an innovative industry that delivers affordable, reliable energy."
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "It's a promising industry but often over-promises and under-delivers."
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "It's an industry that depends too much on government subsidies."
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "It mostly benefits big companies more than consumers or communities."
                }
            ],
            "qlabel": "Q11",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "Do you think a focus on growing renewable energy helps or hurts America's ability to compete globally?",
            "variables": [
                {
                    "vgroup": "Q12",
                    "qtitle": "Do you think a focus on growing renewable energy helps or hurts America's ability to compete globally?",
                    "colTitle": null,
                    "title": "Do you think a focus on growing renewable energy helps or hurts America's ability to compete globally?",
                    "rowTitle": null,
                    "label": "Q12",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Helps a lot"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Helps somewhat"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "Hurts somewhat"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Hurts a lot"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q12"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Helps a lot"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Helps somewhat"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Hurts somewhat"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Hurts a lot"
                }
            ],
            "qlabel": "Q12",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "Thinking about the future of electricity demand in the U.S., which of the following do you think is most likely in the next 10 years?",
            "variables": [
                {
                    "vgroup": "Q13",
                    "qtitle": "Thinking about the future of electricity demand in the U.S., which of the following do you think is most likely in the next 10 years?",
                    "colTitle": null,
                    "title": "Thinking about the future of electricity demand in the U.S., which of the following do you think is most likely in the next 10 years?",
                    "rowTitle": null,
                    "label": "Q13",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Electricity demand will be much higher than today"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Electricity demand will be somewhat higher than today"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "Electricity demand will stay about the same as today"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Electricity demand will be somewhat lower than today"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "Electricity demand will be much lower than today"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Not sure"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q13"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Electricity demand will be much higher than today"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Electricity demand will be somewhat higher than today"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Electricity demand will stay about the same as today"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Electricity demand will be somewhat lower than today"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "Electricity demand will be much lower than today"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Not sure"
                }
            ],
            "qlabel": "Q13",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
            "qlabel": "Q14",
            "variables": [
                {
                    "vgroup": "Q14",
                    "qtitle": "Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
                    "colTitle": null,
                    "title": "Solar - Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
                    "rowTitle": "Solar",
                    "label": "Q14r1",
                    "row": "r1",
                    "type": "number",
                    "col": null,
                    "qlabel": "Q14"
                },
                {
                    "vgroup": "Q14",
                    "qtitle": "Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
                    "colTitle": null,
                    "title": "Wind - Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
                    "rowTitle": "Wind",
                    "label": "Q14r2",
                    "row": "r2",
                    "type": "number",
                    "col": null,
                    "qlabel": "Q14"
                },
                {
                    "vgroup": "Q14",
                    "qtitle": "Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
                    "colTitle": null,
                    "title": "Natural gas - Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
                    "rowTitle": "Natural gas",
                    "label": "Q14r3",
                    "row": "r3",
                    "type": "number",
                    "col": null,
                    "qlabel": "Q14"
                },
                {
                    "vgroup": "Q14",
                    "qtitle": "Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
                    "colTitle": null,
                    "title": "Hydropower - Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
                    "rowTitle": "Hydropower",
                    "label": "Q14r4",
                    "row": "r4",
                    "type": "number",
                    "col": null,
                    "qlabel": "Q14"
                },
                {
                    "vgroup": "Q14",
                    "qtitle": "Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
                    "colTitle": null,
                    "title": "Nuclear - Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
                    "rowTitle": "Nuclear",
                    "label": "Q14r5",
                    "row": "r5",
                    "type": "number",
                    "col": null,
                    "qlabel": "Q14"
                },
                {
                    "vgroup": "Q14",
                    "qtitle": "Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
                    "colTitle": null,
                    "title": "Coal - Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
                    "rowTitle": "Coal",
                    "label": "Q14r6",
                    "row": "r6",
                    "type": "number",
                    "col": null,
                    "qlabel": "Q14"
                },
                {
                    "vgroup": "Q14",
                    "qtitle": "Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
                    "colTitle": null,
                    "title": "Biomass - Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
                    "rowTitle": "Biomass",
                    "label": "Q14r7",
                    "row": "r7",
                    "type": "number",
                    "col": null,
                    "qlabel": "Q14"
                },
                {
                    "vgroup": "Q14",
                    "qtitle": "Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
                    "colTitle": null,
                    "title": "Geothermal - Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
                    "rowTitle": "Geothermal",
                    "label": "Q14r8",
                    "row": "r8",
                    "type": "number",
                    "col": null,
                    "qlabel": "Q14"
                },
                {
                    "vgroup": "Q14",
                    "qtitle": "Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
                    "colTitle": null,
                    "title": "Petroleum - Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
                    "rowTitle": "Petroleum",
                    "label": "Q14r9",
                    "row": "r9",
                    "type": "number",
                    "col": null,
                    "qlabel": "Q14"
                },
                {
                    "vgroup": "Q14",
                    "qtitle": "Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
                    "colTitle": null,
                    "title": "Other - Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%.",
                    "rowTitle": "Other",
                    "label": "Q14r10",
                    "row": "r10",
                    "type": "number",
                    "col": null,
                    "qlabel": "Q14"
                }
            ],
            "grouping": "cols",
            "type": "number",
            "dq": "autosum"
        },
        {
            "qtitle": "Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
            "qlabel": "Q15",
            "variables": [
                {
                    "vgroup": "Q15",
                    "qtitle": "Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
                    "colTitle": null,
                    "title": "Clean energy - Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
                    "rowTitle": "Clean energy",
                    "label": "Q15r1",
                    "values": [
                        {
                            "label": "c1",
                            "value": 0,
                            "title": "0 - Extremely negative"
                        },
                        {
                            "label": "c2",
                            "value": 1,
                            "title": "1"
                        },
                        {
                            "label": "c3",
                            "value": 2,
                            "title": "2"
                        },
                        {
                            "label": "c4",
                            "value": 3,
                            "title": "3"
                        },
                        {
                            "label": "c5",
                            "value": 4,
                            "title": "4"
                        },
                        {
                            "label": "c6",
                            "value": 5,
                            "title": "5 - Neutral"
                        },
                        {
                            "label": "c7",
                            "value": 6,
                            "title": "6"
                        },
                        {
                            "label": "c8",
                            "value": 7,
                            "title": "7"
                        },
                        {
                            "label": "c9",
                            "value": 8,
                            "title": "8"
                        },
                        {
                            "label": "c10",
                            "value": 9,
                            "title": "9"
                        },
                        {
                            "label": "c11",
                            "value": 10,
                            "title": "10 - Extremely positive"
                        }
                    ],
                    "row": "r1",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q15"
                },
                {
                    "vgroup": "Q15",
                    "qtitle": "Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
                    "colTitle": null,
                    "title": "Renewable energy - Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
                    "rowTitle": "Renewable energy",
                    "label": "Q15r2",
                    "values": [
                        {
                            "label": "c1",
                            "value": 0,
                            "title": "0 - Extremely negative"
                        },
                        {
                            "label": "c2",
                            "value": 1,
                            "title": "1"
                        },
                        {
                            "label": "c3",
                            "value": 2,
                            "title": "2"
                        },
                        {
                            "label": "c4",
                            "value": 3,
                            "title": "3"
                        },
                        {
                            "label": "c5",
                            "value": 4,
                            "title": "4"
                        },
                        {
                            "label": "c6",
                            "value": 5,
                            "title": "5 - Neutral"
                        },
                        {
                            "label": "c7",
                            "value": 6,
                            "title": "6"
                        },
                        {
                            "label": "c8",
                            "value": 7,
                            "title": "7"
                        },
                        {
                            "label": "c9",
                            "value": 8,
                            "title": "8"
                        },
                        {
                            "label": "c10",
                            "value": 9,
                            "title": "9"
                        },
                        {
                            "label": "c11",
                            "value": 10,
                            "title": "10 - Extremely positive"
                        }
                    ],
                    "row": "r2",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q15"
                },
                {
                    "vgroup": "Q15",
                    "qtitle": "Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
                    "colTitle": null,
                    "title": "Sustainable energy - Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
                    "rowTitle": "Sustainable energy",
                    "label": "Q15r3",
                    "values": [
                        {
                            "label": "c1",
                            "value": 0,
                            "title": "0 - Extremely negative"
                        },
                        {
                            "label": "c2",
                            "value": 1,
                            "title": "1"
                        },
                        {
                            "label": "c3",
                            "value": 2,
                            "title": "2"
                        },
                        {
                            "label": "c4",
                            "value": 3,
                            "title": "3"
                        },
                        {
                            "label": "c5",
                            "value": 4,
                            "title": "4"
                        },
                        {
                            "label": "c6",
                            "value": 5,
                            "title": "5 - Neutral"
                        },
                        {
                            "label": "c7",
                            "value": 6,
                            "title": "6"
                        },
                        {
                            "label": "c8",
                            "value": 7,
                            "title": "7"
                        },
                        {
                            "label": "c9",
                            "value": 8,
                            "title": "8"
                        },
                        {
                            "label": "c10",
                            "value": 9,
                            "title": "9"
                        },
                        {
                            "label": "c11",
                            "value": 10,
                            "title": "10 - Extremely positive"
                        }
                    ],
                    "row": "r3",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q15"
                },
                {
                    "vgroup": "Q15",
                    "qtitle": "Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
                    "colTitle": null,
                    "title": "21st Century energy - Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
                    "rowTitle": "21st Century energy",
                    "label": "Q15r4",
                    "values": [
                        {
                            "label": "c1",
                            "value": 0,
                            "title": "0 - Extremely negative"
                        },
                        {
                            "label": "c2",
                            "value": 1,
                            "title": "1"
                        },
                        {
                            "label": "c3",
                            "value": 2,
                            "title": "2"
                        },
                        {
                            "label": "c4",
                            "value": 3,
                            "title": "3"
                        },
                        {
                            "label": "c5",
                            "value": 4,
                            "title": "4"
                        },
                        {
                            "label": "c6",
                            "value": 5,
                            "title": "5 - Neutral"
                        },
                        {
                            "label": "c7",
                            "value": 6,
                            "title": "6"
                        },
                        {
                            "label": "c8",
                            "value": 7,
                            "title": "7"
                        },
                        {
                            "label": "c9",
                            "value": 8,
                            "title": "8"
                        },
                        {
                            "label": "c10",
                            "value": 9,
                            "title": "9"
                        },
                        {
                            "label": "c11",
                            "value": 10,
                            "title": "10 - Extremely positive"
                        }
                    ],
                    "row": "r4",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q15"
                },
                {
                    "vgroup": "Q15",
                    "qtitle": "Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
                    "colTitle": null,
                    "title": "Next Generation energy - Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
                    "rowTitle": "Next Generation energy",
                    "label": "Q15r5",
                    "values": [
                        {
                            "label": "c1",
                            "value": 0,
                            "title": "0 - Extremely negative"
                        },
                        {
                            "label": "c2",
                            "value": 1,
                            "title": "1"
                        },
                        {
                            "label": "c3",
                            "value": 2,
                            "title": "2"
                        },
                        {
                            "label": "c4",
                            "value": 3,
                            "title": "3"
                        },
                        {
                            "label": "c5",
                            "value": 4,
                            "title": "4"
                        },
                        {
                            "label": "c6",
                            "value": 5,
                            "title": "5 - Neutral"
                        },
                        {
                            "label": "c7",
                            "value": 6,
                            "title": "6"
                        },
                        {
                            "label": "c8",
                            "value": 7,
                            "title": "7"
                        },
                        {
                            "label": "c9",
                            "value": 8,
                            "title": "8"
                        },
                        {
                            "label": "c10",
                            "value": 9,
                            "title": "9"
                        },
                        {
                            "label": "c11",
                            "value": 10,
                            "title": "10 - Extremely positive"
                        }
                    ],
                    "row": "r5",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q15"
                },
                {
                    "vgroup": "Q15",
                    "qtitle": "Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
                    "colTitle": null,
                    "title": "Green energy - Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
                    "rowTitle": "Green energy",
                    "label": "Q15r6",
                    "values": [
                        {
                            "label": "c1",
                            "value": 0,
                            "title": "0 - Extremely negative"
                        },
                        {
                            "label": "c2",
                            "value": 1,
                            "title": "1"
                        },
                        {
                            "label": "c3",
                            "value": 2,
                            "title": "2"
                        },
                        {
                            "label": "c4",
                            "value": 3,
                            "title": "3"
                        },
                        {
                            "label": "c5",
                            "value": 4,
                            "title": "4"
                        },
                        {
                            "label": "c6",
                            "value": 5,
                            "title": "5 - Neutral"
                        },
                        {
                            "label": "c7",
                            "value": 6,
                            "title": "6"
                        },
                        {
                            "label": "c8",
                            "value": 7,
                            "title": "7"
                        },
                        {
                            "label": "c9",
                            "value": 8,
                            "title": "8"
                        },
                        {
                            "label": "c10",
                            "value": 9,
                            "title": "9"
                        },
                        {
                            "label": "c11",
                            "value": 10,
                            "title": "10 - Extremely positive"
                        }
                    ],
                    "row": "r6",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q15"
                },
                {
                    "vgroup": "Q15",
                    "qtitle": "Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
                    "colTitle": null,
                    "title": "Alternative energy - Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
                    "rowTitle": "Alternative energy",
                    "label": "Q15r7",
                    "values": [
                        {
                            "label": "c1",
                            "value": 0,
                            "title": "0 - Extremely negative"
                        },
                        {
                            "label": "c2",
                            "value": 1,
                            "title": "1"
                        },
                        {
                            "label": "c3",
                            "value": 2,
                            "title": "2"
                        },
                        {
                            "label": "c4",
                            "value": 3,
                            "title": "3"
                        },
                        {
                            "label": "c5",
                            "value": 4,
                            "title": "4"
                        },
                        {
                            "label": "c6",
                            "value": 5,
                            "title": "5 - Neutral"
                        },
                        {
                            "label": "c7",
                            "value": 6,
                            "title": "6"
                        },
                        {
                            "label": "c8",
                            "value": 7,
                            "title": "7"
                        },
                        {
                            "label": "c9",
                            "value": 8,
                            "title": "8"
                        },
                        {
                            "label": "c10",
                            "value": 9,
                            "title": "9"
                        },
                        {
                            "label": "c11",
                            "value": 10,
                            "title": "10 - Extremely positive"
                        }
                    ],
                    "row": "r7",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q15"
                },
                {
                    "vgroup": "Q15",
                    "qtitle": "Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
                    "colTitle": null,
                    "title": "Advanced energy - Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
                    "rowTitle": "Advanced energy",
                    "label": "Q15r8",
                    "values": [
                        {
                            "label": "c1",
                            "value": 0,
                            "title": "0 - Extremely negative"
                        },
                        {
                            "label": "c2",
                            "value": 1,
                            "title": "1"
                        },
                        {
                            "label": "c3",
                            "value": 2,
                            "title": "2"
                        },
                        {
                            "label": "c4",
                            "value": 3,
                            "title": "3"
                        },
                        {
                            "label": "c5",
                            "value": 4,
                            "title": "4"
                        },
                        {
                            "label": "c6",
                            "value": 5,
                            "title": "5 - Neutral"
                        },
                        {
                            "label": "c7",
                            "value": 6,
                            "title": "6"
                        },
                        {
                            "label": "c8",
                            "value": 7,
                            "title": "7"
                        },
                        {
                            "label": "c9",
                            "value": 8,
                            "title": "8"
                        },
                        {
                            "label": "c10",
                            "value": 9,
                            "title": "9"
                        },
                        {
                            "label": "c11",
                            "value": 10,
                            "title": "10 - Extremely positive"
                        }
                    ],
                    "row": "r8",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q15"
                },
                {
                    "vgroup": "Q15",
                    "qtitle": "Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
                    "colTitle": null,
                    "title": "Future energy - Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?",
                    "rowTitle": "Future energy",
                    "label": "Q15r9",
                    "values": [
                        {
                            "label": "c1",
                            "value": 0,
                            "title": "0 - Extremely negative"
                        },
                        {
                            "label": "c2",
                            "value": 1,
                            "title": "1"
                        },
                        {
                            "label": "c3",
                            "value": 2,
                            "title": "2"
                        },
                        {
                            "label": "c4",
                            "value": 3,
                            "title": "3"
                        },
                        {
                            "label": "c5",
                            "value": 4,
                            "title": "4"
                        },
                        {
                            "label": "c6",
                            "value": 5,
                            "title": "5 - Neutral"
                        },
                        {
                            "label": "c7",
                            "value": 6,
                            "title": "6"
                        },
                        {
                            "label": "c8",
                            "value": 7,
                            "title": "7"
                        },
                        {
                            "label": "c9",
                            "value": 8,
                            "title": "8"
                        },
                        {
                            "label": "c10",
                            "value": 9,
                            "title": "9"
                        },
                        {
                            "label": "c11",
                            "value": 10,
                            "title": "10 - Extremely positive"
                        }
                    ],
                    "row": "r9",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q15"
                }
            ],
            "values": [
                {
                    "label": "c1",
                    "value": 0,
                    "title": "0 - Extremely negative"
                },
                {
                    "label": "c2",
                    "value": 1,
                    "title": "1"
                },
                {
                    "label": "c3",
                    "value": 2,
                    "title": "2"
                },
                {
                    "label": "c4",
                    "value": 3,
                    "title": "3"
                },
                {
                    "label": "c5",
                    "value": 4,
                    "title": "4"
                },
                {
                    "label": "c6",
                    "value": 5,
                    "title": "5 - Neutral"
                },
                {
                    "label": "c7",
                    "value": 6,
                    "title": "6"
                },
                {
                    "label": "c8",
                    "value": 7,
                    "title": "7"
                },
                {
                    "label": "c9",
                    "value": 8,
                    "title": "8"
                },
                {
                    "label": "c10",
                    "value": 9,
                    "title": "9"
                },
                {
                    "label": "c11",
                    "value": 10,
                    "title": "10 - Extremely positive"
                }
            ],
            "grouping": "rows",
            "type": "single",
            "dq": "cardrating"
        },
        {
            "qtitle": "Please read the below statements and select the one that comes the closest to your own opinion.",
            "variables": [
                {
                    "vgroup": "Q16",
                    "qtitle": "Please read the below statements and select the one that comes the closest to your own opinion.",
                    "colTitle": null,
                    "title": "Please read the below statements and select the one that comes the closest to your own opinion.",
                    "rowTitle": null,
                    "label": "Q16",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "I believe fossil fuels should play the largest role in America's energy mix. Oil, natural gas, and coal remain the most proven sources of energy, and moving away from them would be a mistake."
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "I believe the U.S. is too reliant on fossil fuels. We should be moving more quickly toward renewable and cleaner energy sources."
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q16"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "I believe fossil fuels should play the largest role in America's energy mix. Oil, natural gas, and coal remain the most proven sources of energy, and moving away from them would be a mistake."
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "I believe the U.S. is too reliant on fossil fuels. We should be moving more quickly toward renewable and cleaner energy sources."
                }
            ],
            "qlabel": "Q16",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "Please read the below statements and select the one that comes the closest to your own opinion.",
            "variables": [
                {
                    "vgroup": "Q17",
                    "qtitle": "Please read the below statements and select the one that comes the closest to your own opinion.",
                    "colTitle": null,
                    "title": "Please read the below statements and select the one that comes the closest to your own opinion.",
                    "rowTitle": null,
                    "label": "Q17",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Fossil fuels are the most affordable source of energy, and renewables are usually less affordable once you factor hidden costs, like infrastructure and storage."
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Renewable energy is becoming more affordable, but fossil fuels are still cheaper in many cases."
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "Renewable energy is the lowest-cost option, cheaper than fossil fuels in many cases."
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q17"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Fossil fuels are the most affordable source of energy, and renewables are usually less affordable once you factor hidden costs, like infrastructure and storage."
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Renewable energy is becoming more affordable, but fossil fuels are still cheaper in many cases."
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Renewable energy is the lowest-cost option, cheaper than fossil fuels in many cases."
                }
            ],
            "qlabel": "Q17",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "Please read the below statements and select the one that comes the closest to your own opinion.",
            "variables": [
                {
                    "vgroup": "Q18",
                    "qtitle": "Please read the below statements and select the one that comes the closest to your own opinion.",
                    "colTitle": null,
                    "title": "Please read the below statements and select the one that comes the closest to your own opinion.",
                    "rowTitle": null,
                    "label": "Q18",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Fossil fuels are the most reliable sources of energy because the U.S. has vast reserves capable of sustaining growing energy demands."
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Renewable energy is the most reliable because it is abundant and inexhaustible. The sun and wind will never run out."
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "A mix of fossil fuels, nuclear, and renewables is the best way to create the most dependable energy system."
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q18"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Fossil fuels are the most reliable sources of energy because the U.S. has vast reserves capable of sustaining growing energy demands."
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Renewable energy is the most reliable because it is abundant and inexhaustible. The sun and wind will never run out."
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A mix of fossil fuels, nuclear, and renewables is the best way to create the most dependable energy system."
                }
            ],
            "qlabel": "Q18",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "Please read the below statements and select the one that comes the closest to your own opinion.",
            "variables": [
                {
                    "vgroup": "Q19",
                    "qtitle": "Please read the below statements and select the one that comes the closest to your own opinion.",
                    "colTitle": null,
                    "title": "Please read the below statements and select the one that comes the closest to your own opinion.",
                    "rowTitle": null,
                    "label": "Q19",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Fossil fuel industries create better jobs. They're higher-paying, more stable, and longer-term than renewable energy jobs."
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Renewable energy jobs are surging, and the industry will employ more Americans in the future than fossil fuels."
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q19"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Fossil fuel industries create better jobs. They're higher-paying, more stable, and longer-term than renewable energy jobs."
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Renewable energy jobs are surging, and the industry will employ more Americans in the future than fossil fuels."
                }
            ],
            "qlabel": "Q19",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "Please read the below statements and select the one that comes the closest to your own opinion.",
            "variables": [
                {
                    "vgroup": "Q20",
                    "qtitle": "Please read the below statements and select the one that comes the closest to your own opinion.",
                    "colTitle": null,
                    "title": "Please read the below statements and select the one that comes the closest to your own opinion.",
                    "rowTitle": null,
                    "label": "Q20",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Fossil fuels strengthen U.S. energy security since they are proven and available domestically."
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Renewable energy strengthens U.S. security by reducing dependence on foreign oil and gas."
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "True energy security requires a balanced mix because both renewables and fossil fuels have vulnerabilities."
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q20"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Fossil fuels strengthen U.S. energy security since they are proven and available domestically."
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Renewable energy strengthens U.S. security by reducing dependence on foreign oil and gas."
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "True energy security requires a balanced mix because both renewables and fossil fuels have vulnerabilities."
                }
            ],
            "qlabel": "Q20",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "HIDDEN: Comment pipe for Q21",
            "variables": [
                {
                    "vgroup": "Q21comment",
                    "qtitle": "HIDDEN: Comment pipe for Q21",
                    "colTitle": null,
                    "title": "HIDDEN: Comment pipe for Q21",
                    "rowTitle": null,
                    "label": "Q21comment",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Tap each option in order of trust. Start with the one you trust most and end with the one you trust least."
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": ""
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q21comment"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Tap each option in order of trust. Start with the one you trust most and end with the one you trust least."
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": ""
                }
            ],
            "flags": "x",
            "qlabel": "Q21comment",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
            "qlabel": "Q21",
            "variables": [
                {
                    "vgroup": "Q21",
                    "qtitle": "Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
                    "colTitle": null,
                    "title": "Industry leaders - Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
                    "rowTitle": "Industry leaders",
                    "label": "Q21r1",
                    "values": [
                        {
                            "label": "ch1",
                            "value": 1,
                            "title": "Trust the most"
                        },
                        {
                            "label": "ch2",
                            "value": 2,
                            "title": ""
                        },
                        {
                            "label": "ch3",
                            "value": 3,
                            "title": ""
                        },
                        {
                            "label": "ch4",
                            "value": 4,
                            "title": ""
                        },
                        {
                            "label": "ch5",
                            "value": 5,
                            "title": ""
                        },
                        {
                            "label": "ch6",
                            "value": 6,
                            "title": ""
                        },
                        {
                            "label": "ch7",
                            "value": 7,
                            "title": "Trust the least"
                        }
                    ],
                    "row": "r1",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q21"
                },
                {
                    "vgroup": "Q21",
                    "qtitle": "Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
                    "colTitle": null,
                    "title": "Government agencies - Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
                    "rowTitle": "Government agencies",
                    "label": "Q21r2",
                    "values": [
                        {
                            "label": "ch1",
                            "value": 1,
                            "title": "Trust the most"
                        },
                        {
                            "label": "ch2",
                            "value": 2,
                            "title": ""
                        },
                        {
                            "label": "ch3",
                            "value": 3,
                            "title": ""
                        },
                        {
                            "label": "ch4",
                            "value": 4,
                            "title": ""
                        },
                        {
                            "label": "ch5",
                            "value": 5,
                            "title": ""
                        },
                        {
                            "label": "ch6",
                            "value": 6,
                            "title": ""
                        },
                        {
                            "label": "ch7",
                            "value": 7,
                            "title": "Trust the least"
                        }
                    ],
                    "row": "r2",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q21"
                },
                {
                    "vgroup": "Q21",
                    "qtitle": "Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
                    "colTitle": null,
                    "title": "Environmental groups - Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
                    "rowTitle": "Environmental groups",
                    "label": "Q21r3",
                    "values": [
                        {
                            "label": "ch1",
                            "value": 1,
                            "title": "Trust the most"
                        },
                        {
                            "label": "ch2",
                            "value": 2,
                            "title": ""
                        },
                        {
                            "label": "ch3",
                            "value": 3,
                            "title": ""
                        },
                        {
                            "label": "ch4",
                            "value": 4,
                            "title": ""
                        },
                        {
                            "label": "ch5",
                            "value": 5,
                            "title": ""
                        },
                        {
                            "label": "ch6",
                            "value": 6,
                            "title": ""
                        },
                        {
                            "label": "ch7",
                            "value": 7,
                            "title": "Trust the least"
                        }
                    ],
                    "row": "r3",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q21"
                },
                {
                    "vgroup": "Q21",
                    "qtitle": "Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
                    "colTitle": null,
                    "title": "Academics and other technical experts - Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
                    "rowTitle": "Academics and other technical experts",
                    "label": "Q21r4",
                    "values": [
                        {
                            "label": "ch1",
                            "value": 1,
                            "title": "Trust the most"
                        },
                        {
                            "label": "ch2",
                            "value": 2,
                            "title": ""
                        },
                        {
                            "label": "ch3",
                            "value": 3,
                            "title": ""
                        },
                        {
                            "label": "ch4",
                            "value": 4,
                            "title": ""
                        },
                        {
                            "label": "ch5",
                            "value": 5,
                            "title": ""
                        },
                        {
                            "label": "ch6",
                            "value": 6,
                            "title": ""
                        },
                        {
                            "label": "ch7",
                            "value": 7,
                            "title": "Trust the least"
                        }
                    ],
                    "row": "r4",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q21"
                },
                {
                    "vgroup": "Q21",
                    "qtitle": "Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
                    "colTitle": null,
                    "title": "Local community members - Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
                    "rowTitle": "Local community members",
                    "label": "Q21r5",
                    "values": [
                        {
                            "label": "ch1",
                            "value": 1,
                            "title": "Trust the most"
                        },
                        {
                            "label": "ch2",
                            "value": 2,
                            "title": ""
                        },
                        {
                            "label": "ch3",
                            "value": 3,
                            "title": ""
                        },
                        {
                            "label": "ch4",
                            "value": 4,
                            "title": ""
                        },
                        {
                            "label": "ch5",
                            "value": 5,
                            "title": ""
                        },
                        {
                            "label": "ch6",
                            "value": 6,
                            "title": ""
                        },
                        {
                            "label": "ch7",
                            "value": 7,
                            "title": "Trust the least"
                        }
                    ],
                    "row": "r5",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q21"
                },
                {
                    "vgroup": "Q21",
                    "qtitle": "Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
                    "colTitle": null,
                    "title": "Energy workers - Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
                    "rowTitle": "Energy workers",
                    "label": "Q21r6",
                    "values": [
                        {
                            "label": "ch1",
                            "value": 1,
                            "title": "Trust the most"
                        },
                        {
                            "label": "ch2",
                            "value": 2,
                            "title": ""
                        },
                        {
                            "label": "ch3",
                            "value": 3,
                            "title": ""
                        },
                        {
                            "label": "ch4",
                            "value": 4,
                            "title": ""
                        },
                        {
                            "label": "ch5",
                            "value": 5,
                            "title": ""
                        },
                        {
                            "label": "ch6",
                            "value": 6,
                            "title": ""
                        },
                        {
                            "label": "ch7",
                            "value": 7,
                            "title": "Trust the least"
                        }
                    ],
                    "row": "r6",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q21"
                },
                {
                    "vgroup": "Q21",
                    "qtitle": "Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
                    "colTitle": null,
                    "title": "National and local energy media - Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future.",
                    "rowTitle": "National and local energy media",
                    "label": "Q21r7",
                    "values": [
                        {
                            "label": "ch1",
                            "value": 1,
                            "title": "Trust the most"
                        },
                        {
                            "label": "ch2",
                            "value": 2,
                            "title": ""
                        },
                        {
                            "label": "ch3",
                            "value": 3,
                            "title": ""
                        },
                        {
                            "label": "ch4",
                            "value": 4,
                            "title": ""
                        },
                        {
                            "label": "ch5",
                            "value": 5,
                            "title": ""
                        },
                        {
                            "label": "ch6",
                            "value": 6,
                            "title": ""
                        },
                        {
                            "label": "ch7",
                            "value": 7,
                            "title": "Trust the least"
                        }
                    ],
                    "row": "r7",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q21"
                }
            ],
            "values": [
                {
                    "label": "ch1",
                    "value": 1,
                    "title": "Trust the most"
                },
                {
                    "label": "ch2",
                    "value": 2,
                    "title": ""
                },
                {
                    "label": "ch3",
                    "value": 3,
                    "title": ""
                },
                {
                    "label": "ch4",
                    "value": 4,
                    "title": ""
                },
                {
                    "label": "ch5",
                    "value": 5,
                    "title": ""
                },
                {
                    "label": "ch6",
                    "value": 6,
                    "title": ""
                },
                {
                    "label": "ch7",
                    "value": 7,
                    "title": "Trust the least"
                }
            ],
            "grouping": "cols",
            "type": "single",
            "dq": "ranksort"
        },
        {
            "qtitle": "Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is most convincing to you and the ONE that is least convincing.",
            "qlabel": "Q22",
            "variables": [
                {
                    "vgroup": "Q22",
                    "qtitle": "Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is most convincing to you and the ONE that is least convincing.",
                    "colTitle": "Most convincing",
                    "title": "Most convincing - Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is most convincing to you and the ONE that is least convincing.",
                    "rowTitle": null,
                    "label": "Q22c1",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Creates good-paying jobs, and strengthens America’s economy"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Homegrown power that frees us from dependence on foreign countries"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "A dependable and predictable source of power that will always be available when we need it"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                        },
                        {
                            "label": "r7",
                            "value": 7,
                            "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                        },
                        {
                            "label": "r8",
                            "value": 8,
                            "title": "The power source that can fuel America’s growth in AI"
                        },
                        {
                            "label": "r9",
                            "value": 9,
                            "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": "c1",
                    "qlabel": "Q22"
                },
                {
                    "vgroup": "Q22",
                    "qtitle": "Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is most convincing to you and the ONE that is least convincing.",
                    "colTitle": "Least convincing",
                    "title": "Least convincing - Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is most convincing to you and the ONE that is least convincing.",
                    "rowTitle": null,
                    "label": "Q22c2",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Creates good-paying jobs, and strengthens America’s economy"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Homegrown power that frees us from dependence on foreign countries"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "A dependable and predictable source of power that will always be available when we need it"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                        },
                        {
                            "label": "r7",
                            "value": 7,
                            "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                        },
                        {
                            "label": "r8",
                            "value": 8,
                            "title": "The power source that can fuel America’s growth in AI"
                        },
                        {
                            "label": "r9",
                            "value": 9,
                            "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": "c2",
                    "qlabel": "Q22"
                }
            ],
            "flags": "x",
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "grouping": "cols",
            "type": "single",
            "dq": "de_maxdiff"
        },
        {
            "qtitle": "MaxDiff Score (0-100 scale)",
            "variables": [
                {
                    "vgroup": "Q22_score",
                    "qtitle": "MaxDiff Score (0-100 scale)",
                    "colTitle": null,
                    "title": "Creates good-paying jobs, and strengthens America’s economy - MaxDiff Score (0-100 scale)",
                    "rowTitle": "Creates good-paying jobs, and strengthens America’s economy",
                    "label": "Q22_scorer1",
                    "row": "r1",
                    "type": "float",
                    "col": null,
                    "qlabel": "Q22_score"
                },
                {
                    "vgroup": "Q22_score",
                    "qtitle": "MaxDiff Score (0-100 scale)",
                    "colTitle": null,
                    "title": "Homegrown power that frees us from dependence on foreign countries - MaxDiff Score (0-100 scale)",
                    "rowTitle": "Homegrown power that frees us from dependence on foreign countries",
                    "label": "Q22_scorer2",
                    "row": "r2",
                    "type": "float",
                    "col": null,
                    "qlabel": "Q22_score"
                },
                {
                    "vgroup": "Q22_score",
                    "qtitle": "MaxDiff Score (0-100 scale)",
                    "colTitle": null,
                    "title": "A dependable and predictable source of power that will always be available when we need it - MaxDiff Score (0-100 scale)",
                    "rowTitle": "A dependable and predictable source of power that will always be available when we need it",
                    "label": "Q22_scorer3",
                    "row": "r3",
                    "type": "float",
                    "col": null,
                    "qlabel": "Q22_score"
                },
                {
                    "vgroup": "Q22_score",
                    "qtitle": "MaxDiff Score (0-100 scale)",
                    "colTitle": null,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in - MaxDiff Score (0-100 scale)",
                    "rowTitle": "Healthy energy that reduces air pollution and makes our communities safer to live in",
                    "label": "Q22_scorer4",
                    "row": "r4",
                    "type": "float",
                    "col": null,
                    "qlabel": "Q22_score"
                },
                {
                    "vgroup": "Q22_score",
                    "qtitle": "MaxDiff Score (0-100 scale)",
                    "colTitle": null,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change - MaxDiff Score (0-100 scale)",
                    "rowTitle": "A critical part of reducing greenhouse gas emissions and combating climate change",
                    "label": "Q22_scorer5",
                    "row": "r5",
                    "type": "float",
                    "col": null,
                    "qlabel": "Q22_score"
                },
                {
                    "vgroup": "Q22_score",
                    "qtitle": "MaxDiff Score (0-100 scale)",
                    "colTitle": null,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes - MaxDiff Score (0-100 scale)",
                    "rowTitle": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes",
                    "label": "Q22_scorer6",
                    "row": "r6",
                    "type": "float",
                    "col": null,
                    "qlabel": "Q22_score"
                },
                {
                    "vgroup": "Q22_score",
                    "qtitle": "MaxDiff Score (0-100 scale)",
                    "colTitle": null,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race - MaxDiff Score (0-100 scale)",
                    "rowTitle": "A critical energy source for America to lead in the global technology and manufacturing race",
                    "label": "Q22_scorer7",
                    "row": "r7",
                    "type": "float",
                    "col": null,
                    "qlabel": "Q22_score"
                },
                {
                    "vgroup": "Q22_score",
                    "qtitle": "MaxDiff Score (0-100 scale)",
                    "colTitle": null,
                    "title": "The power source that can fuel America’s growth in AI - MaxDiff Score (0-100 scale)",
                    "rowTitle": "The power source that can fuel America’s growth in AI",
                    "label": "Q22_scorer8",
                    "row": "r8",
                    "type": "float",
                    "col": null,
                    "qlabel": "Q22_score"
                },
                {
                    "vgroup": "Q22_score",
                    "qtitle": "MaxDiff Score (0-100 scale)",
                    "colTitle": null,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out - MaxDiff Score (0-100 scale)",
                    "rowTitle": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out",
                    "label": "Q22_scorer9",
                    "row": "r9",
                    "type": "float",
                    "col": null,
                    "qlabel": "Q22_score"
                }
            ],
            "flags": "vt",
            "qlabel": "Q22_score",
            "type": "float",
            "grouping": "cols"
        },
        {
            "qtitle": "Version Selected",
            "variables": [
                {
                    "vgroup": "Q22_version",
                    "qtitle": "Version Selected",
                    "colTitle": null,
                    "title": "Version Selected",
                    "rowTitle": null,
                    "label": "Q22_version",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Version 1: 1 2 7 8; 2 8 1 4; 5 1 9 6; 9 3 4 1; 7 5 2 3; 3 9 8 6; 6 7 5 2; 8 4 3 5; 4 6 7 9"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Version 2: 5 2 6 4; 2 5 8 9; 6 8 4 1; 3 1 5 7; 1 4 8 5; 8 7 2 9; 7 6 3 4; 9 3 1 7; 2 9 6 3"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "Version 3: 6 1 7 8; 8 6 5 3; 4 5 9 2; 3 7 4 2; 5 3 6 1; 1 2 9 6; 1 8 2 3; 9 4 8 7; 4 9 7 5"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Version 4: 7 9 1 5; 6 7 5 8; 4 6 1 2; 2 4 3 1; 3 2 6 7; 5 1 4 9; 8 5 9 3; 9 8 2 6; 7 3 8 4"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "Version 5: 2 7 9 4; 4 2 3 6; 3 9 2 5; 1 2 5 8; 7 6 1 9; 5 3 7 1; 6 8 4 5; 8 1 3 9; 8 4 6 7"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Version 6: 3 5 7 2; 5 1 4 6; 9 4 1 2; 7 9 5 8; 6 3 9 4; 9 6 3 8; 4 8 2 3; 5 7 6 1; 1 8 2 7"
                        },
                        {
                            "label": "r7",
                            "value": 7,
                            "title": "Version 7: 2 9 7 6; 9 7 8 3; 8 5 9 4; 4 3 8 1; 1 5 6 2; 3 4 5 7; 6 1 2 3; 7 1 4 9; 2 6 8 5"
                        },
                        {
                            "label": "r8",
                            "value": 8,
                            "title": "Version 8: 4 3 1 5; 7 2 4 8; 1 7 9 8; 2 4 5 9; 6 8 7 1; 5 9 3 6; 2 6 7 4; 9 3 6 1; 3 2 5 8"
                        },
                        {
                            "label": "r9",
                            "value": 9,
                            "title": "Version 9: 8 3 1 7; 1 7 3 4; 4 5 6 7; 9 5 1 2; 6 4 2 5; 8 2 9 1; 3 8 6 9; 9 6 8 4; 5 7 3 2"
                        },
                        {
                            "label": "r10",
                            "value": 10,
                            "title": "Version 10: 7 8 4 5; 8 2 4 6; 8 9 2 3; 6 9 7 2; 5 4 3 9; 5 1 9 7; 2 4 1 3; 3 6 7 1; 1 5 8 6"
                        },
                        {
                            "label": "r11",
                            "value": 11,
                            "title": "Version 11: 7 1 4 2; 2 7 5 8; 4 8 3 9; 1 2 9 6; 6 9 1 4; 1 5 4 8; 8 3 5 6; 7 6 2 3; 3 7 9 5"
                        },
                        {
                            "label": "r12",
                            "value": 12,
                            "title": "Version 12: 4 1 3 7; 9 1 2 5; 5 6 8 2; 3 5 1 8; 2 8 3 1; 7 4 6 8; 9 5 7 6; 6 3 4 9; 4 9 2 7"
                        },
                        {
                            "label": "r13",
                            "value": 13,
                            "title": "Version 13: 4 2 5 3; 1 9 8 4; 2 8 7 3; 3 1 6 2; 6 3 4 7; 9 6 1 7; 7 8 5 9; 5 4 9 2; 8 1 6 5"
                        },
                        {
                            "label": "r14",
                            "value": 14,
                            "title": "Version 14: 7 2 8 9; 9 2 8 3; 1 3 9 4; 3 7 6 5; 5 9 3 6; 8 6 4 1; 4 5 1 7; 2 7 5 1; 6 4 2 8"
                        },
                        {
                            "label": "r15",
                            "value": 15,
                            "title": "Version 15: 2 6 7 4; 7 8 6 3; 3 1 9 5; 5 4 8 6; 4 5 3 9; 3 2 5 4; 8 7 1 2; 6 9 2 1; 9 1 7 8"
                        },
                        {
                            "label": "r16",
                            "value": 16,
                            "title": "Version 16: 1 2 4 7; 2 3 6 9; 1 6 2 3; 6 4 1 5; 4 9 7 8; 8 5 6 1; 5 7 9 2; 9 3 8 4; 7 3 5 8"
                        },
                        {
                            "label": "r17",
                            "value": 17,
                            "title": "Version 17: 5 1 3 7; 2 8 5 6; 7 5 4 6; 1 7 6 9; 6 9 7 3; 9 4 1 8; 8 3 2 4; 4 2 9 5; 3 8 1 2"
                        },
                        {
                            "label": "r18",
                            "value": 18,
                            "title": "Version 18: 5 4 3 1; 3 1 4 7; 4 6 8 9; 7 8 2 1; 1 6 3 2; 2 9 5 8; 8 5 9 6; 6 7 3 4; 9 2 7 5"
                        },
                        {
                            "label": "r19",
                            "value": 19,
                            "title": "Version 19: 5 7 8 3; 6 5 4 1; 1 4 8 2; 2 3 9 4; 9 1 5 3; 3 6 7 8; 8 9 1 6; 7 5 2 9; 4 2 6 7"
                        },
                        {
                            "label": "r20",
                            "value": 20,
                            "title": "Version 20: 3 8 2 5; 5 2 6 1; 8 6 3 4; 1 3 7 9; 2 9 6 3; 6 4 9 2; 7 8 5 1; 4 1 9 7; 7 8 4 5"
                        },
                        {
                            "label": "r21",
                            "value": 21,
                            "title": "Version 21: 8 4 1 2; 2 1 5 3; 4 5 3 6; 9 7 8 6; 2 9 8 7; 5 6 1 9; 6 7 4 5; 9 3 8 4; 1 2 7 3"
                        },
                        {
                            "label": "r22",
                            "value": 22,
                            "title": "Version 22: 3 6 4 7; 6 5 2 8; 8 7 6 1; 5 2 9 4; 9 3 1 6; 1 4 2 7; 2 8 3 9; 4 1 5 8; 7 3 9 5"
                        },
                        {
                            "label": "r23",
                            "value": 23,
                            "title": "Version 23: 3 9 8 1; 6 1 3 2; 5 6 7 2; 1 5 4 9; 9 2 6 4; 8 9 7 6; 7 1 2 4; 3 7 5 8; 4 8 3 5"
                        },
                        {
                            "label": "r24",
                            "value": 24,
                            "title": "Version 24: 9 6 7 3; 6 3 1 8; 7 4 2 3; 2 4 9 5; 8 5 6 2; 1 9 5 6; 3 7 8 4; 5 2 1 7; 4 8 9 1"
                        },
                        {
                            "label": "r25",
                            "value": 25,
                            "title": "Version 25: 8 1 4 6; 5 4 7 9; 6 9 1 7; 3 8 5 2; 9 2 7 8; 1 3 6 5; 7 5 2 1; 4 6 3 2; 4 9 8 3"
                        },
                        {
                            "label": "r26",
                            "value": 26,
                            "title": "Version 26: 2 7 1 8; 5 2 6 9; 9 5 3 1; 3 7 4 5; 6 4 8 7; 7 6 5 8; 8 1 2 9; 2 3 4 6; 1 9 3 4"
                        },
                        {
                            "label": "r27",
                            "value": 27,
                            "title": "Version 27: 5 8 4 1; 8 4 9 2; 9 5 8 6; 6 2 1 3; 3 7 5 4; 1 4 7 6; 2 3 9 7; 8 1 2 3; 7 6 5 9"
                        },
                        {
                            "label": "r28",
                            "value": 28,
                            "title": "Version 28: 3 8 6 2; 4 1 2 5; 6 8 1 7; 7 3 6 9; 5 7 3 8; 4 2 6 5; 2 9 7 1; 9 4 8 3; 1 9 4 5"
                        },
                        {
                            "label": "r29",
                            "value": 29,
                            "title": "Version 29: 6 5 9 8; 1 3 2 4; 9 2 5 3; 5 8 1 3; 4 6 9 1; 2 6 4 7; 8 7 9 4; 3 1 7 6; 7 5 8 2"
                        },
                        {
                            "label": "r30",
                            "value": 30,
                            "title": "Version 30: 7 5 3 9; 3 2 5 6; 6 4 2 8; 2 7 3 9; 5 6 8 1; 4 8 7 1; 1 9 8 2; 9 1 4 7; 5 3 6 4"
                        },
                        {
                            "label": "r31",
                            "value": 31,
                            "title": "Version 31: 9 3 1 5; 1 4 3 6; 4 6 7 2; 8 6 9 3; 2 8 4 5; 6 2 7 9; 7 3 1 8; 8 9 5 4; 5 7 2 1"
                        },
                        {
                            "label": "r32",
                            "value": 32,
                            "title": "Version 32: 8 1 6 5; 9 8 6 7; 1 5 9 6; 3 9 1 2; 2 6 3 4; 7 2 8 3; 4 9 2 8; 1 7 5 4; 3 4 5 7"
                        },
                        {
                            "label": "r33",
                            "value": 33,
                            "title": "Version 33: 2 1 4 9; 4 5 8 3; 6 5 9 3; 5 1 2 7; 6 4 1 8; 9 2 7 5; 3 8 2 1; 4 7 6 9; 7 3 8 6"
                        },
                        {
                            "label": "r34",
                            "value": 34,
                            "title": "Version 34: 6 1 9 2; 7 4 3 5; 8 9 4 7; 5 3 1 8; 3 2 4 9; 9 7 3 1; 1 6 7 4; 8 5 6 2; 2 8 5 6"
                        },
                        {
                            "label": "r35",
                            "value": 35,
                            "title": "Version 35: 3 1 7 2; 1 8 9 5; 7 9 2 6; 5 3 6 9; 6 7 8 1; 8 2 3 4; 9 5 4 8; 4 2 5 7; 4 6 1 3"
                        },
                        {
                            "label": "r36",
                            "value": 36,
                            "title": "Version 36: 5 4 7 6; 3 4 1 9; 2 3 8 7; 1 7 9 5; 6 5 2 3; 8 6 4 9; 7 8 2 1; 2 1 5 4; 9 3 6 8"
                        },
                        {
                            "label": "r37",
                            "value": 37,
                            "title": "Version 37: 4 9 5 2; 1 4 3 6; 6 2 8 7; 9 1 7 3; 5 7 3 4; 8 3 7 5; 6 8 1 5; 2 9 4 8; 1 6 9 2"
                        },
                        {
                            "label": "r38",
                            "value": 38,
                            "title": "Version 38: 2 8 4 1; 7 5 1 4; 3 7 8 9; 7 2 6 5; 5 1 9 8; 4 8 6 3; 9 6 4 7; 3 5 2 6; 2 9 3 1"
                        },
                        {
                            "label": "r39",
                            "value": 39,
                            "title": "Version 39: 9 4 5 3; 3 6 1 7; 8 7 9 2; 5 9 6 2; 8 5 7 6; 3 4 8 7; 4 1 2 6; 1 2 9 4; 5 3 1 8"
                        },
                        {
                            "label": "r40",
                            "value": 40,
                            "title": "Version 40: 6 2 3 9; 7 3 2 1; 2 1 5 8; 9 5 7 4; 4 8 6 5; 8 4 3 2; 6 9 5 3; 7 6 4 1; 1 7 8 9"
                        },
                        {
                            "label": "r41",
                            "value": 41,
                            "title": "Version 41: 1 6 4 8; 5 1 2 3; 6 5 1 9; 4 8 9 3; 8 2 9 7; 9 4 6 7; 7 5 4 2; 8 3 5 1; 3 7 2 6"
                        },
                        {
                            "label": "r42",
                            "value": 42,
                            "title": "Version 42: 2 9 5 4; 1 9 3 6; 9 7 8 1; 6 2 3 4; 3 4 7 5; 4 1 8 6; 2 6 7 8; 7 3 9 5; 5 8 1 2"
                        },
                        {
                            "label": "r43",
                            "value": 43,
                            "title": "Version 43: 8 2 6 3; 3 1 7 4; 2 1 6 9; 9 8 3 7; 6 9 2 5; 1 7 4 2; 7 5 1 6; 4 3 8 5; 5 4 8 9"
                        },
                        {
                            "label": "r44",
                            "value": 44,
                            "title": "Version 44: 3 6 9 8; 6 7 5 1; 5 3 2 4; 1 9 3 4; 9 2 7 3; 4 5 1 6; 2 8 1 9; 8 6 4 7; 8 7 5 2"
                        },
                        {
                            "label": "r45",
                            "value": 45,
                            "title": "Version 45: 7 5 6 3; 2 4 7 1; 4 2 9 7; 1 9 5 8; 5 3 6 9; 6 4 3 1; 9 7 4 8; 3 1 2 8; 5 8 6 2"
                        },
                        {
                            "label": "r46",
                            "value": 46,
                            "title": "Version 46: 7 1 2 3; 1 9 4 5; 2 4 8 5; 8 6 1 9; 3 5 7 2; 6 3 8 4; 7 8 3 6; 9 7 5 1; 4 6 2 9"
                        },
                        {
                            "label": "r47",
                            "value": 47,
                            "title": "Version 47: 8 6 9 7; 3 2 8 1; 7 2 6 5; 5 3 9 4; 4 8 7 3; 1 5 7 8; 2 4 5 6; 9 1 3 2; 6 4 1 9"
                        },
                        {
                            "label": "r48",
                            "value": 48,
                            "title": "Version 48: 6 9 2 7; 7 9 8 5; 1 7 4 3; 4 1 6 7; 3 6 1 5; 9 2 4 8; 5 8 3 9; 2 5 8 4; 6 3 1 2"
                        },
                        {
                            "label": "r49",
                            "value": 49,
                            "title": "Version 49: 8 2 9 1; 2 3 5 6; 8 6 5 1; 3 9 6 4; 7 4 8 6; 1 8 3 7; 5 4 9 2; 9 7 2 3; 4 1 5 7"
                        },
                        {
                            "label": "r50",
                            "value": 50,
                            "title": "Version 50: 6 9 3 8; 9 6 4 1; 4 1 7 9; 7 5 9 3; 8 5 3 1; 5 7 6 2; 1 2 4 5; 3 8 2 4; 2 6 7 8"
                        },
                        {
                            "label": "r51",
                            "value": 51,
                            "title": "Version 51: 8 2 7 4; 5 7 8 6; 4 3 9 8; 6 8 1 2; 3 5 4 6; 1 9 6 7; 2 1 5 9; 9 4 5 3; 7 3 2 1"
                        },
                        {
                            "label": "r52",
                            "value": 52,
                            "title": "Version 52: 9 2 6 5; 2 9 3 8; 8 5 9 7; 5 8 1 4; 1 6 8 9; 4 3 7 6; 3 7 2 1; 7 1 4 5; 6 4 2 3"
                        },
                        {
                            "label": "r53",
                            "value": 53,
                            "title": "Version 53: 8 3 1 4; 3 9 1 2; 1 6 3 5; 4 7 9 6; 7 8 4 2; 5 7 6 9; 2 9 4 5; 6 2 1 8; 8 5 7 3"
                        },
                        {
                            "label": "r54",
                            "value": 54,
                            "title": "Version 54: 2 3 5 6; 9 5 8 3; 1 4 9 7; 4 8 2 6; 6 4 8 9; 5 1 7 8; 7 1 9 3; 1 2 5 4; 3 6 7 2"
                        },
                        {
                            "label": "r55",
                            "value": 55,
                            "title": "Version 55: 8 5 6 7; 5 8 3 4; 4 6 3 1; 9 7 5 2; 9 3 6 7; 2 9 1 5; 3 1 2 4; 1 6 8 9; 7 4 2 8"
                        },
                        {
                            "label": "r56",
                            "value": 56,
                            "title": "Version 56: 6 2 4 7; 4 9 5 3; 9 2 3 8; 9 4 8 1; 3 5 6 7; 6 1 4 5; 7 8 1 3; 8 7 9 2; 2 6 5 1"
                        },
                        {
                            "label": "r57",
                            "value": 57,
                            "title": "Version 57: 5 8 1 6; 4 5 2 9; 1 3 7 2; 5 4 7 1; 8 3 4 6; 6 2 8 9; 7 9 3 4; 6 1 9 7; 2 5 3 8"
                        },
                        {
                            "label": "r58",
                            "value": 58,
                            "title": "Version 58: 3 9 6 5; 5 7 9 1; 9 8 5 4; 3 6 4 2; 8 1 2 6; 1 3 2 9; 2 4 7 6; 8 7 3 5; 7 4 8 1"
                        },
                        {
                            "label": "r59",
                            "value": 59,
                            "title": "Version 59: 5 2 1 8; 4 2 6 9; 9 1 6 3; 3 8 6 5; 6 9 4 7; 7 5 1 3; 1 3 8 4; 4 7 5 2; 7 2 9 8"
                        },
                        {
                            "label": "r60",
                            "value": 60,
                            "title": "Version 60: 4 6 1 8; 2 6 7 1; 8 4 2 5; 2 1 5 9; 1 9 4 3; 9 7 3 2; 5 3 6 4; 6 8 5 7; 3 9 7 8"
                        },
                        {
                            "label": "r61",
                            "value": 61,
                            "title": "Version 61: 2 1 8 3; 4 5 9 6; 1 5 9 6; 5 2 1 7; 3 6 7 5; 8 3 2 6; 7 4 3 2; 9 8 4 7; 8 9 4 1"
                        },
                        {
                            "label": "r62",
                            "value": 62,
                            "title": "Version 62: 5 7 8 3; 6 5 8 9; 9 8 5 2; 9 2 3 4; 1 4 7 5; 6 1 9 3; 2 6 1 7; 7 3 1 4; 2 4 6 8"
                        },
                        {
                            "label": "r63",
                            "value": 63,
                            "title": "Version 63: 6 7 2 9; 3 8 2 1; 3 9 6 1; 1 7 9 8; 5 3 8 9; 4 8 7 6; 7 5 4 6; 4 2 3 5; 2 1 5 4"
                        },
                        {
                            "label": "r64",
                            "value": 64,
                            "title": "Version 64: 4 1 3 2; 8 6 2 3; 8 7 1 5; 7 5 9 1; 5 2 7 3; 9 4 8 7; 3 9 6 4; 6 9 5 2; 1 6 4 8"
                        },
                        {
                            "label": "r65",
                            "value": 65,
                            "title": "Version 65: 2 8 1 9; 1 6 8 7; 9 2 5 4; 6 5 9 8; 7 3 6 2; 3 7 4 9; 5 3 6 1; 7 1 2 4; 4 3 8 5"
                        },
                        {
                            "label": "r66",
                            "value": 66,
                            "title": "Version 66: 3 1 7 6; 8 9 3 1; 9 4 7 6; 8 7 2 5; 3 2 9 7; 2 4 6 8; 6 1 4 5; 8 5 3 4; 1 2 5 9"
                        },
                        {
                            "label": "r67",
                            "value": 67,
                            "title": "Version 67: 6 8 7 2; 5 6 9 3; 4 9 2 7; 2 6 1 9; 1 5 4 2; 5 3 1 4; 3 8 1 6; 4 9 7 8; 7 5 3 8"
                        },
                        {
                            "label": "r68",
                            "value": 68,
                            "title": "Version 68: 2 4 6 3; 4 7 5 3; 4 3 8 1; 7 2 5 6; 9 4 8 6; 6 1 5 7; 9 8 2 1; 1 7 3 9; 5 8 9 2"
                        },
                        {
                            "label": "r69",
                            "value": 69,
                            "title": "Version 69: 9 3 4 5; 7 6 4 1; 8 9 1 7; 1 4 9 5; 6 7 5 3; 3 2 7 8; 5 6 2 8; 2 3 6 9; 8 1 4 2"
                        },
                        {
                            "label": "r70",
                            "value": 70,
                            "title": "Version 70: 7 1 2 4; 3 7 8 9; 4 2 7 6; 1 5 3 2; 6 8 9 5; 9 6 1 5; 5 4 8 7; 4 8 6 3; 2 9 3 1"
                        },
                        {
                            "label": "r71",
                            "value": 71,
                            "title": "Version 71: 8 5 7 1; 2 5 8 4; 8 4 3 9; 3 2 5 6; 7 3 2 9; 9 7 4 5; 1 6 2 7; 6 3 1 8; 1 9 6 4"
                        },
                        {
                            "label": "r72",
                            "value": 72,
                            "title": "Version 72: 5 1 8 2; 5 7 9 3; 2 9 6 4; 4 2 1 7; 8 4 3 1; 9 8 7 6; 5 6 9 2; 3 7 6 8; 1 5 4 3"
                        },
                        {
                            "label": "r73",
                            "value": 73,
                            "title": "Version 73: 7 1 5 9; 6 1 7 3; 3 6 4 2; 6 8 1 7; 9 4 3 5; 4 5 8 6; 8 9 2 4; 8 2 9 1; 7 2 5 3"
                        },
                        {
                            "label": "r74",
                            "value": 74,
                            "title": "Version 74: 1 3 6 4; 9 1 3 8; 2 3 9 7; 2 7 8 5; 4 6 2 5; 7 4 1 6; 5 9 6 1; 9 4 7 8; 8 5 3 2"
                        },
                        {
                            "label": "r75",
                            "value": 75,
                            "title": "Version 75: 3 6 2 9; 3 8 1 2; 6 8 5 7; 9 1 4 3; 5 9 1 6; 1 5 4 2; 4 3 5 7; 7 6 9 8; 2 7 8 4"
                        },
                        {
                            "label": "r76",
                            "value": 76,
                            "title": "Version 76: 3 2 8 9; 4 8 3 1; 2 1 7 9; 7 4 9 5; 6 3 7 1; 7 2 4 6; 1 9 5 4; 6 5 8 3; 8 5 6 2"
                        },
                        {
                            "label": "r77",
                            "value": 77,
                            "title": "Version 77: 5 9 2 1; 9 6 4 8; 5 4 6 3; 8 7 9 4; 6 7 3 9; 2 8 5 1; 3 2 4 7; 1 3 7 5; 6 1 2 8"
                        },
                        {
                            "label": "r78",
                            "value": 78,
                            "title": "Version 78: 7 2 5 9; 4 9 2 3; 4 8 1 6; 5 3 8 4; 8 6 1 7; 9 3 6 2; 1 5 9 6; 3 5 7 8; 1 7 2 4"
                        },
                        {
                            "label": "r79",
                            "value": 79,
                            "title": "Version 79: 9 4 3 1; 2 8 9 5; 4 2 5 6; 3 1 6 2; 5 1 4 7; 8 9 1 7; 7 6 3 5; 2 7 8 3; 6 8 4 9"
                        },
                        {
                            "label": "r80",
                            "value": 80,
                            "title": "Version 80: 2 6 1 8; 1 2 5 3; 8 5 7 9; 5 4 8 3; 3 1 9 5; 4 9 6 8; 6 3 7 9; 7 4 2 6; 4 7 2 1"
                        },
                        {
                            "label": "r81",
                            "value": 81,
                            "title": "Version 81: 9 6 7 1; 7 9 8 4; 9 4 3 2; 6 2 9 5; 2 8 3 7; 5 7 6 4; 1 5 8 2; 3 1 5 6; 8 3 4 1"
                        },
                        {
                            "label": "r82",
                            "value": 82,
                            "title": "Version 82: 7 9 3 8; 9 2 1 4; 4 7 2 6; 6 3 7 5; 3 4 5 8; 2 6 9 3; 1 5 4 9; 5 8 1 7; 8 1 6 2"
                        },
                        {
                            "label": "r83",
                            "value": 83,
                            "title": "Version 83: 2 6 8 5; 5 2 4 7; 4 8 6 9; 8 7 1 3; 1 9 7 4; 6 5 9 8; 4 1 3 6; 3 7 2 1; 9 3 5 2"
                        },
                        {
                            "label": "r84",
                            "value": 84,
                            "title": "Version 84: 8 4 1 6; 7 8 5 2; 6 1 8 3; 3 4 9 5; 4 3 2 8; 5 9 7 1; 1 2 9 7; 9 2 3 6; 5 6 4 7"
                        },
                        {
                            "label": "r85",
                            "value": 85,
                            "title": "Version 85: 8 5 1 9; 7 9 6 3; 2 9 8 4; 1 4 5 3; 3 5 2 9; 7 1 6 8; 8 3 7 4; 2 6 7 5; 2 6 4 1"
                        },
                        {
                            "label": "r86",
                            "value": 86,
                            "title": "Version 86: 6 8 3 4; 6 7 4 2; 9 7 5 1; 1 2 3 7; 9 1 8 2; 5 8 1 3; 5 4 6 9; 3 7 9 6; 4 5 2 8"
                        },
                        {
                            "label": "r87",
                            "value": 87,
                            "title": "Version 87: 2 8 6 5; 6 3 5 1; 7 3 4 5; 1 6 2 9; 4 1 7 2; 9 8 3 7; 8 9 3 2; 9 4 1 6; 7 5 8 4"
                        },
                        {
                            "label": "r88",
                            "value": 88,
                            "title": "Version 88: 3 2 7 6; 5 4 9 8; 6 3 8 7; 3 9 4 1; 8 5 6 9; 4 1 2 3; 2 7 9 4; 1 6 5 8; 7 2 1 5"
                        },
                        {
                            "label": "r89",
                            "value": 89,
                            "title": "Version 89: 2 4 5 8; 8 5 2 3; 7 8 1 9; 5 9 7 6; 3 7 6 9; 6 3 4 5; 9 2 3 1; 4 6 1 2; 1 4 8 7"
                        },
                        {
                            "label": "r90",
                            "value": 90,
                            "title": "Version 90: 6 3 9 4; 4 6 2 7; 3 1 7 5; 1 8 6 3; 5 1 8 2; 8 7 4 3; 8 2 9 6; 2 9 7 5; 9 5 4 1"
                        },
                        {
                            "label": "r91",
                            "value": 91,
                            "title": "Version 91: 2 9 3 8; 6 8 1 4; 7 3 5 9; 7 6 5 4; 5 4 3 1; 4 2 1 6; 3 5 2 6; 9 7 8 2; 1 7 9 8"
                        },
                        {
                            "label": "r92",
                            "value": 92,
                            "title": "Version 92: 3 2 9 4; 4 8 6 7; 7 1 2 4; 8 1 5 9; 1 3 7 8; 5 6 7 2; 2 4 3 5; 6 9 5 1; 6 9 8 3"
                        },
                        {
                            "label": "r93",
                            "value": 93,
                            "title": "Version 93: 9 4 6 7; 9 8 4 2; 1 7 9 3; 7 5 6 1; 2 3 1 6; 8 6 2 7; 4 5 8 9; 5 3 4 8; 3 1 2 5"
                        },
                        {
                            "label": "r94",
                            "value": 94,
                            "title": "Version 94: 6 2 1 9; 7 2 3 4; 3 7 8 1; 9 4 7 5; 1 5 9 2; 5 6 3 8; 4 9 6 1; 2 8 5 7; 8 3 4 6"
                        },
                        {
                            "label": "r95",
                            "value": 95,
                            "title": "Version 95: 5 1 4 6; 6 8 2 7; 2 6 5 9; 8 4 1 3; 9 2 8 4; 1 9 7 3; 4 7 1 8; 3 5 9 6; 7 2 3 5"
                        },
                        {
                            "label": "r96",
                            "value": 96,
                            "title": "Version 96: 8 1 6 2; 1 3 4 5; 7 8 5 1; 4 7 3 9; 6 4 5 7; 5 9 8 2; 9 2 7 4; 3 9 6 8; 2 6 1 3"
                        },
                        {
                            "label": "r97",
                            "value": 97,
                            "title": "Version 97: 4 5 2 3; 5 1 4 6; 1 6 9 8; 6 3 2 7; 9 1 7 2; 8 4 3 2; 3 5 9 1; 7 8 9 4; 7 8 6 5"
                        },
                        {
                            "label": "r98",
                            "value": 98,
                            "title": "Version 98: 5 3 1 9; 2 7 8 3; 3 9 7 6; 1 5 8 2; 9 6 3 4; 6 1 4 7; 2 4 6 8; 4 2 5 9; 8 7 5 1"
                        },
                        {
                            "label": "r99",
                            "value": 99,
                            "title": "Version 99: 9 8 4 1; 4 7 2 5; 1 4 2 3; 2 9 1 6; 7 1 5 4; 6 3 8 2; 5 6 3 8; 3 8 9 7; 7 5 6 9"
                        },
                        {
                            "label": "r100",
                            "value": 100,
                            "title": "Version 100: 9 2 1 3; 1 2 7 6; 9 7 6 5; 8 9 6 4; 5 2 8 1; 2 6 4 5; 4 3 9 7; 3 4 1 8; 8 5 7 3"
                        },
                        {
                            "label": "r101",
                            "value": 101,
                            "title": "Version 101: 4 5 2 7; 6 1 3 7; 7 4 3 2; 3 6 4 1; 2 8 4 9; 5 9 2 8; 8 1 9 5; 6 3 5 9; 1 7 8 6"
                        },
                        {
                            "label": "r102",
                            "value": 102,
                            "title": "Version 102: 5 8 3 4; 4 9 8 6; 2 6 7 1; 7 2 9 8; 1 4 5 6; 8 1 7 3; 6 3 2 5; 9 7 1 4; 3 5 2 9"
                        },
                        {
                            "label": "r103",
                            "value": 103,
                            "title": "Version 103: 1 4 5 9; 4 9 3 7; 3 1 8 2; 8 3 6 4; 5 7 6 8; 8 5 1 2; 9 2 3 1; 7 6 9 5; 6 2 7 4"
                        },
                        {
                            "label": "r104",
                            "value": 104,
                            "title": "Version 104: 2 6 4 3; 3 1 5 7; 2 8 7 9; 5 7 2 3; 6 8 1 9; 9 3 6 8; 7 4 8 1; 4 5 1 6; 5 9 4 2"
                        },
                        {
                            "label": "r105",
                            "value": 105,
                            "title": "Version 105: 7 8 9 5; 8 5 2 4; 6 2 8 7; 1 4 6 3; 4 3 5 8; 9 6 2 1; 1 9 7 4; 3 5 9 6; 2 1 7 3"
                        },
                        {
                            "label": "r106",
                            "value": 106,
                            "title": "Version 106: 1 2 3 5; 9 3 4 8; 6 7 4 2; 2 6 9 1; 4 9 1 2; 8 7 5 3; 3 5 9 7; 4 8 6 7; 5 1 8 6"
                        },
                        {
                            "label": "r107",
                            "value": 107,
                            "title": "Version 107: 6 4 2 5; 7 4 3 1; 1 2 7 8; 5 1 4 8; 8 3 6 9; 3 7 1 9; 7 9 5 6; 2 8 3 6; 9 5 4 2"
                        },
                        {
                            "label": "r108",
                            "value": 108,
                            "title": "Version 108: 2 3 7 4; 4 6 8 1; 8 2 9 4; 2 1 3 5; 6 9 5 1; 9 7 4 5; 6 8 2 3; 7 6 3 5; 1 8 7 9"
                        },
                        {
                            "label": "r109",
                            "value": 109,
                            "title": "Version 109: 5 3 6 4; 8 5 1 9; 3 4 8 7; 1 4 8 5; 7 9 6 2; 9 1 2 3; 4 6 3 9; 1 7 6 2; 5 2 8 7"
                        },
                        {
                            "label": "r110",
                            "value": 110,
                            "title": "Version 110: 3 6 5 8; 8 2 9 6; 2 5 7 4; 6 5 1 7; 7 8 1 3; 5 9 2 3; 4 1 7 6; 3 4 9 1; 9 2 4 8"
                        },
                        {
                            "label": "r111",
                            "value": 111,
                            "title": "Version 111: 9 8 1 6; 3 7 8 9; 1 6 4 2; 2 6 5 8; 6 3 7 4; 5 1 8 4; 1 3 2 5; 7 9 3 2; 4 7 9 5"
                        },
                        {
                            "label": "r112",
                            "value": 112,
                            "title": "Version 112: 8 4 5 2; 3 9 6 1; 6 1 2 7; 5 3 6 9; 4 7 5 9; 9 4 2 1; 7 5 6 8; 2 8 4 3; 8 1 3 7"
                        },
                        {
                            "label": "r113",
                            "value": 113,
                            "title": "Version 113: 4 8 1 3; 1 3 5 7; 7 4 9 6; 8 2 7 9; 6 7 5 2; 5 9 1 8; 9 2 4 1; 3 5 6 4; 3 6 8 2"
                        },
                        {
                            "label": "r114",
                            "value": 114,
                            "title": "Version 114: 7 4 8 6; 8 6 9 1; 9 6 3 5; 2 7 1 5; 6 9 4 7; 2 1 7 8; 1 2 3 4; 2 3 9 5; 5 8 4 3"
                        },
                        {
                            "label": "r115",
                            "value": 115,
                            "title": "Version 115: 1 5 7 3; 7 1 9 6; 8 3 2 7; 4 9 8 5; 6 2 8 9; 5 1 2 6; 3 9 7 4; 4 8 5 2; 3 6 1 4"
                        },
                        {
                            "label": "r116",
                            "value": 116,
                            "title": "Version 116: 9 5 3 8; 2 7 6 1; 9 2 3 7; 2 4 6 3; 5 7 2 4; 8 3 1 9; 4 8 7 6; 1 4 9 5; 6 5 1 8"
                        },
                        {
                            "label": "r117",
                            "value": 117,
                            "title": "Version 117: 3 6 8 2; 7 8 5 9; 6 7 3 5; 9 6 4 1; 5 3 4 1; 8 2 7 3; 7 1 4 8; 9 5 6 2; 4 9 1 2"
                        },
                        {
                            "label": "r118",
                            "value": 118,
                            "title": "Version 118: 3 4 2 6; 1 2 5 7; 6 3 9 8; 8 7 9 1; 4 8 3 1; 1 6 5 7; 5 8 6 4; 5 9 2 3; 2 4 7 9"
                        },
                        {
                            "label": "r119",
                            "value": 119,
                            "title": "Version 119: 8 1 5 4; 7 5 3 6; 3 1 8 2; 6 2 8 9; 9 5 1 2; 4 9 7 3; 1 4 6 3; 7 5 9 6; 2 7 4 8"
                        },
                        {
                            "label": "r120",
                            "value": 120,
                            "title": "Version 120: 8 4 6 7; 6 3 1 5; 5 3 2 9; 4 2 5 7; 2 8 5 6; 1 9 8 7; 3 1 9 8; 7 3 4 9; 1 6 2 4"
                        },
                        {
                            "label": "r121",
                            "value": 121,
                            "title": "Version 121: 2 4 8 5; 8 7 3 2; 9 7 4 6; 2 9 6 1; 4 8 9 5; 5 6 9 1; 7 2 1 3; 3 6 8 4; 3 5 7 1"
                        },
                        {
                            "label": "r122",
                            "value": 122,
                            "title": "Version 122: 6 5 3 7; 9 1 2 8; 9 7 1 4; 5 8 1 7; 1 2 4 6; 6 3 2 5; 8 5 3 4; 7 9 6 8; 4 2 3 9"
                        },
                        {
                            "label": "r123",
                            "value": 123,
                            "title": "Version 123: 3 1 7 2; 8 4 6 3; 7 4 5 1; 2 6 8 7; 5 3 4 9; 6 9 5 8; 1 2 9 6; 9 8 1 3; 4 7 2 5"
                        },
                        {
                            "label": "r124",
                            "value": 124,
                            "title": "Version 124: 4 5 7 9; 7 9 3 8; 5 4 9 2; 8 7 2 6; 8 1 5 2; 1 8 6 4; 3 1 6 4; 6 3 7 1; 9 5 2 3"
                        },
                        {
                            "label": "r125",
                            "value": 125,
                            "title": "Version 125: 3 6 9 5; 2 6 4 9; 2 4 3 7; 5 4 8 1; 4 2 1 3; 9 7 5 6; 9 8 1 2; 6 3 8 7; 1 8 7 5"
                        },
                        {
                            "label": "r126",
                            "value": 126,
                            "title": "Version 126: 7 2 4 8; 8 9 4 3; 3 5 8 2; 2 1 9 7; 5 3 6 1; 6 5 2 8; 7 9 4 6; 4 6 5 1; 1 7 3 9"
                        },
                        {
                            "label": "r127",
                            "value": 127,
                            "title": "Version 127: 8 1 9 3; 2 1 6 4; 4 8 9 5; 5 1 7 8; 1 2 7 5; 9 3 4 6; 7 6 3 2; 6 9 8 2; 7 4 5 3"
                        },
                        {
                            "label": "r128",
                            "value": 128,
                            "title": "Version 128: 4 7 8 9; 5 7 1 4; 3 5 1 6; 1 9 2 5; 6 8 5 4; 6 3 7 8; 3 8 2 9; 2 6 9 7; 3 4 2 1"
                        },
                        {
                            "label": "r129",
                            "value": 129,
                            "title": "Version 129: 9 2 7 5; 8 9 6 1; 9 1 3 4; 7 6 3 1; 8 7 5 3; 5 2 6 8; 1 4 8 7; 2 5 4 3; 4 2 6 9"
                        },
                        {
                            "label": "r130",
                            "value": 130,
                            "title": "Version 130: 8 7 1 6; 1 8 9 4; 9 6 1 5; 5 3 8 2; 7 3 5 9; 2 4 7 6; 4 5 6 3; 4 9 2 7; 3 1 2 8"
                        },
                        {
                            "label": "r131",
                            "value": 131,
                            "title": "Version 131: 6 8 4 2; 6 5 9 1; 2 9 3 1; 5 4 8 9; 1 3 4 2; 2 1 5 7; 7 6 5 8; 3 7 8 9; 7 6 3 4"
                        },
                        {
                            "label": "r132",
                            "value": 132,
                            "title": "Version 132: 5 4 1 6; 8 3 9 5; 1 2 6 8; 9 2 7 6; 8 7 4 1; 3 1 6 9; 4 8 2 3; 9 5 7 4; 3 7 5 2"
                        },
                        {
                            "label": "r133",
                            "value": 133,
                            "title": "Version 133: 6 9 3 7; 7 3 8 2; 2 6 1 5; 9 2 4 6; 5 8 6 3; 8 5 2 4; 1 9 4 5; 8 1 9 7; 4 1 3 7"
                        },
                        {
                            "label": "r134",
                            "value": 134,
                            "title": "Version 134: 2 4 7 5; 6 7 1 3; 6 4 1 8; 3 2 9 6; 7 6 8 4; 9 8 2 5; 5 9 3 4; 1 5 3 2; 9 8 7 1"
                        },
                        {
                            "label": "r135",
                            "value": 135,
                            "title": "Version 135: 4 3 1 6; 2 6 5 7; 7 9 2 8; 4 1 7 2; 6 3 4 9; 1 5 9 7; 5 4 8 9; 8 2 1 3; 3 5 6 8"
                        },
                        {
                            "label": "r136",
                            "value": 136,
                            "title": "Version 136: 6 7 8 9; 7 3 5 1; 1 6 4 2; 9 1 6 2; 3 8 9 5; 8 7 3 4; 2 9 4 3; 5 8 1 6; 4 2 5 7"
                        },
                        {
                            "label": "r137",
                            "value": 137,
                            "title": "Version 137: 5 4 7 6; 3 5 9 1; 7 4 9 1; 6 3 2 5; 5 2 7 8; 2 7 6 3; 4 1 3 8; 9 6 8 4; 1 9 2 8"
                        },
                        {
                            "label": "r138",
                            "value": 138,
                            "title": "Version 138: 7 6 3 9; 6 7 5 1; 8 2 6 4; 1 3 7 9; 4 5 8 3; 9 4 5 1; 8 1 4 2; 3 8 2 7; 2 9 6 5"
                        },
                        {
                            "label": "r139",
                            "value": 139,
                            "title": "Version 139: 2 5 1 7; 8 2 1 6; 6 4 3 9; 5 6 4 3; 4 7 1 8; 7 9 2 4; 3 9 5 2; 9 1 8 3; 6 8 7 5"
                        },
                        {
                            "label": "r140",
                            "value": 140,
                            "title": "Version 140: 2 8 9 6; 1 3 2 4; 8 3 7 5; 9 6 8 7; 7 2 9 4; 3 5 6 1; 1 2 5 9; 4 5 3 8; 1 4 7 6"
                        },
                        {
                            "label": "r141",
                            "value": 141,
                            "title": "Version 141: 5 7 4 9; 6 7 9 2; 9 1 3 8; 7 4 2 3; 3 1 6 7; 5 8 1 2; 4 8 5 1; 9 6 4 5; 8 2 3 6"
                        },
                        {
                            "label": "r142",
                            "value": 142,
                            "title": "Version 142: 7 3 8 9; 2 3 5 4; 3 9 2 1; 8 4 9 2; 4 6 8 3; 5 7 6 8; 2 5 1 7; 6 1 4 7; 1 9 5 6"
                        },
                        {
                            "label": "r143",
                            "value": 143,
                            "title": "Version 143: 2 3 4 6; 8 4 9 5; 4 8 7 1; 6 2 8 1; 1 7 3 9; 5 9 2 6; 3 6 1 4; 7 9 3 5; 2 5 7 8"
                        },
                        {
                            "label": "r144",
                            "value": 144,
                            "title": "Version 144: 9 1 4 2; 7 2 6 5; 2 4 7 3; 1 6 5 8; 3 5 8 9; 9 7 6 4; 4 8 5 7; 8 1 9 3; 6 1 2 3"
                        },
                        {
                            "label": "r145",
                            "value": 145,
                            "title": "Version 145: 5 3 4 2; 4 8 6 7; 5 3 9 6; 7 5 1 3; 9 7 2 1; 6 2 8 9; 9 4 1 5; 8 6 1 4; 3 8 7 2"
                        },
                        {
                            "label": "r146",
                            "value": 146,
                            "title": "Version 146: 4 6 3 8; 1 2 6 7; 3 4 8 2; 7 3 5 1; 2 5 4 1; 7 9 3 6; 5 9 6 4; 8 2 9 5; 1 7 8 9"
                        },
                        {
                            "label": "r147",
                            "value": 147,
                            "title": "Version 147: 6 1 3 8; 4 6 7 5; 3 8 2 7; 5 1 2 8; 7 3 4 9; 2 4 5 3; 6 7 1 9; 9 1 8 4; 2 9 5 6"
                        },
                        {
                            "label": "r148",
                            "value": 148,
                            "title": "Version 148: 8 5 6 3; 1 3 9 4; 9 6 3 2; 8 4 2 9; 3 5 7 1; 1 8 5 6; 4 2 1 7; 6 7 4 2; 5 9 7 8"
                        },
                        {
                            "label": "r149",
                            "value": 149,
                            "title": "Version 149: 8 7 9 6; 1 6 2 5; 7 8 3 5; 2 1 6 4; 4 9 1 8; 6 4 5 3; 3 2 8 7; 9 3 1 2; 5 7 4 9"
                        },
                        {
                            "label": "r150",
                            "value": 150,
                            "title": "Version 150: 3 5 7 6; 5 2 8 4; 8 3 6 1; 7 4 9 3; 4 1 7 8; 2 9 4 5; 9 6 3 1; 1 5 2 7; 6 8 9 2"
                        },
                        {
                            "label": "r151",
                            "value": 151,
                            "title": "Version 151: 4 6 7 1; 7 8 6 2; 6 7 4 3; 8 4 1 5; 2 9 3 7; 3 2 1 4; 9 5 8 3; 5 9 2 6; 5 1 9 8"
                        },
                        {
                            "label": "r152",
                            "value": 152,
                            "title": "Version 152: 4 6 5 9; 1 8 9 7; 9 1 7 2; 7 4 5 9; 8 3 4 2; 2 7 6 8; 3 2 1 5; 6 3 8 4; 1 5 3 6"
                        },
                        {
                            "label": "r153",
                            "value": 153,
                            "title": "Version 153: 4 8 2 5; 7 2 5 1; 1 6 9 3; 8 1 7 6; 5 7 4 3; 3 4 8 1; 6 9 5 7; 9 2 6 4; 2 3 9 8"
                        },
                        {
                            "label": "r154",
                            "value": 154,
                            "title": "Version 154: 7 5 6 4; 8 3 2 7; 2 6 3 8; 6 1 4 9; 1 9 3 2; 8 5 1 6; 9 7 3 5; 4 2 7 1; 4 8 5 9"
                        },
                        {
                            "label": "r155",
                            "value": 155,
                            "title": "Version 155: 5 6 8 1; 6 8 7 9; 5 9 2 6; 3 5 2 7; 7 4 8 1; 1 3 5 2; 2 4 6 3; 9 7 4 8; 3 1 9 4"
                        },
                        {
                            "label": "r156",
                            "value": 156,
                            "title": "Version 156: 6 9 2 8; 9 2 1 7; 1 4 9 5; 4 6 7 3; 3 1 8 9; 8 3 4 5; 2 5 8 4; 7 5 1 6; 3 7 6 2"
                        },
                        {
                            "label": "r157",
                            "value": 157,
                            "title": "Version 157: 5 8 6 2; 2 9 4 7; 9 1 3 5; 7 8 9 4; 8 3 5 7; 6 3 5 9; 2 7 1 8; 4 6 3 1; 1 2 4 6"
                        },
                        {
                            "label": "r158",
                            "value": 158,
                            "title": "Version 158: 5 7 2 6; 9 1 7 3; 1 5 7 8; 3 6 8 9; 6 4 3 7; 4 2 9 3; 8 4 6 5; 8 9 1 2; 5 2 4 1"
                        },
                        {
                            "label": "r159",
                            "value": 159,
                            "title": "Version 159: 6 9 1 4; 1 8 2 6; 4 5 9 2; 9 8 5 3; 3 1 2 8; 7 6 2 4; 7 9 6 5; 5 3 7 1; 7 4 8 3"
                        },
                        {
                            "label": "r160",
                            "value": 160,
                            "title": "Version 160: 6 8 1 9; 1 7 3 6; 2 7 5 1; 8 1 7 4; 5 3 4 2; 2 5 9 3; 4 6 8 5; 3 4 6 9; 9 2 7 8"
                        },
                        {
                            "label": "r161",
                            "value": 161,
                            "title": "Version 161: 4 8 3 7; 8 2 1 5; 7 3 9 6; 5 4 3 1; 9 5 1 7; 3 6 2 8; 6 5 8 9; 1 6 4 2; 2 7 9 4"
                        },
                        {
                            "label": "r162",
                            "value": 162,
                            "title": "Version 162: 3 8 7 2; 4 1 5 3; 2 7 6 5; 6 9 4 2; 7 5 6 8; 9 4 3 8; 5 9 1 4; 1 7 8 9; 3 2 6 1"
                        },
                        {
                            "label": "r163",
                            "value": 163,
                            "title": "Version 163: 8 9 2 6; 6 3 5 8; 8 1 5 4; 1 3 2 7; 4 6 7 1; 9 2 3 5; 2 8 4 9; 7 1 9 6; 5 4 7 3"
                        },
                        {
                            "label": "r164",
                            "value": 164,
                            "title": "Version 164: 9 3 5 1; 1 6 4 2; 6 9 3 1; 4 5 8 7; 5 7 9 6; 3 4 6 8; 8 7 2 3; 7 2 9 4; 2 8 1 5"
                        },
                        {
                            "label": "r165",
                            "value": 165,
                            "title": "Version 165: 2 4 5 7; 7 5 4 6; 5 6 2 3; 6 1 3 2; 7 3 8 9; 1 8 6 4; 8 9 7 1; 9 3 8 4; 2 1 9 5"
                        },
                        {
                            "label": "r166",
                            "value": 166,
                            "title": "Version 166: 4 2 3 8; 3 4 1 9; 5 2 6 7; 1 7 5 8; 4 1 2 7; 8 9 2 6; 9 5 4 3; 6 8 5 9; 3 1 7 6"
                        },
                        {
                            "label": "r167",
                            "value": 167,
                            "title": "Version 167: 9 6 4 7; 3 7 6 5; 4 5 9 2; 1 6 8 4; 7 2 1 8; 5 6 1 9; 8 4 3 2; 9 3 7 2; 3 8 5 1"
                        },
                        {
                            "label": "r168",
                            "value": 168,
                            "title": "Version 168: 7 9 1 4; 6 4 7 3; 2 1 3 6; 1 3 7 5; 2 9 4 1; 9 5 8 3; 6 8 4 5; 6 2 9 8; 8 7 5 2"
                        },
                        {
                            "label": "r169",
                            "value": 169,
                            "title": "Version 169: 4 5 8 1; 1 9 2 7; 5 4 2 7; 4 8 6 3; 2 6 5 4; 8 7 3 9; 2 1 9 3; 3 6 9 5; 1 8 6 7"
                        },
                        {
                            "label": "r170",
                            "value": 170,
                            "title": "Version 170: 4 3 8 1; 6 4 7 9; 5 9 1 8; 9 2 8 6; 7 5 2 9; 8 7 4 3; 3 2 1 5; 7 3 6 5; 6 1 4 2"
                        },
                        {
                            "label": "r171",
                            "value": 171,
                            "title": "Version 171: 7 2 3 9; 5 4 1 6; 2 3 7 4; 4 9 8 7; 5 6 2 8; 1 8 6 7; 9 1 3 6; 3 5 9 4; 8 2 5 1"
                        },
                        {
                            "label": "r172",
                            "value": 172,
                            "title": "Version 172: 1 3 4 2; 4 5 3 8; 8 7 1 9; 2 7 5 6; 6 8 9 7; 9 1 4 5; 9 4 2 6; 7 1 5 3; 3 6 8 2"
                        },
                        {
                            "label": "r173",
                            "value": 173,
                            "title": "Version 173: 5 9 6 3; 4 6 7 1; 1 9 3 2; 3 7 1 8; 2 8 6 3; 8 5 9 4; 5 4 7 2; 6 4 9 1; 7 2 8 5"
                        },
                        {
                            "label": "r174",
                            "value": 174,
                            "title": "Version 174: 8 3 6 4; 4 7 8 9; 7 1 2 4; 3 6 7 5; 1 7 3 6; 9 5 1 6; 5 3 4 2; 2 8 9 1; 5 2 8 9"
                        },
                        {
                            "label": "r175",
                            "value": 175,
                            "title": "Version 175: 4 9 2 3; 6 3 5 1; 7 3 2 8; 9 2 6 7; 8 4 1 5; 1 9 4 5; 3 5 7 9; 6 4 8 7; 1 8 2 6"
                        },
                        {
                            "label": "r176",
                            "value": 176,
                            "title": "Version 176: 5 8 3 4; 3 1 4 7; 2 6 1 4; 7 6 5 2; 2 1 5 8; 8 5 7 9; 2 7 9 1; 6 9 3 8; 9 4 6 3"
                        },
                        {
                            "label": "r177",
                            "value": 177,
                            "title": "Version 177: 4 5 9 6; 6 1 5 8; 9 6 4 7; 5 3 6 1; 4 2 3 8; 8 7 2 4; 1 9 2 3; 3 2 7 5; 7 8 1 9"
                        },
                        {
                            "label": "r178",
                            "value": 178,
                            "title": "Version 178: 7 5 6 2; 5 7 9 3; 6 3 8 9; 8 6 7 4; 9 8 1 2; 4 1 5 7; 2 4 9 5; 3 2 1 6; 1 8 4 3"
                        },
                        {
                            "label": "r179",
                            "value": 179,
                            "title": "Version 179: 4 2 3 7; 7 6 8 1; 6 9 2 4; 1 9 8 6; 8 7 3 5; 5 1 3 4; 3 2 9 8; 2 4 5 6; 9 5 7 1"
                        },
                        {
                            "label": "r180",
                            "value": 180,
                            "title": "Version 180: 1 3 8 7; 8 4 6 7; 3 1 4 2; 2 6 1 5; 1 7 4 9; 9 3 6 5; 7 9 2 3; 5 8 4 9; 6 5 2 8"
                        },
                        {
                            "label": "r181",
                            "value": 181,
                            "title": "Version 181: 6 8 5 3; 9 1 8 2; 3 9 5 8; 4 5 7 1; 4 7 6 9; 7 3 1 6; 8 4 2 1; 2 5 7 9; 6 2 3 4"
                        },
                        {
                            "label": "r182",
                            "value": 182,
                            "title": "Version 182: 8 6 7 2; 7 8 4 3; 4 3 9 1; 5 7 3 1; 2 4 5 8; 1 2 6 9; 9 4 8 5; 5 1 2 6; 3 9 6 7"
                        },
                        {
                            "label": "r183",
                            "value": 183,
                            "title": "Version 183: 8 6 9 3; 7 8 1 2; 1 3 8 5; 7 2 9 4; 4 7 3 6; 5 9 4 1; 2 5 7 6; 6 1 4 8; 9 3 5 2"
                        },
                        {
                            "label": "r184",
                            "value": 184,
                            "title": "Version 184: 9 6 5 4; 3 4 1 2; 3 9 2 8; 6 2 3 4; 5 8 1 7; 2 7 9 8; 8 5 7 6; 4 1 5 3; 1 6 9 7"
                        },
                        {
                            "label": "r185",
                            "value": 185,
                            "title": "Version 185: 3 7 1 9; 2 4 8 5; 7 2 3 5; 5 9 6 3; 1 8 6 9; 4 3 8 7; 9 1 4 7; 6 5 2 1; 8 6 4 2"
                        },
                        {
                            "label": "r186",
                            "value": 186,
                            "title": "Version 186: 5 6 7 4; 7 2 1 8; 1 8 5 9; 2 5 6 3; 9 4 8 5; 4 9 2 7; 3 1 9 2; 6 7 3 4; 8 6 3 1"
                        },
                        {
                            "label": "r187",
                            "value": 187,
                            "title": "Version 187: 2 1 4 6; 1 3 8 4; 6 4 1 9; 4 5 7 1; 8 7 5 2; 7 3 6 9; 9 2 5 3; 7 8 2 6; 5 9 3 8"
                        },
                        {
                            "label": "r188",
                            "value": 188,
                            "title": "Version 188: 4 6 9 5; 3 4 2 8; 8 9 7 4; 3 2 7 1; 6 5 8 3; 5 3 4 7; 9 1 6 2; 1 7 6 5; 9 8 1 2"
                        },
                        {
                            "label": "r189",
                            "value": 189,
                            "title": "Version 189: 2 4 8 6; 5 8 9 7; 6 9 2 7; 2 5 1 3; 1 6 4 8; 3 1 5 8; 4 2 9 5; 7 3 9 4; 1 7 3 6"
                        },
                        {
                            "label": "r190",
                            "value": 190,
                            "title": "Version 190: 9 5 7 1; 3 2 6 9; 8 7 5 2; 4 1 8 9; 5 4 2 1; 2 3 4 7; 7 6 8 5; 1 6 3 4; 8 9 3 6"
                        },
                        {
                            "label": "r191",
                            "value": 191,
                            "title": "Version 191: 6 8 7 1; 6 9 2 5; 9 4 7 3; 4 5 6 2; 8 3 1 9; 2 8 7 1; 7 1 2 3; 5 4 9 6; 3 5 4 8"
                        },
                        {
                            "label": "r192",
                            "value": 192,
                            "title": "Version 192: 3 2 5 8; 5 7 1 9; 1 3 5 6; 7 5 1 4; 8 6 3 9; 9 8 2 7; 6 8 4 7; 2 1 4 3; 4 9 6 2"
                        },
                        {
                            "label": "r193",
                            "value": 193,
                            "title": "Version 193: 3 2 8 6; 3 7 9 5; 2 9 5 1; 5 3 8 4; 1 6 5 8; 6 1 3 7; 9 4 1 8; 7 2 9 4; 4 7 6 2"
                        },
                        {
                            "label": "r194",
                            "value": 194,
                            "title": "Version 194: 8 4 7 6; 4 2 8 3; 8 7 3 9; 2 6 7 5; 9 8 2 1; 1 5 9 6; 7 1 4 5; 6 3 1 9; 5 2 3 4"
                        },
                        {
                            "label": "r195",
                            "value": 195,
                            "title": "Version 195: 1 8 7 2; 4 9 6 1; 8 6 2 5; 2 9 5 3; 6 1 8 4; 9 5 4 8; 5 3 6 7; 3 7 1 2; 7 4 9 3"
                        },
                        {
                            "label": "r196",
                            "value": 196,
                            "title": "Version 196: 6 4 5 1; 7 6 8 3; 8 5 7 9; 5 7 3 1; 1 8 2 5; 9 2 6 7; 3 9 4 8; 2 9 4 6; 4 1 3 2"
                        },
                        {
                            "label": "r197",
                            "value": 197,
                            "title": "Version 197: 5 1 9 8; 9 3 8 6; 3 8 7 4; 2 5 6 3; 7 6 1 9; 4 6 5 7; 5 7 2 4; 8 4 1 2; 1 2 9 3"
                        },
                        {
                            "label": "r198",
                            "value": 198,
                            "title": "Version 198: 6 1 8 9; 4 3 1 5; 3 4 5 7; 9 5 4 2; 1 3 6 4; 8 2 7 1; 7 8 9 5; 6 7 2 9; 6 2 3 8"
                        },
                        {
                            "label": "r199",
                            "value": 199,
                            "title": "Version 199: 4 8 7 6; 8 9 5 3; 9 4 1 7; 2 6 8 5; 7 8 2 4; 1 5 9 2; 3 1 7 2; 5 3 6 1; 9 4 3 6"
                        },
                        {
                            "label": "r200",
                            "value": 200,
                            "title": "Version 200: 1 7 6 5; 3 9 5 8; 2 9 4 3; 4 1 9 7; 5 6 8 7; 7 3 2 9; 6 5 2 4; 2 1 8 6; 8 3 1 4"
                        },
                        {
                            "label": "r201",
                            "value": 201,
                            "title": "Version 201: 2 7 3 1; 9 2 1 8; 8 7 4 5; 3 8 7 6; 4 2 5 8; 6 9 4 1; 4 6 9 2; 1 5 3 6; 7 9 5 3"
                        },
                        {
                            "label": "r202",
                            "value": 202,
                            "title": "Version 202: 5 1 2 7; 7 4 6 3; 1 3 4 8; 3 6 8 9; 5 8 9 4; 2 5 1 4; 6 7 9 2; 9 8 7 1; 3 2 6 5"
                        },
                        {
                            "label": "r203",
                            "value": 203,
                            "title": "Version 203: 8 4 7 2; 8 4 3 2; 1 7 4 9; 7 9 6 5; 6 1 5 4; 2 6 8 1; 6 3 1 7; 9 2 5 3; 5 9 3 8"
                        },
                        {
                            "label": "r204",
                            "value": 204,
                            "title": "Version 204: 7 5 8 3; 4 5 3 9; 5 4 8 6; 3 7 2 6; 9 2 7 6; 8 6 4 1; 4 1 2 9; 2 3 9 1; 1 8 7 5"
                        },
                        {
                            "label": "r205",
                            "value": 205,
                            "title": "Version 205: 4 5 6 2; 9 7 6 8; 8 2 1 5; 5 9 1 3; 2 3 9 8; 6 8 4 9; 4 1 3 7; 1 6 5 7; 3 4 7 2"
                        },
                        {
                            "label": "r206",
                            "value": 206,
                            "title": "Version 206: 3 8 1 4; 7 4 9 5; 7 9 4 3; 9 5 2 1; 8 2 1 6; 1 3 6 9; 2 7 5 4; 6 3 8 5; 7 6 2 8"
                        },
                        {
                            "label": "r207",
                            "value": 207,
                            "title": "Version 207: 5 1 9 6; 1 4 3 7; 3 6 4 2; 6 9 8 4; 8 7 3 1; 2 5 6 3; 9 2 7 8; 4 1 5 7; 5 8 2 9"
                        },
                        {
                            "label": "r208",
                            "value": 208,
                            "title": "Version 208: 9 2 6 4; 3 9 1 8; 7 4 9 5; 5 3 8 4; 6 7 1 9; 4 6 3 2; 1 8 7 2; 2 5 8 7; 3 1 5 6"
                        },
                        {
                            "label": "r209",
                            "value": 209,
                            "title": "Version 209: 8 6 4 1; 8 9 6 7; 4 8 2 1; 6 1 2 5; 2 8 5 3; 7 2 3 9; 9 3 7 4; 5 6 7 3; 5 4 9 1"
                        },
                        {
                            "label": "r210",
                            "value": 210,
                            "title": "Version 210: 1 5 4 2; 9 7 1 8; 7 1 2 6; 8 5 4 9; 2 9 6 4; 6 7 5 3; 8 3 9 5; 1 2 3 7; 4 3 8 6"
                        },
                        {
                            "label": "r211",
                            "value": 211,
                            "title": "Version 211: 3 4 2 7; 4 6 1 9; 3 9 6 1; 7 4 1 5; 5 7 4 8; 2 8 3 9; 9 2 5 6; 6 5 8 7; 1 3 2 8"
                        },
                        {
                            "label": "r212",
                            "value": 212,
                            "title": "Version 212: 3 4 6 2; 8 1 7 3; 6 5 4 3; 1 3 9 5; 2 1 8 5; 4 2 7 9; 9 7 5 2; 7 6 4 8; 1 9 8 6"
                        },
                        {
                            "label": "r213",
                            "value": 213,
                            "title": "Version 213: 5 7 9 6; 5 2 3 1; 9 6 7 2; 6 1 5 4; 3 4 1 7; 2 8 9 5; 8 9 3 4; 4 8 2 1; 7 6 8 3"
                        },
                        {
                            "label": "r214",
                            "value": 214,
                            "title": "Version 214: 2 7 6 8; 8 9 3 4; 4 8 6 1; 1 2 9 4; 6 3 1 9; 3 5 7 2; 5 4 8 7; 9 1 7 5; 3 5 2 6"
                        },
                        {
                            "label": "r215",
                            "value": 215,
                            "title": "Version 215: 7 2 4 6; 2 4 5 1; 6 3 2 8; 9 2 4 3; 5 8 3 9; 7 1 8 3; 1 7 9 5; 8 5 6 4; 6 9 1 7"
                        },
                        {
                            "label": "r216",
                            "value": 216,
                            "title": "Version 216: 4 7 1 3; 4 9 5 8; 1 6 9 2; 5 1 3 6; 3 5 4 6; 2 4 7 8; 7 5 2 3; 9 8 7 2; 8 6 9 1"
                        },
                        {
                            "label": "r217",
                            "value": 217,
                            "title": "Version 217: 1 3 8 2; 3 4 6 9; 4 9 5 1; 2 8 5 1; 6 2 4 9; 5 3 8 7; 9 7 3 4; 7 1 6 2; 8 6 7 5"
                        },
                        {
                            "label": "r218",
                            "value": 218,
                            "title": "Version 218: 4 7 1 8; 1 9 3 6; 9 8 6 7; 7 1 6 5; 5 4 9 8; 3 7 2 4; 2 5 9 3; 8 3 2 1; 6 2 4 5"
                        },
                        {
                            "label": "r219",
                            "value": 219,
                            "title": "Version 219: 6 1 5 8; 8 5 1 4; 2 9 3 7; 7 5 2 9; 4 3 1 7; 9 2 1 4; 5 6 7 3; 3 4 8 6; 8 6 9 2"
                        },
                        {
                            "label": "r220",
                            "value": 220,
                            "title": "Version 220: 6 3 4 7; 1 3 5 9; 7 8 4 9; 3 8 9 6; 1 7 6 2; 9 1 8 7; 2 4 5 1; 5 2 3 8; 4 6 2 5"
                        },
                        {
                            "label": "r221",
                            "value": 221,
                            "title": "Version 221: 8 1 7 2; 1 4 8 3; 2 8 1 4; 7 9 5 6; 9 7 3 5; 5 6 2 8; 4 2 9 3; 6 9 3 1; 6 5 7 4"
                        },
                        {
                            "label": "r222",
                            "value": 222,
                            "title": "Version 222: 3 7 4 5; 5 8 7 2; 4 8 6 9; 9 5 4 1; 1 4 3 7; 3 1 5 6; 8 2 7 9; 2 3 8 6; 2 6 1 9"
                        },
                        {
                            "label": "r223",
                            "value": 223,
                            "title": "Version 223: 5 9 8 3; 7 5 2 1; 1 2 6 3; 7 1 3 9; 9 4 2 5; 4 3 2 8; 8 6 4 5; 1 9 6 7; 6 7 4 8"
                        },
                        {
                            "label": "r224",
                            "value": 224,
                            "title": "Version 224: 6 1 5 7; 5 8 9 1; 3 5 1 8; 3 6 8 4; 1 4 7 2; 4 9 6 2; 2 7 6 3; 9 2 5 3; 7 8 9 4"
                        },
                        {
                            "label": "r225",
                            "value": 225,
                            "title": "Version 225: 8 9 7 5; 9 3 1 4; 2 3 9 6; 6 2 4 7; 4 6 1 5; 5 1 8 3; 4 5 7 2; 7 9 3 8; 8 1 2 6"
                        },
                        {
                            "label": "r226",
                            "value": 226,
                            "title": "Version 226: 3 7 5 6; 9 4 5 1; 5 6 8 9; 1 4 9 2; 7 8 6 1; 2 3 6 7; 3 5 2 4; 8 7 4 3; 9 2 1 8"
                        },
                        {
                            "label": "r227",
                            "value": 227,
                            "title": "Version 227: 4 8 3 9; 6 3 4 1; 8 6 5 4; 6 4 9 7; 7 1 8 2; 1 7 9 5; 3 2 7 1; 2 9 5 6; 5 3 2 8"
                        },
                        {
                            "label": "r228",
                            "value": 228,
                            "title": "Version 228: 4 2 1 9; 2 9 8 7; 8 5 7 1; 9 5 3 6; 7 8 6 4; 3 6 2 9; 5 4 7 2; 1 5 4 3; 6 1 3 8"
                        },
                        {
                            "label": "r229",
                            "value": 229,
                            "title": "Version 229: 9 7 6 5; 4 6 1 2; 7 9 1 6; 1 7 9 3; 2 6 5 8; 5 3 4 7; 8 4 3 2; 3 8 4 9; 8 2 1 5"
                        },
                        {
                            "label": "r230",
                            "value": 230,
                            "title": "Version 230: 9 7 8 5; 8 1 7 4; 6 1 5 3; 6 8 2 3; 3 6 1 7; 5 2 9 4; 4 9 8 6; 7 3 5 2; 2 4 9 1"
                        },
                        {
                            "label": "r231",
                            "value": 231,
                            "title": "Version 231: 1 9 3 8; 3 5 4 1; 7 1 2 8; 4 5 6 9; 2 3 7 5; 6 7 8 4; 9 4 3 7; 1 2 6 9; 5 8 2 6"
                        },
                        {
                            "label": "r232",
                            "value": 232,
                            "title": "Version 232: 8 1 9 6; 9 8 2 5; 6 2 4 3; 3 9 7 2; 1 6 5 4; 3 7 6 8; 5 8 1 9; 2 4 1 7; 4 3 7 5"
                        },
                        {
                            "label": "r233",
                            "value": 233,
                            "title": "Version 233: 7 6 9 1; 7 5 8 4; 5 4 2 9; 2 1 3 8; 1 3 4 8; 6 7 5 2; 8 9 2 3; 9 6 3 7; 4 5 6 1"
                        },
                        {
                            "label": "r234",
                            "value": 234,
                            "title": "Version 234: 7 2 8 6; 8 7 4 9; 2 3 5 1; 3 9 8 5; 6 4 3 9; 9 7 1 4; 5 8 6 3; 5 2 7 1; 1 6 4 2"
                        },
                        {
                            "label": "r235",
                            "value": 235,
                            "title": "Version 235: 4 8 2 6; 6 2 9 3; 9 4 3 2; 1 5 8 9; 8 1 3 7; 3 1 7 6; 7 9 5 2; 4 5 1 8; 6 7 4 5"
                        },
                        {
                            "label": "r236",
                            "value": 236,
                            "title": "Version 236: 8 6 9 1; 2 1 6 4; 9 3 6 5; 4 8 9 7; 5 3 2 1; 7 2 8 6; 1 9 2 7; 3 5 4 8; 5 4 7 3"
                        },
                        {
                            "label": "r237",
                            "value": 237,
                            "title": "Version 237: 2 8 3 4; 3 5 1 9; 9 4 5 2; 4 9 2 7; 6 7 9 5; 8 1 7 3; 1 6 3 4; 7 1 6 8; 2 8 5 6"
                        },
                        {
                            "label": "r238",
                            "value": 238,
                            "title": "Version 238: 3 2 8 9; 2 9 1 6; 1 2 7 4; 7 3 5 2; 8 3 4 6; 6 9 1 3; 5 4 8 1; 9 7 5 8; 4 5 6 7"
                        },
                        {
                            "label": "r239",
                            "value": 239,
                            "title": "Version 239: 2 4 8 7; 1 3 9 5; 5 6 9 8; 4 7 6 1; 3 6 1 5; 8 2 4 9; 7 9 3 4; 6 7 2 3; 1 5 8 2"
                        },
                        {
                            "label": "r240",
                            "value": 240,
                            "title": "Version 240: 2 8 6 5; 9 5 7 4; 7 1 9 8; 5 6 1 4; 4 1 2 9; 8 4 7 3; 9 8 3 6; 6 3 5 2; 3 1 2 7"
                        },
                        {
                            "label": "r241",
                            "value": 241,
                            "title": "Version 241: 9 2 6 7; 2 9 8 1; 1 7 5 8; 6 2 4 5; 7 5 9 3; 3 4 1 2; 8 5 7 6; 6 3 4 9; 4 8 3 1"
                        },
                        {
                            "label": "r242",
                            "value": 242,
                            "title": "Version 242: 5 9 1 2; 2 3 8 7; 1 4 9 5; 4 6 7 9; 3 1 7 5; 9 6 4 8; 7 2 6 3; 8 6 3 1; 5 8 2 4"
                        },
                        {
                            "label": "r243",
                            "value": 243,
                            "title": "Version 243: 4 7 9 3; 9 3 5 8; 2 8 3 6; 6 4 1 7; 1 9 5 7; 2 1 6 9; 5 8 4 6; 8 2 7 1; 3 5 2 4"
                        },
                        {
                            "label": "r244",
                            "value": 244,
                            "title": "Version 244: 7 1 8 9; 3 9 5 2; 1 3 9 6; 5 7 2 4; 8 5 7 6; 6 4 3 5; 4 2 9 8; 7 6 1 2; 1 8 4 3"
                        },
                        {
                            "label": "r245",
                            "value": 245,
                            "title": "Version 245: 9 4 6 2; 6 9 3 5; 4 7 5 1; 6 2 8 1; 7 3 4 8; 9 7 2 3; 5 1 8 4; 3 5 1 2; 8 6 7 9"
                        },
                        {
                            "label": "r246",
                            "value": 246,
                            "title": "Version 246: 1 3 4 7; 3 7 6 8; 4 6 3 9; 2 5 7 3; 8 1 5 9; 9 5 1 6; 4 2 6 1; 2 4 9 8; 5 2 8 7"
                        },
                        {
                            "label": "r247",
                            "value": 247,
                            "title": "Version 247: 6 8 5 4; 3 9 4 1; 7 8 3 9; 1 4 2 5; 9 6 4 7; 2 1 7 6; 5 3 6 8; 7 9 2 5; 8 1 2 3"
                        },
                        {
                            "label": "r248",
                            "value": 248,
                            "title": "Version 248: 3 4 8 2; 8 2 9 4; 4 7 6 2; 7 3 1 4; 1 6 3 5; 9 8 1 6; 5 7 6 8; 9 5 7 1; 2 9 5 3"
                        },
                        {
                            "label": "r249",
                            "value": 249,
                            "title": "Version 249: 1 8 9 2; 2 9 4 3; 6 1 8 7; 7 3 8 5; 5 2 3 6; 5 7 9 4; 4 3 8 1; 6 2 1 7; 4 5 6 9"
                        },
                        {
                            "label": "r250",
                            "value": 250,
                            "title": "Version 250: 6 4 3 1; 2 1 5 3; 3 6 7 9; 9 7 2 5; 8 5 1 4; 7 8 5 4; 6 4 2 7; 1 9 2 8; 8 6 3 9"
                        },
                        {
                            "label": "r251",
                            "value": 251,
                            "title": "Version 251: 3 1 4 7; 5 6 4 2; 3 7 9 1; 7 9 1 8; 2 4 8 7; 8 5 2 6; 8 2 6 3; 4 3 9 5; 9 5 1 6"
                        },
                        {
                            "label": "r252",
                            "value": 252,
                            "title": "Version 252: 1 6 7 2; 9 8 3 4; 2 8 7 9; 1 9 6 4; 4 2 9 6; 3 4 5 1; 5 3 7 8; 6 1 8 5; 7 5 2 3"
                        },
                        {
                            "label": "r253",
                            "value": 253,
                            "title": "Version 253: 6 7 4 8; 9 6 5 2; 5 9 4 7; 8 4 3 2; 2 7 1 3; 3 8 6 5; 4 1 7 6; 1 5 9 8; 3 2 1 9"
                        },
                        {
                            "label": "r254",
                            "value": 254,
                            "title": "Version 254: 7 2 5 1; 1 7 8 9; 5 9 8 6; 2 1 5 4; 9 4 8 2; 6 3 4 1; 8 3 2 6; 9 6 3 7; 4 3 7 5"
                        },
                        {
                            "label": "r255",
                            "value": 255,
                            "title": "Version 255: 1 6 9 2; 7 8 5 3; 3 1 2 8; 8 9 3 4; 2 7 6 9; 6 4 1 7; 7 2 4 5; 5 9 6 3; 4 5 8 1"
                        },
                        {
                            "label": "r256",
                            "value": 256,
                            "title": "Version 256: 1 2 9 3; 2 8 5 6; 6 1 3 5; 9 5 2 4; 8 4 7 2; 7 3 9 4; 4 6 1 8; 3 8 6 7; 5 7 1 9"
                        },
                        {
                            "label": "r257",
                            "value": 257,
                            "title": "Version 257: 9 7 4 6; 5 9 3 8; 6 5 4 8; 7 3 5 2; 8 9 5 1; 1 2 4 3; 2 3 6 7; 6 4 9 1; 7 8 2 1"
                        },
                        {
                            "label": "r258",
                            "value": 258,
                            "title": "Version 258: 4 6 2 5; 3 4 8 2; 5 2 7 9; 4 8 9 7; 5 1 3 4; 1 5 7 6; 8 1 7 9; 2 6 9 3; 3 6 1 8"
                        },
                        {
                            "label": "r259",
                            "value": 259,
                            "title": "Version 259: 1 4 8 2; 8 7 6 5; 7 5 1 3; 9 1 4 3; 4 7 2 6; 2 8 9 1; 3 9 6 7; 9 3 5 4; 6 2 8 5"
                        },
                        {
                            "label": "r260",
                            "value": 260,
                            "title": "Version 260: 1 7 3 8; 2 8 5 9; 3 2 1 6; 6 9 2 3; 9 5 1 2; 7 3 8 4; 4 6 7 5; 5 1 4 7; 8 4 6 9"
                        },
                        {
                            "label": "r261",
                            "value": 261,
                            "title": "Version 261: 2 5 3 4; 6 4 2 1; 8 2 9 7; 9 1 8 3; 3 8 4 5; 5 6 7 9; 4 9 7 1; 7 3 6 2; 1 8 5 6"
                        },
                        {
                            "label": "r262",
                            "value": 262,
                            "title": "Version 262: 6 4 3 9; 5 6 3 8; 3 7 1 2; 9 7 5 3; 4 1 8 6; 2 4 8 7; 8 2 4 9; 7 5 6 1; 1 9 2 5"
                        },
                        {
                            "label": "r263",
                            "value": 263,
                            "title": "Version 263: 7 5 2 4; 4 7 9 6; 5 3 4 1; 9 6 5 2; 5 4 1 8; 3 2 7 8; 2 3 1 6; 6 8 3 9; 1 9 8 7"
                        },
                        {
                            "label": "r264",
                            "value": 264,
                            "title": "Version 264: 8 2 9 4; 9 1 6 7; 2 1 8 5; 6 5 2 4; 8 6 7 3; 7 9 4 3; 3 9 5 1; 2 8 3 5; 1 7 6 4"
                        },
                        {
                            "label": "r265",
                            "value": 265,
                            "title": "Version 265: 1 3 9 5; 9 6 1 8; 6 7 3 2; 4 5 7 8; 8 1 2 7; 8 4 9 6; 3 2 4 1; 5 3 6 4; 7 5 2 9"
                        },
                        {
                            "label": "r266",
                            "value": 266,
                            "title": "Version 266: 4 8 5 9; 4 8 3 7; 1 9 4 2; 3 9 8 6; 6 2 5 8; 2 1 7 6; 5 6 1 7; 7 3 9 5; 4 2 3 1"
                        },
                        {
                            "label": "r267",
                            "value": 267,
                            "title": "Version 267: 9 4 6 1; 1 7 8 5; 9 8 7 2; 9 1 2 3; 6 3 7 4; 2 4 6 5; 7 4 8 3; 8 5 1 6; 5 3 9 2"
                        },
                        {
                            "label": "r268",
                            "value": 268,
                            "title": "Version 268: 4 6 5 9; 3 7 4 5; 3 2 6 8; 5 8 3 1; 1 4 9 8; 6 1 7 3; 7 9 2 8; 2 5 6 9; 1 7 4 2"
                        },
                        {
                            "label": "r269",
                            "value": 269,
                            "title": "Version 269: 2 6 3 4; 3 9 5 7; 8 2 1 4; 4 5 9 2; 6 3 1 8; 9 1 4 5; 8 7 2 6; 5 8 7 1; 7 6 3 9"
                        },
                        {
                            "label": "r270",
                            "value": 270,
                            "title": "Version 270: 8 4 5 3; 5 3 2 1; 4 2 1 7; 7 6 8 4; 1 9 2 3; 9 8 5 6; 2 7 6 5; 8 3 4 9; 6 1 9 7"
                        },
                        {
                            "label": "r271",
                            "value": 271,
                            "title": "Version 271: 7 9 8 2; 3 6 4 1; 4 5 3 2; 6 8 2 3; 9 4 6 1; 1 3 9 7; 2 7 5 4; 5 1 8 6; 7 5 8 9"
                        },
                        {
                            "label": "r272",
                            "value": 272,
                            "title": "Version 272: 3 4 7 8; 6 2 1 7; 1 2 9 8; 2 7 3 5; 3 9 4 8; 9 6 4 2; 4 1 5 7; 3 5 6 9; 8 5 1 6"
                        },
                        {
                            "label": "r273",
                            "value": 273,
                            "title": "Version 273: 6 4 2 3; 5 6 7 9; 9 8 1 2; 1 8 7 4; 7 5 9 4; 5 1 3 6; 8 2 6 4; 9 7 1 3; 3 8 5 2"
                        },
                        {
                            "label": "r274",
                            "value": 274,
                            "title": "Version 274: 2 9 7 6; 2 3 9 1; 4 1 3 9; 1 2 4 5; 5 2 8 7; 6 7 8 3; 4 7 6 8; 4 9 5 6; 8 3 5 1"
                        },
                        {
                            "label": "r275",
                            "value": 275,
                            "title": "Version 275: 3 6 4 8; 6 4 2 1; 7 3 9 4; 7 1 6 5; 5 6 2 8; 8 4 5 9; 9 5 7 3; 9 8 1 2; 2 3 1 7"
                        },
                        {
                            "label": "r276",
                            "value": 276,
                            "title": "Version 276: 2 9 8 4; 1 7 4 5; 7 8 3 1; 3 1 4 6; 1 6 8 9; 6 2 7 9; 8 9 3 5; 4 5 2 7; 5 6 3 2"
                        },
                        {
                            "label": "r277",
                            "value": 277,
                            "title": "Version 277: 8 5 2 3; 6 2 9 7; 5 4 8 1; 3 4 7 8; 9 1 6 5; 4 3 6 9; 7 9 1 2; 2 5 4 3; 1 8 7 6"
                        },
                        {
                            "label": "r278",
                            "value": 278,
                            "title": "Version 278: 1 9 5 4; 4 7 8 6; 2 8 9 3; 5 6 1 2; 7 4 2 8; 3 7 9 1; 6 3 5 7; 1 2 3 4; 8 9 6 5"
                        },
                        {
                            "label": "r279",
                            "value": 279,
                            "title": "Version 279: 9 5 7 8; 5 2 9 4; 4 1 2 8; 9 1 5 3; 2 4 6 7; 8 1 3 2; 3 6 7 5; 7 8 1 6; 6 3 4 9"
                        },
                        {
                            "label": "r280",
                            "value": 280,
                            "title": "Version 280: 5 7 8 9; 8 5 3 2; 3 7 8 4; 2 7 5 1; 9 2 6 3; 6 4 1 5; 1 6 2 9; 7 3 4 1; 8 9 4 6"
                        },
                        {
                            "label": "r281",
                            "value": 281,
                            "title": "Version 281: 6 8 3 7; 7 5 2 1; 4 7 9 5; 1 8 6 3; 2 6 5 8; 9 3 7 2; 4 9 1 2; 8 1 9 4; 5 4 3 6"
                        },
                        {
                            "label": "r282",
                            "value": 282,
                            "title": "Version 282: 6 2 4 7; 9 6 8 1; 4 8 2 5; 7 5 1 4; 3 1 9 7; 4 9 6 3; 3 5 8 1; 2 9 7 8; 5 2 3 6"
                        },
                        {
                            "label": "r283",
                            "value": 283,
                            "title": "Version 283: 2 3 4 7; 1 7 5 6; 3 4 1 9; 1 2 6 8; 9 7 5 8; 5 3 2 9; 7 8 3 2; 6 4 9 5; 8 1 6 4"
                        },
                        {
                            "label": "r284",
                            "value": 284,
                            "title": "Version 284: 1 2 8 4; 2 5 1 3; 3 6 8 9; 8 9 5 2; 8 3 7 4; 9 6 7 2; 6 1 3 5; 4 9 6 7; 7 4 5 1"
                        },
                        {
                            "label": "r285",
                            "value": 285,
                            "title": "Version 285: 5 8 7 6; 7 5 8 3; 9 2 4 1; 1 3 9 7; 5 6 2 4; 1 8 9 5; 4 8 2 3; 6 4 3 9; 2 1 7 6"
                        },
                        {
                            "label": "r286",
                            "value": 286,
                            "title": "Version 286: 3 9 2 6; 4 7 1 5; 6 1 2 7; 9 5 1 3; 7 9 4 8; 5 6 8 4; 7 2 9 8; 2 4 3 5; 3 8 6 1"
                        },
                        {
                            "label": "r287",
                            "value": 287,
                            "title": "Version 287: 7 3 5 2; 8 5 4 6; 3 7 6 1; 5 2 6 9; 4 3 8 1; 1 9 8 2; 8 7 9 5; 6 1 4 9; 2 4 7 3"
                        },
                        {
                            "label": "r288",
                            "value": 288,
                            "title": "Version 288: 9 5 1 2; 9 3 5 8; 2 8 9 7; 3 6 2 4; 5 4 3 6; 1 6 2 8; 4 7 6 9; 8 1 7 3; 4 1 5 7"
                        },
                        {
                            "label": "r289",
                            "value": 289,
                            "title": "Version 289: 8 4 1 5; 6 8 4 7; 5 2 7 1; 1 5 9 3; 3 6 1 8; 9 2 5 4; 2 3 8 6; 7 9 4 2; 6 7 3 9"
                        },
                        {
                            "label": "r290",
                            "value": 290,
                            "title": "Version 290: 3 7 5 4; 4 3 1 2; 2 4 7 1; 5 6 9 8; 8 5 2 6; 9 8 4 3; 7 9 3 6; 1 2 8 9; 6 1 7 5"
                        },
                        {
                            "label": "r291",
                            "value": 291,
                            "title": "Version 291: 1 2 6 4; 8 3 5 7; 3 8 2 7; 4 5 8 6; 7 4 9 2; 9 4 1 8; 6 1 7 9; 2 6 3 5; 5 3 9 1"
                        },
                        {
                            "label": "r292",
                            "value": 292,
                            "title": "Version 292: 8 7 5 2; 2 9 6 3; 3 9 4 1; 6 8 4 1; 5 6 7 9; 4 9 2 5; 7 1 6 5; 1 2 8 3; 8 7 3 4"
                        },
                        {
                            "label": "r293",
                            "value": 293,
                            "title": "Version 293: 6 3 2 7; 9 7 1 8; 9 5 1 3; 5 8 4 2; 9 4 8 6; 7 6 1 2; 1 6 3 4; 4 5 9 7; 2 3 5 8"
                        },
                        {
                            "label": "r294",
                            "value": 294,
                            "title": "Version 294: 3 4 5 9; 3 8 4 7; 4 2 6 9; 5 1 2 4; 7 5 6 1; 2 9 8 1; 6 2 3 5; 8 7 9 6; 1 3 7 8"
                        },
                        {
                            "label": "r295",
                            "value": 295,
                            "title": "Version 295: 2 7 5 9; 7 8 6 4; 7 4 2 3; 4 2 8 5; 5 1 9 3; 3 1 7 4; 6 5 1 8; 8 6 3 9; 9 1 2 6"
                        },
                        {
                            "label": "r296",
                            "value": 296,
                            "title": "Version 296: 1 3 4 2; 2 9 3 6; 5 6 8 7; 1 2 7 8; 3 8 6 2; 4 5 1 7; 9 7 5 3; 8 9 4 5; 6 4 9 1"
                        },
                        {
                            "label": "r297",
                            "value": 297,
                            "title": "Version 297: 6 9 4 8; 9 7 2 3; 2 6 5 1; 3 4 6 5; 7 2 4 6; 5 1 7 3; 1 8 9 7; 4 8 9 2; 8 3 5 1"
                        },
                        {
                            "label": "r298",
                            "value": 298,
                            "title": "Version 298: 6 5 1 4; 8 4 3 6; 2 5 1 9; 5 2 8 7; 1 4 8 2; 4 3 7 9; 9 1 6 7; 7 6 2 3; 3 9 8 5"
                        },
                        {
                            "label": "r299",
                            "value": 299,
                            "title": "Version 299: 4 7 5 8; 6 7 3 1; 2 5 6 4; 1 2 3 8; 5 7 4 9; 9 6 2 8; 3 9 5 6; 7 1 9 2; 8 3 1 4"
                        },
                        {
                            "label": "r300",
                            "value": 300,
                            "title": "Version 300: 2 9 7 4; 3 8 9 5; 5 2 6 1; 6 5 8 7; 4 3 2 5; 8 6 1 9; 7 8 3 2; 9 4 1 3; 1 4 7 6"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q22_version"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Version 1: 1 2 7 8; 2 8 1 4; 5 1 9 6; 9 3 4 1; 7 5 2 3; 3 9 8 6; 6 7 5 2; 8 4 3 5; 4 6 7 9"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Version 2: 5 2 6 4; 2 5 8 9; 6 8 4 1; 3 1 5 7; 1 4 8 5; 8 7 2 9; 7 6 3 4; 9 3 1 7; 2 9 6 3"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Version 3: 6 1 7 8; 8 6 5 3; 4 5 9 2; 3 7 4 2; 5 3 6 1; 1 2 9 6; 1 8 2 3; 9 4 8 7; 4 9 7 5"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Version 4: 7 9 1 5; 6 7 5 8; 4 6 1 2; 2 4 3 1; 3 2 6 7; 5 1 4 9; 8 5 9 3; 9 8 2 6; 7 3 8 4"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "Version 5: 2 7 9 4; 4 2 3 6; 3 9 2 5; 1 2 5 8; 7 6 1 9; 5 3 7 1; 6 8 4 5; 8 1 3 9; 8 4 6 7"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Version 6: 3 5 7 2; 5 1 4 6; 9 4 1 2; 7 9 5 8; 6 3 9 4; 9 6 3 8; 4 8 2 3; 5 7 6 1; 1 8 2 7"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "Version 7: 2 9 7 6; 9 7 8 3; 8 5 9 4; 4 3 8 1; 1 5 6 2; 3 4 5 7; 6 1 2 3; 7 1 4 9; 2 6 8 5"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "Version 8: 4 3 1 5; 7 2 4 8; 1 7 9 8; 2 4 5 9; 6 8 7 1; 5 9 3 6; 2 6 7 4; 9 3 6 1; 3 2 5 8"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Version 9: 8 3 1 7; 1 7 3 4; 4 5 6 7; 9 5 1 2; 6 4 2 5; 8 2 9 1; 3 8 6 9; 9 6 8 4; 5 7 3 2"
                },
                {
                    "label": "r10",
                    "value": 10,
                    "title": "Version 10: 7 8 4 5; 8 2 4 6; 8 9 2 3; 6 9 7 2; 5 4 3 9; 5 1 9 7; 2 4 1 3; 3 6 7 1; 1 5 8 6"
                },
                {
                    "label": "r11",
                    "value": 11,
                    "title": "Version 11: 7 1 4 2; 2 7 5 8; 4 8 3 9; 1 2 9 6; 6 9 1 4; 1 5 4 8; 8 3 5 6; 7 6 2 3; 3 7 9 5"
                },
                {
                    "label": "r12",
                    "value": 12,
                    "title": "Version 12: 4 1 3 7; 9 1 2 5; 5 6 8 2; 3 5 1 8; 2 8 3 1; 7 4 6 8; 9 5 7 6; 6 3 4 9; 4 9 2 7"
                },
                {
                    "label": "r13",
                    "value": 13,
                    "title": "Version 13: 4 2 5 3; 1 9 8 4; 2 8 7 3; 3 1 6 2; 6 3 4 7; 9 6 1 7; 7 8 5 9; 5 4 9 2; 8 1 6 5"
                },
                {
                    "label": "r14",
                    "value": 14,
                    "title": "Version 14: 7 2 8 9; 9 2 8 3; 1 3 9 4; 3 7 6 5; 5 9 3 6; 8 6 4 1; 4 5 1 7; 2 7 5 1; 6 4 2 8"
                },
                {
                    "label": "r15",
                    "value": 15,
                    "title": "Version 15: 2 6 7 4; 7 8 6 3; 3 1 9 5; 5 4 8 6; 4 5 3 9; 3 2 5 4; 8 7 1 2; 6 9 2 1; 9 1 7 8"
                },
                {
                    "label": "r16",
                    "value": 16,
                    "title": "Version 16: 1 2 4 7; 2 3 6 9; 1 6 2 3; 6 4 1 5; 4 9 7 8; 8 5 6 1; 5 7 9 2; 9 3 8 4; 7 3 5 8"
                },
                {
                    "label": "r17",
                    "value": 17,
                    "title": "Version 17: 5 1 3 7; 2 8 5 6; 7 5 4 6; 1 7 6 9; 6 9 7 3; 9 4 1 8; 8 3 2 4; 4 2 9 5; 3 8 1 2"
                },
                {
                    "label": "r18",
                    "value": 18,
                    "title": "Version 18: 5 4 3 1; 3 1 4 7; 4 6 8 9; 7 8 2 1; 1 6 3 2; 2 9 5 8; 8 5 9 6; 6 7 3 4; 9 2 7 5"
                },
                {
                    "label": "r19",
                    "value": 19,
                    "title": "Version 19: 5 7 8 3; 6 5 4 1; 1 4 8 2; 2 3 9 4; 9 1 5 3; 3 6 7 8; 8 9 1 6; 7 5 2 9; 4 2 6 7"
                },
                {
                    "label": "r20",
                    "value": 20,
                    "title": "Version 20: 3 8 2 5; 5 2 6 1; 8 6 3 4; 1 3 7 9; 2 9 6 3; 6 4 9 2; 7 8 5 1; 4 1 9 7; 7 8 4 5"
                },
                {
                    "label": "r21",
                    "value": 21,
                    "title": "Version 21: 8 4 1 2; 2 1 5 3; 4 5 3 6; 9 7 8 6; 2 9 8 7; 5 6 1 9; 6 7 4 5; 9 3 8 4; 1 2 7 3"
                },
                {
                    "label": "r22",
                    "value": 22,
                    "title": "Version 22: 3 6 4 7; 6 5 2 8; 8 7 6 1; 5 2 9 4; 9 3 1 6; 1 4 2 7; 2 8 3 9; 4 1 5 8; 7 3 9 5"
                },
                {
                    "label": "r23",
                    "value": 23,
                    "title": "Version 23: 3 9 8 1; 6 1 3 2; 5 6 7 2; 1 5 4 9; 9 2 6 4; 8 9 7 6; 7 1 2 4; 3 7 5 8; 4 8 3 5"
                },
                {
                    "label": "r24",
                    "value": 24,
                    "title": "Version 24: 9 6 7 3; 6 3 1 8; 7 4 2 3; 2 4 9 5; 8 5 6 2; 1 9 5 6; 3 7 8 4; 5 2 1 7; 4 8 9 1"
                },
                {
                    "label": "r25",
                    "value": 25,
                    "title": "Version 25: 8 1 4 6; 5 4 7 9; 6 9 1 7; 3 8 5 2; 9 2 7 8; 1 3 6 5; 7 5 2 1; 4 6 3 2; 4 9 8 3"
                },
                {
                    "label": "r26",
                    "value": 26,
                    "title": "Version 26: 2 7 1 8; 5 2 6 9; 9 5 3 1; 3 7 4 5; 6 4 8 7; 7 6 5 8; 8 1 2 9; 2 3 4 6; 1 9 3 4"
                },
                {
                    "label": "r27",
                    "value": 27,
                    "title": "Version 27: 5 8 4 1; 8 4 9 2; 9 5 8 6; 6 2 1 3; 3 7 5 4; 1 4 7 6; 2 3 9 7; 8 1 2 3; 7 6 5 9"
                },
                {
                    "label": "r28",
                    "value": 28,
                    "title": "Version 28: 3 8 6 2; 4 1 2 5; 6 8 1 7; 7 3 6 9; 5 7 3 8; 4 2 6 5; 2 9 7 1; 9 4 8 3; 1 9 4 5"
                },
                {
                    "label": "r29",
                    "value": 29,
                    "title": "Version 29: 6 5 9 8; 1 3 2 4; 9 2 5 3; 5 8 1 3; 4 6 9 1; 2 6 4 7; 8 7 9 4; 3 1 7 6; 7 5 8 2"
                },
                {
                    "label": "r30",
                    "value": 30,
                    "title": "Version 30: 7 5 3 9; 3 2 5 6; 6 4 2 8; 2 7 3 9; 5 6 8 1; 4 8 7 1; 1 9 8 2; 9 1 4 7; 5 3 6 4"
                },
                {
                    "label": "r31",
                    "value": 31,
                    "title": "Version 31: 9 3 1 5; 1 4 3 6; 4 6 7 2; 8 6 9 3; 2 8 4 5; 6 2 7 9; 7 3 1 8; 8 9 5 4; 5 7 2 1"
                },
                {
                    "label": "r32",
                    "value": 32,
                    "title": "Version 32: 8 1 6 5; 9 8 6 7; 1 5 9 6; 3 9 1 2; 2 6 3 4; 7 2 8 3; 4 9 2 8; 1 7 5 4; 3 4 5 7"
                },
                {
                    "label": "r33",
                    "value": 33,
                    "title": "Version 33: 2 1 4 9; 4 5 8 3; 6 5 9 3; 5 1 2 7; 6 4 1 8; 9 2 7 5; 3 8 2 1; 4 7 6 9; 7 3 8 6"
                },
                {
                    "label": "r34",
                    "value": 34,
                    "title": "Version 34: 6 1 9 2; 7 4 3 5; 8 9 4 7; 5 3 1 8; 3 2 4 9; 9 7 3 1; 1 6 7 4; 8 5 6 2; 2 8 5 6"
                },
                {
                    "label": "r35",
                    "value": 35,
                    "title": "Version 35: 3 1 7 2; 1 8 9 5; 7 9 2 6; 5 3 6 9; 6 7 8 1; 8 2 3 4; 9 5 4 8; 4 2 5 7; 4 6 1 3"
                },
                {
                    "label": "r36",
                    "value": 36,
                    "title": "Version 36: 5 4 7 6; 3 4 1 9; 2 3 8 7; 1 7 9 5; 6 5 2 3; 8 6 4 9; 7 8 2 1; 2 1 5 4; 9 3 6 8"
                },
                {
                    "label": "r37",
                    "value": 37,
                    "title": "Version 37: 4 9 5 2; 1 4 3 6; 6 2 8 7; 9 1 7 3; 5 7 3 4; 8 3 7 5; 6 8 1 5; 2 9 4 8; 1 6 9 2"
                },
                {
                    "label": "r38",
                    "value": 38,
                    "title": "Version 38: 2 8 4 1; 7 5 1 4; 3 7 8 9; 7 2 6 5; 5 1 9 8; 4 8 6 3; 9 6 4 7; 3 5 2 6; 2 9 3 1"
                },
                {
                    "label": "r39",
                    "value": 39,
                    "title": "Version 39: 9 4 5 3; 3 6 1 7; 8 7 9 2; 5 9 6 2; 8 5 7 6; 3 4 8 7; 4 1 2 6; 1 2 9 4; 5 3 1 8"
                },
                {
                    "label": "r40",
                    "value": 40,
                    "title": "Version 40: 6 2 3 9; 7 3 2 1; 2 1 5 8; 9 5 7 4; 4 8 6 5; 8 4 3 2; 6 9 5 3; 7 6 4 1; 1 7 8 9"
                },
                {
                    "label": "r41",
                    "value": 41,
                    "title": "Version 41: 1 6 4 8; 5 1 2 3; 6 5 1 9; 4 8 9 3; 8 2 9 7; 9 4 6 7; 7 5 4 2; 8 3 5 1; 3 7 2 6"
                },
                {
                    "label": "r42",
                    "value": 42,
                    "title": "Version 42: 2 9 5 4; 1 9 3 6; 9 7 8 1; 6 2 3 4; 3 4 7 5; 4 1 8 6; 2 6 7 8; 7 3 9 5; 5 8 1 2"
                },
                {
                    "label": "r43",
                    "value": 43,
                    "title": "Version 43: 8 2 6 3; 3 1 7 4; 2 1 6 9; 9 8 3 7; 6 9 2 5; 1 7 4 2; 7 5 1 6; 4 3 8 5; 5 4 8 9"
                },
                {
                    "label": "r44",
                    "value": 44,
                    "title": "Version 44: 3 6 9 8; 6 7 5 1; 5 3 2 4; 1 9 3 4; 9 2 7 3; 4 5 1 6; 2 8 1 9; 8 6 4 7; 8 7 5 2"
                },
                {
                    "label": "r45",
                    "value": 45,
                    "title": "Version 45: 7 5 6 3; 2 4 7 1; 4 2 9 7; 1 9 5 8; 5 3 6 9; 6 4 3 1; 9 7 4 8; 3 1 2 8; 5 8 6 2"
                },
                {
                    "label": "r46",
                    "value": 46,
                    "title": "Version 46: 7 1 2 3; 1 9 4 5; 2 4 8 5; 8 6 1 9; 3 5 7 2; 6 3 8 4; 7 8 3 6; 9 7 5 1; 4 6 2 9"
                },
                {
                    "label": "r47",
                    "value": 47,
                    "title": "Version 47: 8 6 9 7; 3 2 8 1; 7 2 6 5; 5 3 9 4; 4 8 7 3; 1 5 7 8; 2 4 5 6; 9 1 3 2; 6 4 1 9"
                },
                {
                    "label": "r48",
                    "value": 48,
                    "title": "Version 48: 6 9 2 7; 7 9 8 5; 1 7 4 3; 4 1 6 7; 3 6 1 5; 9 2 4 8; 5 8 3 9; 2 5 8 4; 6 3 1 2"
                },
                {
                    "label": "r49",
                    "value": 49,
                    "title": "Version 49: 8 2 9 1; 2 3 5 6; 8 6 5 1; 3 9 6 4; 7 4 8 6; 1 8 3 7; 5 4 9 2; 9 7 2 3; 4 1 5 7"
                },
                {
                    "label": "r50",
                    "value": 50,
                    "title": "Version 50: 6 9 3 8; 9 6 4 1; 4 1 7 9; 7 5 9 3; 8 5 3 1; 5 7 6 2; 1 2 4 5; 3 8 2 4; 2 6 7 8"
                },
                {
                    "label": "r51",
                    "value": 51,
                    "title": "Version 51: 8 2 7 4; 5 7 8 6; 4 3 9 8; 6 8 1 2; 3 5 4 6; 1 9 6 7; 2 1 5 9; 9 4 5 3; 7 3 2 1"
                },
                {
                    "label": "r52",
                    "value": 52,
                    "title": "Version 52: 9 2 6 5; 2 9 3 8; 8 5 9 7; 5 8 1 4; 1 6 8 9; 4 3 7 6; 3 7 2 1; 7 1 4 5; 6 4 2 3"
                },
                {
                    "label": "r53",
                    "value": 53,
                    "title": "Version 53: 8 3 1 4; 3 9 1 2; 1 6 3 5; 4 7 9 6; 7 8 4 2; 5 7 6 9; 2 9 4 5; 6 2 1 8; 8 5 7 3"
                },
                {
                    "label": "r54",
                    "value": 54,
                    "title": "Version 54: 2 3 5 6; 9 5 8 3; 1 4 9 7; 4 8 2 6; 6 4 8 9; 5 1 7 8; 7 1 9 3; 1 2 5 4; 3 6 7 2"
                },
                {
                    "label": "r55",
                    "value": 55,
                    "title": "Version 55: 8 5 6 7; 5 8 3 4; 4 6 3 1; 9 7 5 2; 9 3 6 7; 2 9 1 5; 3 1 2 4; 1 6 8 9; 7 4 2 8"
                },
                {
                    "label": "r56",
                    "value": 56,
                    "title": "Version 56: 6 2 4 7; 4 9 5 3; 9 2 3 8; 9 4 8 1; 3 5 6 7; 6 1 4 5; 7 8 1 3; 8 7 9 2; 2 6 5 1"
                },
                {
                    "label": "r57",
                    "value": 57,
                    "title": "Version 57: 5 8 1 6; 4 5 2 9; 1 3 7 2; 5 4 7 1; 8 3 4 6; 6 2 8 9; 7 9 3 4; 6 1 9 7; 2 5 3 8"
                },
                {
                    "label": "r58",
                    "value": 58,
                    "title": "Version 58: 3 9 6 5; 5 7 9 1; 9 8 5 4; 3 6 4 2; 8 1 2 6; 1 3 2 9; 2 4 7 6; 8 7 3 5; 7 4 8 1"
                },
                {
                    "label": "r59",
                    "value": 59,
                    "title": "Version 59: 5 2 1 8; 4 2 6 9; 9 1 6 3; 3 8 6 5; 6 9 4 7; 7 5 1 3; 1 3 8 4; 4 7 5 2; 7 2 9 8"
                },
                {
                    "label": "r60",
                    "value": 60,
                    "title": "Version 60: 4 6 1 8; 2 6 7 1; 8 4 2 5; 2 1 5 9; 1 9 4 3; 9 7 3 2; 5 3 6 4; 6 8 5 7; 3 9 7 8"
                },
                {
                    "label": "r61",
                    "value": 61,
                    "title": "Version 61: 2 1 8 3; 4 5 9 6; 1 5 9 6; 5 2 1 7; 3 6 7 5; 8 3 2 6; 7 4 3 2; 9 8 4 7; 8 9 4 1"
                },
                {
                    "label": "r62",
                    "value": 62,
                    "title": "Version 62: 5 7 8 3; 6 5 8 9; 9 8 5 2; 9 2 3 4; 1 4 7 5; 6 1 9 3; 2 6 1 7; 7 3 1 4; 2 4 6 8"
                },
                {
                    "label": "r63",
                    "value": 63,
                    "title": "Version 63: 6 7 2 9; 3 8 2 1; 3 9 6 1; 1 7 9 8; 5 3 8 9; 4 8 7 6; 7 5 4 6; 4 2 3 5; 2 1 5 4"
                },
                {
                    "label": "r64",
                    "value": 64,
                    "title": "Version 64: 4 1 3 2; 8 6 2 3; 8 7 1 5; 7 5 9 1; 5 2 7 3; 9 4 8 7; 3 9 6 4; 6 9 5 2; 1 6 4 8"
                },
                {
                    "label": "r65",
                    "value": 65,
                    "title": "Version 65: 2 8 1 9; 1 6 8 7; 9 2 5 4; 6 5 9 8; 7 3 6 2; 3 7 4 9; 5 3 6 1; 7 1 2 4; 4 3 8 5"
                },
                {
                    "label": "r66",
                    "value": 66,
                    "title": "Version 66: 3 1 7 6; 8 9 3 1; 9 4 7 6; 8 7 2 5; 3 2 9 7; 2 4 6 8; 6 1 4 5; 8 5 3 4; 1 2 5 9"
                },
                {
                    "label": "r67",
                    "value": 67,
                    "title": "Version 67: 6 8 7 2; 5 6 9 3; 4 9 2 7; 2 6 1 9; 1 5 4 2; 5 3 1 4; 3 8 1 6; 4 9 7 8; 7 5 3 8"
                },
                {
                    "label": "r68",
                    "value": 68,
                    "title": "Version 68: 2 4 6 3; 4 7 5 3; 4 3 8 1; 7 2 5 6; 9 4 8 6; 6 1 5 7; 9 8 2 1; 1 7 3 9; 5 8 9 2"
                },
                {
                    "label": "r69",
                    "value": 69,
                    "title": "Version 69: 9 3 4 5; 7 6 4 1; 8 9 1 7; 1 4 9 5; 6 7 5 3; 3 2 7 8; 5 6 2 8; 2 3 6 9; 8 1 4 2"
                },
                {
                    "label": "r70",
                    "value": 70,
                    "title": "Version 70: 7 1 2 4; 3 7 8 9; 4 2 7 6; 1 5 3 2; 6 8 9 5; 9 6 1 5; 5 4 8 7; 4 8 6 3; 2 9 3 1"
                },
                {
                    "label": "r71",
                    "value": 71,
                    "title": "Version 71: 8 5 7 1; 2 5 8 4; 8 4 3 9; 3 2 5 6; 7 3 2 9; 9 7 4 5; 1 6 2 7; 6 3 1 8; 1 9 6 4"
                },
                {
                    "label": "r72",
                    "value": 72,
                    "title": "Version 72: 5 1 8 2; 5 7 9 3; 2 9 6 4; 4 2 1 7; 8 4 3 1; 9 8 7 6; 5 6 9 2; 3 7 6 8; 1 5 4 3"
                },
                {
                    "label": "r73",
                    "value": 73,
                    "title": "Version 73: 7 1 5 9; 6 1 7 3; 3 6 4 2; 6 8 1 7; 9 4 3 5; 4 5 8 6; 8 9 2 4; 8 2 9 1; 7 2 5 3"
                },
                {
                    "label": "r74",
                    "value": 74,
                    "title": "Version 74: 1 3 6 4; 9 1 3 8; 2 3 9 7; 2 7 8 5; 4 6 2 5; 7 4 1 6; 5 9 6 1; 9 4 7 8; 8 5 3 2"
                },
                {
                    "label": "r75",
                    "value": 75,
                    "title": "Version 75: 3 6 2 9; 3 8 1 2; 6 8 5 7; 9 1 4 3; 5 9 1 6; 1 5 4 2; 4 3 5 7; 7 6 9 8; 2 7 8 4"
                },
                {
                    "label": "r76",
                    "value": 76,
                    "title": "Version 76: 3 2 8 9; 4 8 3 1; 2 1 7 9; 7 4 9 5; 6 3 7 1; 7 2 4 6; 1 9 5 4; 6 5 8 3; 8 5 6 2"
                },
                {
                    "label": "r77",
                    "value": 77,
                    "title": "Version 77: 5 9 2 1; 9 6 4 8; 5 4 6 3; 8 7 9 4; 6 7 3 9; 2 8 5 1; 3 2 4 7; 1 3 7 5; 6 1 2 8"
                },
                {
                    "label": "r78",
                    "value": 78,
                    "title": "Version 78: 7 2 5 9; 4 9 2 3; 4 8 1 6; 5 3 8 4; 8 6 1 7; 9 3 6 2; 1 5 9 6; 3 5 7 8; 1 7 2 4"
                },
                {
                    "label": "r79",
                    "value": 79,
                    "title": "Version 79: 9 4 3 1; 2 8 9 5; 4 2 5 6; 3 1 6 2; 5 1 4 7; 8 9 1 7; 7 6 3 5; 2 7 8 3; 6 8 4 9"
                },
                {
                    "label": "r80",
                    "value": 80,
                    "title": "Version 80: 2 6 1 8; 1 2 5 3; 8 5 7 9; 5 4 8 3; 3 1 9 5; 4 9 6 8; 6 3 7 9; 7 4 2 6; 4 7 2 1"
                },
                {
                    "label": "r81",
                    "value": 81,
                    "title": "Version 81: 9 6 7 1; 7 9 8 4; 9 4 3 2; 6 2 9 5; 2 8 3 7; 5 7 6 4; 1 5 8 2; 3 1 5 6; 8 3 4 1"
                },
                {
                    "label": "r82",
                    "value": 82,
                    "title": "Version 82: 7 9 3 8; 9 2 1 4; 4 7 2 6; 6 3 7 5; 3 4 5 8; 2 6 9 3; 1 5 4 9; 5 8 1 7; 8 1 6 2"
                },
                {
                    "label": "r83",
                    "value": 83,
                    "title": "Version 83: 2 6 8 5; 5 2 4 7; 4 8 6 9; 8 7 1 3; 1 9 7 4; 6 5 9 8; 4 1 3 6; 3 7 2 1; 9 3 5 2"
                },
                {
                    "label": "r84",
                    "value": 84,
                    "title": "Version 84: 8 4 1 6; 7 8 5 2; 6 1 8 3; 3 4 9 5; 4 3 2 8; 5 9 7 1; 1 2 9 7; 9 2 3 6; 5 6 4 7"
                },
                {
                    "label": "r85",
                    "value": 85,
                    "title": "Version 85: 8 5 1 9; 7 9 6 3; 2 9 8 4; 1 4 5 3; 3 5 2 9; 7 1 6 8; 8 3 7 4; 2 6 7 5; 2 6 4 1"
                },
                {
                    "label": "r86",
                    "value": 86,
                    "title": "Version 86: 6 8 3 4; 6 7 4 2; 9 7 5 1; 1 2 3 7; 9 1 8 2; 5 8 1 3; 5 4 6 9; 3 7 9 6; 4 5 2 8"
                },
                {
                    "label": "r87",
                    "value": 87,
                    "title": "Version 87: 2 8 6 5; 6 3 5 1; 7 3 4 5; 1 6 2 9; 4 1 7 2; 9 8 3 7; 8 9 3 2; 9 4 1 6; 7 5 8 4"
                },
                {
                    "label": "r88",
                    "value": 88,
                    "title": "Version 88: 3 2 7 6; 5 4 9 8; 6 3 8 7; 3 9 4 1; 8 5 6 9; 4 1 2 3; 2 7 9 4; 1 6 5 8; 7 2 1 5"
                },
                {
                    "label": "r89",
                    "value": 89,
                    "title": "Version 89: 2 4 5 8; 8 5 2 3; 7 8 1 9; 5 9 7 6; 3 7 6 9; 6 3 4 5; 9 2 3 1; 4 6 1 2; 1 4 8 7"
                },
                {
                    "label": "r90",
                    "value": 90,
                    "title": "Version 90: 6 3 9 4; 4 6 2 7; 3 1 7 5; 1 8 6 3; 5 1 8 2; 8 7 4 3; 8 2 9 6; 2 9 7 5; 9 5 4 1"
                },
                {
                    "label": "r91",
                    "value": 91,
                    "title": "Version 91: 2 9 3 8; 6 8 1 4; 7 3 5 9; 7 6 5 4; 5 4 3 1; 4 2 1 6; 3 5 2 6; 9 7 8 2; 1 7 9 8"
                },
                {
                    "label": "r92",
                    "value": 92,
                    "title": "Version 92: 3 2 9 4; 4 8 6 7; 7 1 2 4; 8 1 5 9; 1 3 7 8; 5 6 7 2; 2 4 3 5; 6 9 5 1; 6 9 8 3"
                },
                {
                    "label": "r93",
                    "value": 93,
                    "title": "Version 93: 9 4 6 7; 9 8 4 2; 1 7 9 3; 7 5 6 1; 2 3 1 6; 8 6 2 7; 4 5 8 9; 5 3 4 8; 3 1 2 5"
                },
                {
                    "label": "r94",
                    "value": 94,
                    "title": "Version 94: 6 2 1 9; 7 2 3 4; 3 7 8 1; 9 4 7 5; 1 5 9 2; 5 6 3 8; 4 9 6 1; 2 8 5 7; 8 3 4 6"
                },
                {
                    "label": "r95",
                    "value": 95,
                    "title": "Version 95: 5 1 4 6; 6 8 2 7; 2 6 5 9; 8 4 1 3; 9 2 8 4; 1 9 7 3; 4 7 1 8; 3 5 9 6; 7 2 3 5"
                },
                {
                    "label": "r96",
                    "value": 96,
                    "title": "Version 96: 8 1 6 2; 1 3 4 5; 7 8 5 1; 4 7 3 9; 6 4 5 7; 5 9 8 2; 9 2 7 4; 3 9 6 8; 2 6 1 3"
                },
                {
                    "label": "r97",
                    "value": 97,
                    "title": "Version 97: 4 5 2 3; 5 1 4 6; 1 6 9 8; 6 3 2 7; 9 1 7 2; 8 4 3 2; 3 5 9 1; 7 8 9 4; 7 8 6 5"
                },
                {
                    "label": "r98",
                    "value": 98,
                    "title": "Version 98: 5 3 1 9; 2 7 8 3; 3 9 7 6; 1 5 8 2; 9 6 3 4; 6 1 4 7; 2 4 6 8; 4 2 5 9; 8 7 5 1"
                },
                {
                    "label": "r99",
                    "value": 99,
                    "title": "Version 99: 9 8 4 1; 4 7 2 5; 1 4 2 3; 2 9 1 6; 7 1 5 4; 6 3 8 2; 5 6 3 8; 3 8 9 7; 7 5 6 9"
                },
                {
                    "label": "r100",
                    "value": 100,
                    "title": "Version 100: 9 2 1 3; 1 2 7 6; 9 7 6 5; 8 9 6 4; 5 2 8 1; 2 6 4 5; 4 3 9 7; 3 4 1 8; 8 5 7 3"
                },
                {
                    "label": "r101",
                    "value": 101,
                    "title": "Version 101: 4 5 2 7; 6 1 3 7; 7 4 3 2; 3 6 4 1; 2 8 4 9; 5 9 2 8; 8 1 9 5; 6 3 5 9; 1 7 8 6"
                },
                {
                    "label": "r102",
                    "value": 102,
                    "title": "Version 102: 5 8 3 4; 4 9 8 6; 2 6 7 1; 7 2 9 8; 1 4 5 6; 8 1 7 3; 6 3 2 5; 9 7 1 4; 3 5 2 9"
                },
                {
                    "label": "r103",
                    "value": 103,
                    "title": "Version 103: 1 4 5 9; 4 9 3 7; 3 1 8 2; 8 3 6 4; 5 7 6 8; 8 5 1 2; 9 2 3 1; 7 6 9 5; 6 2 7 4"
                },
                {
                    "label": "r104",
                    "value": 104,
                    "title": "Version 104: 2 6 4 3; 3 1 5 7; 2 8 7 9; 5 7 2 3; 6 8 1 9; 9 3 6 8; 7 4 8 1; 4 5 1 6; 5 9 4 2"
                },
                {
                    "label": "r105",
                    "value": 105,
                    "title": "Version 105: 7 8 9 5; 8 5 2 4; 6 2 8 7; 1 4 6 3; 4 3 5 8; 9 6 2 1; 1 9 7 4; 3 5 9 6; 2 1 7 3"
                },
                {
                    "label": "r106",
                    "value": 106,
                    "title": "Version 106: 1 2 3 5; 9 3 4 8; 6 7 4 2; 2 6 9 1; 4 9 1 2; 8 7 5 3; 3 5 9 7; 4 8 6 7; 5 1 8 6"
                },
                {
                    "label": "r107",
                    "value": 107,
                    "title": "Version 107: 6 4 2 5; 7 4 3 1; 1 2 7 8; 5 1 4 8; 8 3 6 9; 3 7 1 9; 7 9 5 6; 2 8 3 6; 9 5 4 2"
                },
                {
                    "label": "r108",
                    "value": 108,
                    "title": "Version 108: 2 3 7 4; 4 6 8 1; 8 2 9 4; 2 1 3 5; 6 9 5 1; 9 7 4 5; 6 8 2 3; 7 6 3 5; 1 8 7 9"
                },
                {
                    "label": "r109",
                    "value": 109,
                    "title": "Version 109: 5 3 6 4; 8 5 1 9; 3 4 8 7; 1 4 8 5; 7 9 6 2; 9 1 2 3; 4 6 3 9; 1 7 6 2; 5 2 8 7"
                },
                {
                    "label": "r110",
                    "value": 110,
                    "title": "Version 110: 3 6 5 8; 8 2 9 6; 2 5 7 4; 6 5 1 7; 7 8 1 3; 5 9 2 3; 4 1 7 6; 3 4 9 1; 9 2 4 8"
                },
                {
                    "label": "r111",
                    "value": 111,
                    "title": "Version 111: 9 8 1 6; 3 7 8 9; 1 6 4 2; 2 6 5 8; 6 3 7 4; 5 1 8 4; 1 3 2 5; 7 9 3 2; 4 7 9 5"
                },
                {
                    "label": "r112",
                    "value": 112,
                    "title": "Version 112: 8 4 5 2; 3 9 6 1; 6 1 2 7; 5 3 6 9; 4 7 5 9; 9 4 2 1; 7 5 6 8; 2 8 4 3; 8 1 3 7"
                },
                {
                    "label": "r113",
                    "value": 113,
                    "title": "Version 113: 4 8 1 3; 1 3 5 7; 7 4 9 6; 8 2 7 9; 6 7 5 2; 5 9 1 8; 9 2 4 1; 3 5 6 4; 3 6 8 2"
                },
                {
                    "label": "r114",
                    "value": 114,
                    "title": "Version 114: 7 4 8 6; 8 6 9 1; 9 6 3 5; 2 7 1 5; 6 9 4 7; 2 1 7 8; 1 2 3 4; 2 3 9 5; 5 8 4 3"
                },
                {
                    "label": "r115",
                    "value": 115,
                    "title": "Version 115: 1 5 7 3; 7 1 9 6; 8 3 2 7; 4 9 8 5; 6 2 8 9; 5 1 2 6; 3 9 7 4; 4 8 5 2; 3 6 1 4"
                },
                {
                    "label": "r116",
                    "value": 116,
                    "title": "Version 116: 9 5 3 8; 2 7 6 1; 9 2 3 7; 2 4 6 3; 5 7 2 4; 8 3 1 9; 4 8 7 6; 1 4 9 5; 6 5 1 8"
                },
                {
                    "label": "r117",
                    "value": 117,
                    "title": "Version 117: 3 6 8 2; 7 8 5 9; 6 7 3 5; 9 6 4 1; 5 3 4 1; 8 2 7 3; 7 1 4 8; 9 5 6 2; 4 9 1 2"
                },
                {
                    "label": "r118",
                    "value": 118,
                    "title": "Version 118: 3 4 2 6; 1 2 5 7; 6 3 9 8; 8 7 9 1; 4 8 3 1; 1 6 5 7; 5 8 6 4; 5 9 2 3; 2 4 7 9"
                },
                {
                    "label": "r119",
                    "value": 119,
                    "title": "Version 119: 8 1 5 4; 7 5 3 6; 3 1 8 2; 6 2 8 9; 9 5 1 2; 4 9 7 3; 1 4 6 3; 7 5 9 6; 2 7 4 8"
                },
                {
                    "label": "r120",
                    "value": 120,
                    "title": "Version 120: 8 4 6 7; 6 3 1 5; 5 3 2 9; 4 2 5 7; 2 8 5 6; 1 9 8 7; 3 1 9 8; 7 3 4 9; 1 6 2 4"
                },
                {
                    "label": "r121",
                    "value": 121,
                    "title": "Version 121: 2 4 8 5; 8 7 3 2; 9 7 4 6; 2 9 6 1; 4 8 9 5; 5 6 9 1; 7 2 1 3; 3 6 8 4; 3 5 7 1"
                },
                {
                    "label": "r122",
                    "value": 122,
                    "title": "Version 122: 6 5 3 7; 9 1 2 8; 9 7 1 4; 5 8 1 7; 1 2 4 6; 6 3 2 5; 8 5 3 4; 7 9 6 8; 4 2 3 9"
                },
                {
                    "label": "r123",
                    "value": 123,
                    "title": "Version 123: 3 1 7 2; 8 4 6 3; 7 4 5 1; 2 6 8 7; 5 3 4 9; 6 9 5 8; 1 2 9 6; 9 8 1 3; 4 7 2 5"
                },
                {
                    "label": "r124",
                    "value": 124,
                    "title": "Version 124: 4 5 7 9; 7 9 3 8; 5 4 9 2; 8 7 2 6; 8 1 5 2; 1 8 6 4; 3 1 6 4; 6 3 7 1; 9 5 2 3"
                },
                {
                    "label": "r125",
                    "value": 125,
                    "title": "Version 125: 3 6 9 5; 2 6 4 9; 2 4 3 7; 5 4 8 1; 4 2 1 3; 9 7 5 6; 9 8 1 2; 6 3 8 7; 1 8 7 5"
                },
                {
                    "label": "r126",
                    "value": 126,
                    "title": "Version 126: 7 2 4 8; 8 9 4 3; 3 5 8 2; 2 1 9 7; 5 3 6 1; 6 5 2 8; 7 9 4 6; 4 6 5 1; 1 7 3 9"
                },
                {
                    "label": "r127",
                    "value": 127,
                    "title": "Version 127: 8 1 9 3; 2 1 6 4; 4 8 9 5; 5 1 7 8; 1 2 7 5; 9 3 4 6; 7 6 3 2; 6 9 8 2; 7 4 5 3"
                },
                {
                    "label": "r128",
                    "value": 128,
                    "title": "Version 128: 4 7 8 9; 5 7 1 4; 3 5 1 6; 1 9 2 5; 6 8 5 4; 6 3 7 8; 3 8 2 9; 2 6 9 7; 3 4 2 1"
                },
                {
                    "label": "r129",
                    "value": 129,
                    "title": "Version 129: 9 2 7 5; 8 9 6 1; 9 1 3 4; 7 6 3 1; 8 7 5 3; 5 2 6 8; 1 4 8 7; 2 5 4 3; 4 2 6 9"
                },
                {
                    "label": "r130",
                    "value": 130,
                    "title": "Version 130: 8 7 1 6; 1 8 9 4; 9 6 1 5; 5 3 8 2; 7 3 5 9; 2 4 7 6; 4 5 6 3; 4 9 2 7; 3 1 2 8"
                },
                {
                    "label": "r131",
                    "value": 131,
                    "title": "Version 131: 6 8 4 2; 6 5 9 1; 2 9 3 1; 5 4 8 9; 1 3 4 2; 2 1 5 7; 7 6 5 8; 3 7 8 9; 7 6 3 4"
                },
                {
                    "label": "r132",
                    "value": 132,
                    "title": "Version 132: 5 4 1 6; 8 3 9 5; 1 2 6 8; 9 2 7 6; 8 7 4 1; 3 1 6 9; 4 8 2 3; 9 5 7 4; 3 7 5 2"
                },
                {
                    "label": "r133",
                    "value": 133,
                    "title": "Version 133: 6 9 3 7; 7 3 8 2; 2 6 1 5; 9 2 4 6; 5 8 6 3; 8 5 2 4; 1 9 4 5; 8 1 9 7; 4 1 3 7"
                },
                {
                    "label": "r134",
                    "value": 134,
                    "title": "Version 134: 2 4 7 5; 6 7 1 3; 6 4 1 8; 3 2 9 6; 7 6 8 4; 9 8 2 5; 5 9 3 4; 1 5 3 2; 9 8 7 1"
                },
                {
                    "label": "r135",
                    "value": 135,
                    "title": "Version 135: 4 3 1 6; 2 6 5 7; 7 9 2 8; 4 1 7 2; 6 3 4 9; 1 5 9 7; 5 4 8 9; 8 2 1 3; 3 5 6 8"
                },
                {
                    "label": "r136",
                    "value": 136,
                    "title": "Version 136: 6 7 8 9; 7 3 5 1; 1 6 4 2; 9 1 6 2; 3 8 9 5; 8 7 3 4; 2 9 4 3; 5 8 1 6; 4 2 5 7"
                },
                {
                    "label": "r137",
                    "value": 137,
                    "title": "Version 137: 5 4 7 6; 3 5 9 1; 7 4 9 1; 6 3 2 5; 5 2 7 8; 2 7 6 3; 4 1 3 8; 9 6 8 4; 1 9 2 8"
                },
                {
                    "label": "r138",
                    "value": 138,
                    "title": "Version 138: 7 6 3 9; 6 7 5 1; 8 2 6 4; 1 3 7 9; 4 5 8 3; 9 4 5 1; 8 1 4 2; 3 8 2 7; 2 9 6 5"
                },
                {
                    "label": "r139",
                    "value": 139,
                    "title": "Version 139: 2 5 1 7; 8 2 1 6; 6 4 3 9; 5 6 4 3; 4 7 1 8; 7 9 2 4; 3 9 5 2; 9 1 8 3; 6 8 7 5"
                },
                {
                    "label": "r140",
                    "value": 140,
                    "title": "Version 140: 2 8 9 6; 1 3 2 4; 8 3 7 5; 9 6 8 7; 7 2 9 4; 3 5 6 1; 1 2 5 9; 4 5 3 8; 1 4 7 6"
                },
                {
                    "label": "r141",
                    "value": 141,
                    "title": "Version 141: 5 7 4 9; 6 7 9 2; 9 1 3 8; 7 4 2 3; 3 1 6 7; 5 8 1 2; 4 8 5 1; 9 6 4 5; 8 2 3 6"
                },
                {
                    "label": "r142",
                    "value": 142,
                    "title": "Version 142: 7 3 8 9; 2 3 5 4; 3 9 2 1; 8 4 9 2; 4 6 8 3; 5 7 6 8; 2 5 1 7; 6 1 4 7; 1 9 5 6"
                },
                {
                    "label": "r143",
                    "value": 143,
                    "title": "Version 143: 2 3 4 6; 8 4 9 5; 4 8 7 1; 6 2 8 1; 1 7 3 9; 5 9 2 6; 3 6 1 4; 7 9 3 5; 2 5 7 8"
                },
                {
                    "label": "r144",
                    "value": 144,
                    "title": "Version 144: 9 1 4 2; 7 2 6 5; 2 4 7 3; 1 6 5 8; 3 5 8 9; 9 7 6 4; 4 8 5 7; 8 1 9 3; 6 1 2 3"
                },
                {
                    "label": "r145",
                    "value": 145,
                    "title": "Version 145: 5 3 4 2; 4 8 6 7; 5 3 9 6; 7 5 1 3; 9 7 2 1; 6 2 8 9; 9 4 1 5; 8 6 1 4; 3 8 7 2"
                },
                {
                    "label": "r146",
                    "value": 146,
                    "title": "Version 146: 4 6 3 8; 1 2 6 7; 3 4 8 2; 7 3 5 1; 2 5 4 1; 7 9 3 6; 5 9 6 4; 8 2 9 5; 1 7 8 9"
                },
                {
                    "label": "r147",
                    "value": 147,
                    "title": "Version 147: 6 1 3 8; 4 6 7 5; 3 8 2 7; 5 1 2 8; 7 3 4 9; 2 4 5 3; 6 7 1 9; 9 1 8 4; 2 9 5 6"
                },
                {
                    "label": "r148",
                    "value": 148,
                    "title": "Version 148: 8 5 6 3; 1 3 9 4; 9 6 3 2; 8 4 2 9; 3 5 7 1; 1 8 5 6; 4 2 1 7; 6 7 4 2; 5 9 7 8"
                },
                {
                    "label": "r149",
                    "value": 149,
                    "title": "Version 149: 8 7 9 6; 1 6 2 5; 7 8 3 5; 2 1 6 4; 4 9 1 8; 6 4 5 3; 3 2 8 7; 9 3 1 2; 5 7 4 9"
                },
                {
                    "label": "r150",
                    "value": 150,
                    "title": "Version 150: 3 5 7 6; 5 2 8 4; 8 3 6 1; 7 4 9 3; 4 1 7 8; 2 9 4 5; 9 6 3 1; 1 5 2 7; 6 8 9 2"
                },
                {
                    "label": "r151",
                    "value": 151,
                    "title": "Version 151: 4 6 7 1; 7 8 6 2; 6 7 4 3; 8 4 1 5; 2 9 3 7; 3 2 1 4; 9 5 8 3; 5 9 2 6; 5 1 9 8"
                },
                {
                    "label": "r152",
                    "value": 152,
                    "title": "Version 152: 4 6 5 9; 1 8 9 7; 9 1 7 2; 7 4 5 9; 8 3 4 2; 2 7 6 8; 3 2 1 5; 6 3 8 4; 1 5 3 6"
                },
                {
                    "label": "r153",
                    "value": 153,
                    "title": "Version 153: 4 8 2 5; 7 2 5 1; 1 6 9 3; 8 1 7 6; 5 7 4 3; 3 4 8 1; 6 9 5 7; 9 2 6 4; 2 3 9 8"
                },
                {
                    "label": "r154",
                    "value": 154,
                    "title": "Version 154: 7 5 6 4; 8 3 2 7; 2 6 3 8; 6 1 4 9; 1 9 3 2; 8 5 1 6; 9 7 3 5; 4 2 7 1; 4 8 5 9"
                },
                {
                    "label": "r155",
                    "value": 155,
                    "title": "Version 155: 5 6 8 1; 6 8 7 9; 5 9 2 6; 3 5 2 7; 7 4 8 1; 1 3 5 2; 2 4 6 3; 9 7 4 8; 3 1 9 4"
                },
                {
                    "label": "r156",
                    "value": 156,
                    "title": "Version 156: 6 9 2 8; 9 2 1 7; 1 4 9 5; 4 6 7 3; 3 1 8 9; 8 3 4 5; 2 5 8 4; 7 5 1 6; 3 7 6 2"
                },
                {
                    "label": "r157",
                    "value": 157,
                    "title": "Version 157: 5 8 6 2; 2 9 4 7; 9 1 3 5; 7 8 9 4; 8 3 5 7; 6 3 5 9; 2 7 1 8; 4 6 3 1; 1 2 4 6"
                },
                {
                    "label": "r158",
                    "value": 158,
                    "title": "Version 158: 5 7 2 6; 9 1 7 3; 1 5 7 8; 3 6 8 9; 6 4 3 7; 4 2 9 3; 8 4 6 5; 8 9 1 2; 5 2 4 1"
                },
                {
                    "label": "r159",
                    "value": 159,
                    "title": "Version 159: 6 9 1 4; 1 8 2 6; 4 5 9 2; 9 8 5 3; 3 1 2 8; 7 6 2 4; 7 9 6 5; 5 3 7 1; 7 4 8 3"
                },
                {
                    "label": "r160",
                    "value": 160,
                    "title": "Version 160: 6 8 1 9; 1 7 3 6; 2 7 5 1; 8 1 7 4; 5 3 4 2; 2 5 9 3; 4 6 8 5; 3 4 6 9; 9 2 7 8"
                },
                {
                    "label": "r161",
                    "value": 161,
                    "title": "Version 161: 4 8 3 7; 8 2 1 5; 7 3 9 6; 5 4 3 1; 9 5 1 7; 3 6 2 8; 6 5 8 9; 1 6 4 2; 2 7 9 4"
                },
                {
                    "label": "r162",
                    "value": 162,
                    "title": "Version 162: 3 8 7 2; 4 1 5 3; 2 7 6 5; 6 9 4 2; 7 5 6 8; 9 4 3 8; 5 9 1 4; 1 7 8 9; 3 2 6 1"
                },
                {
                    "label": "r163",
                    "value": 163,
                    "title": "Version 163: 8 9 2 6; 6 3 5 8; 8 1 5 4; 1 3 2 7; 4 6 7 1; 9 2 3 5; 2 8 4 9; 7 1 9 6; 5 4 7 3"
                },
                {
                    "label": "r164",
                    "value": 164,
                    "title": "Version 164: 9 3 5 1; 1 6 4 2; 6 9 3 1; 4 5 8 7; 5 7 9 6; 3 4 6 8; 8 7 2 3; 7 2 9 4; 2 8 1 5"
                },
                {
                    "label": "r165",
                    "value": 165,
                    "title": "Version 165: 2 4 5 7; 7 5 4 6; 5 6 2 3; 6 1 3 2; 7 3 8 9; 1 8 6 4; 8 9 7 1; 9 3 8 4; 2 1 9 5"
                },
                {
                    "label": "r166",
                    "value": 166,
                    "title": "Version 166: 4 2 3 8; 3 4 1 9; 5 2 6 7; 1 7 5 8; 4 1 2 7; 8 9 2 6; 9 5 4 3; 6 8 5 9; 3 1 7 6"
                },
                {
                    "label": "r167",
                    "value": 167,
                    "title": "Version 167: 9 6 4 7; 3 7 6 5; 4 5 9 2; 1 6 8 4; 7 2 1 8; 5 6 1 9; 8 4 3 2; 9 3 7 2; 3 8 5 1"
                },
                {
                    "label": "r168",
                    "value": 168,
                    "title": "Version 168: 7 9 1 4; 6 4 7 3; 2 1 3 6; 1 3 7 5; 2 9 4 1; 9 5 8 3; 6 8 4 5; 6 2 9 8; 8 7 5 2"
                },
                {
                    "label": "r169",
                    "value": 169,
                    "title": "Version 169: 4 5 8 1; 1 9 2 7; 5 4 2 7; 4 8 6 3; 2 6 5 4; 8 7 3 9; 2 1 9 3; 3 6 9 5; 1 8 6 7"
                },
                {
                    "label": "r170",
                    "value": 170,
                    "title": "Version 170: 4 3 8 1; 6 4 7 9; 5 9 1 8; 9 2 8 6; 7 5 2 9; 8 7 4 3; 3 2 1 5; 7 3 6 5; 6 1 4 2"
                },
                {
                    "label": "r171",
                    "value": 171,
                    "title": "Version 171: 7 2 3 9; 5 4 1 6; 2 3 7 4; 4 9 8 7; 5 6 2 8; 1 8 6 7; 9 1 3 6; 3 5 9 4; 8 2 5 1"
                },
                {
                    "label": "r172",
                    "value": 172,
                    "title": "Version 172: 1 3 4 2; 4 5 3 8; 8 7 1 9; 2 7 5 6; 6 8 9 7; 9 1 4 5; 9 4 2 6; 7 1 5 3; 3 6 8 2"
                },
                {
                    "label": "r173",
                    "value": 173,
                    "title": "Version 173: 5 9 6 3; 4 6 7 1; 1 9 3 2; 3 7 1 8; 2 8 6 3; 8 5 9 4; 5 4 7 2; 6 4 9 1; 7 2 8 5"
                },
                {
                    "label": "r174",
                    "value": 174,
                    "title": "Version 174: 8 3 6 4; 4 7 8 9; 7 1 2 4; 3 6 7 5; 1 7 3 6; 9 5 1 6; 5 3 4 2; 2 8 9 1; 5 2 8 9"
                },
                {
                    "label": "r175",
                    "value": 175,
                    "title": "Version 175: 4 9 2 3; 6 3 5 1; 7 3 2 8; 9 2 6 7; 8 4 1 5; 1 9 4 5; 3 5 7 9; 6 4 8 7; 1 8 2 6"
                },
                {
                    "label": "r176",
                    "value": 176,
                    "title": "Version 176: 5 8 3 4; 3 1 4 7; 2 6 1 4; 7 6 5 2; 2 1 5 8; 8 5 7 9; 2 7 9 1; 6 9 3 8; 9 4 6 3"
                },
                {
                    "label": "r177",
                    "value": 177,
                    "title": "Version 177: 4 5 9 6; 6 1 5 8; 9 6 4 7; 5 3 6 1; 4 2 3 8; 8 7 2 4; 1 9 2 3; 3 2 7 5; 7 8 1 9"
                },
                {
                    "label": "r178",
                    "value": 178,
                    "title": "Version 178: 7 5 6 2; 5 7 9 3; 6 3 8 9; 8 6 7 4; 9 8 1 2; 4 1 5 7; 2 4 9 5; 3 2 1 6; 1 8 4 3"
                },
                {
                    "label": "r179",
                    "value": 179,
                    "title": "Version 179: 4 2 3 7; 7 6 8 1; 6 9 2 4; 1 9 8 6; 8 7 3 5; 5 1 3 4; 3 2 9 8; 2 4 5 6; 9 5 7 1"
                },
                {
                    "label": "r180",
                    "value": 180,
                    "title": "Version 180: 1 3 8 7; 8 4 6 7; 3 1 4 2; 2 6 1 5; 1 7 4 9; 9 3 6 5; 7 9 2 3; 5 8 4 9; 6 5 2 8"
                },
                {
                    "label": "r181",
                    "value": 181,
                    "title": "Version 181: 6 8 5 3; 9 1 8 2; 3 9 5 8; 4 5 7 1; 4 7 6 9; 7 3 1 6; 8 4 2 1; 2 5 7 9; 6 2 3 4"
                },
                {
                    "label": "r182",
                    "value": 182,
                    "title": "Version 182: 8 6 7 2; 7 8 4 3; 4 3 9 1; 5 7 3 1; 2 4 5 8; 1 2 6 9; 9 4 8 5; 5 1 2 6; 3 9 6 7"
                },
                {
                    "label": "r183",
                    "value": 183,
                    "title": "Version 183: 8 6 9 3; 7 8 1 2; 1 3 8 5; 7 2 9 4; 4 7 3 6; 5 9 4 1; 2 5 7 6; 6 1 4 8; 9 3 5 2"
                },
                {
                    "label": "r184",
                    "value": 184,
                    "title": "Version 184: 9 6 5 4; 3 4 1 2; 3 9 2 8; 6 2 3 4; 5 8 1 7; 2 7 9 8; 8 5 7 6; 4 1 5 3; 1 6 9 7"
                },
                {
                    "label": "r185",
                    "value": 185,
                    "title": "Version 185: 3 7 1 9; 2 4 8 5; 7 2 3 5; 5 9 6 3; 1 8 6 9; 4 3 8 7; 9 1 4 7; 6 5 2 1; 8 6 4 2"
                },
                {
                    "label": "r186",
                    "value": 186,
                    "title": "Version 186: 5 6 7 4; 7 2 1 8; 1 8 5 9; 2 5 6 3; 9 4 8 5; 4 9 2 7; 3 1 9 2; 6 7 3 4; 8 6 3 1"
                },
                {
                    "label": "r187",
                    "value": 187,
                    "title": "Version 187: 2 1 4 6; 1 3 8 4; 6 4 1 9; 4 5 7 1; 8 7 5 2; 7 3 6 9; 9 2 5 3; 7 8 2 6; 5 9 3 8"
                },
                {
                    "label": "r188",
                    "value": 188,
                    "title": "Version 188: 4 6 9 5; 3 4 2 8; 8 9 7 4; 3 2 7 1; 6 5 8 3; 5 3 4 7; 9 1 6 2; 1 7 6 5; 9 8 1 2"
                },
                {
                    "label": "r189",
                    "value": 189,
                    "title": "Version 189: 2 4 8 6; 5 8 9 7; 6 9 2 7; 2 5 1 3; 1 6 4 8; 3 1 5 8; 4 2 9 5; 7 3 9 4; 1 7 3 6"
                },
                {
                    "label": "r190",
                    "value": 190,
                    "title": "Version 190: 9 5 7 1; 3 2 6 9; 8 7 5 2; 4 1 8 9; 5 4 2 1; 2 3 4 7; 7 6 8 5; 1 6 3 4; 8 9 3 6"
                },
                {
                    "label": "r191",
                    "value": 191,
                    "title": "Version 191: 6 8 7 1; 6 9 2 5; 9 4 7 3; 4 5 6 2; 8 3 1 9; 2 8 7 1; 7 1 2 3; 5 4 9 6; 3 5 4 8"
                },
                {
                    "label": "r192",
                    "value": 192,
                    "title": "Version 192: 3 2 5 8; 5 7 1 9; 1 3 5 6; 7 5 1 4; 8 6 3 9; 9 8 2 7; 6 8 4 7; 2 1 4 3; 4 9 6 2"
                },
                {
                    "label": "r193",
                    "value": 193,
                    "title": "Version 193: 3 2 8 6; 3 7 9 5; 2 9 5 1; 5 3 8 4; 1 6 5 8; 6 1 3 7; 9 4 1 8; 7 2 9 4; 4 7 6 2"
                },
                {
                    "label": "r194",
                    "value": 194,
                    "title": "Version 194: 8 4 7 6; 4 2 8 3; 8 7 3 9; 2 6 7 5; 9 8 2 1; 1 5 9 6; 7 1 4 5; 6 3 1 9; 5 2 3 4"
                },
                {
                    "label": "r195",
                    "value": 195,
                    "title": "Version 195: 1 8 7 2; 4 9 6 1; 8 6 2 5; 2 9 5 3; 6 1 8 4; 9 5 4 8; 5 3 6 7; 3 7 1 2; 7 4 9 3"
                },
                {
                    "label": "r196",
                    "value": 196,
                    "title": "Version 196: 6 4 5 1; 7 6 8 3; 8 5 7 9; 5 7 3 1; 1 8 2 5; 9 2 6 7; 3 9 4 8; 2 9 4 6; 4 1 3 2"
                },
                {
                    "label": "r197",
                    "value": 197,
                    "title": "Version 197: 5 1 9 8; 9 3 8 6; 3 8 7 4; 2 5 6 3; 7 6 1 9; 4 6 5 7; 5 7 2 4; 8 4 1 2; 1 2 9 3"
                },
                {
                    "label": "r198",
                    "value": 198,
                    "title": "Version 198: 6 1 8 9; 4 3 1 5; 3 4 5 7; 9 5 4 2; 1 3 6 4; 8 2 7 1; 7 8 9 5; 6 7 2 9; 6 2 3 8"
                },
                {
                    "label": "r199",
                    "value": 199,
                    "title": "Version 199: 4 8 7 6; 8 9 5 3; 9 4 1 7; 2 6 8 5; 7 8 2 4; 1 5 9 2; 3 1 7 2; 5 3 6 1; 9 4 3 6"
                },
                {
                    "label": "r200",
                    "value": 200,
                    "title": "Version 200: 1 7 6 5; 3 9 5 8; 2 9 4 3; 4 1 9 7; 5 6 8 7; 7 3 2 9; 6 5 2 4; 2 1 8 6; 8 3 1 4"
                },
                {
                    "label": "r201",
                    "value": 201,
                    "title": "Version 201: 2 7 3 1; 9 2 1 8; 8 7 4 5; 3 8 7 6; 4 2 5 8; 6 9 4 1; 4 6 9 2; 1 5 3 6; 7 9 5 3"
                },
                {
                    "label": "r202",
                    "value": 202,
                    "title": "Version 202: 5 1 2 7; 7 4 6 3; 1 3 4 8; 3 6 8 9; 5 8 9 4; 2 5 1 4; 6 7 9 2; 9 8 7 1; 3 2 6 5"
                },
                {
                    "label": "r203",
                    "value": 203,
                    "title": "Version 203: 8 4 7 2; 8 4 3 2; 1 7 4 9; 7 9 6 5; 6 1 5 4; 2 6 8 1; 6 3 1 7; 9 2 5 3; 5 9 3 8"
                },
                {
                    "label": "r204",
                    "value": 204,
                    "title": "Version 204: 7 5 8 3; 4 5 3 9; 5 4 8 6; 3 7 2 6; 9 2 7 6; 8 6 4 1; 4 1 2 9; 2 3 9 1; 1 8 7 5"
                },
                {
                    "label": "r205",
                    "value": 205,
                    "title": "Version 205: 4 5 6 2; 9 7 6 8; 8 2 1 5; 5 9 1 3; 2 3 9 8; 6 8 4 9; 4 1 3 7; 1 6 5 7; 3 4 7 2"
                },
                {
                    "label": "r206",
                    "value": 206,
                    "title": "Version 206: 3 8 1 4; 7 4 9 5; 7 9 4 3; 9 5 2 1; 8 2 1 6; 1 3 6 9; 2 7 5 4; 6 3 8 5; 7 6 2 8"
                },
                {
                    "label": "r207",
                    "value": 207,
                    "title": "Version 207: 5 1 9 6; 1 4 3 7; 3 6 4 2; 6 9 8 4; 8 7 3 1; 2 5 6 3; 9 2 7 8; 4 1 5 7; 5 8 2 9"
                },
                {
                    "label": "r208",
                    "value": 208,
                    "title": "Version 208: 9 2 6 4; 3 9 1 8; 7 4 9 5; 5 3 8 4; 6 7 1 9; 4 6 3 2; 1 8 7 2; 2 5 8 7; 3 1 5 6"
                },
                {
                    "label": "r209",
                    "value": 209,
                    "title": "Version 209: 8 6 4 1; 8 9 6 7; 4 8 2 1; 6 1 2 5; 2 8 5 3; 7 2 3 9; 9 3 7 4; 5 6 7 3; 5 4 9 1"
                },
                {
                    "label": "r210",
                    "value": 210,
                    "title": "Version 210: 1 5 4 2; 9 7 1 8; 7 1 2 6; 8 5 4 9; 2 9 6 4; 6 7 5 3; 8 3 9 5; 1 2 3 7; 4 3 8 6"
                },
                {
                    "label": "r211",
                    "value": 211,
                    "title": "Version 211: 3 4 2 7; 4 6 1 9; 3 9 6 1; 7 4 1 5; 5 7 4 8; 2 8 3 9; 9 2 5 6; 6 5 8 7; 1 3 2 8"
                },
                {
                    "label": "r212",
                    "value": 212,
                    "title": "Version 212: 3 4 6 2; 8 1 7 3; 6 5 4 3; 1 3 9 5; 2 1 8 5; 4 2 7 9; 9 7 5 2; 7 6 4 8; 1 9 8 6"
                },
                {
                    "label": "r213",
                    "value": 213,
                    "title": "Version 213: 5 7 9 6; 5 2 3 1; 9 6 7 2; 6 1 5 4; 3 4 1 7; 2 8 9 5; 8 9 3 4; 4 8 2 1; 7 6 8 3"
                },
                {
                    "label": "r214",
                    "value": 214,
                    "title": "Version 214: 2 7 6 8; 8 9 3 4; 4 8 6 1; 1 2 9 4; 6 3 1 9; 3 5 7 2; 5 4 8 7; 9 1 7 5; 3 5 2 6"
                },
                {
                    "label": "r215",
                    "value": 215,
                    "title": "Version 215: 7 2 4 6; 2 4 5 1; 6 3 2 8; 9 2 4 3; 5 8 3 9; 7 1 8 3; 1 7 9 5; 8 5 6 4; 6 9 1 7"
                },
                {
                    "label": "r216",
                    "value": 216,
                    "title": "Version 216: 4 7 1 3; 4 9 5 8; 1 6 9 2; 5 1 3 6; 3 5 4 6; 2 4 7 8; 7 5 2 3; 9 8 7 2; 8 6 9 1"
                },
                {
                    "label": "r217",
                    "value": 217,
                    "title": "Version 217: 1 3 8 2; 3 4 6 9; 4 9 5 1; 2 8 5 1; 6 2 4 9; 5 3 8 7; 9 7 3 4; 7 1 6 2; 8 6 7 5"
                },
                {
                    "label": "r218",
                    "value": 218,
                    "title": "Version 218: 4 7 1 8; 1 9 3 6; 9 8 6 7; 7 1 6 5; 5 4 9 8; 3 7 2 4; 2 5 9 3; 8 3 2 1; 6 2 4 5"
                },
                {
                    "label": "r219",
                    "value": 219,
                    "title": "Version 219: 6 1 5 8; 8 5 1 4; 2 9 3 7; 7 5 2 9; 4 3 1 7; 9 2 1 4; 5 6 7 3; 3 4 8 6; 8 6 9 2"
                },
                {
                    "label": "r220",
                    "value": 220,
                    "title": "Version 220: 6 3 4 7; 1 3 5 9; 7 8 4 9; 3 8 9 6; 1 7 6 2; 9 1 8 7; 2 4 5 1; 5 2 3 8; 4 6 2 5"
                },
                {
                    "label": "r221",
                    "value": 221,
                    "title": "Version 221: 8 1 7 2; 1 4 8 3; 2 8 1 4; 7 9 5 6; 9 7 3 5; 5 6 2 8; 4 2 9 3; 6 9 3 1; 6 5 7 4"
                },
                {
                    "label": "r222",
                    "value": 222,
                    "title": "Version 222: 3 7 4 5; 5 8 7 2; 4 8 6 9; 9 5 4 1; 1 4 3 7; 3 1 5 6; 8 2 7 9; 2 3 8 6; 2 6 1 9"
                },
                {
                    "label": "r223",
                    "value": 223,
                    "title": "Version 223: 5 9 8 3; 7 5 2 1; 1 2 6 3; 7 1 3 9; 9 4 2 5; 4 3 2 8; 8 6 4 5; 1 9 6 7; 6 7 4 8"
                },
                {
                    "label": "r224",
                    "value": 224,
                    "title": "Version 224: 6 1 5 7; 5 8 9 1; 3 5 1 8; 3 6 8 4; 1 4 7 2; 4 9 6 2; 2 7 6 3; 9 2 5 3; 7 8 9 4"
                },
                {
                    "label": "r225",
                    "value": 225,
                    "title": "Version 225: 8 9 7 5; 9 3 1 4; 2 3 9 6; 6 2 4 7; 4 6 1 5; 5 1 8 3; 4 5 7 2; 7 9 3 8; 8 1 2 6"
                },
                {
                    "label": "r226",
                    "value": 226,
                    "title": "Version 226: 3 7 5 6; 9 4 5 1; 5 6 8 9; 1 4 9 2; 7 8 6 1; 2 3 6 7; 3 5 2 4; 8 7 4 3; 9 2 1 8"
                },
                {
                    "label": "r227",
                    "value": 227,
                    "title": "Version 227: 4 8 3 9; 6 3 4 1; 8 6 5 4; 6 4 9 7; 7 1 8 2; 1 7 9 5; 3 2 7 1; 2 9 5 6; 5 3 2 8"
                },
                {
                    "label": "r228",
                    "value": 228,
                    "title": "Version 228: 4 2 1 9; 2 9 8 7; 8 5 7 1; 9 5 3 6; 7 8 6 4; 3 6 2 9; 5 4 7 2; 1 5 4 3; 6 1 3 8"
                },
                {
                    "label": "r229",
                    "value": 229,
                    "title": "Version 229: 9 7 6 5; 4 6 1 2; 7 9 1 6; 1 7 9 3; 2 6 5 8; 5 3 4 7; 8 4 3 2; 3 8 4 9; 8 2 1 5"
                },
                {
                    "label": "r230",
                    "value": 230,
                    "title": "Version 230: 9 7 8 5; 8 1 7 4; 6 1 5 3; 6 8 2 3; 3 6 1 7; 5 2 9 4; 4 9 8 6; 7 3 5 2; 2 4 9 1"
                },
                {
                    "label": "r231",
                    "value": 231,
                    "title": "Version 231: 1 9 3 8; 3 5 4 1; 7 1 2 8; 4 5 6 9; 2 3 7 5; 6 7 8 4; 9 4 3 7; 1 2 6 9; 5 8 2 6"
                },
                {
                    "label": "r232",
                    "value": 232,
                    "title": "Version 232: 8 1 9 6; 9 8 2 5; 6 2 4 3; 3 9 7 2; 1 6 5 4; 3 7 6 8; 5 8 1 9; 2 4 1 7; 4 3 7 5"
                },
                {
                    "label": "r233",
                    "value": 233,
                    "title": "Version 233: 7 6 9 1; 7 5 8 4; 5 4 2 9; 2 1 3 8; 1 3 4 8; 6 7 5 2; 8 9 2 3; 9 6 3 7; 4 5 6 1"
                },
                {
                    "label": "r234",
                    "value": 234,
                    "title": "Version 234: 7 2 8 6; 8 7 4 9; 2 3 5 1; 3 9 8 5; 6 4 3 9; 9 7 1 4; 5 8 6 3; 5 2 7 1; 1 6 4 2"
                },
                {
                    "label": "r235",
                    "value": 235,
                    "title": "Version 235: 4 8 2 6; 6 2 9 3; 9 4 3 2; 1 5 8 9; 8 1 3 7; 3 1 7 6; 7 9 5 2; 4 5 1 8; 6 7 4 5"
                },
                {
                    "label": "r236",
                    "value": 236,
                    "title": "Version 236: 8 6 9 1; 2 1 6 4; 9 3 6 5; 4 8 9 7; 5 3 2 1; 7 2 8 6; 1 9 2 7; 3 5 4 8; 5 4 7 3"
                },
                {
                    "label": "r237",
                    "value": 237,
                    "title": "Version 237: 2 8 3 4; 3 5 1 9; 9 4 5 2; 4 9 2 7; 6 7 9 5; 8 1 7 3; 1 6 3 4; 7 1 6 8; 2 8 5 6"
                },
                {
                    "label": "r238",
                    "value": 238,
                    "title": "Version 238: 3 2 8 9; 2 9 1 6; 1 2 7 4; 7 3 5 2; 8 3 4 6; 6 9 1 3; 5 4 8 1; 9 7 5 8; 4 5 6 7"
                },
                {
                    "label": "r239",
                    "value": 239,
                    "title": "Version 239: 2 4 8 7; 1 3 9 5; 5 6 9 8; 4 7 6 1; 3 6 1 5; 8 2 4 9; 7 9 3 4; 6 7 2 3; 1 5 8 2"
                },
                {
                    "label": "r240",
                    "value": 240,
                    "title": "Version 240: 2 8 6 5; 9 5 7 4; 7 1 9 8; 5 6 1 4; 4 1 2 9; 8 4 7 3; 9 8 3 6; 6 3 5 2; 3 1 2 7"
                },
                {
                    "label": "r241",
                    "value": 241,
                    "title": "Version 241: 9 2 6 7; 2 9 8 1; 1 7 5 8; 6 2 4 5; 7 5 9 3; 3 4 1 2; 8 5 7 6; 6 3 4 9; 4 8 3 1"
                },
                {
                    "label": "r242",
                    "value": 242,
                    "title": "Version 242: 5 9 1 2; 2 3 8 7; 1 4 9 5; 4 6 7 9; 3 1 7 5; 9 6 4 8; 7 2 6 3; 8 6 3 1; 5 8 2 4"
                },
                {
                    "label": "r243",
                    "value": 243,
                    "title": "Version 243: 4 7 9 3; 9 3 5 8; 2 8 3 6; 6 4 1 7; 1 9 5 7; 2 1 6 9; 5 8 4 6; 8 2 7 1; 3 5 2 4"
                },
                {
                    "label": "r244",
                    "value": 244,
                    "title": "Version 244: 7 1 8 9; 3 9 5 2; 1 3 9 6; 5 7 2 4; 8 5 7 6; 6 4 3 5; 4 2 9 8; 7 6 1 2; 1 8 4 3"
                },
                {
                    "label": "r245",
                    "value": 245,
                    "title": "Version 245: 9 4 6 2; 6 9 3 5; 4 7 5 1; 6 2 8 1; 7 3 4 8; 9 7 2 3; 5 1 8 4; 3 5 1 2; 8 6 7 9"
                },
                {
                    "label": "r246",
                    "value": 246,
                    "title": "Version 246: 1 3 4 7; 3 7 6 8; 4 6 3 9; 2 5 7 3; 8 1 5 9; 9 5 1 6; 4 2 6 1; 2 4 9 8; 5 2 8 7"
                },
                {
                    "label": "r247",
                    "value": 247,
                    "title": "Version 247: 6 8 5 4; 3 9 4 1; 7 8 3 9; 1 4 2 5; 9 6 4 7; 2 1 7 6; 5 3 6 8; 7 9 2 5; 8 1 2 3"
                },
                {
                    "label": "r248",
                    "value": 248,
                    "title": "Version 248: 3 4 8 2; 8 2 9 4; 4 7 6 2; 7 3 1 4; 1 6 3 5; 9 8 1 6; 5 7 6 8; 9 5 7 1; 2 9 5 3"
                },
                {
                    "label": "r249",
                    "value": 249,
                    "title": "Version 249: 1 8 9 2; 2 9 4 3; 6 1 8 7; 7 3 8 5; 5 2 3 6; 5 7 9 4; 4 3 8 1; 6 2 1 7; 4 5 6 9"
                },
                {
                    "label": "r250",
                    "value": 250,
                    "title": "Version 250: 6 4 3 1; 2 1 5 3; 3 6 7 9; 9 7 2 5; 8 5 1 4; 7 8 5 4; 6 4 2 7; 1 9 2 8; 8 6 3 9"
                },
                {
                    "label": "r251",
                    "value": 251,
                    "title": "Version 251: 3 1 4 7; 5 6 4 2; 3 7 9 1; 7 9 1 8; 2 4 8 7; 8 5 2 6; 8 2 6 3; 4 3 9 5; 9 5 1 6"
                },
                {
                    "label": "r252",
                    "value": 252,
                    "title": "Version 252: 1 6 7 2; 9 8 3 4; 2 8 7 9; 1 9 6 4; 4 2 9 6; 3 4 5 1; 5 3 7 8; 6 1 8 5; 7 5 2 3"
                },
                {
                    "label": "r253",
                    "value": 253,
                    "title": "Version 253: 6 7 4 8; 9 6 5 2; 5 9 4 7; 8 4 3 2; 2 7 1 3; 3 8 6 5; 4 1 7 6; 1 5 9 8; 3 2 1 9"
                },
                {
                    "label": "r254",
                    "value": 254,
                    "title": "Version 254: 7 2 5 1; 1 7 8 9; 5 9 8 6; 2 1 5 4; 9 4 8 2; 6 3 4 1; 8 3 2 6; 9 6 3 7; 4 3 7 5"
                },
                {
                    "label": "r255",
                    "value": 255,
                    "title": "Version 255: 1 6 9 2; 7 8 5 3; 3 1 2 8; 8 9 3 4; 2 7 6 9; 6 4 1 7; 7 2 4 5; 5 9 6 3; 4 5 8 1"
                },
                {
                    "label": "r256",
                    "value": 256,
                    "title": "Version 256: 1 2 9 3; 2 8 5 6; 6 1 3 5; 9 5 2 4; 8 4 7 2; 7 3 9 4; 4 6 1 8; 3 8 6 7; 5 7 1 9"
                },
                {
                    "label": "r257",
                    "value": 257,
                    "title": "Version 257: 9 7 4 6; 5 9 3 8; 6 5 4 8; 7 3 5 2; 8 9 5 1; 1 2 4 3; 2 3 6 7; 6 4 9 1; 7 8 2 1"
                },
                {
                    "label": "r258",
                    "value": 258,
                    "title": "Version 258: 4 6 2 5; 3 4 8 2; 5 2 7 9; 4 8 9 7; 5 1 3 4; 1 5 7 6; 8 1 7 9; 2 6 9 3; 3 6 1 8"
                },
                {
                    "label": "r259",
                    "value": 259,
                    "title": "Version 259: 1 4 8 2; 8 7 6 5; 7 5 1 3; 9 1 4 3; 4 7 2 6; 2 8 9 1; 3 9 6 7; 9 3 5 4; 6 2 8 5"
                },
                {
                    "label": "r260",
                    "value": 260,
                    "title": "Version 260: 1 7 3 8; 2 8 5 9; 3 2 1 6; 6 9 2 3; 9 5 1 2; 7 3 8 4; 4 6 7 5; 5 1 4 7; 8 4 6 9"
                },
                {
                    "label": "r261",
                    "value": 261,
                    "title": "Version 261: 2 5 3 4; 6 4 2 1; 8 2 9 7; 9 1 8 3; 3 8 4 5; 5 6 7 9; 4 9 7 1; 7 3 6 2; 1 8 5 6"
                },
                {
                    "label": "r262",
                    "value": 262,
                    "title": "Version 262: 6 4 3 9; 5 6 3 8; 3 7 1 2; 9 7 5 3; 4 1 8 6; 2 4 8 7; 8 2 4 9; 7 5 6 1; 1 9 2 5"
                },
                {
                    "label": "r263",
                    "value": 263,
                    "title": "Version 263: 7 5 2 4; 4 7 9 6; 5 3 4 1; 9 6 5 2; 5 4 1 8; 3 2 7 8; 2 3 1 6; 6 8 3 9; 1 9 8 7"
                },
                {
                    "label": "r264",
                    "value": 264,
                    "title": "Version 264: 8 2 9 4; 9 1 6 7; 2 1 8 5; 6 5 2 4; 8 6 7 3; 7 9 4 3; 3 9 5 1; 2 8 3 5; 1 7 6 4"
                },
                {
                    "label": "r265",
                    "value": 265,
                    "title": "Version 265: 1 3 9 5; 9 6 1 8; 6 7 3 2; 4 5 7 8; 8 1 2 7; 8 4 9 6; 3 2 4 1; 5 3 6 4; 7 5 2 9"
                },
                {
                    "label": "r266",
                    "value": 266,
                    "title": "Version 266: 4 8 5 9; 4 8 3 7; 1 9 4 2; 3 9 8 6; 6 2 5 8; 2 1 7 6; 5 6 1 7; 7 3 9 5; 4 2 3 1"
                },
                {
                    "label": "r267",
                    "value": 267,
                    "title": "Version 267: 9 4 6 1; 1 7 8 5; 9 8 7 2; 9 1 2 3; 6 3 7 4; 2 4 6 5; 7 4 8 3; 8 5 1 6; 5 3 9 2"
                },
                {
                    "label": "r268",
                    "value": 268,
                    "title": "Version 268: 4 6 5 9; 3 7 4 5; 3 2 6 8; 5 8 3 1; 1 4 9 8; 6 1 7 3; 7 9 2 8; 2 5 6 9; 1 7 4 2"
                },
                {
                    "label": "r269",
                    "value": 269,
                    "title": "Version 269: 2 6 3 4; 3 9 5 7; 8 2 1 4; 4 5 9 2; 6 3 1 8; 9 1 4 5; 8 7 2 6; 5 8 7 1; 7 6 3 9"
                },
                {
                    "label": "r270",
                    "value": 270,
                    "title": "Version 270: 8 4 5 3; 5 3 2 1; 4 2 1 7; 7 6 8 4; 1 9 2 3; 9 8 5 6; 2 7 6 5; 8 3 4 9; 6 1 9 7"
                },
                {
                    "label": "r271",
                    "value": 271,
                    "title": "Version 271: 7 9 8 2; 3 6 4 1; 4 5 3 2; 6 8 2 3; 9 4 6 1; 1 3 9 7; 2 7 5 4; 5 1 8 6; 7 5 8 9"
                },
                {
                    "label": "r272",
                    "value": 272,
                    "title": "Version 272: 3 4 7 8; 6 2 1 7; 1 2 9 8; 2 7 3 5; 3 9 4 8; 9 6 4 2; 4 1 5 7; 3 5 6 9; 8 5 1 6"
                },
                {
                    "label": "r273",
                    "value": 273,
                    "title": "Version 273: 6 4 2 3; 5 6 7 9; 9 8 1 2; 1 8 7 4; 7 5 9 4; 5 1 3 6; 8 2 6 4; 9 7 1 3; 3 8 5 2"
                },
                {
                    "label": "r274",
                    "value": 274,
                    "title": "Version 274: 2 9 7 6; 2 3 9 1; 4 1 3 9; 1 2 4 5; 5 2 8 7; 6 7 8 3; 4 7 6 8; 4 9 5 6; 8 3 5 1"
                },
                {
                    "label": "r275",
                    "value": 275,
                    "title": "Version 275: 3 6 4 8; 6 4 2 1; 7 3 9 4; 7 1 6 5; 5 6 2 8; 8 4 5 9; 9 5 7 3; 9 8 1 2; 2 3 1 7"
                },
                {
                    "label": "r276",
                    "value": 276,
                    "title": "Version 276: 2 9 8 4; 1 7 4 5; 7 8 3 1; 3 1 4 6; 1 6 8 9; 6 2 7 9; 8 9 3 5; 4 5 2 7; 5 6 3 2"
                },
                {
                    "label": "r277",
                    "value": 277,
                    "title": "Version 277: 8 5 2 3; 6 2 9 7; 5 4 8 1; 3 4 7 8; 9 1 6 5; 4 3 6 9; 7 9 1 2; 2 5 4 3; 1 8 7 6"
                },
                {
                    "label": "r278",
                    "value": 278,
                    "title": "Version 278: 1 9 5 4; 4 7 8 6; 2 8 9 3; 5 6 1 2; 7 4 2 8; 3 7 9 1; 6 3 5 7; 1 2 3 4; 8 9 6 5"
                },
                {
                    "label": "r279",
                    "value": 279,
                    "title": "Version 279: 9 5 7 8; 5 2 9 4; 4 1 2 8; 9 1 5 3; 2 4 6 7; 8 1 3 2; 3 6 7 5; 7 8 1 6; 6 3 4 9"
                },
                {
                    "label": "r280",
                    "value": 280,
                    "title": "Version 280: 5 7 8 9; 8 5 3 2; 3 7 8 4; 2 7 5 1; 9 2 6 3; 6 4 1 5; 1 6 2 9; 7 3 4 1; 8 9 4 6"
                },
                {
                    "label": "r281",
                    "value": 281,
                    "title": "Version 281: 6 8 3 7; 7 5 2 1; 4 7 9 5; 1 8 6 3; 2 6 5 8; 9 3 7 2; 4 9 1 2; 8 1 9 4; 5 4 3 6"
                },
                {
                    "label": "r282",
                    "value": 282,
                    "title": "Version 282: 6 2 4 7; 9 6 8 1; 4 8 2 5; 7 5 1 4; 3 1 9 7; 4 9 6 3; 3 5 8 1; 2 9 7 8; 5 2 3 6"
                },
                {
                    "label": "r283",
                    "value": 283,
                    "title": "Version 283: 2 3 4 7; 1 7 5 6; 3 4 1 9; 1 2 6 8; 9 7 5 8; 5 3 2 9; 7 8 3 2; 6 4 9 5; 8 1 6 4"
                },
                {
                    "label": "r284",
                    "value": 284,
                    "title": "Version 284: 1 2 8 4; 2 5 1 3; 3 6 8 9; 8 9 5 2; 8 3 7 4; 9 6 7 2; 6 1 3 5; 4 9 6 7; 7 4 5 1"
                },
                {
                    "label": "r285",
                    "value": 285,
                    "title": "Version 285: 5 8 7 6; 7 5 8 3; 9 2 4 1; 1 3 9 7; 5 6 2 4; 1 8 9 5; 4 8 2 3; 6 4 3 9; 2 1 7 6"
                },
                {
                    "label": "r286",
                    "value": 286,
                    "title": "Version 286: 3 9 2 6; 4 7 1 5; 6 1 2 7; 9 5 1 3; 7 9 4 8; 5 6 8 4; 7 2 9 8; 2 4 3 5; 3 8 6 1"
                },
                {
                    "label": "r287",
                    "value": 287,
                    "title": "Version 287: 7 3 5 2; 8 5 4 6; 3 7 6 1; 5 2 6 9; 4 3 8 1; 1 9 8 2; 8 7 9 5; 6 1 4 9; 2 4 7 3"
                },
                {
                    "label": "r288",
                    "value": 288,
                    "title": "Version 288: 9 5 1 2; 9 3 5 8; 2 8 9 7; 3 6 2 4; 5 4 3 6; 1 6 2 8; 4 7 6 9; 8 1 7 3; 4 1 5 7"
                },
                {
                    "label": "r289",
                    "value": 289,
                    "title": "Version 289: 8 4 1 5; 6 8 4 7; 5 2 7 1; 1 5 9 3; 3 6 1 8; 9 2 5 4; 2 3 8 6; 7 9 4 2; 6 7 3 9"
                },
                {
                    "label": "r290",
                    "value": 290,
                    "title": "Version 290: 3 7 5 4; 4 3 1 2; 2 4 7 1; 5 6 9 8; 8 5 2 6; 9 8 4 3; 7 9 3 6; 1 2 8 9; 6 1 7 5"
                },
                {
                    "label": "r291",
                    "value": 291,
                    "title": "Version 291: 1 2 6 4; 8 3 5 7; 3 8 2 7; 4 5 8 6; 7 4 9 2; 9 4 1 8; 6 1 7 9; 2 6 3 5; 5 3 9 1"
                },
                {
                    "label": "r292",
                    "value": 292,
                    "title": "Version 292: 8 7 5 2; 2 9 6 3; 3 9 4 1; 6 8 4 1; 5 6 7 9; 4 9 2 5; 7 1 6 5; 1 2 8 3; 8 7 3 4"
                },
                {
                    "label": "r293",
                    "value": 293,
                    "title": "Version 293: 6 3 2 7; 9 7 1 8; 9 5 1 3; 5 8 4 2; 9 4 8 6; 7 6 1 2; 1 6 3 4; 4 5 9 7; 2 3 5 8"
                },
                {
                    "label": "r294",
                    "value": 294,
                    "title": "Version 294: 3 4 5 9; 3 8 4 7; 4 2 6 9; 5 1 2 4; 7 5 6 1; 2 9 8 1; 6 2 3 5; 8 7 9 6; 1 3 7 8"
                },
                {
                    "label": "r295",
                    "value": 295,
                    "title": "Version 295: 2 7 5 9; 7 8 6 4; 7 4 2 3; 4 2 8 5; 5 1 9 3; 3 1 7 4; 6 5 1 8; 8 6 3 9; 9 1 2 6"
                },
                {
                    "label": "r296",
                    "value": 296,
                    "title": "Version 296: 1 3 4 2; 2 9 3 6; 5 6 8 7; 1 2 7 8; 3 8 6 2; 4 5 1 7; 9 7 5 3; 8 9 4 5; 6 4 9 1"
                },
                {
                    "label": "r297",
                    "value": 297,
                    "title": "Version 297: 6 9 4 8; 9 7 2 3; 2 6 5 1; 3 4 6 5; 7 2 4 6; 5 1 7 3; 1 8 9 7; 4 8 9 2; 8 3 5 1"
                },
                {
                    "label": "r298",
                    "value": 298,
                    "title": "Version 298: 6 5 1 4; 8 4 3 6; 2 5 1 9; 5 2 8 7; 1 4 8 2; 4 3 7 9; 9 1 6 7; 7 6 2 3; 3 9 8 5"
                },
                {
                    "label": "r299",
                    "value": 299,
                    "title": "Version 299: 4 7 5 8; 6 7 3 1; 2 5 6 4; 1 2 3 8; 5 7 4 9; 9 6 2 8; 3 9 5 6; 7 1 9 2; 8 3 1 4"
                },
                {
                    "label": "r300",
                    "value": 300,
                    "title": "Version 300: 2 9 7 4; 3 8 9 5; 5 2 6 1; 6 5 8 7; 4 3 2 5; 8 6 1 9; 7 8 3 2; 9 4 1 3; 1 4 7 6"
                }
            ],
            "flags": "xt",
            "qlabel": "Q22_version",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "variables": [
                {
                    "vgroup": "Q22_1",
                    "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "colTitle": "Most convincing",
                    "title": "Most convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "rowTitle": null,
                    "label": "Q22_1c1",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Creates good-paying jobs, and strengthens America’s economy"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Homegrown power that frees us from dependence on foreign countries"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "A dependable and predictable source of power that will always be available when we need it"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                        },
                        {
                            "label": "r7",
                            "value": 7,
                            "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                        },
                        {
                            "label": "r8",
                            "value": 8,
                            "title": "The power source that can fuel America’s growth in AI"
                        },
                        {
                            "label": "r9",
                            "value": 9,
                            "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": "c1",
                    "qlabel": "Q22_1"
                },
                {
                    "vgroup": "Q22_1",
                    "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "colTitle": "Least convincing",
                    "title": "Least convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "rowTitle": null,
                    "label": "Q22_1c2",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Creates good-paying jobs, and strengthens America’s economy"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Homegrown power that frees us from dependence on foreign countries"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "A dependable and predictable source of power that will always be available when we need it"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                        },
                        {
                            "label": "r7",
                            "value": 7,
                            "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                        },
                        {
                            "label": "r8",
                            "value": 8,
                            "title": "The power source that can fuel America’s growth in AI"
                        },
                        {
                            "label": "r9",
                            "value": 9,
                            "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": "c2",
                    "qlabel": "Q22_1"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "flags": "t",
            "qlabel": "Q22_1",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "variables": [
                {
                    "vgroup": "Q22_2",
                    "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "colTitle": "Most convincing",
                    "title": "Most convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "rowTitle": null,
                    "label": "Q22_2c1",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Creates good-paying jobs, and strengthens America’s economy"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Homegrown power that frees us from dependence on foreign countries"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "A dependable and predictable source of power that will always be available when we need it"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                        },
                        {
                            "label": "r7",
                            "value": 7,
                            "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                        },
                        {
                            "label": "r8",
                            "value": 8,
                            "title": "The power source that can fuel America’s growth in AI"
                        },
                        {
                            "label": "r9",
                            "value": 9,
                            "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": "c1",
                    "qlabel": "Q22_2"
                },
                {
                    "vgroup": "Q22_2",
                    "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "colTitle": "Least convincing",
                    "title": "Least convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "rowTitle": null,
                    "label": "Q22_2c2",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Creates good-paying jobs, and strengthens America’s economy"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Homegrown power that frees us from dependence on foreign countries"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "A dependable and predictable source of power that will always be available when we need it"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                        },
                        {
                            "label": "r7",
                            "value": 7,
                            "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                        },
                        {
                            "label": "r8",
                            "value": 8,
                            "title": "The power source that can fuel America’s growth in AI"
                        },
                        {
                            "label": "r9",
                            "value": 9,
                            "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": "c2",
                    "qlabel": "Q22_2"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "flags": "t",
            "qlabel": "Q22_2",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "variables": [
                {
                    "vgroup": "Q22_3",
                    "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "colTitle": "Most convincing",
                    "title": "Most convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "rowTitle": null,
                    "label": "Q22_3c1",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Creates good-paying jobs, and strengthens America’s economy"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Homegrown power that frees us from dependence on foreign countries"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "A dependable and predictable source of power that will always be available when we need it"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                        },
                        {
                            "label": "r7",
                            "value": 7,
                            "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                        },
                        {
                            "label": "r8",
                            "value": 8,
                            "title": "The power source that can fuel America’s growth in AI"
                        },
                        {
                            "label": "r9",
                            "value": 9,
                            "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": "c1",
                    "qlabel": "Q22_3"
                },
                {
                    "vgroup": "Q22_3",
                    "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "colTitle": "Least convincing",
                    "title": "Least convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "rowTitle": null,
                    "label": "Q22_3c2",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Creates good-paying jobs, and strengthens America’s economy"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Homegrown power that frees us from dependence on foreign countries"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "A dependable and predictable source of power that will always be available when we need it"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                        },
                        {
                            "label": "r7",
                            "value": 7,
                            "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                        },
                        {
                            "label": "r8",
                            "value": 8,
                            "title": "The power source that can fuel America’s growth in AI"
                        },
                        {
                            "label": "r9",
                            "value": 9,
                            "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": "c2",
                    "qlabel": "Q22_3"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "flags": "t",
            "qlabel": "Q22_3",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "variables": [
                {
                    "vgroup": "Q22_4",
                    "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "colTitle": "Most convincing",
                    "title": "Most convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "rowTitle": null,
                    "label": "Q22_4c1",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Creates good-paying jobs, and strengthens America’s economy"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Homegrown power that frees us from dependence on foreign countries"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "A dependable and predictable source of power that will always be available when we need it"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                        },
                        {
                            "label": "r7",
                            "value": 7,
                            "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                        },
                        {
                            "label": "r8",
                            "value": 8,
                            "title": "The power source that can fuel America’s growth in AI"
                        },
                        {
                            "label": "r9",
                            "value": 9,
                            "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": "c1",
                    "qlabel": "Q22_4"
                },
                {
                    "vgroup": "Q22_4",
                    "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "colTitle": "Least convincing",
                    "title": "Least convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "rowTitle": null,
                    "label": "Q22_4c2",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Creates good-paying jobs, and strengthens America’s economy"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Homegrown power that frees us from dependence on foreign countries"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "A dependable and predictable source of power that will always be available when we need it"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                        },
                        {
                            "label": "r7",
                            "value": 7,
                            "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                        },
                        {
                            "label": "r8",
                            "value": 8,
                            "title": "The power source that can fuel America’s growth in AI"
                        },
                        {
                            "label": "r9",
                            "value": 9,
                            "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": "c2",
                    "qlabel": "Q22_4"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "flags": "t",
            "qlabel": "Q22_4",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "variables": [
                {
                    "vgroup": "Q22_5",
                    "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "colTitle": "Most convincing",
                    "title": "Most convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "rowTitle": null,
                    "label": "Q22_5c1",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Creates good-paying jobs, and strengthens America’s economy"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Homegrown power that frees us from dependence on foreign countries"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "A dependable and predictable source of power that will always be available when we need it"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                        },
                        {
                            "label": "r7",
                            "value": 7,
                            "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                        },
                        {
                            "label": "r8",
                            "value": 8,
                            "title": "The power source that can fuel America’s growth in AI"
                        },
                        {
                            "label": "r9",
                            "value": 9,
                            "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": "c1",
                    "qlabel": "Q22_5"
                },
                {
                    "vgroup": "Q22_5",
                    "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "colTitle": "Least convincing",
                    "title": "Least convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "rowTitle": null,
                    "label": "Q22_5c2",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Creates good-paying jobs, and strengthens America’s economy"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Homegrown power that frees us from dependence on foreign countries"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "A dependable and predictable source of power that will always be available when we need it"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                        },
                        {
                            "label": "r7",
                            "value": 7,
                            "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                        },
                        {
                            "label": "r8",
                            "value": 8,
                            "title": "The power source that can fuel America’s growth in AI"
                        },
                        {
                            "label": "r9",
                            "value": 9,
                            "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": "c2",
                    "qlabel": "Q22_5"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "flags": "t",
            "qlabel": "Q22_5",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "variables": [
                {
                    "vgroup": "Q22_6",
                    "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "colTitle": "Most convincing",
                    "title": "Most convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "rowTitle": null,
                    "label": "Q22_6c1",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Creates good-paying jobs, and strengthens America’s economy"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Homegrown power that frees us from dependence on foreign countries"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "A dependable and predictable source of power that will always be available when we need it"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                        },
                        {
                            "label": "r7",
                            "value": 7,
                            "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                        },
                        {
                            "label": "r8",
                            "value": 8,
                            "title": "The power source that can fuel America’s growth in AI"
                        },
                        {
                            "label": "r9",
                            "value": 9,
                            "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": "c1",
                    "qlabel": "Q22_6"
                },
                {
                    "vgroup": "Q22_6",
                    "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "colTitle": "Least convincing",
                    "title": "Least convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "rowTitle": null,
                    "label": "Q22_6c2",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Creates good-paying jobs, and strengthens America’s economy"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Homegrown power that frees us from dependence on foreign countries"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "A dependable and predictable source of power that will always be available when we need it"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                        },
                        {
                            "label": "r7",
                            "value": 7,
                            "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                        },
                        {
                            "label": "r8",
                            "value": 8,
                            "title": "The power source that can fuel America’s growth in AI"
                        },
                        {
                            "label": "r9",
                            "value": 9,
                            "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": "c2",
                    "qlabel": "Q22_6"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "flags": "t",
            "qlabel": "Q22_6",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "variables": [
                {
                    "vgroup": "Q22_7",
                    "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "colTitle": "Most convincing",
                    "title": "Most convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "rowTitle": null,
                    "label": "Q22_7c1",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Creates good-paying jobs, and strengthens America’s economy"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Homegrown power that frees us from dependence on foreign countries"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "A dependable and predictable source of power that will always be available when we need it"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                        },
                        {
                            "label": "r7",
                            "value": 7,
                            "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                        },
                        {
                            "label": "r8",
                            "value": 8,
                            "title": "The power source that can fuel America’s growth in AI"
                        },
                        {
                            "label": "r9",
                            "value": 9,
                            "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": "c1",
                    "qlabel": "Q22_7"
                },
                {
                    "vgroup": "Q22_7",
                    "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "colTitle": "Least convincing",
                    "title": "Least convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "rowTitle": null,
                    "label": "Q22_7c2",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Creates good-paying jobs, and strengthens America’s economy"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Homegrown power that frees us from dependence on foreign countries"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "A dependable and predictable source of power that will always be available when we need it"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                        },
                        {
                            "label": "r7",
                            "value": 7,
                            "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                        },
                        {
                            "label": "r8",
                            "value": 8,
                            "title": "The power source that can fuel America’s growth in AI"
                        },
                        {
                            "label": "r9",
                            "value": 9,
                            "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": "c2",
                    "qlabel": "Q22_7"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "flags": "t",
            "qlabel": "Q22_7",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "variables": [
                {
                    "vgroup": "Q22_8",
                    "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "colTitle": "Most convincing",
                    "title": "Most convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "rowTitle": null,
                    "label": "Q22_8c1",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Creates good-paying jobs, and strengthens America’s economy"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Homegrown power that frees us from dependence on foreign countries"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "A dependable and predictable source of power that will always be available when we need it"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                        },
                        {
                            "label": "r7",
                            "value": 7,
                            "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                        },
                        {
                            "label": "r8",
                            "value": 8,
                            "title": "The power source that can fuel America’s growth in AI"
                        },
                        {
                            "label": "r9",
                            "value": 9,
                            "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": "c1",
                    "qlabel": "Q22_8"
                },
                {
                    "vgroup": "Q22_8",
                    "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "colTitle": "Least convincing",
                    "title": "Least convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "rowTitle": null,
                    "label": "Q22_8c2",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Creates good-paying jobs, and strengthens America’s economy"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Homegrown power that frees us from dependence on foreign countries"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "A dependable and predictable source of power that will always be available when we need it"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                        },
                        {
                            "label": "r7",
                            "value": 7,
                            "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                        },
                        {
                            "label": "r8",
                            "value": 8,
                            "title": "The power source that can fuel America’s growth in AI"
                        },
                        {
                            "label": "r9",
                            "value": 9,
                            "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": "c2",
                    "qlabel": "Q22_8"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "flags": "t",
            "qlabel": "Q22_8",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
            "variables": [
                {
                    "vgroup": "Q22_9",
                    "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "colTitle": "Most convincing",
                    "title": "Most convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "rowTitle": null,
                    "label": "Q22_9c1",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Creates good-paying jobs, and strengthens America’s economy"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Homegrown power that frees us from dependence on foreign countries"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "A dependable and predictable source of power that will always be available when we need it"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                        },
                        {
                            "label": "r7",
                            "value": 7,
                            "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                        },
                        {
                            "label": "r8",
                            "value": 8,
                            "title": "The power source that can fuel America’s growth in AI"
                        },
                        {
                            "label": "r9",
                            "value": 9,
                            "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": "c1",
                    "qlabel": "Q22_9"
                },
                {
                    "vgroup": "Q22_9",
                    "qtitle": "<div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "colTitle": "Least convincing",
                    "title": "Least convincing - <div><span>Different people describe renewable energy in different ways. Below you will see sets of statements describing renewable energy. In each set, please select the ONE description that is <strong>most convincing</strong> to you and the ONE that is <strong>least convincing</strong>. </span></div>",
                    "rowTitle": null,
                    "label": "Q22_9c2",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Creates good-paying jobs, and strengthens America’s economy"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Homegrown power that frees us from dependence on foreign countries"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "A dependable and predictable source of power that will always be available when we need it"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                        },
                        {
                            "label": "r7",
                            "value": 7,
                            "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                        },
                        {
                            "label": "r8",
                            "value": 8,
                            "title": "The power source that can fuel America’s growth in AI"
                        },
                        {
                            "label": "r9",
                            "value": 9,
                            "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": "c2",
                    "qlabel": "Q22_9"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Creates good-paying jobs, and strengthens America’s economy"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Homegrown power that frees us from dependence on foreign countries"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "A dependable and predictable source of power that will always be available when we need it"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Healthy energy that reduces air pollution and makes our communities safer to live in"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "A critical part of reducing greenhouse gas emissions and combating climate change"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Strengthens local communities by paying billions in landowner lease payments and state and local taxes"
                },
                {
                    "label": "r7",
                    "value": 7,
                    "title": "A critical energy source for America to lead in the global technology and manufacturing race"
                },
                {
                    "label": "r8",
                    "value": 8,
                    "title": "The power source that can fuel America’s growth in AI"
                },
                {
                    "label": "r9",
                    "value": 9,
                    "title": "Abundant and inexhaustible, sources like the sun, wind, and water will never run out"
                }
            ],
            "flags": "t",
            "qlabel": "Q22_9",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "When you hear the term \"clean energy,\" which of the following comes closest to your view?",
            "variables": [
                {
                    "vgroup": "Q23",
                    "qtitle": "When you hear the term \"clean energy,\" which of the following comes closest to your view?",
                    "colTitle": null,
                    "title": "When you hear the term \"clean energy,\" which of the following comes closest to your view?",
                    "rowTitle": null,
                    "label": "Q23",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "It is strongly associated with the Democratic Party"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "It is somewhat associated with the Democratic Party"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "It is associated with both parties equally"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "It is somewhat associated with the Republican Party"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "It is strongly associated with the Republican Party"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q23"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "It is strongly associated with the Democratic Party"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "It is somewhat associated with the Democratic Party"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "It is associated with both parties equally"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "It is somewhat associated with the Republican Party"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "It is strongly associated with the Republican Party"
                }
            ],
            "qlabel": "Q23",
            "type": "single",
            "grouping": "cols"
        },
        {
            "variables": [
                {
                    "vgroup": "Q24",
                    "qtitle": "When you hear the term \"clean energy,\" what does it mean to you personally?",
                    "colTitle": null,
                    "title": "When you hear the term \"clean energy,\" what does it mean to you personally?",
                    "rowTitle": null,
                    "label": "Q24",
                    "row": null,
                    "type": "text",
                    "col": null,
                    "qlabel": "Q24"
                }
            ],
            "grouping": "rows",
            "type": "text",
            "qtitle": "When you hear the term \"clean energy,\" what does it mean to you personally?",
            "qlabel": "Q24"
        },
        {
            "qtitle": "Which of the following do you see as the biggest threat to the growth of clean energy in the U.S.?",
            "variables": [
                {
                    "vgroup": "Q30",
                    "qtitle": "Which of the following do you see as the biggest threat to the growth of clean energy in the U.S.?",
                    "colTitle": null,
                    "title": "Which of the following do you see as the biggest threat to the growth of clean energy in the U.S.?",
                    "rowTitle": null,
                    "label": "Q30",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Higher costs for consumers"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Unreliable and inconsistent supply"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "Dependence on foreign countries for energy or materials"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Political opposition and polarization"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "Lack of technological innovation"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Other, please specify"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q30"
                },
                {
                    "vgroup": "Q30r6oe",
                    "qtitle": "Which of the following do you see as the biggest threat to the growth of clean energy in the U.S.?",
                    "colTitle": null,
                    "title": "Which of the following do you see as the biggest threat to the growth of clean energy in the U.S.? - Other, please specify",
                    "rowTitle": "Other, please specify",
                    "label": "Q30r6oe",
                    "row": "r6",
                    "type": "text",
                    "col": null,
                    "qlabel": "Q30"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Higher costs for consumers"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Unreliable and inconsistent supply"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Dependence on foreign countries for energy or materials"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Political opposition and polarization"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "Lack of technological innovation"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Other, please specify"
                }
            ],
            "qlabel": "Q30",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "Do you think adding more clean energy to the grid makes the system...",
            "variables": [
                {
                    "vgroup": "Q31",
                    "qtitle": "Do you think adding more clean energy to the grid makes the system...",
                    "colTitle": null,
                    "title": "Do you think adding more clean energy to the grid makes the system...",
                    "rowTitle": null,
                    "label": "Q31",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Stronger and more reliable overall because it adds new supply, reduces dependence on fossil fuels, and modernizes the grid."
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Stronger in some ways but more strained in others, because it provides more supply but also puts pressure on the grid and requires major new infrastructure."
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "Weaker and less reliable overall because renewables make the grid more vulnerable to shortages and disruptions."
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q31"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Stronger and more reliable overall because it adds new supply, reduces dependence on fossil fuels, and modernizes the grid."
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Stronger in some ways but more strained in others, because it provides more supply but also puts pressure on the grid and requires major new infrastructure."
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Weaker and less reliable overall because renewables make the grid more vulnerable to shortages and disruptions."
                }
            ],
            "qlabel": "Q31",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "Please read the following statements and select the one that comes the closest to your own opinion.",
            "variables": [
                {
                    "vgroup": "Q32",
                    "qtitle": "Please read the following statements and select the one that comes the closest to your own opinion.",
                    "colTitle": null,
                    "title": "Please read the following statements and select the one that comes the closest to your own opinion.",
                    "rowTitle": null,
                    "label": "Q32",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "I fully support all types of clean energy projects being built in my community. Clean energy infrastructure from wind turbines to solar farms will only serve to benefit my local community and the environment by reducing our reliance on fossil fuels."
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "I have mixed feelings about clean energy projects being built in my community. I recognize the importance of transitioning away from fossil fuels to more clean energy sources, but I worry about how it will look, the noise it may produce, and impacts on local infrastructure."
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "I have mixed feelings about clean energy projects being built near me. I don't worry about how they look or the noise they make, but I'm most concerned with whether the energy generated from that project will benefit me directly, or if the energy produced will get transported elsewhere. I don't want an energy project built near me if I won't benefit directly from it."
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "I am fully opposed to any and all clean energy infrastructure projects being built near me. There is nothing companies can say about the jobs they will produce, their positive impact on our local climate, and positive impacts on local energy prices that would persuade me to support it."
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q32"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "I fully support all types of clean energy projects being built in my community. Clean energy infrastructure from wind turbines to solar farms will only serve to benefit my local community and the environment by reducing our reliance on fossil fuels."
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "I have mixed feelings about clean energy projects being built in my community. I recognize the importance of transitioning away from fossil fuels to more clean energy sources, but I worry about how it will look, the noise it may produce, and impacts on local infrastructure."
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "I have mixed feelings about clean energy projects being built near me. I don't worry about how they look or the noise they make, but I'm most concerned with whether the energy generated from that project will benefit me directly, or if the energy produced will get transported elsewhere. I don't want an energy project built near me if I won't benefit directly from it."
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "I am fully opposed to any and all clean energy infrastructure projects being built near me. There is nothing companies can say about the jobs they will produce, their positive impact on our local climate, and positive impacts on local energy prices that would persuade me to support it."
                }
            ],
            "qlabel": "Q32",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "Please read the below statements and select the one that comes the closest to your own opinion.",
            "variables": [
                {
                    "vgroup": "Q33",
                    "qtitle": "Please read the below statements and select the one that comes the closest to your own opinion.",
                    "colTitle": null,
                    "title": "Please read the below statements and select the one that comes the closest to your own opinion.",
                    "rowTitle": null,
                    "label": "Q33",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Once an energy project has already been permitted, it should be allowed to move forward. Reversing or cancelling permitted projects deters investment by reducing business leaders' confidence in the reliability of America's government."
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Presidential administrations should re-examine and, if necessary, stop energy projects that, in their view, don't benefit America, even if those projects have already received permits from a prior administration and begun construction."
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q33"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Once an energy project has already been permitted, it should be allowed to move forward. Reversing or cancelling permitted projects deters investment by reducing business leaders' confidence in the reliability of America's government."
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Presidential administrations should re-examine and, if necessary, stop energy projects that, in their view, don't benefit America, even if those projects have already received permits from a prior administration and begun construction."
                }
            ],
            "qlabel": "Q33",
            "type": "single",
            "grouping": "cols"
        },
        {
            "variables": [
                {
                    "vgroup": "Q34",
                    "qtitle": "What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
                    "colTitle": null,
                    "title": "Lower energy bills or guaranteed local energy savings - What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
                    "rowTitle": "Lower energy bills or guaranteed local energy savings",
                    "label": "Q34r1",
                    "value": 1,
                    "row": "r1",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q34"
                },
                {
                    "vgroup": "Q34",
                    "qtitle": "What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
                    "colTitle": null,
                    "title": "More local jobs created by the project - What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
                    "rowTitle": "More local jobs created by the project",
                    "label": "Q34r2",
                    "value": 1,
                    "row": "r2",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q34"
                },
                {
                    "vgroup": "Q34",
                    "qtitle": "What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
                    "colTitle": null,
                    "title": "Clear evidence that the project will be safe, quiet, and not disruptive - What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
                    "rowTitle": "Clear evidence that the project will be safe, quiet, and not disruptive",
                    "label": "Q34r3",
                    "value": 1,
                    "row": "r3",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q34"
                },
                {
                    "vgroup": "Q34",
                    "qtitle": "What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
                    "colTitle": null,
                    "title": "Strong protections for property values and local land use - What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
                    "rowTitle": "Strong protections for property values and local land use",
                    "label": "Q34r4",
                    "value": 1,
                    "row": "r4",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q34"
                },
                {
                    "vgroup": "Q34",
                    "qtitle": "What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
                    "colTitle": null,
                    "title": "Reduced pollution in the area - What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
                    "rowTitle": "Reduced pollution in the area",
                    "label": "Q34r5",
                    "value": 1,
                    "row": "r5",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q34"
                },
                {
                    "vgroup": "Q34",
                    "qtitle": "What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
                    "colTitle": null,
                    "title": "Local ownership or community investment opportunities - What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
                    "rowTitle": "Local ownership or community investment opportunities",
                    "label": "Q34r6",
                    "value": 1,
                    "row": "r6",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q34"
                },
                {
                    "vgroup": "Q34",
                    "qtitle": "What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
                    "colTitle": null,
                    "title": "Assurance that the energy generated will directly benefit my community - What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
                    "rowTitle": "Assurance that the energy generated will directly benefit my community",
                    "label": "Q34r7",
                    "value": 1,
                    "row": "r7",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q34"
                },
                {
                    "vgroup": "Q34",
                    "qtitle": "What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
                    "colTitle": null,
                    "title": "Transparency and open communication from developers and government officials - What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
                    "rowTitle": "Transparency and open communication from developers and government officials",
                    "label": "Q34r8",
                    "value": 1,
                    "row": "r8",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q34"
                },
                {
                    "vgroup": "Q34",
                    "qtitle": "What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
                    "colTitle": null,
                    "title": "None of the above - What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
                    "rowTitle": "None of the above",
                    "label": "Q34r9",
                    "value": 1,
                    "row": "r9",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q34"
                }
            ],
            "grouping": "cols",
            "type": "multiple",
            "qtitle": "What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?",
            "qlabel": "Q34"
        },
        {
            "qtitle": "Personally, do you consider yourself to be a(n)",
            "variables": [
                {
                    "vgroup": "Q35",
                    "qtitle": "Personally, do you consider yourself to be a(n)",
                    "colTitle": null,
                    "title": "Personally, do you consider yourself to be a(n)",
                    "rowTitle": null,
                    "label": "Q35",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Strong Republican"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Moderate Republican"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "Independent"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Moderate Democrat"
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "Strong Democrat"
                        },
                        {
                            "label": "r6",
                            "value": 6,
                            "title": "Other"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q35"
                },
                {
                    "vgroup": "Q35r6oe",
                    "qtitle": "Personally, do you consider yourself to be a(n)",
                    "colTitle": null,
                    "title": "Personally, do you consider yourself to be a(n) - Other",
                    "rowTitle": "Other",
                    "label": "Q35r6oe",
                    "row": "r6",
                    "type": "text",
                    "col": null,
                    "qlabel": "Q35"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Strong Republican"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Moderate Republican"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Independent"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Moderate Democrat"
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "Strong Democrat"
                },
                {
                    "label": "r6",
                    "value": 6,
                    "title": "Other"
                }
            ],
            "qlabel": "Q35",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "Which of the following best describes you?",
            "variables": [
                {
                    "vgroup": "Q36",
                    "qtitle": "Which of the following best describes you?",
                    "colTitle": null,
                    "title": "Which of the following best describes you?",
                    "rowTitle": null,
                    "label": "Q36",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Emphasizes strong national borders, America-first policies, economic nationalism, and a focus on reducing government regulation."
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Emphasizes limited government, free-market principles, and a strong national defense."
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "Emphasizes preserving traditional values, promoting family-oriented policies, and advocating for religious freedoms."
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Emphasizes individual liberties, minimal government intervention, and free-market solutions."
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "Emphasizes a middle ground on various issues, advocating for bipartisan solutions and cooperation."
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q36"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Emphasizes strong national borders, America-first policies, economic nationalism, and a focus on reducing government regulation."
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Emphasizes limited government, free-market principles, and a strong national defense."
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Emphasizes preserving traditional values, promoting family-oriented policies, and advocating for religious freedoms."
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Emphasizes individual liberties, minimal government intervention, and free-market solutions."
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "Emphasizes a middle ground on various issues, advocating for bipartisan solutions and cooperation."
                }
            ],
            "qlabel": "Q36",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "Which of the following best describes you?",
            "variables": [
                {
                    "vgroup": "Q37",
                    "qtitle": "Which of the following best describes you?",
                    "colTitle": null,
                    "title": "Which of the following best describes you?",
                    "rowTitle": null,
                    "label": "Q37",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Emphasizes social justice, climate action, economic equality, and comprehensive healthcare reform."
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Emphasizes pragmatic policies, maintaining party unity, and incremental reforms."
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "Emphasizes expanding social welfare programs, workers' rights, and reducing income inequality."
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Emphasizes centrist policies, bipartisan cooperation, and practical solutions to issues like healthcare, education, and economic stability."
                        },
                        {
                            "label": "r5",
                            "value": 5,
                            "title": "Emphasizes civil rights, immigration reform, and policies that support minority communities."
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q37"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Emphasizes social justice, climate action, economic equality, and comprehensive healthcare reform."
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Emphasizes pragmatic policies, maintaining party unity, and incremental reforms."
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Emphasizes expanding social welfare programs, workers' rights, and reducing income inequality."
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Emphasizes centrist policies, bipartisan cooperation, and practical solutions to issues like healthcare, education, and economic stability."
                },
                {
                    "label": "r5",
                    "value": 5,
                    "title": "Emphasizes civil rights, immigration reform, and policies that support minority communities."
                }
            ],
            "qlabel": "Q37",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "What type of community do you live in?",
            "variables": [
                {
                    "vgroup": "Q38",
                    "qtitle": "What type of community do you live in?",
                    "colTitle": null,
                    "title": "What type of community do you live in?",
                    "rowTitle": null,
                    "label": "Q38",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Large city"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Suburb near a large city"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "Small city or town"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "Rural area"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q38"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Large city"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Suburb near a large city"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Small city or town"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "Rural area"
                }
            ],
            "qlabel": "Q38",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "How frequently do others come to you for your opinion or advice on the following topics?",
            "variables": [
                {
                    "vgroup": "Q39",
                    "qtitle": "How frequently do others come to you for your opinion or advice on the following topics?",
                    "colTitle": null,
                    "title": "Geopolitical issues (e.g., US-China issues, trade tensions, rise in populism) - How frequently do others come to you for your opinion or advice on the following topics?",
                    "rowTitle": "Geopolitical issues (e.g., US-China issues, trade tensions, rise in populism)",
                    "label": "Q39r1",
                    "values": [
                        {
                            "label": "c1",
                            "value": 1,
                            "title": "All the time"
                        },
                        {
                            "label": "c2",
                            "value": 2,
                            "title": "Quite often"
                        },
                        {
                            "label": "c3",
                            "value": 3,
                            "title": "Sometimes"
                        },
                        {
                            "label": "c4",
                            "value": 4,
                            "title": "Seldom or rarely"
                        },
                        {
                            "label": "c5",
                            "value": 5,
                            "title": "Never"
                        }
                    ],
                    "row": "r1",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q39"
                },
                {
                    "vgroup": "Q39",
                    "qtitle": "How frequently do others come to you for your opinion or advice on the following topics?",
                    "colTitle": null,
                    "title": "Domestic policy and regulation - How frequently do others come to you for your opinion or advice on the following topics?",
                    "rowTitle": "Domestic policy and regulation",
                    "label": "Q39r2",
                    "values": [
                        {
                            "label": "c1",
                            "value": 1,
                            "title": "All the time"
                        },
                        {
                            "label": "c2",
                            "value": 2,
                            "title": "Quite often"
                        },
                        {
                            "label": "c3",
                            "value": 3,
                            "title": "Sometimes"
                        },
                        {
                            "label": "c4",
                            "value": 4,
                            "title": "Seldom or rarely"
                        },
                        {
                            "label": "c5",
                            "value": 5,
                            "title": "Never"
                        }
                    ],
                    "row": "r2",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q39"
                },
                {
                    "vgroup": "Q39",
                    "qtitle": "How frequently do others come to you for your opinion or advice on the following topics?",
                    "colTitle": null,
                    "title": "Economic issues (e.g., Overall state of the economy, tax policy, inflation) - How frequently do others come to you for your opinion or advice on the following topics?",
                    "rowTitle": "Economic issues (e.g., Overall state of the economy, tax policy, inflation)",
                    "label": "Q39r3",
                    "values": [
                        {
                            "label": "c1",
                            "value": 1,
                            "title": "All the time"
                        },
                        {
                            "label": "c2",
                            "value": 2,
                            "title": "Quite often"
                        },
                        {
                            "label": "c3",
                            "value": 3,
                            "title": "Sometimes"
                        },
                        {
                            "label": "c4",
                            "value": 4,
                            "title": "Seldom or rarely"
                        },
                        {
                            "label": "c5",
                            "value": 5,
                            "title": "Never"
                        }
                    ],
                    "row": "r3",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q39"
                },
                {
                    "vgroup": "Q39",
                    "qtitle": "How frequently do others come to you for your opinion or advice on the following topics?",
                    "colTitle": null,
                    "title": "Environmental sustainability/climate change - How frequently do others come to you for your opinion or advice on the following topics?",
                    "rowTitle": "Environmental sustainability/climate change",
                    "label": "Q39r4",
                    "values": [
                        {
                            "label": "c1",
                            "value": 1,
                            "title": "All the time"
                        },
                        {
                            "label": "c2",
                            "value": 2,
                            "title": "Quite often"
                        },
                        {
                            "label": "c3",
                            "value": 3,
                            "title": "Sometimes"
                        },
                        {
                            "label": "c4",
                            "value": 4,
                            "title": "Seldom or rarely"
                        },
                        {
                            "label": "c5",
                            "value": 5,
                            "title": "Never"
                        }
                    ],
                    "row": "r4",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q39"
                },
                {
                    "vgroup": "Q39",
                    "qtitle": "How frequently do others come to you for your opinion or advice on the following topics?",
                    "colTitle": null,
                    "title": "Energy - How frequently do others come to you for your opinion or advice on the following topics?",
                    "rowTitle": "Energy",
                    "label": "Q39r5",
                    "values": [
                        {
                            "label": "c1",
                            "value": 1,
                            "title": "All the time"
                        },
                        {
                            "label": "c2",
                            "value": 2,
                            "title": "Quite often"
                        },
                        {
                            "label": "c3",
                            "value": 3,
                            "title": "Sometimes"
                        },
                        {
                            "label": "c4",
                            "value": 4,
                            "title": "Seldom or rarely"
                        },
                        {
                            "label": "c5",
                            "value": 5,
                            "title": "Never"
                        }
                    ],
                    "row": "r5",
                    "type": "single",
                    "col": null,
                    "qlabel": "Q39"
                }
            ],
            "values": [
                {
                    "label": "c1",
                    "value": 1,
                    "title": "All the time"
                },
                {
                    "label": "c2",
                    "value": 2,
                    "title": "Quite often"
                },
                {
                    "label": "c3",
                    "value": 3,
                    "title": "Sometimes"
                },
                {
                    "label": "c4",
                    "value": 4,
                    "title": "Seldom or rarely"
                },
                {
                    "label": "c5",
                    "value": 5,
                    "title": "Never"
                }
            ],
            "qlabel": "Q39",
            "type": "single",
            "grouping": "rows"
        },
        {
            "variables": [
                {
                    "vgroup": "Q40",
                    "qtitle": "Which, if any, of the following generally describe you?",
                    "colTitle": null,
                    "title": "Business entrepreneur (someone who has set up a business which uses new ideas or new techniques or targets a new market) - Which, if any, of the following generally describe you?",
                    "rowTitle": "Business entrepreneur (someone who has set up a business which uses new ideas or new techniques or targets a new market)",
                    "label": "Q40r1",
                    "value": 1,
                    "row": "r1",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q40"
                },
                {
                    "vgroup": "Q40",
                    "qtitle": "Which, if any, of the following generally describe you?",
                    "colTitle": null,
                    "title": "Social entrepreneur (someone who has set up a charity or not-for-profit organization which uses new ideas or new techniques or helps a new group) - Which, if any, of the following generally describe you?",
                    "rowTitle": "Social entrepreneur (someone who has set up a charity or not-for-profit organization which uses new ideas or new techniques or helps a new group)",
                    "label": "Q40r2",
                    "value": 1,
                    "row": "r2",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q40"
                },
                {
                    "vgroup": "Q40",
                    "qtitle": "Which, if any, of the following generally describe you?",
                    "colTitle": null,
                    "title": "Religious leader (priest, rabbi, imam, guru, etc.) - Which, if any, of the following generally describe you?",
                    "rowTitle": "Religious leader (priest, rabbi, imam, guru, etc.)",
                    "label": "Q40r3",
                    "value": 1,
                    "row": "r3",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q40"
                },
                {
                    "vgroup": "Q40",
                    "qtitle": "Which, if any, of the following generally describe you?",
                    "colTitle": null,
                    "title": "Organizer of national or local civic activities (e.g., public or community events, community action) - Which, if any, of the following generally describe you?",
                    "rowTitle": "Organizer of national or local civic activities (e.g., public or community events, community action)",
                    "label": "Q40r4",
                    "value": 1,
                    "row": "r4",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q40"
                },
                {
                    "vgroup": "Q40",
                    "qtitle": "Which, if any, of the following generally describe you?",
                    "colTitle": null,
                    "title": "Organizer of national or local social activities (e.g., children's group, sports club, voluntary group) - Which, if any, of the following generally describe you?",
                    "rowTitle": "Organizer of national or local social activities (e.g., children's group, sports club, voluntary group)",
                    "label": "Q40r5",
                    "value": 1,
                    "row": "r5",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q40"
                },
                {
                    "vgroup": "Q40",
                    "qtitle": "Which, if any, of the following generally describe you?",
                    "colTitle": null,
                    "title": "Journalist, writer or blogger (at least weekly) on news, public affairs, business or community issues - Which, if any, of the following generally describe you?",
                    "rowTitle": "Journalist, writer or blogger (at least weekly) on news, public affairs, business or community issues",
                    "label": "Q40r6",
                    "value": 1,
                    "row": "r6",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q40"
                },
                {
                    "vgroup": "Q40",
                    "qtitle": "Which, if any, of the following generally describe you?",
                    "colTitle": null,
                    "title": "Stood for public office in the past 10 years (e.g., election to local council, MP, magistrate) - Which, if any, of the following generally describe you?",
                    "rowTitle": "Stood for public office in the past 10 years (e.g., election to local council, MP, magistrate)",
                    "label": "Q40r7",
                    "value": 1,
                    "row": "r7",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q40"
                },
                {
                    "vgroup": "Q40",
                    "qtitle": "Which, if any, of the following generally describe you?",
                    "colTitle": null,
                    "title": "Community leader - Which, if any, of the following generally describe you?",
                    "rowTitle": "Community leader",
                    "label": "Q40r8",
                    "value": 1,
                    "row": "r8",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q40"
                },
                {
                    "vgroup": "Q40",
                    "qtitle": "Which, if any, of the following generally describe you?",
                    "colTitle": null,
                    "title": "None of these - Which, if any, of the following generally describe you?",
                    "rowTitle": "None of these",
                    "label": "Q40r9",
                    "value": 1,
                    "row": "r9",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q40"
                }
            ],
            "grouping": "cols",
            "type": "multiple",
            "qtitle": "Which, if any, of the following generally describe you?",
            "qlabel": "Q40"
        },
        {
            "variables": [
                {
                    "vgroup": "Q41",
                    "qtitle": "And which, if any, of the following also generally describe you?",
                    "colTitle": null,
                    "title": "Active member of a large society, business association or professional body - And which, if any, of the following also generally describe you?",
                    "rowTitle": "Active member of a large society, business association or professional body",
                    "label": "Q41r1",
                    "value": 1,
                    "row": "r1",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q41"
                },
                {
                    "vgroup": "Q41",
                    "qtitle": "And which, if any, of the following also generally describe you?",
                    "colTitle": null,
                    "title": "Director of a large business (more than 250 employees) - And which, if any, of the following also generally describe you?",
                    "rowTitle": "Director of a large business (more than 250 employees)",
                    "label": "Q41r2",
                    "value": 1,
                    "row": "r2",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q41"
                },
                {
                    "vgroup": "Q41",
                    "qtitle": "And which, if any, of the following also generally describe you?",
                    "colTitle": null,
                    "title": "Director of a small or medium sized business (less than 250 employees) - And which, if any, of the following also generally describe you?",
                    "rowTitle": "Director of a small or medium sized business (less than 250 employees)",
                    "label": "Q41r3",
                    "value": 1,
                    "row": "r3",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q41"
                },
                {
                    "vgroup": "Q41",
                    "qtitle": "And which, if any, of the following also generally describe you?",
                    "colTitle": null,
                    "title": "Director of a charity, NGO or non-governmental education or health organization (e.g., university, private school) - And which, if any, of the following also generally describe you?",
                    "rowTitle": "Director of a charity, NGO or non-governmental education or health organization (e.g., university, private school)",
                    "label": "Q41r4",
                    "value": 1,
                    "row": "r4",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q41"
                },
                {
                    "vgroup": "Q41",
                    "qtitle": "And which, if any, of the following also generally describe you?",
                    "colTitle": null,
                    "title": "Director of a public sector organization (e.g., central or local government department, agency, service, hospital, school, CCG) - And which, if any, of the following also generally describe you?",
                    "rowTitle": "Director of a public sector organization (e.g., central or local government department, agency, service, hospital, school, CCG)",
                    "label": "Q41r5",
                    "value": 1,
                    "row": "r5",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q41"
                },
                {
                    "vgroup": "Q41",
                    "qtitle": "And which, if any, of the following also generally describe you?",
                    "colTitle": null,
                    "title": "Been publicly recognized for my work (e.g., finalist or winner of a major award) - And which, if any, of the following also generally describe you?",
                    "rowTitle": "Been publicly recognized for my work (e.g., finalist or winner of a major award)",
                    "label": "Q41r6",
                    "value": 1,
                    "row": "r6",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q41"
                },
                {
                    "vgroup": "Q41",
                    "qtitle": "And which, if any, of the following also generally describe you?",
                    "colTitle": null,
                    "title": "Hold a trustee or governor's role of a significant organization (e.g., large charity, school) - And which, if any, of the following also generally describe you?",
                    "rowTitle": "Hold a trustee or governor's role of a significant organization (e.g., large charity, school)",
                    "label": "Q41r7",
                    "value": 1,
                    "row": "r7",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q41"
                },
                {
                    "vgroup": "Q41",
                    "qtitle": "And which, if any, of the following also generally describe you?",
                    "colTitle": null,
                    "title": "None of these - And which, if any, of the following also generally describe you?",
                    "rowTitle": "None of these",
                    "label": "Q41r8",
                    "value": 1,
                    "row": "r8",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q41"
                }
            ],
            "grouping": "cols",
            "type": "multiple",
            "qtitle": "And which, if any, of the following also generally describe you?",
            "qlabel": "Q41"
        },
        {
            "variables": [
                {
                    "vgroup": "Q42",
                    "qtitle": "And again which, if any, of the following apply to you personally?",
                    "colTitle": null,
                    "title": "Have over 500 connections on LinkedIn - And again which, if any, of the following apply to you personally?",
                    "rowTitle": "Have over 500 connections on LinkedIn",
                    "label": "Q42r1",
                    "value": 1,
                    "row": "r1",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q42"
                },
                {
                    "vgroup": "Q42",
                    "qtitle": "And again which, if any, of the following apply to you personally?",
                    "colTitle": null,
                    "title": "Have over 500 friends on Facebook - And again which, if any, of the following apply to you personally?",
                    "rowTitle": "Have over 500 friends on Facebook",
                    "label": "Q42r2",
                    "value": 1,
                    "row": "r2",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q42"
                },
                {
                    "vgroup": "Q42",
                    "qtitle": "And again which, if any, of the following apply to you personally?",
                    "colTitle": null,
                    "title": "Use Twitter at least daily to read tweets about news, public affairs, politics, business or community issues - And again which, if any, of the following apply to you personally?",
                    "rowTitle": "Use Twitter at least daily to read tweets about news, public affairs, politics, business or community issues",
                    "label": "Q42r3",
                    "value": 1,
                    "row": "r3",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q42"
                },
                {
                    "vgroup": "Q42",
                    "qtitle": "And again which, if any, of the following apply to you personally?",
                    "colTitle": null,
                    "title": "Use Twitter at least daily to tweet about news, public affairs, politics, business or community issues - And again which, if any, of the following apply to you personally?",
                    "rowTitle": "Use Twitter at least daily to tweet about news, public affairs, politics, business or community issues",
                    "label": "Q42r4",
                    "value": 1,
                    "row": "r4",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q42"
                },
                {
                    "vgroup": "Q42",
                    "qtitle": "And again which, if any, of the following apply to you personally?",
                    "colTitle": null,
                    "title": "Read a national newspaper at least three times a week - And again which, if any, of the following apply to you personally?",
                    "rowTitle": "Read a national newspaper at least three times a week",
                    "label": "Q42r5",
                    "value": 1,
                    "row": "r5",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q42"
                },
                {
                    "vgroup": "Q42",
                    "qtitle": "And again which, if any, of the following apply to you personally?",
                    "colTitle": null,
                    "title": "Read a business, news or current affairs magazine at least once a month - And again which, if any, of the following apply to you personally?",
                    "rowTitle": "Read a business, news or current affairs magazine at least once a month",
                    "label": "Q42r6",
                    "value": 1,
                    "row": "r6",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q42"
                },
                {
                    "vgroup": "Q42",
                    "qtitle": "And again which, if any, of the following apply to you personally?",
                    "colTitle": null,
                    "title": "Watch the news on TV or listen on the radio every day - And again which, if any, of the following apply to you personally?",
                    "rowTitle": "Watch the news on TV or listen on the radio every day",
                    "label": "Q42r7",
                    "value": 1,
                    "row": "r7",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q42"
                },
                {
                    "vgroup": "Q42",
                    "qtitle": "And again which, if any, of the following apply to you personally?",
                    "colTitle": null,
                    "title": "Written a published paper, article or book (excluding self-published items such as blogs or eBooks) - And again which, if any, of the following apply to you personally?",
                    "rowTitle": "Written a published paper, article or book (excluding self-published items such as blogs or eBooks)",
                    "label": "Q42r8",
                    "value": 1,
                    "row": "r8",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q42"
                },
                {
                    "vgroup": "Q42",
                    "qtitle": "And again which, if any, of the following apply to you personally?",
                    "colTitle": null,
                    "title": "None of these - And again which, if any, of the following apply to you personally?",
                    "rowTitle": "None of these",
                    "label": "Q42r9",
                    "value": 1,
                    "row": "r9",
                    "type": "multiple",
                    "col": null,
                    "qlabel": "Q42"
                }
            ],
            "grouping": "cols",
            "type": "multiple",
            "qtitle": "And again which, if any, of the following apply to you personally?",
            "qlabel": "Q42"
        },
        {
            "qtitle": "Regardless of how you feel about the candidates today, for whom did you vote for in the 2024 presidential election?",
            "variables": [
                {
                    "vgroup": "Q43",
                    "qtitle": "Regardless of how you feel about the candidates today, for whom did you vote for in the 2024 presidential election?",
                    "colTitle": null,
                    "title": "Regardless of how you feel about the candidates today, for whom did you vote for in the 2024 presidential election?",
                    "rowTitle": null,
                    "label": "Q43",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Donald Trump, the Republican candidate"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Kamala Harris, the Democratic candidate"
                        },
                        {
                            "label": "r3",
                            "value": 3,
                            "title": "Someone else"
                        },
                        {
                            "label": "r4",
                            "value": 4,
                            "title": "I did not vote"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "Q43"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Donald Trump, the Republican candidate"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Kamala Harris, the Democratic candidate"
                },
                {
                    "label": "r3",
                    "value": 3,
                    "title": "Someone else"
                },
                {
                    "label": "r4",
                    "value": 4,
                    "title": "I did not vote"
                }
            ],
            "qlabel": "Q43",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "FINAL DATA VALIDITY STATUS (QUALITY CONTROL)",
            "variables": [
                {
                    "vgroup": "dvfail",
                    "qtitle": "FINAL DATA VALIDITY STATUS (QUALITY CONTROL)",
                    "colTitle": null,
                    "title": "FINAL DATA VALIDITY STATUS (QUALITY CONTROL)",
                    "rowTitle": null,
                    "label": "dvfail",
                    "values": [
                        {
                            "label": "r1",
                            "value": 1,
                            "title": "Data Validity Fail"
                        },
                        {
                            "label": "r2",
                            "value": 2,
                            "title": "Data Validity Pass"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "dvfail"
                }
            ],
            "values": [
                {
                    "label": "r1",
                    "value": 1,
                    "title": "Data Validity Fail"
                },
                {
                    "label": "r2",
                    "value": 2,
                    "title": "Data Validity Pass"
                }
            ],
            "flags": "x",
            "qlabel": "dvfail",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "Crosstabs - Oct 2025",
            "variables": [
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "Total",
                    "title": "Total - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c1",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c1",
                    "qlabel": "vctq1"
                },
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "Trump",
                    "title": "Trump - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c2",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c2",
                    "qlabel": "vctq1"
                },
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "Harris",
                    "title": "Harris - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c3",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c3",
                    "qlabel": "vctq1"
                },
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "Independent",
                    "title": "Independent - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c4",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c4",
                    "qlabel": "vctq1"
                },
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "Dem",
                    "title": "Dem - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c5",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c5",
                    "qlabel": "vctq1"
                },
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "GOP",
                    "title": "GOP - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c6",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c6",
                    "qlabel": "vctq1"
                },
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "MAGA/Trump Republican",
                    "title": "MAGA/Trump Republican - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c7",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c7",
                    "qlabel": "vctq1"
                },
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "Non-MAGA GOP",
                    "title": "Non-MAGA GOP - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c8",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c8",
                    "qlabel": "vctq1"
                },
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "Traditional Republican",
                    "title": "Traditional Republican - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c9",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c9",
                    "qlabel": "vctq1"
                },
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "Social Conservative",
                    "title": "Social Conservative - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c10",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c10",
                    "qlabel": "vctq1"
                },
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "Libertarian Republican",
                    "title": "Libertarian Republican - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c11",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c11",
                    "qlabel": "vctq1"
                },
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "Moderate Republican",
                    "title": "Moderate Republican - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c12",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c12",
                    "qlabel": "vctq1"
                },
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "Progressive Democrat",
                    "title": "Progressive Democrat - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c13",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c13",
                    "qlabel": "vctq1"
                },
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "Establishment Democrat",
                    "title": "Establishment Democrat - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c14",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c14",
                    "qlabel": "vctq1"
                },
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "Social Democrat",
                    "title": "Social Democrat - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c15",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c15",
                    "qlabel": "vctq1"
                },
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "Moderate Democrat",
                    "title": "Moderate Democrat - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c16",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c16",
                    "qlabel": "vctq1"
                },
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "Identity-focused Democrat",
                    "title": "Identity-focused Democrat - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c17",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c17",
                    "qlabel": "vctq1"
                },
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "Opinion Leader",
                    "title": "Opinion Leader - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c18",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c18",
                    "qlabel": "vctq1"
                },
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "Gen Z",
                    "title": "Gen Z - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c19",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c19",
                    "qlabel": "vctq1"
                },
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "Millennial",
                    "title": "Millennial - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c20",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c20",
                    "qlabel": "vctq1"
                },
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "Gen X",
                    "title": "Gen X - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c21",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c21",
                    "qlabel": "vctq1"
                },
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "Boomer",
                    "title": "Boomer - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c22",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c22",
                    "qlabel": "vctq1"
                },
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "Silent",
                    "title": "Silent - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c23",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c23",
                    "qlabel": "vctq1"
                },
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "Male",
                    "title": "Male - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c24",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c24",
                    "qlabel": "vctq1"
                },
                {
                    "vgroup": "vctq1",
                    "qtitle": "Crosstabs - Oct 2025",
                    "colTitle": "Female",
                    "title": "Female - Crosstabs - Oct 2025",
                    "rowTitle": null,
                    "label": "vctq1c25",
                    "value": 1,
                    "row": null,
                    "type": "multiple",
                    "col": "c25",
                    "qlabel": "vctq1"
                }
            ],
            "flags": "vt",
            "qlabel": "vctq1",
            "type": "multiple",
            "grouping": "rows"
        },
        {
            "qtitle": "Q24_summary",
            "variables": [
                {
                    "vgroup": "Q24_summary",
                    "qtitle": "Q24_summary",
                    "colTitle": null,
                    "title": "Q24_summary",
                    "rowTitle": null,
                    "label": "Q24_summary",
                    "row": null,
                    "type": "text",
                    "col": null,
                    "qlabel": "Q24_summary"
                }
            ],
            "flags": "t",
            "qlabel": "Q24_summary",
            "type": "text",
            "grouping": "rows"
        },
        {
            "qtitle": "Q24_sentiment",
            "variables": [
                {
                    "vgroup": "Q24_sentiment",
                    "qtitle": "Q24_sentiment",
                    "colTitle": null,
                    "title": "Q24_sentiment",
                    "rowTitle": null,
                    "label": "Q24_sentiment",
                    "row": null,
                    "type": "text",
                    "col": null,
                    "qlabel": "Q24_sentiment"
                }
            ],
            "flags": "t",
            "qlabel": "Q24_sentiment",
            "type": "text",
            "grouping": "rows"
        },
        {
            "qtitle": "Participant source",
            "variables": [
                {
                    "vgroup": "vlist",
                    "qtitle": "Participant source",
                    "colTitle": null,
                    "title": "Participant source",
                    "rowTitle": null,
                    "label": "vlist",
                    "values": [
                        {
                            "label": "22",
                            "value": 1,
                            "title": "Client Test Source (list=22)"
                        },
                        {
                            "label": "1",
                            "value": 2,
                            "title": "NAV (list=1)"
                        },
                        {
                            "label": "1t",
                            "value": 3,
                            "title": "NAV - SURVEY TESTING PORTAL ONLY (list=1t)"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "vlist"
                }
            ],
            "values": [
                {
                    "label": "22",
                    "value": 1,
                    "title": "Client Test Source (list=22)"
                },
                {
                    "label": "1",
                    "value": 2,
                    "title": "NAV (list=1)"
                },
                {
                    "label": "1t",
                    "value": 3,
                    "title": "NAV - SURVEY TESTING PORTAL ONLY (list=1t)"
                }
            ],
            "flags": "vt",
            "qlabel": "vlist",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "Total Interview Time",
            "variables": [
                {
                    "vgroup": "qtime",
                    "qtitle": "Total Interview Time",
                    "colTitle": null,
                    "title": "Total Interview Time",
                    "rowTitle": null,
                    "label": "qtime",
                    "row": null,
                    "type": "float",
                    "col": null,
                    "qlabel": "qtime"
                }
            ],
            "flags": "t",
            "qlabel": "qtime",
            "type": "float",
            "grouping": "rows"
        },
        {
            "qtitle": "Operating System",
            "variables": [
                {
                    "vgroup": "vos",
                    "qtitle": "Operating System",
                    "colTitle": null,
                    "title": "Operating System",
                    "rowTitle": null,
                    "label": "vos",
                    "values": [
                        {
                            "label": "r0",
                            "value": 1,
                            "title": "Windows 95"
                        },
                        {
                            "label": "r1",
                            "value": 2,
                            "title": "Windows 98"
                        },
                        {
                            "label": "r2",
                            "value": 3,
                            "title": "Windows 8"
                        },
                        {
                            "label": "r3",
                            "value": 4,
                            "title": "Windows 10"
                        },
                        {
                            "label": "r4",
                            "value": 5,
                            "title": "Windows 7"
                        },
                        {
                            "label": "r5",
                            "value": 6,
                            "title": "Windows Vista"
                        },
                        {
                            "label": "r6",
                            "value": 7,
                            "title": "Windows 2003"
                        },
                        {
                            "label": "r7",
                            "value": 8,
                            "title": "Windows XP"
                        },
                        {
                            "label": "r8",
                            "value": 9,
                            "title": "Windows 2000"
                        },
                        {
                            "label": "r9",
                            "value": 10,
                            "title": "Microsoft Windows NT 4.0"
                        },
                        {
                            "label": "r10",
                            "value": 11,
                            "title": "Windows ME"
                        },
                        {
                            "label": "r11",
                            "value": 12,
                            "title": "iPhone/iPad"
                        },
                        {
                            "label": "r12",
                            "value": 13,
                            "title": "Mac OS X or older"
                        },
                        {
                            "label": "r13",
                            "value": 14,
                            "title": "Other Mobile"
                        },
                        {
                            "label": "r14",
                            "value": 15,
                            "title": "Linux, UNIX"
                        },
                        {
                            "label": "r15",
                            "value": 16,
                            "title": "Other"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "vos"
                },
                {
                    "vgroup": "vosr15oe",
                    "qtitle": "Operating System",
                    "colTitle": null,
                    "title": "Operating System - Other",
                    "rowTitle": "Other",
                    "label": "vosr15oe",
                    "row": "r15",
                    "type": "text",
                    "col": null,
                    "qlabel": "vos"
                }
            ],
            "values": [
                {
                    "label": "r0",
                    "value": 1,
                    "title": "Windows 95"
                },
                {
                    "label": "r1",
                    "value": 2,
                    "title": "Windows 98"
                },
                {
                    "label": "r2",
                    "value": 3,
                    "title": "Windows 8"
                },
                {
                    "label": "r3",
                    "value": 4,
                    "title": "Windows 10"
                },
                {
                    "label": "r4",
                    "value": 5,
                    "title": "Windows 7"
                },
                {
                    "label": "r5",
                    "value": 6,
                    "title": "Windows Vista"
                },
                {
                    "label": "r6",
                    "value": 7,
                    "title": "Windows 2003"
                },
                {
                    "label": "r7",
                    "value": 8,
                    "title": "Windows XP"
                },
                {
                    "label": "r8",
                    "value": 9,
                    "title": "Windows 2000"
                },
                {
                    "label": "r9",
                    "value": 10,
                    "title": "Microsoft Windows NT 4.0"
                },
                {
                    "label": "r10",
                    "value": 11,
                    "title": "Windows ME"
                },
                {
                    "label": "r11",
                    "value": 12,
                    "title": "iPhone/iPad"
                },
                {
                    "label": "r12",
                    "value": 13,
                    "title": "Mac OS X or older"
                },
                {
                    "label": "r13",
                    "value": 14,
                    "title": "Other Mobile"
                },
                {
                    "label": "r14",
                    "value": 15,
                    "title": "Linux, UNIX"
                },
                {
                    "label": "r15",
                    "value": 16,
                    "title": "Other"
                }
            ],
            "flags": "vt",
            "qlabel": "vos",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "Browser",
            "variables": [
                {
                    "vgroup": "vbrowser",
                    "qtitle": "Browser",
                    "colTitle": null,
                    "title": "Browser",
                    "rowTitle": null,
                    "label": "vbrowser",
                    "values": [
                        {
                            "label": "r0",
                            "value": 1,
                            "title": "Opera"
                        },
                        {
                            "label": "r1",
                            "value": 2,
                            "title": "MS Edge"
                        },
                        {
                            "label": "r2",
                            "value": 3,
                            "title": "MSIE 11"
                        },
                        {
                            "label": "r3",
                            "value": 4,
                            "title": "MSIE 10.x"
                        },
                        {
                            "label": "r4",
                            "value": 5,
                            "title": "MSIE 9.x"
                        },
                        {
                            "label": "r5",
                            "value": 6,
                            "title": "MSIE 8.x"
                        },
                        {
                            "label": "r6",
                            "value": 7,
                            "title": "MSIE 7.x"
                        },
                        {
                            "label": "r7",
                            "value": 8,
                            "title": "MSIE 6.x"
                        },
                        {
                            "label": "r8",
                            "value": 9,
                            "title": "MSIE 5.x or older"
                        },
                        {
                            "label": "r9",
                            "value": 10,
                            "title": "Chrome"
                        },
                        {
                            "label": "r10",
                            "value": 11,
                            "title": "Safari"
                        },
                        {
                            "label": "r11",
                            "value": 12,
                            "title": "Firefox"
                        },
                        {
                            "label": "r12",
                            "value": 13,
                            "title": "Other Mozilla or Netscape"
                        },
                        {
                            "label": "r13",
                            "value": 14,
                            "title": "Mobile"
                        },
                        {
                            "label": "r14",
                            "value": 15,
                            "title": "Text Browser"
                        },
                        {
                            "label": "r15",
                            "value": 16,
                            "title": "Other"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "vbrowser"
                },
                {
                    "vgroup": "vbrowserr15oe",
                    "qtitle": "Browser",
                    "colTitle": null,
                    "title": "Browser - Other",
                    "rowTitle": "Other",
                    "label": "vbrowserr15oe",
                    "row": "r15",
                    "type": "text",
                    "col": null,
                    "qlabel": "vbrowser"
                }
            ],
            "values": [
                {
                    "label": "r0",
                    "value": 1,
                    "title": "Opera"
                },
                {
                    "label": "r1",
                    "value": 2,
                    "title": "MS Edge"
                },
                {
                    "label": "r2",
                    "value": 3,
                    "title": "MSIE 11"
                },
                {
                    "label": "r3",
                    "value": 4,
                    "title": "MSIE 10.x"
                },
                {
                    "label": "r4",
                    "value": 5,
                    "title": "MSIE 9.x"
                },
                {
                    "label": "r5",
                    "value": 6,
                    "title": "MSIE 8.x"
                },
                {
                    "label": "r6",
                    "value": 7,
                    "title": "MSIE 7.x"
                },
                {
                    "label": "r7",
                    "value": 8,
                    "title": "MSIE 6.x"
                },
                {
                    "label": "r8",
                    "value": 9,
                    "title": "MSIE 5.x or older"
                },
                {
                    "label": "r9",
                    "value": 10,
                    "title": "Chrome"
                },
                {
                    "label": "r10",
                    "value": 11,
                    "title": "Safari"
                },
                {
                    "label": "r11",
                    "value": 12,
                    "title": "Firefox"
                },
                {
                    "label": "r12",
                    "value": 13,
                    "title": "Other Mozilla or Netscape"
                },
                {
                    "label": "r13",
                    "value": 14,
                    "title": "Mobile"
                },
                {
                    "label": "r14",
                    "value": 15,
                    "title": "Text Browser"
                },
                {
                    "label": "r15",
                    "value": 16,
                    "title": "Other"
                }
            ],
            "flags": "vt",
            "qlabel": "vbrowser",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "Mobile device category",
            "variables": [
                {
                    "vgroup": "vmobiledevice",
                    "qtitle": "Mobile device category",
                    "colTitle": null,
                    "title": "Mobile device category",
                    "rowTitle": null,
                    "label": "vmobiledevice",
                    "values": [
                        {
                            "label": "r0",
                            "value": 1,
                            "title": "Smartphone"
                        },
                        {
                            "label": "r1",
                            "value": 2,
                            "title": "Featurephone"
                        },
                        {
                            "label": "r2",
                            "value": 3,
                            "title": "Tablet"
                        },
                        {
                            "label": "r3",
                            "value": 4,
                            "title": "Other mobile"
                        },
                        {
                            "label": "r4",
                            "value": 5,
                            "title": "Desktop"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "vmobiledevice"
                }
            ],
            "values": [
                {
                    "label": "r0",
                    "value": 1,
                    "title": "Smartphone"
                },
                {
                    "label": "r1",
                    "value": 2,
                    "title": "Featurephone"
                },
                {
                    "label": "r2",
                    "value": 3,
                    "title": "Tablet"
                },
                {
                    "label": "r3",
                    "value": 4,
                    "title": "Other mobile"
                },
                {
                    "label": "r4",
                    "value": 5,
                    "title": "Desktop"
                }
            ],
            "flags": "vt",
            "qlabel": "vmobiledevice",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "Mobile OS",
            "variables": [
                {
                    "vgroup": "vmobileos",
                    "qtitle": "Mobile OS",
                    "colTitle": null,
                    "title": "Mobile OS",
                    "rowTitle": null,
                    "label": "vmobileos",
                    "values": [
                        {
                            "label": "r0",
                            "value": 1,
                            "title": "iOS"
                        },
                        {
                            "label": "r1",
                            "value": 2,
                            "title": "Android"
                        },
                        {
                            "label": "r2",
                            "value": 3,
                            "title": "Symbian"
                        },
                        {
                            "label": "r3",
                            "value": 4,
                            "title": "Windows Phone"
                        },
                        {
                            "label": "r4",
                            "value": 5,
                            "title": "Blackberry"
                        },
                        {
                            "label": "r5",
                            "value": 6,
                            "title": "Other/Desktop"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "vmobileos"
                }
            ],
            "values": [
                {
                    "label": "r0",
                    "value": 1,
                    "title": "iOS"
                },
                {
                    "label": "r1",
                    "value": 2,
                    "title": "Android"
                },
                {
                    "label": "r2",
                    "value": 3,
                    "title": "Symbian"
                },
                {
                    "label": "r3",
                    "value": 4,
                    "title": "Windows Phone"
                },
                {
                    "label": "r4",
                    "value": 5,
                    "title": "Blackberry"
                },
                {
                    "label": "r5",
                    "value": 6,
                    "title": "Other/Desktop"
                }
            ],
            "flags": "vt",
            "qlabel": "vmobileos",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "Survey start time",
            "variables": [
                {
                    "vgroup": "start_date",
                    "qtitle": "Survey start time",
                    "colTitle": null,
                    "title": "Survey start time",
                    "rowTitle": null,
                    "label": "start_date",
                    "row": null,
                    "type": "text",
                    "col": null,
                    "qlabel": "start_date"
                }
            ],
            "flags": "t",
            "qlabel": "start_date",
            "type": "text",
            "grouping": "rows"
        },
        {
            "qtitle": "Participant status",
            "variables": [
                {
                    "vgroup": "status",
                    "qtitle": "Participant status",
                    "colTitle": null,
                    "title": "Participant status",
                    "rowTitle": null,
                    "label": "status",
                    "values": [
                        {
                            "label": "terminated",
                            "value": 1,
                            "title": "Terminated"
                        },
                        {
                            "label": "overquota",
                            "value": 2,
                            "title": "Overquota"
                        },
                        {
                            "label": "qualified",
                            "value": 3,
                            "title": "Qualified"
                        },
                        {
                            "label": "partial",
                            "value": 4,
                            "title": "Partial"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "status"
                }
            ],
            "values": [
                {
                    "label": "terminated",
                    "value": 1,
                    "title": "Terminated"
                },
                {
                    "label": "overquota",
                    "value": 2,
                    "title": "Overquota"
                },
                {
                    "label": "qualified",
                    "value": 3,
                    "title": "Qualified"
                },
                {
                    "label": "partial",
                    "value": 4,
                    "title": "Partial"
                }
            ],
            "flags": "vt",
            "qlabel": "status",
            "type": "single",
            "grouping": "cols"
        },
        {
            "qtitle": "Last seen question",
            "variables": [
                {
                    "vgroup": "vdropout",
                    "qtitle": "Last seen question",
                    "colTitle": null,
                    "title": "Last seen question",
                    "rowTitle": null,
                    "label": "vdropout",
                    "values": [
                        {
                            "label": "Q1",
                            "value": 1,
                            "title": "(Q1) In what year were you born?"
                        },
                        {
                            "label": "Q2",
                            "value": 2,
                            "title": "(Q2) What is your gender?"
                        },
                        {
                            "label": "Q3",
                            "value": 3,
                            "title": "(Q3) In what state do you reside?"
                        },
                        {
                            "label": "Q4",
                            "value": 4,
                            "title": "(Q4) Which of the following best describes your racial and ethnic heritage?"
                        },
                        {
                            "label": "Q5",
                            "value": 5,
                            "title": "(Q5) What is the highest level of education you have completed?"
                        },
                        {
                            "label": "Q6",
                            "value": 6,
                            "title": "(Q6) Which of the following ranges includes your household's TOTAL annual income?"
                        },
                        {
                            "label": "Q7",
                            "value": 7,
                            "title": "(Q7) Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?"
                        },
                        {
                            "label": "Q8",
                            "value": 8,
                            "title": "(Q8) Thinking about the past year, how has what you pay for each of the following changed, if at all?"
                        },
                        {
                            "label": "Q9",
                            "value": 9,
                            "title": "(Q9) When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?"
                        },
                        {
                            "label": "Q10",
                            "value": 10,
                            "title": "(Q10) Which do you prioritize more when thinking about America's energy future?"
                        },
                        {
                            "label": "Q11",
                            "value": 11,
                            "title": "(Q11) Which statement comes closest to your view of the U.S. renewable energy industry?"
                        },
                        {
                            "label": "Q12",
                            "value": 12,
                            "title": "(Q12) Do you think a focus on growing renewable energy helps or hurts America's ability to compete globally?"
                        },
                        {
                            "label": "Q13",
                            "value": 13,
                            "title": "(Q13) Thinking about the future of electricity demand in the U.S., which of the following do you think is most likely in the next 10 years?"
                        },
                        {
                            "label": "Q14",
                            "value": 14,
                            "title": "(Q14) Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%."
                        },
                        {
                            "label": "Q15",
                            "value": 15,
                            "title": "(Q15) Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?"
                        },
                        {
                            "label": "Q16",
                            "value": 16,
                            "title": "(Q16) Please read the below statements and select the one that comes the closest to your own opinion."
                        },
                        {
                            "label": "Q17",
                            "value": 17,
                            "title": "(Q17) Please read the below statements and select the one that comes the closest to your own opinion."
                        },
                        {
                            "label": "Q18",
                            "value": 18,
                            "title": "(Q18) Please read the below statements and select the one that comes the closest to your own opinion."
                        },
                        {
                            "label": "Q19",
                            "value": 19,
                            "title": "(Q19) Please read the below statements and select the one that comes the closest to your own opinion."
                        },
                        {
                            "label": "Q20",
                            "value": 20,
                            "title": "(Q20) Please read the below statements and select the one that comes the closest to your own opinion."
                        },
                        {
                            "label": "Q21",
                            "value": 21,
                            "title": "(Q21) Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future."
                        },
                        {
                            "label": "Q22_1",
                            "value": 22,
                            "title": "(Q22_1) ${Q22.title}"
                        },
                        {
                            "label": "Q22_2",
                            "value": 23,
                            "title": "(Q22_2) ${Q22.title}"
                        },
                        {
                            "label": "Q22_3",
                            "value": 24,
                            "title": "(Q22_3) ${Q22.title}"
                        },
                        {
                            "label": "Q22_4",
                            "value": 25,
                            "title": "(Q22_4) ${Q22.title}"
                        },
                        {
                            "label": "Q22_5",
                            "value": 26,
                            "title": "(Q22_5) ${Q22.title}"
                        },
                        {
                            "label": "Q22_6",
                            "value": 27,
                            "title": "(Q22_6) ${Q22.title}"
                        },
                        {
                            "label": "Q22_7",
                            "value": 28,
                            "title": "(Q22_7) ${Q22.title}"
                        },
                        {
                            "label": "Q22_8",
                            "value": 29,
                            "title": "(Q22_8) ${Q22.title}"
                        },
                        {
                            "label": "Q22_9",
                            "value": 30,
                            "title": "(Q22_9) ${Q22.title}"
                        },
                        {
                            "label": "Q23",
                            "value": 31,
                            "title": "(Q23) When you hear the term \"clean energy,\" which of the following comes closest to your view?"
                        },
                        {
                            "label": "preQ24",
                            "value": 32,
                            "title": "(preQ24) Comment element"
                        },
                        {
                            "label": "Q24",
                            "value": 33,
                            "title": "(Q24) When you hear the term \"clean energy,\" what does it mean to you personally?"
                        },
                        {
                            "label": "Q30",
                            "value": 34,
                            "title": "(Q30) Which of the following do you see as the biggest threat to the growth of clean energy in the U.S.?"
                        },
                        {
                            "label": "Q31",
                            "value": 35,
                            "title": "(Q31) Do you think adding more clean energy to the grid makes the system..."
                        },
                        {
                            "label": "Q32",
                            "value": 36,
                            "title": "(Q32) Please read the following statements and select the one that comes the closest to your own opinion."
                        },
                        {
                            "label": "Q33",
                            "value": 37,
                            "title": "(Q33) Please read the below statements and select the one that comes the closest to your own opinion."
                        },
                        {
                            "label": "Q34",
                            "value": 38,
                            "title": "(Q34) What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?"
                        },
                        {
                            "label": "Q35",
                            "value": 39,
                            "title": "(Q35) Personally, do you consider yourself to be a(n)"
                        },
                        {
                            "label": "Q36",
                            "value": 40,
                            "title": "(Q36) Which of the following best describes you?"
                        },
                        {
                            "label": "Q37",
                            "value": 41,
                            "title": "(Q37) Which of the following best describes you?"
                        },
                        {
                            "label": "Q38",
                            "value": 42,
                            "title": "(Q38) What type of community do you live in?"
                        },
                        {
                            "label": "Q39",
                            "value": 43,
                            "title": "(Q39) How frequently do others come to you for your opinion or advice on the following topics?"
                        },
                        {
                            "label": "Q40",
                            "value": 44,
                            "title": "(Q40) Which, if any, of the following generally describe you?"
                        },
                        {
                            "label": "Q41",
                            "value": 45,
                            "title": "(Q41) And which, if any, of the following also generally describe you?"
                        },
                        {
                            "label": "Q42",
                            "value": 46,
                            "title": "(Q42) And again which, if any, of the following apply to you personally?"
                        },
                        {
                            "label": "Q43",
                            "value": 47,
                            "title": "(Q43) Regardless of how you feel about the candidates today, for whom did you vote for in the 2024 presidential election?"
                        },
                        {
                            "label": "V2outtro",
                            "value": 48,
                            "title": "(V2outtro) Comment element"
                        }
                    ],
                    "row": null,
                    "type": "single",
                    "col": null,
                    "qlabel": "vdropout"
                }
            ],
            "values": [
                {
                    "label": "Q1",
                    "value": 1,
                    "title": "(Q1) In what year were you born?"
                },
                {
                    "label": "Q2",
                    "value": 2,
                    "title": "(Q2) What is your gender?"
                },
                {
                    "label": "Q3",
                    "value": 3,
                    "title": "(Q3) In what state do you reside?"
                },
                {
                    "label": "Q4",
                    "value": 4,
                    "title": "(Q4) Which of the following best describes your racial and ethnic heritage?"
                },
                {
                    "label": "Q5",
                    "value": 5,
                    "title": "(Q5) What is the highest level of education you have completed?"
                },
                {
                    "label": "Q6",
                    "value": 6,
                    "title": "(Q6) Which of the following ranges includes your household's TOTAL annual income?"
                },
                {
                    "label": "Q7",
                    "value": 7,
                    "title": "(Q7) Below is a list of issues people sometimes say are important to America's future. If you had to choose the top three priorities for America's future, which would they be?"
                },
                {
                    "label": "Q8",
                    "value": 8,
                    "title": "(Q8) Thinking about the past year, how has what you pay for each of the following changed, if at all?"
                },
                {
                    "label": "Q9",
                    "value": 9,
                    "title": "(Q9) When you think about why electricity bills are rising, how much do you think each of the following contributes to the higher prices?"
                },
                {
                    "label": "Q10",
                    "value": 10,
                    "title": "(Q10) Which do you prioritize more when thinking about America's energy future?"
                },
                {
                    "label": "Q11",
                    "value": 11,
                    "title": "(Q11) Which statement comes closest to your view of the U.S. renewable energy industry?"
                },
                {
                    "label": "Q12",
                    "value": 12,
                    "title": "(Q12) Do you think a focus on growing renewable energy helps or hurts America's ability to compete globally?"
                },
                {
                    "label": "Q13",
                    "value": 13,
                    "title": "(Q13) Thinking about the future of electricity demand in the U.S., which of the following do you think is most likely in the next 10 years?"
                },
                {
                    "label": "Q14",
                    "value": 14,
                    "title": "(Q14) Looking ahead, what share of America's future electricity supply do you think should come from each of the following sources? Please allocate percentages across the list below so that your total adds up to 100%."
                },
                {
                    "label": "Q15",
                    "value": 15,
                    "title": "(Q15) Different words are sometimes used to describe energy that is not derived from traditional fossil fuels such as coal, oil, and natural gas. On a scale from 0 to 10, where 0 means extremely negative, 5 means neutral, and 10 means extremely positive, how do you feel about each of the following terms to describe this type of energy?"
                },
                {
                    "label": "Q16",
                    "value": 16,
                    "title": "(Q16) Please read the below statements and select the one that comes the closest to your own opinion."
                },
                {
                    "label": "Q17",
                    "value": 17,
                    "title": "(Q17) Please read the below statements and select the one that comes the closest to your own opinion."
                },
                {
                    "label": "Q18",
                    "value": 18,
                    "title": "(Q18) Please read the below statements and select the one that comes the closest to your own opinion."
                },
                {
                    "label": "Q19",
                    "value": 19,
                    "title": "(Q19) Please read the below statements and select the one that comes the closest to your own opinion."
                },
                {
                    "label": "Q20",
                    "value": 20,
                    "title": "(Q20) Please read the below statements and select the one that comes the closest to your own opinion."
                },
                {
                    "label": "Q21",
                    "value": 21,
                    "title": "(Q21) Please rank the following sources from the one you trust the most to the one you trust the least when it comes to information America's energy future."
                },
                {
                    "label": "Q22_1",
                    "value": 22,
                    "title": "(Q22_1) ${Q22.title}"
                },
                {
                    "label": "Q22_2",
                    "value": 23,
                    "title": "(Q22_2) ${Q22.title}"
                },
                {
                    "label": "Q22_3",
                    "value": 24,
                    "title": "(Q22_3) ${Q22.title}"
                },
                {
                    "label": "Q22_4",
                    "value": 25,
                    "title": "(Q22_4) ${Q22.title}"
                },
                {
                    "label": "Q22_5",
                    "value": 26,
                    "title": "(Q22_5) ${Q22.title}"
                },
                {
                    "label": "Q22_6",
                    "value": 27,
                    "title": "(Q22_6) ${Q22.title}"
                },
                {
                    "label": "Q22_7",
                    "value": 28,
                    "title": "(Q22_7) ${Q22.title}"
                },
                {
                    "label": "Q22_8",
                    "value": 29,
                    "title": "(Q22_8) ${Q22.title}"
                },
                {
                    "label": "Q22_9",
                    "value": 30,
                    "title": "(Q22_9) ${Q22.title}"
                },
                {
                    "label": "Q23",
                    "value": 31,
                    "title": "(Q23) When you hear the term \"clean energy,\" which of the following comes closest to your view?"
                },
                {
                    "label": "preQ24",
                    "value": 32,
                    "title": "(preQ24) Comment element"
                },
                {
                    "label": "Q24",
                    "value": 33,
                    "title": "(Q24) When you hear the term \"clean energy,\" what does it mean to you personally?"
                },
                {
                    "label": "Q30",
                    "value": 34,
                    "title": "(Q30) Which of the following do you see as the biggest threat to the growth of clean energy in the U.S.?"
                },
                {
                    "label": "Q31",
                    "value": 35,
                    "title": "(Q31) Do you think adding more clean energy to the grid makes the system..."
                },
                {
                    "label": "Q32",
                    "value": 36,
                    "title": "(Q32) Please read the following statements and select the one that comes the closest to your own opinion."
                },
                {
                    "label": "Q33",
                    "value": 37,
                    "title": "(Q33) Please read the below statements and select the one that comes the closest to your own opinion."
                },
                {
                    "label": "Q34",
                    "value": 38,
                    "title": "(Q34) What would make you more comfortable with clean energy infrastructure (such as wind turbines, solar farms, or transmission lines) being built in or near your community?"
                },
                {
                    "label": "Q35",
                    "value": 39,
                    "title": "(Q35) Personally, do you consider yourself to be a(n)"
                },
                {
                    "label": "Q36",
                    "value": 40,
                    "title": "(Q36) Which of the following best describes you?"
                },
                {
                    "label": "Q37",
                    "value": 41,
                    "title": "(Q37) Which of the following best describes you?"
                },
                {
                    "label": "Q38",
                    "value": 42,
                    "title": "(Q38) What type of community do you live in?"
                },
                {
                    "label": "Q39",
                    "value": 43,
                    "title": "(Q39) How frequently do others come to you for your opinion or advice on the following topics?"
                },
                {
                    "label": "Q40",
                    "value": 44,
                    "title": "(Q40) Which, if any, of the following generally describe you?"
                },
                {
                    "label": "Q41",
                    "value": 45,
                    "title": "(Q41) And which, if any, of the following also generally describe you?"
                },
                {
                    "label": "Q42",
                    "value": 46,
                    "title": "(Q42) And again which, if any, of the following apply to you personally?"
                },
                {
                    "label": "Q43",
                    "value": 47,
                    "title": "(Q43) Regardless of how you feel about the candidates today, for whom did you vote for in the 2024 presidential election?"
                },
                {
                    "label": "V2outtro",
                    "value": 48,
                    "title": "(V2outtro) Comment element"
                }
            ],
            "flags": "vt",
            "qlabel": "vdropout",
            "type": "single",
            "grouping": "cols"
        }
    ]
}
